import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
export type CreateFhirAppointmentMutationVariables = Exact<{
  appointmentPrework: CreateFhirAppointmentInputWithoutPatientCodexId;
}>;


export type CreateFhirAppointmentMutation = { __typename?: 'Mutation', createFHIRAppointmentForCurrentUser: { __typename?: 'CreateFHIRAppointmentOutput', appointment: { __typename?: 'CreateAppoinimentOutput', appointmentCodexId: string, appointmentId: string } } };

export type PatchFhirAppointmentMutationVariables = Exact<{
  appointmentInformation: PatchFhirAppointmentInput;
}>;


export type PatchFhirAppointmentMutation = { __typename?: 'Mutation', patchFHIRAppointment: { __typename?: 'PatchFHIRAppointmentOutput', appointment: { __typename?: 'PatchAppointmentOutput', appointmentId: string } } };

export type CancelAppointmentMutationVariables = Exact<{
  codexAppointmentId: Scalars['String'];
  cancelationReason: Scalars['String'];
}>;


export type CancelAppointmentMutation = { __typename?: 'Mutation', cancelFHIRAppointment: { __typename?: 'PatchFHIRAppointmentOutput', appointment: { __typename?: 'PatchAppointmentOutput', appointmentId: string } } };

export type PatchFhirEncounterMutationVariables = Exact<{
  encounterCodexId: Scalars['String'];
  files?: InputMaybe<Array<FileAttachmentInput> | FileAttachmentInput>;
  followupRecommendations: Scalars['String'];
  providerNotes: Scalars['String'];
  providerSummary: Scalars['String'];
  systemGenerated?: InputMaybe<Scalars['String']>;
  transcription?: InputMaybe<Scalars['String']>;
  diagnosticReportIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type PatchFhirEncounterMutation = { __typename?: 'Mutation', patchFHIREncounter: { __typename?: 'PatchFHIREncounterOutput', encounter?: { __typename?: 'PatchEncounterOutput', encounterId: string, status: string } | null } };

export type AppendEncounterNotesToFhirAppointmentMutationVariables = Exact<{
  codexAppointmentId: Scalars['String'];
  providerNotes: Scalars['String'];
  followupRecommendations: Scalars['String'];
  providerSummary: Scalars['String'];
  files?: InputMaybe<Array<FileAttachmentInput> | FileAttachmentInput>;
  systemGenerated?: InputMaybe<Scalars['String']>;
  transcription?: InputMaybe<Scalars['String']>;
  diagnosticReportIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type AppendEncounterNotesToFhirAppointmentMutation = { __typename?: 'Mutation', appendEncounterToFHIRAppointment: { __typename?: 'PatchAppointmentAndEncounterOutput', encounter: { __typename?: 'AppendEncounterOutput', encounterId: string }, appointment: { __typename?: 'PatchAppointmentOutput', appointmentId: string } } };

export type AddMessageToAppointmentMessageListByAppointmentCodexIdMutationVariables = Exact<{
  appointmentCodexId: Scalars['String'];
  messages?: InputMaybe<Array<AppointmentChatMessageInput> | AppointmentChatMessageInput>;
}>;


export type AddMessageToAppointmentMessageListByAppointmentCodexIdMutation = { __typename?: 'Mutation', addMessageToAppointmentMessageListByAppointmentCodexId: { __typename?: 'Communication', id: string } };

export type CompleteAppointmentMutationVariables = Exact<{
  appointmentCodexId: Scalars['String'];
}>;


export type CompleteAppointmentMutation = { __typename?: 'Mutation', patchFHIRAppointment: { __typename?: 'PatchFHIRAppointmentOutput', appointment: { __typename?: 'PatchAppointmentOutput', appointmentId: string } } };

export type RescheduleAppointmentMutationVariables = Exact<{
  appointmentCodexId: Scalars['String'];
  datetime: Scalars['String'];
}>;


export type RescheduleAppointmentMutation = { __typename?: 'Mutation', rescheduleAppointment: { __typename?: 'RescheduleFHIRAppointmentOutput', appointment: { __typename?: 'RescheduleAppointmentOutput', appointmentCodexId: string, appointmentId: string, created: string, lastProcessedDate: string, start: string, status: string } } };

export type RequestAppointmentNewDateMutationVariables = Exact<{
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  appointmentTypeId?: InputMaybe<Scalars['Int']>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
  proposedDate: Scalars['String'];
  type: AppointmentRequestType;
}>;


export type RequestAppointmentNewDateMutation = { __typename?: 'Mutation', createAppointmentRequest: { __typename?: 'AppointmentRequestOutput', status: AppointmentRequestStatus, appointmentCodexId?: string | null, approvedDate?: string | null, id: string, createdAt: string, proposedDate: string, providerCodexId: string, reason: string, type: AppointmentRequestType, updatedAt: string, patient?: { __typename?: 'GetPatientOutput', SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null } | null } };

export type RejectAppointmentRescheduleRequestMutationVariables = Exact<{
  input: GetAppointmentRescheduleRequestInput;
}>;


export type RejectAppointmentRescheduleRequestMutation = { __typename?: 'Mutation', rejectAppointmentRequest: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type DeleteAppointmentRequestMutationVariables = Exact<{
  input: GetAppointmentRescheduleRequestInput;
}>;


export type DeleteAppointmentRequestMutation = { __typename?: 'Mutation', deleteAppointmentRequest: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type EnsureAppointmentSummaryPdfMutationVariables = Exact<{
  appointmentCodexId: Scalars['String'];
}>;


export type EnsureAppointmentSummaryPdfMutation = { __typename?: 'Mutation', ensureAppointmentSummaryPdf: { __typename?: 'AppointmentSummaryPdfOutput', status: AppointmentSummaryPdfStatus, summaryPdfFileId?: string | null } };

export type GetAppointmentsByPatientCodexIdQueryVariables = Exact<{
  appointmentStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Float']>;
  tzOffset?: InputMaybe<Scalars['Float']>;
  dayFilter?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  providerName?: InputMaybe<Scalars['String']>;
  codexProviderId?: InputMaybe<Scalars['String']>;
  isSummaryCompleted?: InputMaybe<Scalars['Boolean']>;
  find?: InputMaybe<Scalars['String']>;
}>;


export type GetAppointmentsByPatientCodexIdQuery = { __typename?: 'Query', getFHIRAppointmentByRequestPatientCodexId: { __typename?: 'GetFHIRAppointmentsOutputWithUpcomingCounts', total: number, appointment: Array<{ __typename?: 'GetAppointmentOutput', acuityId?: string | null, appointmentCodexId: string, appointmentId: string, appointmentStatus?: number | null, appointmentType?: AppointmentTypeEnum | null, appointmentUrl?: string | null, cancelationReason?: string | null, codexPatientId: string, codexProviderId?: string | null, created: string, paymentSessionOpenedAt?: string | null, encounterId?: string | null, end?: string | null, isSummaryCompleted: boolean, lastProcessedDate: string, lastUpdate?: string | null, patientFirstName?: string | null, patientLastName?: string | null, providerFirstName?: string | null, providerLastName?: string | null, start?: string | null, status: string, subjectOfAppointment?: string | null, symptomsLocation?: Array<string> | null, visitSummaryPdfUrl?: string | null, appointmentNotes?: { __typename?: 'FHIRAppointmentNotesObservationOutput', anythingElseQuestion?: string | null, howLongQuestion?: string | null, practitionerNotes?: string | null, severityQuestion?: string | null, symptomsTypes?: Array<string> | null } | null, diagnosticReports?: Array<{ __typename?: 'GetFHIRAppointmentDiagnosticReportOutput', diagnosticReportId: string, diagnosticReportStatus: Hasura_Dnavisit_Test_Statuses_Enum, diagnosticReportTestType: Hasura_Test_Types_Enum, swabCode: string, patientPdfId?: string | null, statusHistory: Array<{ __typename?: 'TestKitStatusHistoryEntry', datetime: string, status: Hasura_Dnavisit_Test_Statuses_Enum }>, patientPdf?: { __typename?: 'FileOutput', contentType?: string | null, fileId?: string | null, fileName?: string | null, url?: string | null, size?: number | null } | null }> | null, encounterNotes?: { __typename?: 'FHIREncounterNotesOutput', followupRecommendations: string, lastUpdated: string, providerNotes: string, providerSummary: string, systemGenerated: string, transcription: string, files?: Array<{ __typename?: 'EncounterFileOutput', contentType?: ContentType | null, fileId?: string | null, size?: number | null, title?: string | null, url?: string | null }> | null } | null, events?: Array<{ __typename?: 'AppointmentEvent', author: Appointment_Event_Source, date: string, event: Appointment_Event, fhirId: string }> | null, media?: Array<{ __typename?: 'GetAppointmentMediaOutput', bodySite?: string | null, description?: string | null, fileId?: string | null, fhirId: string, url?: string | null }> | null, participant: Array<{ __typename?: 'ReferenceType', reference?: string | null, type?: string | null }>, paymentInformation?: { __typename?: 'AppointmentPaymentOutput', amount?: number | null, status?: number | null, discount?: { __typename?: 'DiscountOutput', amountOff?: number | null, percentOff?: number | null } | null } | null, pendingRescheduleRequest?: { __typename?: 'AppointmentRequestOutput', proposedDate: string, reason: string, id: string } | null, recommendations?: Array<{ __typename?: 'GetFHIRRecommendationOutput', createdAt: string, id: string, imageUrl?: string | null, productId: number, productTitle: string, providerName: string, providerCodexId: string, quantity: number, status: ServiceRequestStatus, totalPrice: number }> | null, supportingInformation?: Array<{ __typename?: 'ReferenceType', reference?: string | null, type?: string | null }> | null }>, counts: { __typename?: 'UpcomingAppointmentCounts', month: number, today: number, tomorrow: number, week: number } } };

export type GetUnfilledSummariesByRequestProviderIdQueryVariables = Exact<{
  appointmentStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Float']>;
}>;


export type GetUnfilledSummariesByRequestProviderIdQuery = { __typename?: 'Query', getUnfilledSummariesByRequestProviderId: { __typename?: 'GetFHIRAppointmentsOutput', total: number, appointment: Array<{ __typename?: 'GetAppointmentOutput', acuityId?: string | null, appointmentCodexId: string, appointmentId: string, appointmentStatus?: number | null, appointmentType?: AppointmentTypeEnum | null, appointmentUrl?: string | null, cancelationReason?: string | null, codexPatientId: string, codexProviderId?: string | null, created: string, encounterId?: string | null, end?: string | null, isSummaryCompleted: boolean, lastProcessedDate: string, lastUpdate?: string | null, patientFirstName?: string | null, patientLastName?: string | null, providerFirstName?: string | null, providerLastName?: string | null, start?: string | null, status: string, subjectOfAppointment?: string | null, symptomsLocation?: Array<string> | null, appointmentNotes?: { __typename?: 'FHIRAppointmentNotesObservationOutput', anythingElseQuestion?: string | null, howLongQuestion?: string | null, practitionerNotes?: string | null, severityQuestion?: string | null, symptomsTypes?: Array<string> | null } | null, diagnosticReports?: Array<{ __typename?: 'GetFHIRAppointmentDiagnosticReportOutput', diagnosticReportId: string, diagnosticReportStatus: Hasura_Dnavisit_Test_Statuses_Enum, diagnosticReportTestType: Hasura_Test_Types_Enum, swabCode: string, patientPdfId?: string | null, providerPdfId?: string | null, patientPdf?: { __typename?: 'FileOutput', contentType?: string | null, fileId?: string | null, fileName?: string | null, url?: string | null, size?: number | null } | null, providerPdf?: { __typename?: 'FileOutput', contentType?: string | null, fileId?: string | null, fileName?: string | null, size?: number | null, url?: string | null } | null }> | null, encounterNotes?: { __typename?: 'FHIREncounterNotesOutput', followupRecommendations: string, lastUpdated: string, providerNotes: string, providerSummary: string, systemGenerated: string, transcription: string, files?: Array<{ __typename?: 'EncounterFileOutput', contentType?: ContentType | null, fileId?: string | null, size?: number | null, title?: string | null, url?: string | null }> | null } | null, events?: Array<{ __typename?: 'AppointmentEvent', author: Appointment_Event_Source, date: string, event: Appointment_Event, fhirId: string }> | null, media?: Array<{ __typename?: 'GetAppointmentMediaOutput', bodySite?: string | null, description?: string | null, fileId?: string | null, fhirId: string, url?: string | null }> | null, participant: Array<{ __typename?: 'ReferenceType', reference?: string | null, type?: string | null }>, paymentInformation?: { __typename?: 'AppointmentPaymentOutput', amount?: number | null, status?: number | null } | null, recommendations?: Array<{ __typename?: 'GetFHIRRecommendationOutput', createdAt: string, id: string, imageUrl?: string | null, productId: number, productTitle: string, providerName: string, providerCodexId: string, quantity: number, status: ServiceRequestStatus, totalPrice: number }> | null, supportingInformation?: Array<{ __typename?: 'ReferenceType', reference?: string | null, type?: string | null }> | null }> } };

export type GetFulfilledAppointmentsByPatientQueryVariables = Exact<{
  codexProviderId?: InputMaybe<Scalars['String']>;
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  find?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tzOffset?: InputMaybe<Scalars['Float']>;
  dayFilter?: InputMaybe<Scalars['String']>;
}>;


export type GetFulfilledAppointmentsByPatientQuery = { __typename?: 'Query', getFHIRAppointmentByRequestPatientCodexId: { __typename?: 'GetFHIRAppointmentsOutputWithUpcomingCounts', total: number, appointment: Array<{ __typename?: 'GetAppointmentOutput', appointmentCodexId: string, appointmentStatus?: number | null, appointmentType?: AppointmentTypeEnum | null, start?: string | null, status: string, codexPatientId: string, codexProviderId?: string | null, subjectOfAppointment?: string | null, providerLastName?: string | null, providerFirstName?: string | null, patientFirstName?: string | null, patientLastName?: string | null, encounterId?: string | null, paymentSessionOpenedAt?: string | null, paymentInformation?: { __typename?: 'AppointmentPaymentOutput', amount?: number | null, status?: number | null } | null, encounterNotes?: { __typename?: 'FHIREncounterNotesOutput', followupRecommendations: string, providerSummary: string } | null, media?: Array<{ __typename?: 'GetAppointmentMediaOutput', url?: string | null, fileId?: string | null, bodySite?: string | null, description?: string | null }> | null }>, counts: { __typename?: 'UpcomingAppointmentCounts', today: number, tomorrow: number, week: number, month: number } } };

export type GetLastPendingAppointmentByPatientQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLastPendingAppointmentByPatientQuery = { __typename?: 'Query', getFHIRAppointmentByRequestPatientCodexId: { __typename?: 'GetFHIRAppointmentsOutputWithUpcomingCounts', appointment: Array<{ __typename?: 'GetAppointmentOutput', appointmentCodexId: string, appointmentStatus?: number | null, start?: string | null, codexProviderId?: string | null, subjectOfAppointment?: string | null, paymentSessionOpenedAt?: string | null, symptomsLocation?: Array<string> | null, appointmentNotes?: { __typename?: 'FHIRAppointmentNotesObservationOutput', anythingElseQuestion?: string | null, howLongQuestion?: string | null, severityQuestion?: string | null, symptomsTypes?: Array<string> | null } | null, media?: Array<{ __typename?: 'GetAppointmentMediaOutput', url?: string | null, fileId?: string | null, bodySite?: string | null, description?: string | null }> | null }> } };

export type GetFhirAppointmentByAcuityIdQueryVariables = Exact<{
  appointmentAcuityId: Scalars['String'];
}>;


export type GetFhirAppointmentByAcuityIdQuery = { __typename?: 'Query', getFHIRAppointmentByAcuityId: { __typename?: 'GetFHIRAppointmentOutput', appointment?: { __typename?: 'GetAppointmentOutput', appointmentCodexId: string, appointmentType?: AppointmentTypeEnum | null, encounterId?: string | null } | null } };

export type GetAppointmentByCodexAppointmentIdInMediaQueryVariables = Exact<{
  appointmentCodexId: Scalars['String'];
}>;


export type GetAppointmentByCodexAppointmentIdInMediaQuery = { __typename?: 'Query', getFHIRAppointmentByCodexId: { __typename?: 'GetFHIRAppointmentOutput', appointment?: { __typename?: 'GetAppointmentOutput', summaryPdfFileId?: string | null, appointmentCodexId: string, appointmentId: string, appointmentType?: AppointmentTypeEnum | null, providerFirstName?: string | null, providerLastName?: string | null, start?: string | null } | null } };

export type GetAppointmentByCodexAppointmentIdQueryVariables = Exact<{
  appointmentCodexId: Scalars['String'];
}>;


export type GetAppointmentByCodexAppointmentIdQuery = { __typename?: 'Query', getFHIRAppointmentByCodexId: { __typename?: 'GetFHIRAppointmentOutput', appointment?: { __typename?: 'GetAppointmentOutput', summaryPdfFileId?: string | null, acuityId?: string | null, appointmentCodexId: string, appointmentId: string, appointmentStatus?: number | null, appointmentType?: AppointmentTypeEnum | null, appointmentUrl?: string | null, cancelationReason?: string | null, codexPatientId: string, codexProviderId?: string | null, created: string, encounterId?: string | null, end?: string | null, isSummaryCompleted: boolean, lastProcessedDate: string, lastUpdate?: string | null, patientFirstName?: string | null, patientLastName?: string | null, providerFirstName?: string | null, providerLastName?: string | null, start?: string | null, status: string, subjectOfAppointment?: string | null, symptomsLocation?: Array<string> | null, appointmentNotes?: { __typename?: 'FHIRAppointmentNotesObservationOutput', anythingElseQuestion?: string | null, howLongQuestion?: string | null, practitionerNotes?: string | null, severityQuestion?: string | null, symptomsTypes?: Array<string> | null } | null, statusHistory: Array<{ __typename?: 'AppointmentStatusHistoryEntry', datetime: string, status: AppointmentStatusHistoryEnum }>, pendingRescheduleRequest?: { __typename?: 'AppointmentRequestOutput', proposedDate: string, reason: string, id: string } | null, diagnosticReports?: Array<{ __typename?: 'GetFHIRAppointmentDiagnosticReportOutput', createdAt?: string | null, diagnosticReportId: string, diagnosticReportStatus: Hasura_Dnavisit_Test_Statuses_Enum, diagnosticReportTestType: Hasura_Test_Types_Enum, swabCode: string, patientPdfId?: string | null, patientPdf?: { __typename?: 'FileOutput', url?: string | null, size?: number | null, fileName?: string | null, fileId?: string | null, contentType?: string | null, creation?: string | null } | null, statusHistory: Array<{ __typename?: 'TestKitStatusHistoryEntry', datetime: string, status: Hasura_Dnavisit_Test_Statuses_Enum }> }> | null, encounterNotes?: { __typename?: 'FHIREncounterNotesOutput', followupRecommendations: string, lastUpdated: string, providerNotes: string, providerSummary: string, systemGenerated: string, transcription: string, files?: Array<{ __typename?: 'EncounterFileOutput', contentType?: ContentType | null, fileId?: string | null, size?: number | null, title?: string | null, url?: string | null }> | null } | null, events?: Array<{ __typename?: 'AppointmentEvent', author: Appointment_Event_Source, date: string, event: Appointment_Event, fhirId: string }> | null, media?: Array<{ __typename?: 'GetAppointmentMediaOutput', bodySite?: string | null, description?: string | null, fileId?: string | null, fhirId: string, url?: string | null }> | null, participant: Array<{ __typename?: 'ReferenceType', reference?: string | null, type?: string | null }>, paymentInformation?: { __typename?: 'AppointmentPaymentOutput', amount?: number | null, status?: number | null, discount?: { __typename?: 'DiscountOutput', amountOff?: number | null, percentOff?: number | null } | null } | null, recommendations?: Array<{ __typename?: 'GetFHIRRecommendationOutput', createdAt: string, id: string, imageUrl?: string | null, productId: number, productTitle: string, providerName: string, providerCodexId: string, quantity: number, status: ServiceRequestStatus, totalPrice: number }> | null, provider?: { __typename?: 'ProviderOutput', SENSITIVE_firstname: string, SENSITIVE_lastname: string } | null, supportingInformation?: Array<{ __typename?: 'ReferenceType', reference?: string | null, type?: string | null }> | null } | null } };

export type GetProviderAppointmentByCodexAppointmentIdQueryVariables = Exact<{
  appointmentCodexId: Scalars['String'];
}>;


export type GetProviderAppointmentByCodexAppointmentIdQuery = { __typename?: 'Query', getFHIRAppointmentByCodexId: { __typename?: 'GetFHIRAppointmentOutput', appointment?: { __typename?: 'GetAppointmentOutput', summaryPdfFileId?: string | null, acuityId?: string | null, appointmentCodexId: string, appointmentId: string, appointmentStatus?: number | null, appointmentType?: AppointmentTypeEnum | null, appointmentUrl?: string | null, cancelationReason?: string | null, codexPatientId: string, codexProviderId?: string | null, created: string, encounterId?: string | null, end?: string | null, isSummaryCompleted: boolean, lastProcessedDate: string, lastUpdate?: string | null, patientFirstName?: string | null, patientLastName?: string | null, providerFirstName?: string | null, providerLastName?: string | null, start?: string | null, status: string, subjectOfAppointment?: string | null, symptomsLocation?: Array<string> | null, appointmentNotes?: { __typename?: 'FHIRAppointmentNotesObservationOutput', anythingElseQuestion?: string | null, howLongQuestion?: string | null, practitionerNotes?: string | null, severityQuestion?: string | null, symptomsTypes?: Array<string> | null } | null, statusHistory: Array<{ __typename?: 'AppointmentStatusHistoryEntry', datetime: string, status: AppointmentStatusHistoryEnum }>, pendingRescheduleRequest?: { __typename?: 'AppointmentRequestOutput', appointmentCodexId?: string | null, createdAt: string, reason: string, type: AppointmentRequestType, id: string, proposedDate: string } | null, diagnosticReports?: Array<{ __typename?: 'GetFHIRAppointmentDiagnosticReportOutput', createdAt?: string | null, diagnosticReportId: string, diagnosticReportStatus: Hasura_Dnavisit_Test_Statuses_Enum, diagnosticReportTestType: Hasura_Test_Types_Enum, swabCode: string, providerPdfId?: string | null, statusHistory: Array<{ __typename?: 'TestKitStatusHistoryEntry', datetime: string, status: Hasura_Dnavisit_Test_Statuses_Enum }>, providerPdf?: { __typename?: 'FileOutput', contentType?: string | null, fileId?: string | null, fileName?: string | null, size?: number | null, url?: string | null, creation?: string | null } | null }> | null, encounterNotes?: { __typename?: 'FHIREncounterNotesOutput', followupRecommendations: string, lastUpdated: string, providerNotes: string, providerSummary: string, systemGenerated: string, transcription: string, files?: Array<{ __typename?: 'EncounterFileOutput', contentType?: ContentType | null, fileId?: string | null, size?: number | null, title?: string | null, url?: string | null }> | null } | null, events?: Array<{ __typename?: 'AppointmentEvent', author: Appointment_Event_Source, date: string, event: Appointment_Event, fhirId: string }> | null, media?: Array<{ __typename?: 'GetAppointmentMediaOutput', bodySite?: string | null, description?: string | null, fileId?: string | null, fhirId: string, url?: string | null }> | null, participant: Array<{ __typename?: 'ReferenceType', reference?: string | null, type?: string | null }>, paymentInformation?: { __typename?: 'AppointmentPaymentOutput', amount?: number | null, status?: number | null, discount?: { __typename?: 'DiscountOutput', amountOff?: number | null, percentOff?: number | null } | null } | null, recommendations?: Array<{ __typename?: 'GetFHIRRecommendationOutput', createdAt: string, id: string, imageUrl?: string | null, productId: number, productTitle: string, providerName: string, providerCodexId: string, quantity: number, status: ServiceRequestStatus, totalPrice: number }> | null, supportingInformation?: Array<{ __typename?: 'ReferenceType', reference?: string | null, type?: string | null }> | null } | null } };

export type GetAppointmentsByProviderQueryVariables = Exact<{
  appointmentStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  find?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tzOffset?: InputMaybe<Scalars['Float']>;
  dayFilter?: InputMaybe<Scalars['String']>;
  patientName?: InputMaybe<Scalars['String']>;
}>;


export type GetAppointmentsByProviderQuery = { __typename?: 'Query', getFHIRAppointmentByRequestProviderId: { __typename?: 'GetFHIRAppointmentsOutputWithUpcomingCounts', total: number, appointment: Array<{ __typename?: 'GetAppointmentOutput', appointmentCodexId: string, appointmentType?: AppointmentTypeEnum | null, start?: string | null, end?: string | null, status: string, isSummaryCompleted: boolean, codexPatientId: string, codexProviderId?: string | null, subjectOfAppointment?: string | null, patientLastName?: string | null, patientFirstName?: string | null, providerFirstName?: string | null, providerLastName?: string | null, appointmentStatus?: number | null, diagnosticReports?: Array<{ __typename?: 'GetFHIRAppointmentDiagnosticReportOutput', providerPdfId?: string | null, swabCode: string, diagnosticReportId: string, diagnosticReportStatus: Hasura_Dnavisit_Test_Statuses_Enum, diagnosticReportTestType: Hasura_Test_Types_Enum, providerPdf?: { __typename?: 'FileOutput', contentType?: string | null, fileId?: string | null, fileName?: string | null, size?: number | null, url?: string | null } | null, statusHistory: Array<{ __typename?: 'TestKitStatusHistoryEntry', datetime: string, status: Hasura_Dnavisit_Test_Statuses_Enum }> }> | null, pendingRescheduleRequest?: { __typename?: 'AppointmentRequestOutput', proposedDate: string, reason: string, id: string } | null, paymentInformation?: { __typename?: 'AppointmentPaymentOutput', amount?: number | null, status?: number | null } | null, encounterNotes?: { __typename?: 'FHIREncounterNotesOutput', followupRecommendations: string, providerSummary: string } | null, media?: Array<{ __typename?: 'GetAppointmentMediaOutput', url?: string | null, fileId?: string | null }> | null, events?: Array<{ __typename?: 'AppointmentEvent', event: Appointment_Event, date: string, author: Appointment_Event_Source }> | null }>, counts: { __typename?: 'UpcomingAppointmentCounts', today: number, tomorrow: number, week: number, month: number } } };

export type GetAppointmentsByPatientIdQueryVariables = Exact<{
  appointmentStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  patientCodexId: Scalars['String'];
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tzOffset?: InputMaybe<Scalars['Float']>;
  dayFilter?: InputMaybe<Scalars['String']>;
  isSummaryCompleted?: InputMaybe<Scalars['Boolean']>;
  withOtherProviders?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAppointmentsByPatientIdQuery = { __typename?: 'Query', getFHIRPatientAppointmentsByProvider: { __typename?: 'GetFHIRAppointmentsOutputWithUpcomingCounts', total: number, appointment: Array<{ __typename?: 'GetAppointmentOutput', appointmentCodexId: string, appointmentType?: AppointmentTypeEnum | null, start?: string | null, end?: string | null, status: string, codexPatientId: string, codexProviderId?: string | null, subjectOfAppointment?: string | null, patientLastName?: string | null, patientFirstName?: string | null, providerFirstName?: string | null, providerLastName?: string | null, appointmentStatus?: number | null, paymentInformation?: { __typename?: 'AppointmentPaymentOutput', amount?: number | null, status?: number | null } | null, encounterNotes?: { __typename?: 'FHIREncounterNotesOutput', followupRecommendations: string, providerSummary: string } | null, media?: Array<{ __typename?: 'GetAppointmentMediaOutput', url?: string | null, fileId?: string | null }> | null, events?: Array<{ __typename?: 'AppointmentEvent', event: Appointment_Event, date: string, author: Appointment_Event_Source }> | null }>, counts: { __typename?: 'UpcomingAppointmentCounts', today: number, tomorrow: number, week: number, month: number } } };

export type GetPatientAppointmentByCodexAppointmentIdQueryVariables = Exact<{
  appointmentCodexId: Scalars['String'];
}>;


export type GetPatientAppointmentByCodexAppointmentIdQuery = { __typename?: 'Query', getFHIRAppointmentByCodexId: { __typename?: 'GetFHIRAppointmentOutput', appointment?: { __typename?: 'GetAppointmentOutput', summaryPdfFileId?: string | null, acuityId?: string | null, appointmentCodexId: string, appointmentId: string, appointmentStatus?: number | null, appointmentType?: AppointmentTypeEnum | null, appointmentUrl?: string | null, cancelationReason?: string | null, codexPatientId: string, codexProviderId?: string | null, created: string, encounterId?: string | null, end?: string | null, isSummaryCompleted: boolean, lastProcessedDate: string, lastUpdate?: string | null, patientFirstName?: string | null, patientLastName?: string | null, providerFirstName?: string | null, providerLastName?: string | null, start?: string | null, status: string, subjectOfAppointment?: string | null, symptomsLocation?: Array<string> | null, appointmentNotes?: { __typename?: 'FHIRAppointmentNotesObservationOutput', anythingElseQuestion?: string | null, howLongQuestion?: string | null, practitionerNotes?: string | null, severityQuestion?: string | null, symptomsTypes?: Array<string> | null } | null, diagnosticReports?: Array<{ __typename?: 'GetFHIRAppointmentDiagnosticReportOutput', diagnosticReportId: string, diagnosticReportStatus: Hasura_Dnavisit_Test_Statuses_Enum, diagnosticReportTestType: Hasura_Test_Types_Enum, swabCode: string, patientPdfId?: string | null, providerPdfId?: string | null, patientPdf?: { __typename?: 'FileOutput', contentType?: string | null, fileId?: string | null, fileName?: string | null, url?: string | null, size?: number | null } | null, providerPdf?: { __typename?: 'FileOutput', contentType?: string | null, fileId?: string | null, fileName?: string | null, size?: number | null, url?: string | null } | null }> | null, encounterNotes?: { __typename?: 'FHIREncounterNotesOutput', followupRecommendations: string, lastUpdated: string, providerNotes: string, providerSummary: string, systemGenerated: string, transcription: string, files?: Array<{ __typename?: 'EncounterFileOutput', contentType?: ContentType | null, fileId?: string | null, size?: number | null, title?: string | null, url?: string | null }> | null } | null, events?: Array<{ __typename?: 'AppointmentEvent', author: Appointment_Event_Source, date: string, event: Appointment_Event, fhirId: string }> | null, media?: Array<{ __typename?: 'GetAppointmentMediaOutput', bodySite?: string | null, description?: string | null, fileId?: string | null, fhirId: string, url?: string | null }> | null, participant: Array<{ __typename?: 'ReferenceType', reference?: string | null, type?: string | null }>, paymentInformation?: { __typename?: 'AppointmentPaymentOutput', amount?: number | null, status?: number | null, discount?: { __typename?: 'DiscountOutput', amountOff?: number | null, percentOff?: number | null } | null } | null, recommendations?: Array<{ __typename?: 'GetFHIRRecommendationOutput', createdAt: string, id: string, imageUrl?: string | null, productId: number, productTitle: string, providerName: string, providerCodexId: string, quantity: number, status: ServiceRequestStatus, totalPrice: number }> | null, supportingInformation?: Array<{ __typename?: 'ReferenceType', reference?: string | null, type?: string | null }> | null } | null } };

export type GetHistoricAppointmentCountQueryVariables = Exact<{
  from?: InputMaybe<Scalars['String']>;
  appointmentStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetHistoricAppointmentCountQuery = { __typename?: 'Query', getFHIRAppointmentByRequestPatientCodexId: { __typename?: 'GetFHIRAppointmentsOutputWithUpcomingCounts', total: number } };

export type GetHistoricAppointmentCountByProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHistoricAppointmentCountByProviderQuery = { __typename?: 'Query', getFHIRAppointmentByRequestProviderId: { __typename?: 'GetFHIRAppointmentsOutputWithUpcomingCounts', total: number } };

export type GetAppointmentRescheduleLinkQueryVariables = Exact<{
  appointmentCodexId: Scalars['String'];
}>;


export type GetAppointmentRescheduleLinkQuery = { __typename?: 'Query', getAppointmentRescheduleLink: { __typename?: 'GetAppointmentRescheduleLinkOutput', rescheduleLink?: string | null } };

export type GetAppointmentPaymentLinkQueryVariables = Exact<{
  appointmentCodexId: Scalars['String'];
}>;


export type GetAppointmentPaymentLinkQuery = { __typename?: 'Query', getAppointmentRetryPaymentLink: { __typename?: 'GetPaymentLinkOutput', link: string } };

export type GetFhirEncountersByProviderQueryVariables = Exact<{
  status?: InputMaybe<EncounterStatuses>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetFhirEncountersByProviderQuery = { __typename?: 'Query', getFHIREncountersByProvider: { __typename?: 'EncounterListOutput', total: number, encounters: Array<{ __typename?: 'EncounterOutput', appointmentCodexId?: string | null, appointmentDate?: string | null, class?: string | null, encounterId: string, patientCodexId?: string | null, patientFirstName?: string | null, patientLastName?: string | null, providerCodexId?: string | null, providerFirstName?: string | null, providerLastName?: string | null, status: string, type?: string | null }> } };

export type UpdateSummaryNotificationStateQueryVariables = Exact<{
  appointmentCodexId: Scalars['String'];
  summaryNotification: Scalars['Boolean'];
}>;


export type UpdateSummaryNotificationStateQuery = { __typename?: 'Query', updateAppointmentSummaryNotificationState: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type GetProviderAppointmentRequestsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetProviderAppointmentRequestsQuery = { __typename?: 'Query', getProviderAppointmentRequests: { __typename?: 'AppointmentRequestsOutput', total: number, requests: Array<{ __typename?: 'AppointmentRequestOutput', appointmentCodexId?: string | null, appointmentTypeId?: number | null, approvedDate?: string | null, createdAt: string, currentDate?: string | null, id: string, proposedDate: string, providerCodexId: string, reason: string, status: AppointmentRequestStatus, type: AppointmentRequestType, updatedAt: string, patient?: { __typename?: 'GetPatientOutput', id: string, SENSITIVE_email?: string | null, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null } | null }> } };

export type GetAppointmentSummaryQueryVariables = Exact<{
  appointmentCodexId: Scalars['String'];
}>;


export type GetAppointmentSummaryQuery = { __typename?: 'Query', getAppointmentSummary: { __typename?: 'VonageSummaryOutput', summaryPdfFileId?: string | null, summary?: string | null, transcription?: string | null } };

export type GetFhirDnaVisitTestsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum> | Hasura_Test_Types_Enum>;
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum> | Hasura_Dnavisit_Test_Statuses_Enum>;
}>;


export type GetFhirDnaVisitTestsQuery = { __typename?: 'Query', getFHIRDnaVisitTests: { __typename?: 'GetFHIRDnaVisitTests', total: number, dnavisit_tests: Array<{ __typename?: 'DnaVisitTestOutput', test_id: string, created_at: string, test_type: Hasura_Test_Types_Enum, sapphiros_barcode: string, provider_name?: string | null, state: Hasura_Dnavisit_Test_Statuses_Enum, tracking_number?: string | null, visit_summary_pdf_id?: string | null, patient_pdf_id?: string | null }> } };

export type GetFhirDnaVisitAndZrtTestsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum> | Hasura_Test_Types_Enum>;
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum> | Hasura_Dnavisit_Test_Statuses_Enum>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  providerName?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  orderBy?: InputMaybe<DiagnosticReportOrderByInput>;
  find?: InputMaybe<Scalars['String']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetFhirDnaVisitAndZrtTestsQuery = { __typename?: 'Query', getFHIRDnaAndZrtTests: { __typename?: 'GetFHIRDnaAndZrtTests', total: number, dna_tests: Array<{ __typename?: 'RankedDnaVisitTestOutput', diagnosticReportId: string, test_id: string, created_at: string, test_type: Hasura_Test_Types_Enum, rank: number, sapphiros_barcode: string, provider_name?: string | null, state: Hasura_Dnavisit_Test_Statuses_Enum, patient_pdf_id?: string | null, updated_at: string, provider_acuity_owner_id?: string | null, provider_acuity_calendar_id?: string | null, provider_codex_id?: string | null, visit_summary_pdf_id?: string | null, tracking_number?: string | null, statusHistory: Array<{ __typename?: 'TestKitStatusHistoryEntry', datetime: string, status: Hasura_Dnavisit_Test_Statuses_Enum }> }>, zrt_tests: Array<{ __typename?: 'RankedZrtTestOutput', appointment_codex_id?: string | null, fhirId: string, reference_code: string, created_at: string, test_type: Hasura_Test_Types_Enum, rank: number, swab_code: string, provider_name?: string | null, state: Hasura_Dnavisit_Test_Statuses_Enum, patient_pdf_id?: string | null, updated_at: string, provider_acuity_owner_id?: string | null, provider_acuity_calendar_id?: string | null, provider_codex_id?: string | null, tracking_number?: string | null, questionnaire_required?: boolean | null, statusHistory: Array<{ __typename?: 'TestKitStatusHistoryEntry', datetime: string, status: Hasura_Dnavisit_Test_Statuses_Enum }> }>, mosaic_tests: Array<{ __typename?: 'RankedMosaicVisitTestOutput', appointment_codex_id?: string | null, created_at: string, fhirId: string, patient_fhir_id?: string | null, patient_pdf_id?: string | null, provider_acuity_calendar_id?: string | null, provider_acuity_owner_id?: string | null, provider_codex_id?: string | null, provider_fhir_id?: string | null, provider_name?: string | null, rank: number, state?: Hasura_Dnavisit_Test_Statuses_Enum | null, swab_code?: string | null, test_id?: string | null, test_type: Hasura_Test_Types_Enum, tracking_number?: string | null, updated_at: string, statusHistory: Array<{ __typename?: 'TestKitStatusHistoryEntry', datetime: string, status: Hasura_Dnavisit_Test_Statuses_Enum }> }>, diagnostic_solution_tests: Array<{ __typename?: 'RankedDiagnosticSolutionVisitTestOutput', appointment_codex_id?: string | null, created_at: string, fhirId: string, patient_fhir_id?: string | null, patient_pdf_id?: string | null, provider_acuity_calendar_id?: string | null, provider_acuity_owner_id?: string | null, provider_codex_id?: string | null, provider_fhir_id?: string | null, provider_name?: string | null, rank: number, state?: Hasura_Dnavisit_Test_Statuses_Enum | null, swab_code?: string | null, test_id?: string | null, test_type: Hasura_Test_Types_Enum, tracking_number?: string | null, updated_at: string, questionnaire_required?: boolean | null, statusHistory: Array<{ __typename?: 'TestKitStatusHistoryEntry', datetime: string, status: Hasura_Dnavisit_Test_Statuses_Enum }> }> } };

export type GetFhirMyPatientTestsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum> | Hasura_Test_Types_Enum>;
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum> | Hasura_Dnavisit_Test_Statuses_Enum>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  providerName?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  orderBy?: InputMaybe<DiagnosticReportOrderByInput>;
  find?: InputMaybe<Scalars['String']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetFhirMyPatientTestsQuery = { __typename?: 'Query', getFHIRDnaAndZrtTests: { __typename?: 'GetFHIRDnaAndZrtTests', total: number, dna_tests: Array<{ __typename?: 'RankedDnaVisitTestOutput', diagnosticReportId: string, visit_summary_pdf_id?: string | null, test_id: string, created_at: string, test_type: Hasura_Test_Types_Enum, rank: number, sapphiros_barcode: string, provider_name?: string | null, state: Hasura_Dnavisit_Test_Statuses_Enum, updated_at: string, provider_acuity_owner_id?: string | null, provider_acuity_calendar_id?: string | null, provider_report_pdf_id?: string | null, provider_codex_id?: string | null, questionnaire_required?: boolean | null }>, zrt_tests: Array<{ __typename?: 'RankedZrtTestOutput', appointment_codex_id?: string | null, fhirId: string, reference_code: string, created_at: string, test_type: Hasura_Test_Types_Enum, rank: number, swab_code: string, provider_name?: string | null, state: Hasura_Dnavisit_Test_Statuses_Enum, provider_report_pdf_id?: string | null, updated_at: string, provider_acuity_owner_id?: string | null, provider_acuity_calendar_id?: string | null, provider_codex_id?: string | null, questionnaire_required?: boolean | null }>, mosaic_tests: Array<{ __typename?: 'RankedMosaicVisitTestOutput', appointment_codex_id?: string | null, created_at: string, fhirId: string, patient_fhir_id?: string | null, provider_acuity_calendar_id?: string | null, provider_acuity_owner_id?: string | null, provider_codex_id?: string | null, provider_fhir_id?: string | null, provider_name?: string | null, provider_report_pdf_id?: string | null, questionnaire_required?: boolean | null, rank: number, state?: Hasura_Dnavisit_Test_Statuses_Enum | null, swab_code?: string | null, test_id?: string | null, test_type: Hasura_Test_Types_Enum, tracking_number?: string | null, updated_at: string }>, diagnostic_solution_tests: Array<{ __typename?: 'RankedDiagnosticSolutionVisitTestOutput', appointment_codex_id?: string | null, created_at: string, fhirId: string, patient_fhir_id?: string | null, provider_acuity_calendar_id?: string | null, provider_acuity_owner_id?: string | null, provider_codex_id?: string | null, provider_fhir_id?: string | null, provider_name?: string | null, provider_report_pdf_id?: string | null, rank: number, state?: Hasura_Dnavisit_Test_Statuses_Enum | null, swab_code?: string | null, test_id?: string | null, test_type: Hasura_Test_Types_Enum, tracking_number?: string | null, updated_at: string, questionnaire_required?: boolean | null }> } };

export type GetFhirDnaVisitTestsByUserIdQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  providerName?: InputMaybe<Scalars['String']>;
  find?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  codexPatientId: Scalars['String'];
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum> | Hasura_Test_Types_Enum>;
  orderBy?: InputMaybe<DnaVisitOrderByInput>;
}>;


export type GetFhirDnaVisitTestsByUserIdQuery = { __typename?: 'Query', getFHIRDnaVisitTestsByUserId: { __typename?: 'GetFHIRDnaVisitTestsByUserId', total: number, providers: Array<string>, dnavisit_tests: Array<{ __typename?: 'DnaVisitTestOutput', test_id: string, created_at: string, test_type: Hasura_Test_Types_Enum, sapphiros_barcode: string, provider_name?: string | null, state: Hasura_Dnavisit_Test_Statuses_Enum, tracking_number?: string | null, visit_summary_pdf_id?: string | null, patient_pdf_id?: string | null }> } };

export type GetActiveRecommendationsByPatientCodexIdQueryVariables = Exact<{
  codexPatientId: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<GetFhirRecommendationsOrderByInput>;
}>;


export type GetActiveRecommendationsByPatientCodexIdQuery = { __typename?: 'Query', getActiveRecommendationsByPatientCodexId: { __typename?: 'GetFHIRRecommendationsOutput', total: number, recommendations: Array<{ __typename?: 'GetFHIRRecommendationOutput', createdAt: string, id: string, productTitle: string, providerName: string, quantity: number }> } };

export type LinkFullscriptProviderAccountMutationVariables = Exact<{
  tokenCode: Scalars['String'];
}>;


export type LinkFullscriptProviderAccountMutation = { __typename?: 'Mutation', linkProviderAccount: { __typename?: 'FullscriptOperationResult', success: boolean } };

export type OnTreatmentPlanActivatedMutationVariables = Exact<{
  patientCodexId: Scalars['String'];
  treatmentPlanId: Scalars['String'];
  appointmentCodexId?: InputMaybe<Scalars['String']>;
}>;


export type OnTreatmentPlanActivatedMutation = { __typename?: 'Mutation', onTreatmentPlanActivated: { __typename?: 'FullscriptOperationResult', success: boolean } };

export type FullscriptDependentMapMutationVariables = Exact<{
  childCodexId: Scalars['String'];
  fullscriptPatientId: Scalars['String'];
}>;


export type FullscriptDependentMapMutation = { __typename?: 'Mutation', fullscriptDependentMap: { __typename?: 'FullscriptOperationResult', message?: string | null, success: boolean } };

export type UnlinkProviderFullscriptAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type UnlinkProviderFullscriptAccountMutation = { __typename?: 'Mutation', unlinkFullscript: { __typename?: 'PatchFHIRProviderOutput', update_providers_one: { __typename?: 'ProviderOutput', id: string, fullscriptId?: string | null } } };

export type GetFullscriptSessionGrantQueryVariables = Exact<{
  patientCodexId: Scalars['String'];
}>;


export type GetFullscriptSessionGrantQuery = { __typename?: 'Query', getSessionGrant: { __typename?: 'FullscriptSessionGrantResult', sessionGrant: string, patientFullscriptId: string } };

export type FullscriptDependentCreateLinkQueryVariables = Exact<{
  childCodexId: Scalars['String'];
}>;


export type FullscriptDependentCreateLinkQuery = { __typename?: 'Query', fullscriptDependentCreateLink: { __typename?: 'DependentLinkOutput', childFullscriptId: string, guardianFullscriptId: string } };

export type GetAllFullscriptAllergensQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetAllFullscriptAllergensQuery = { __typename?: 'Query', getFullscriptAllergens: { __typename?: 'FullscriptAllergensOutput', total: number, fullscript_allergens: Array<{ __typename?: 'FullscriptAllergenOutput', created_at: string, fullscript_id: string, fullscript_name: string, id: number, updated_at: string }> } };

export type GetFullscriptAllergensByPatientHealthQuestionnaireQueryVariables = Exact<{
  codexPatientId: Scalars['String'];
  identifier: Scalars['String'];
  system: Scalars['String'];
}>;


export type GetFullscriptAllergensByPatientHealthQuestionnaireQuery = { __typename?: 'Query', getFullscriptAllergensFromQuestionnaireResponse: { __typename?: 'FullscriptAllergensOutput', total: number, fullscript_allergens: Array<{ __typename?: 'FullscriptAllergenOutput', created_at: string, fullscript_id: string, fullscript_name: string, id: number, updated_at: string }> } };

export type GetFhirPatientMediaQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Float']>;
}>;


export type GetFhirPatientMediaQuery = { __typename?: 'Query', getFHIRMediaByRequestPatientCodexID: { __typename?: 'getFHIRPatientMediaOutput', total: number, media: Array<{ __typename?: 'MediaOutput', id: string, fileId: string, description?: string | null, bodySite?: { __typename?: 'CodeableConcept', coding?: Array<{ __typename?: 'Coding', code?: string | null }> | null } | null, content: { __typename?: 'Attachment', url?: string | null }, meta: { __typename?: 'Meta', lastUpdated: string }, identifier?: Array<{ __typename?: 'Identifier', value?: string | null, type?: { __typename?: 'CodeableConcept', text?: string | null } | null }> | null }> } };

export type GetFhirPatientbyMediaCodexIdParameterQueryVariables = Exact<{
  patientCodexId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Float']>;
}>;


export type GetFhirPatientbyMediaCodexIdParameterQuery = { __typename?: 'Query', getFHIRPatientbyMediaCodexIDParameter: { __typename?: 'getFHIRPatientMediaOutput', patientCodexId: string, total: number, media: Array<{ __typename?: 'MediaOutput', id: string, fileId: string, description?: string | null, bodySite?: { __typename?: 'CodeableConcept', coding?: Array<{ __typename?: 'Coding', code?: string | null }> | null } | null, content: { __typename?: 'Attachment', url?: string | null }, meta: { __typename?: 'Meta', lastUpdated: string }, identifier?: Array<{ __typename?: 'Identifier', value?: string | null, type?: { __typename?: 'CodeableConcept', text?: string | null } | null }> | null }> } };

export type GetFhirMedicationRequestListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Float']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  find?: InputMaybe<Scalars['String']>;
  brandAndName?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  patientCodexId: Scalars['String'];
  encounterId?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Array<MedicationRequestSource> | MedicationRequestSource>;
  includeSubPatients?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetFhirMedicationRequestListQuery = { __typename?: 'Query', getFHIRMedicationRequestByPatientCodexId: { __typename?: 'GetMedicationRequestsOutput', total: number, medication_requests: Array<{ __typename?: 'MedicationRequestOutputDto', pharmacyName?: string | null, frequency?: string | null, appointmentCodexId?: string | null, brandName?: string | null, daysSupply?: number | null, delivery?: string | null, directions?: string | null, displayName: string, dosage?: string | null, effectiveDate?: string | null, fullScriptVariantId?: string | null, fullScriptVariantSKU?: string | null, isOTC: boolean, mediSpanClassification?: string | null, mediSpanId?: string | null, ndc?: string | null, note?: string | null, duration?: string | null, productNotes?: string | null, takeWith?: string | null, numberOfRepeatsAllowed?: number | null, patientCodexId: string, prescriptionFhirId: string, prescriptionFullScriptId?: string | null, providerCodexId?: string | null, providerFullName?: string | null, requestedAt?: string | null, rxcui?: string | null, status: MedicationRequestStatusEnum, substitutionAllowed?: boolean | null, type?: string | null, patientInfo: { __typename?: 'MedicationPatientInfoOutput', firstName: string, id: string, isChild: boolean, lastName: string }, quantity?: { __typename?: 'ValueOutput', unit?: string | null, value?: number | null } | null, initialFill?: { __typename?: 'InitialFillOutput', duration?: { __typename?: 'ValueOutput', unit?: string | null, value?: number | null } | null, quantity?: { __typename?: 'ValueOutput', unit?: string | null, value?: number | null } | null } | null, expectedSupplyDuration?: { __typename?: 'ValueOutput', unit?: string | null, value?: number | null } | null }> } };

export type GetTotalFhirMedicationRequestListQueryVariables = Exact<{
  patientCodexId: Scalars['String'];
}>;


export type GetTotalFhirMedicationRequestListQuery = { __typename?: 'Query', getFHIRMedicationRequestByPatientCodexId: { __typename?: 'GetMedicationRequestsOutput', total: number } };

export type GetFhirMedicationRequestBranAndNamesByPatientCodexIdQueryVariables = Exact<{
  patientCodexId?: InputMaybe<Scalars['String']>;
}>;


export type GetFhirMedicationRequestBranAndNamesByPatientCodexIdQuery = { __typename?: 'Query', getFHIRMedicationRequestBranAndNamesByPatientCodexId: { __typename?: 'GetMedicationRequestsBrandAndNameOutput', medication_request_bran_and_names: Array<string> } };

export type GetMedicationByProfileTabPatientCodexIdQueryVariables = Exact<{
  patientCodexId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  includeSubPatients?: InputMaybe<Scalars['Boolean']>;
  offset: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetMedicationByProfileTabPatientCodexIdQuery = { __typename?: 'Query', getFHIRMedicationRequestByPatientCodexId: { __typename?: 'GetMedicationRequestsOutput', total: number, medication_requests: Array<{ __typename?: 'MedicationRequestOutputDto', note?: string | null, dosage?: string | null, ndc?: string | null, rxcui?: string | null, displayName: string, activeIngredUnit?: string | null, appointmentCodexId?: string | null, providerCodexId?: string | null, prescriptionFhirId: string, pharmacyAddress?: string | null, providerFullName?: string | null, effectiveDate?: string | null, daysSupply?: number | null, activeNumeratorStrength?: string | null, requestedAt?: string | null, patientInfo: { __typename?: 'MedicationPatientInfoOutput', id: string, firstName: string, isChild: boolean, lastName: string }, quantity?: { __typename?: 'ValueOutput', unit?: string | null, value?: number | null } | null, expectedSupplyDuration?: { __typename?: 'ValueOutput', unit?: string | null, value?: number | null } | null }> } };

export type GetMedicationByHealthQuestionnairePatientCodexIdQueryVariables = Exact<{
  patientCodexId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetMedicationByHealthQuestionnairePatientCodexIdQuery = { __typename?: 'Query', getFHIRMedicationRequestByPatientCodexId: { __typename?: 'GetMedicationRequestsOutput', medication_requests: Array<{ __typename?: 'MedicationRequestOutputDto', note?: string | null, frequency?: string | null, dosage?: string | null, duration?: string | null, ndc?: string | null, displayName: string, requestedAt?: string | null, effectiveDate?: string | null, endDate?: string | null, patientInfo: { __typename?: 'MedicationPatientInfoOutput', firstName: string, isChild: boolean, lastName: string, id: string } }> } };

export type GetAllergenClassesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetAllergenClassesQuery = { __typename?: 'Query', getAllergenClasses: { __typename?: 'AllergenClassesOutput', allergenClasses: Array<{ __typename?: 'AllergenClassOutput', classId: string, className: string }> } };

export type PatchFhirPatientPersonalDataMutationVariables = Exact<{
  patientPersonalInfo: PatchFhirPatientPersonalInfoInput;
}>;


export type PatchFhirPatientPersonalDataMutation = { __typename?: 'Mutation', patchFHIRPatientPersonalData: { __typename?: 'PatchFHIRPatientOutput', update_patients_one: { __typename?: 'CreatePatientOutput', SENSITIVE_dob?: string | null, SENSITIVE_etnicity?: Array<string> | null, SENSITIVE_email: string, SENSITIVE_country?: string | null, id: string, SENSITIVE_self_identity_gender?: string | null, SENSITIVE_gender_describe?: string | null, SENSITIVE_phone?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_gender?: string | null, SENSITIVE_firstname?: string | null, SENSITIVE_profile_picture_id?: string | null, SENSITIVE_address_information?: { __typename?: 'AddressInformationOutput', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, state?: string | null, province?: string | null, zipCode?: string | null, phone?: string | null, phoneCountry?: string | null } | null, SENSITIVE_user_measurements?: { __typename?: 'PatientMeasurementsOutput', weight?: number | null, heightFt?: number | null, heightIn?: number | null } | null, SENSITIVE_pharmacies?: Array<{ __typename?: 'PharmacyInformationOutput', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, isDefault: boolean, name?: string | null, phone: string, state?: string | null, zipCode?: string | null }> | null } } };

export type GetFhirPatientbyCodexIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFhirPatientbyCodexIdQuery = { __typename?: 'Query', getFHIRPatientbyCodexID: { __typename?: 'getFHIRPatientOutput', users: Array<{ __typename?: 'GetPatientOutput', SENSITIVE_dob?: string | null, SENSITIVE_etnicity?: Array<string> | null, SENSITIVE_email?: string | null, SENSITIVE_country?: string | null, child_fully_verified?: boolean | null, is_state_dob_valid: boolean, id: string, updated_at: string, created_at: string, minor_autonomy_evidence: Array<MinorAutonomyEvidenceTypes>, measurementsLastUpdatedAt?: string | null, autonomy_determination_status?: AutonomyDeterminationStatus | null, SENSITIVE_self_identity_gender?: string | null, SENSITIVE_gender_describe?: string | null, SENSITIVE_profile_picture_id?: string | null, SENSITIVE_phone?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_gender?: string | null, SENSITIVE_firstname?: string | null, parentCodexId?: string | null, SENSITIVE_address_information?: { __typename?: 'AddressInformationOutput', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, state?: string | null, province?: string | null, zipCode?: string | null, phone?: string | null, phoneCountry?: string | null } | null, SENSITIVE_user_measurements?: { __typename?: 'PatientMeasurementsOutput', weight?: number | null, heightFt?: number | null, heightIn?: number | null, hips?: number | null, waist?: number | null } | null, SENSITIVE_pharmacies?: Array<{ __typename?: 'PharmacyInformationOutput', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, isDefault: boolean, name?: string | null, phone: string, state?: string | null, zipCode?: string | null }> | null }> } };

export type GetCombinedPatientDetailsQueryVariables = Exact<{
  patientCodexId: Scalars['String'];
  skipProviderDetails: Scalars['Boolean'];
}>;


export type GetCombinedPatientDetailsQuery = { __typename?: 'Query', getFHIRPatientbyCodexID?: { __typename?: 'getFHIRPatientOutput', users: Array<{ __typename?: 'GetPatientOutput', SENSITIVE_dob?: string | null, SENSITIVE_etnicity?: Array<string> | null, SENSITIVE_email?: string | null, SENSITIVE_country?: string | null, child_fully_verified?: boolean | null, is_state_dob_valid: boolean, id: string, updated_at: string, created_at: string, minor_autonomy_evidence: Array<MinorAutonomyEvidenceTypes>, measurementsLastUpdatedAt?: string | null, autonomy_determination_status?: AutonomyDeterminationStatus | null, SENSITIVE_self_identity_gender?: string | null, SENSITIVE_gender_describe?: string | null, SENSITIVE_profile_picture_id?: string | null, SENSITIVE_phone?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_gender?: string | null, SENSITIVE_firstname?: string | null, parentCodexId?: string | null, SENSITIVE_address_information?: { __typename?: 'AddressInformationOutput', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, state?: string | null, province?: string | null, zipCode?: string | null, phone?: string | null, phoneCountry?: string | null } | null, SENSITIVE_user_measurements?: { __typename?: 'PatientMeasurementsOutput', weight?: number | null, heightFt?: number | null, heightIn?: number | null, hips?: number | null, waist?: number | null } | null, SENSITIVE_pharmacies?: Array<{ __typename?: 'PharmacyInformationOutput', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, isDefault: boolean, name?: string | null, phone: string, state?: string | null, zipCode?: string | null }> | null }> }, getFHIRPatientbyCodexIDParameter?: { __typename?: 'getFHIRPatientOutput', users: Array<{ __typename?: 'GetPatientOutput', SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_gender?: string | null, SENSITIVE_email?: string | null, SENSITIVE_self_identity_gender?: string | null, SENSITIVE_dob?: string | null, SENSITIVE_etnicity?: Array<string> | null, child_fully_verified?: boolean | null, SENSITIVE_profile_picture_id?: string | null, parentCodexId?: string | null, SENSITIVE_user_measurements?: { __typename?: 'PatientMeasurementsOutput', heightFt?: number | null, heightIn?: number | null, weight?: number | null, hips?: number | null, waist?: number | null } | null, SENSITIVE_pharmacies?: Array<{ __typename?: 'PharmacyInformationOutput', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, name?: string | null, province?: string | null, state?: string | null, phone: string, zipCode?: string | null, id: string, isDefault: boolean }> | null }> } };

export type GetFhirPatientbyEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetFhirPatientbyEmailQuery = { __typename?: 'Query', getFHIRPatientbyEmail: { __typename?: 'getFHIRPatientOutput', users: Array<{ __typename?: 'GetPatientOutput', id: string, child_fully_verified?: boolean | null, SENSITIVE_firstname?: string | null, SENSITIVE_country?: string | null, SENSITIVE_dob?: string | null, SENSITIVE_email?: string | null, SENSITIVE_etnicity?: Array<string> | null, SENSITIVE_gender?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_phone?: string | null, SENSITIVE_profile_picture_id?: string | null, SENSITIVE_self_identity_gender?: string | null, minor_autonomy_evidence: Array<MinorAutonomyEvidenceTypes>, measurementsLastUpdatedAt?: string | null, autonomy_determination_status?: AutonomyDeterminationStatus | null, parentCodexId?: string | null, SENSITIVE_user_measurements?: { __typename?: 'PatientMeasurementsOutput', heightFt?: number | null, heightIn?: number | null, weight?: number | null, hips?: number | null, waist?: number | null } | null, SENSITIVE_address_information?: { __typename?: 'AddressInformationOutput', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, state?: string | null, province?: string | null, zipCode?: string | null, phone?: string | null, phoneCountry?: string | null } | null, SENSITIVE_pharmacies?: Array<{ __typename?: 'PharmacyInformationOutput', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, isDefault: boolean, name?: string | null, phone: string, state?: string | null, zipCode?: string | null }> | null }> } };

export type GetProvidersByPatientIdQueryVariables = Exact<{
  patientCodexId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  appointmentTypeId?: InputMaybe<Scalars['Float']>;
  date?: InputMaybe<Scalars['String']>;
  onlyAvailable?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetProvidersByPatientIdQuery = { __typename?: 'Query', getProvidersByPatientId: { __typename?: 'GetFHIRProviderByIdOutput', total?: number | null, providers: Array<{ __typename?: 'ProviderOutput', id: string, SENSITIVE_firstname: string, SENSITIVE_lastname: string, SENSITIVE_profile_picture_id?: string | null, hide_contact_info?: boolean | null, hide_office_address?: boolean | null, acuityOwnerId?: string | null, acuityCalendarId?: string | null, subscriptionPeriodEnd?: string | null, subscriptionStatus?: CodexSubscriptionStatuses | null, SENSITIVE_credentials: { __typename?: 'ProviderCredentialsOutput', yearsOfPractice: string, certifications: Array<string>, medicalRole: string, titles: Array<string> }, serviceOfferings: Array<{ __typename?: 'ServiceOfferingsOutput', active: boolean, serviceType: ServiceType, price: string }>, patientRequests: Array<{ __typename?: 'PatientRequest', date: string, patientFhirId: string, requestStatus: ProviderRequestStatus }>, SENSITIVE_address_information?: { __typename?: 'AddressInformationOutput', address1?: string | null, city?: string | null, state?: string | null } | null, SENSITIVE_office_information?: { __typename?: 'OfficeAddressInformationOutput', address1?: string | null, city?: string | null, state?: string | null } | null }> } };

export type GetFhirProvidersQueryVariables = Exact<{
  speciality?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  providerCanSpeak?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  appointmentAccepted?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  medicalRole?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  serverOfferedRange?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortByDirections?: InputMaybe<Scalars['String']>;
  yearOfExpirienceRange?: InputMaybe<Scalars['String']>;
}>;


export type GetFhirProvidersQuery = { __typename?: 'Query', getFHIRProviders: { __typename?: 'GetFHIRProvidersOutput', total?: number | null, providers: Array<{ __typename?: 'ProviderOutput', id: string, SENSITIVE_firstname: string, SENSITIVE_lastname: string, SENSITIVE_profile_picture_id?: string | null, hide_office_address?: boolean | null, hide_contact_info?: boolean | null, acuityOwnerId?: string | null, acuityCalendarId?: string | null, accepting_patients: boolean, subscriptionPeriodEnd?: string | null, subscriptionStatus?: CodexSubscriptionStatuses | null, SENSITIVE_credentials: { __typename?: 'ProviderCredentialsOutput', yearsOfPractice: string, certifications: Array<string>, medicalRole: string, titles: Array<string> }, SENSITIVE_address_information?: { __typename?: 'AddressInformationOutput', address1?: string | null, city?: string | null, state?: string | null } | null, SENSITIVE_office_information?: { __typename?: 'OfficeAddressInformationOutput', officeName?: string | null, email: string, address1?: string | null, city?: string | null, state?: string | null } | null, patientRequests: Array<{ __typename?: 'PatientRequest', date: string, patientFhirId: string, requestStatus: ProviderRequestStatus }>, serviceOfferings: Array<{ __typename?: 'ServiceOfferingsOutput', active: boolean, serviceType: ServiceType, price: string }> }> } };

export type GetFhirPatientByCodexIdQueryVariables = Exact<{
  patientCodexId: Scalars['String'];
}>;


export type GetFhirPatientByCodexIdQuery = { __typename?: 'Query', getFHIRPatientbyCodexIDParameter: { __typename?: 'getFHIRPatientOutput', users: Array<{ __typename?: 'GetPatientOutput', id: string, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_profile_picture_id?: string | null }> } };

export type GetProvidersForCurrentPatientQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProvidersForCurrentPatientQuery = { __typename?: 'Query', getProviderByPatientId: { __typename?: 'GetFHIRProvidersOutput', providers: Array<{ __typename?: 'ProviderOutput', id: string, SENSITIVE_firstname: string, SENSITIVE_lastname: string, SENSITIVE_profile_picture_id?: string | null, SENSITIVE_credentials: { __typename?: 'ProviderCredentialsOutput', yearsOfPractice: string, certifications: Array<string>, medicalRole: string, titles: Array<string> } }> } };

export type GetProviderInfoByProviderCodexIdQueryVariables = Exact<{
  providerCodexId: Scalars['String'];
}>;


export type GetProviderInfoByProviderCodexIdQuery = { __typename?: 'Query', getFHIRProviderbyId: { __typename?: 'GetFHIRProviderByIdOutput', providers: Array<{ __typename?: 'ProviderOutput', id: string, SENSITIVE_firstname: string, SENSITIVE_lastname: string, SENSITIVE_profile_picture_id?: string | null, providerBalance?: number | null, SENSITIVE_credentials: { __typename?: 'ProviderCredentialsOutput', yearsOfPractice: string, certifications: Array<string>, medicalRole: string, titles: Array<string> }, SENSITIVE_office_information?: { __typename?: 'OfficeAddressInformationOutput', officeName?: string | null, email: string, address1?: string | null, city?: string | null, state?: string | null } | null, serviceOfferings: Array<{ __typename?: 'ServiceOfferingsOutput', active: boolean, serviceType: ServiceType, price: string }> }> } };

export type GetLastViewedProvidersByUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLastViewedProvidersByUserQuery = { __typename?: 'Query', getLastViewedProvidersByUser: { __typename?: 'GetLastViewedProvidersByUserQueryOutput', providers: Array<{ __typename?: 'ProviderOutput', id: string, SENSITIVE_firstname: string, SENSITIVE_lastname: string, SENSITIVE_profile_picture_id?: string | null, acuityOwnerId?: string | null, acuityCalendarId?: string | null, SENSITIVE_credentials: { __typename?: 'ProviderCredentialsOutput', yearsOfPractice: string, certifications: Array<string>, medicalRole: string, titles: Array<string> }, SENSITIVE_address_information?: { __typename?: 'AddressInformationOutput', address1?: string | null, city?: string | null, state?: string | null } | null, serviceOfferings: Array<{ __typename?: 'ServiceOfferingsOutput', active: boolean, serviceType: ServiceType, price: string }> }> } };

export type CreatePatientRequestMutationVariables = Exact<{
  providerCodexId: Scalars['String'];
}>;


export type CreatePatientRequestMutation = { __typename?: 'Mutation', createBecomePatientRequest: { __typename?: 'PatchFHIRRequestBecomePatientOutput', requestStatus: ProviderRequestStatus } };

export type PatchFhirProviderAccountInfoByCodexIdMutationVariables = Exact<{
  providerAccountInfo: PatchFhirProviderInput;
}>;


export type PatchFhirProviderAccountInfoByCodexIdMutation = { __typename?: 'Mutation', patchFHIRProvider: { __typename?: 'PatchFHIRProviderOutput', update_providers_one: { __typename?: 'ProviderOutput', id: string, SENSITIVE_firstname: string, SENSITIVE_lastname: string, SENSITIVE_phone: string, SENSITIVE_email: string, SENSITIVE_national_provider_identifier: string } } };

export type PatchFhirProviderAllFieldsMutationVariables = Exact<{
  providerInfo: PatchFhirProviderInput;
}>;


export type PatchFhirProviderAllFieldsMutation = { __typename?: 'Mutation', patchFHIRProvider: { __typename?: 'PatchFHIRProviderOutput', update_providers_one: { __typename?: 'ProviderOutput', id: string } } };

export type RequestZrtTestMutationVariables = Exact<{
  providerCodexId: Scalars['String'];
  testType: Scalars['String'];
  zrtSwabCode: Scalars['String'];
  trackingNumber?: InputMaybe<Scalars['String']>;
}>;


export type RequestZrtTestMutation = { __typename?: 'Mutation', requestZrtTest: { __typename?: 'RequestZrtTestOutput', requestStatus: ProviderRequestStatus, serviceRequestId: string } };

export type UnlinkFullscriptMutationVariables = Exact<{ [key: string]: never; }>;


export type UnlinkFullscriptMutation = { __typename?: 'Mutation', unlinkFullscript: { __typename?: 'PatchFHIRProviderOutput', update_providers_one: { __typename?: 'ProviderOutput', id: string } } };

export type GetFhirProviderbyEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetFhirProviderbyEmailQuery = { __typename?: 'Query', getFHIRProviderbyEmail: { __typename?: 'GetFHIRProviderByEmailOutput', providers: Array<{ __typename?: 'ProviderOutput', acuityCalendarId?: string | null, ePrescribeUserId?: string | null, id: string, enabled: boolean, id_verified: boolean, fully_verified: boolean, insurance_verified: boolean, codex_approved: boolean, isStripeConnected?: boolean | null, stripeAccountId?: string | null, stripePayoutsReadyAt?: string | null, SENSITIVE_firstname: string, SENSITIVE_email: string, SENSITIVE_gender: string, SENSITIVE_gender_describe?: string | null, SENSITIVE_dob?: string | null, SENSITIVE_lastname: string, SENSITIVE_phone: string, fullscriptId?: string | null, SENSITIVE_profile_picture_id?: string | null, SENSITIVE_national_provider_identifier: string, SENSITIVE_languages_of_communication: Array<string>, SENSITIVE_about?: string | null, providerBalance?: number | null, hide_contact_info?: boolean | null, hide_office_address?: boolean | null, serviceOfferings: Array<{ __typename?: 'ServiceOfferingsOutput', active: boolean, price: string, priceCategory: PriceCategory, serviceType: ServiceType, healthCareServiceFhirId: string }>, SENSITIVE_credentials: { __typename?: 'ProviderCredentialsOutput', yearsOfPractice: string, certifications: Array<string>, fellowships?: string | null, medicalRole: string, titles: Array<string>, stateLicenses?: Array<{ __typename?: 'ProviderStateLicenseOutput', id: string, state: string, licenseType: StateLicenseType, licenseNumber: string, expirationDate: string }> | null }, SENSITIVE_education: Array<{ __typename?: 'ProviderEducationOutput', medicalSchool: string, residency?: string | null, isStillResident?: boolean | null, residencyEndDate?: string | null, residencyStartDate?: string | null, undergraduate: string }>, SENSITIVE_office_information?: { __typename?: 'OfficeAddressInformationOutput', officeName?: string | null, email: string, phone: string, address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, state?: string | null, province?: string | null, zipCode?: string | null } | null, SENSITIVE_address_information?: { __typename?: 'AddressInformationOutput', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, state?: string | null, province?: string | null, zipCode?: string | null } | null }> } };

export type GetFhirAvailableProvidersNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFhirAvailableProvidersNamesQuery = { __typename?: 'Query', getFHIRProviders: { __typename?: 'GetFHIRProvidersOutput', providers: Array<{ __typename?: 'ProviderOutput', id: string, SENSITIVE_firstname: string, SENSITIVE_lastname: string }> } };

export type GetFhirProviderByCodexIdQueryVariables = Exact<{
  codexProviderId: Scalars['String'];
}>;


export type GetFhirProviderByCodexIdQuery = { __typename?: 'Query', getFHIRProviderbyCodexIdArgument: { __typename?: 'GetProviderBioByIdQueryOutput', providers: Array<{ __typename?: 'GetProviderBioById', providers: { __typename?: 'ProviderOutput', id: string, SENSITIVE_firstname: string, SENSITIVE_lastname: string, SENSITIVE_email: string, SENSITIVE_profile_picture_id?: string | null, SENSITIVE_gender: string, SENSITIVE_gender_describe?: string | null, SENSITIVE_languages_of_communication: Array<string>, SENSITIVE_about?: string | null, hide_contact_info?: boolean | null, hide_office_address?: boolean | null, subscriptionPeriodEnd?: string | null, subscriptionStatus?: CodexSubscriptionStatuses | null, acuityCalendarId?: string | null, acuityOwnerId?: string | null, patientRequests: Array<{ __typename?: 'PatientRequest', date: string, requestStatus: ProviderRequestStatus }>, SENSITIVE_credentials: { __typename?: 'ProviderCredentialsOutput', yearsOfPractice: string, certifications: Array<string>, medicalRole: string, titles: Array<string>, stateLicenses?: Array<{ __typename?: 'ProviderStateLicenseOutput', state: string }> | null }, SENSITIVE_education: Array<{ __typename?: 'ProviderEducationOutput', medicalSchool: string, residency?: string | null, undergraduate: string }>, SENSITIVE_office_information?: { __typename?: 'OfficeAddressInformationOutput', officeName?: string | null, email: string, phone: string, address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, state?: string | null, province?: string | null, zipCode?: string | null } | null, SENSITIVE_address_information?: { __typename?: 'AddressInformationOutput', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, phone?: string | null, state?: string | null, zipCode?: string | null } | null, serviceOfferings: Array<{ __typename?: 'ServiceOfferingsOutput', active: boolean, serviceType: ServiceType, price: string }> } }> } };

export type GetProviderPatientInfoQueryVariables = Exact<{
  patientCodexId: Scalars['String'];
}>;


export type GetProviderPatientInfoQuery = { __typename?: 'Query', getFHIRPatientbyCodexIDParameter: { __typename?: 'getFHIRPatientOutput', users: Array<{ __typename?: 'GetPatientOutput', SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_profile_picture_id?: string | null }> } };

export type GetProviderFullPatientInfoQueryVariables = Exact<{
  patientCodexId: Scalars['String'];
}>;


export type GetProviderFullPatientInfoQuery = { __typename?: 'Query', getFHIRPatientbyCodexIDParameter: { __typename?: 'getFHIRPatientOutput', users: Array<{ __typename?: 'GetPatientOutput', id: string, parentCodexId?: string | null, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_dob?: string | null, SENSITIVE_profile_picture_id?: string | null, SENSITIVE_etnicity?: Array<string> | null, SENSITIVE_gender?: string | null, SENSITIVE_self_identity_gender?: string | null, SENSITIVE_user_measurements?: { __typename?: 'PatientMeasurementsOutput', heightFt?: number | null, heightIn?: number | null, hips?: number | null, waist?: number | null, weight?: number | null } | null }> } };

export type GetFhirPatientsRelatedToProviderQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  direction: OrderByDirections;
  field: FhirPatientOrderByCriterias;
  searchCriteria?: InputMaybe<Scalars['String']>;
  dateFilter?: InputMaybe<GetFhirPatientsByIdDateFilterInput>;
}>;


export type GetFhirPatientsRelatedToProviderQuery = { __typename?: 'Query', getFHIRPatientsById: { __typename?: 'GetFHIRPatientsByProviderIdOutput', total: number, patients: Array<{ __typename?: 'PatientWithMemberOutput', memberDetails?: { __typename?: 'GetMemberGroupOutput', inactive?: boolean | null, period?: { __typename?: 'GroupPeriod', start?: string | null } | null } | null, patient: { __typename?: 'GetBasicPatientInfoOutput', id: string, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_birth_date?: string | null, SENSITIVE_gender?: string | null, SENSITIVE_email?: string | null, SENSITIVE_phone?: string | null, SENSITIVE_profile_picture_id?: string | null, kyc_approved: boolean, canReceivePrescriptions: boolean, SENSITIVE_etnicity?: Array<string> | null, SENSITIVE_self_identity_gender?: string | null, lastAppointmentDate?: string | null, SENSITIVE_address_information?: { __typename?: 'AddressInformationOutput', city?: string | null, state?: string | null, country?: string | null } | null, SENSITIVE_user_measurements?: { __typename?: 'PatientMeasurementsOutput', hips?: number | null, waist?: number | null, weight?: number | null, heightFt?: number | null, heightIn?: number | null } | null, appointments?: Array<{ __typename?: 'GetAppointmentOutput', codexPatientId: string, codexProviderId?: string | null, appointmentCodexId: string, appointmentType?: AppointmentTypeEnum | null, appointmentUrl?: string | null, start?: string | null }> | null } }> } };

export type GetProviderPatientDetailsQueryVariables = Exact<{
  patientCodexId: Scalars['String'];
}>;


export type GetProviderPatientDetailsQuery = { __typename?: 'Query', getFHIRPatientbyCodexIDParameter: { __typename?: 'getFHIRPatientOutput', users: Array<{ __typename?: 'GetPatientOutput', SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_gender?: string | null, SENSITIVE_email?: string | null, SENSITIVE_self_identity_gender?: string | null, SENSITIVE_dob?: string | null, SENSITIVE_etnicity?: Array<string> | null, child_fully_verified?: boolean | null, SENSITIVE_profile_picture_id?: string | null, parentCodexId?: string | null, SENSITIVE_user_measurements?: { __typename?: 'PatientMeasurementsOutput', heightFt?: number | null, heightIn?: number | null, weight?: number | null, hips?: number | null, waist?: number | null } | null, SENSITIVE_pharmacies?: Array<{ __typename?: 'PharmacyInformationOutput', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, name?: string | null, province?: string | null, state?: string | null, phone: string, zipCode?: string | null, id: string, isDefault: boolean }> | null }> } };

export type GetAppointmentMessageListByAppointmentCodexIdQueryVariables = Exact<{
  appointmentCodexId: Scalars['String'];
}>;


export type GetAppointmentMessageListByAppointmentCodexIdQuery = { __typename?: 'Query', getAppointmentMessageListByAppointmentCodexId: { __typename?: 'GetAppointmentChatMessagesOutput', chat?: { __typename?: 'AppointmentChat', id: string, patientId: string, providerId: string, messages: Array<{ __typename?: 'AppointmentChatMessage', from: string, mediaUrl?: string | null, fileId?: string | null, message?: string | null, contentType?: ContentType | null, date: string, fileName?: string | null }> } | null } };

export type GetFhirPatientRelatedToProviderByPatientIdQueryVariables = Exact<{
  patientCodexId: Scalars['String'];
}>;


export type GetFhirPatientRelatedToProviderByPatientIdQuery = { __typename?: 'Query', getFHIRPatientsById: { __typename?: 'GetFHIRPatientsByProviderIdOutput', total: number, patients: Array<{ __typename?: 'PatientWithMemberOutput', memberDetails?: { __typename?: 'GetMemberGroupOutput', inactive?: boolean | null, period?: { __typename?: 'GroupPeriod', start?: string | null } | null } | null, patient: { __typename?: 'GetBasicPatientInfoOutput', id: string, created_at?: string | null, parentCodexId?: string | null, SENSITIVE_email?: string | null, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_birth_date?: string | null, SENSITIVE_gender?: string | null, SENSITIVE_profile_picture_id?: string | null, fhirId?: string | null, kyc_approved: boolean, canReceivePrescriptions: boolean, SENSITIVE_etnicity?: Array<string> | null, SENSITIVE_self_identity_gender?: string | null, SENSITIVE_user_measurements?: { __typename?: 'PatientMeasurementsOutput', heightFt?: number | null, heightIn?: number | null, hips?: number | null, waist?: number | null, weight?: number | null } | null, SENSITIVE_address_information?: { __typename?: 'AddressInformationOutput', city?: string | null, country?: string | null, state?: string | null } | null, SENSITIVE_pharmacies?: Array<{ __typename?: 'PharmacyInformationOutput', address1?: string | null, city?: string | null, country?: string | null, address2?: string | null, name?: string | null, state?: string | null, zipCode?: string | null }> | null } }> } };

export type GetProviderPatientsByIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProviderPatientsByIdQuery = { __typename?: 'Query', getFHIRPatientsById: { __typename?: 'GetFHIRPatientsByProviderIdOutput', patients: Array<{ __typename?: 'PatientWithMemberOutput', patient: { __typename?: 'GetBasicPatientInfoOutput', id: string, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null } }> } };

export type GetFhirProviderByRequestIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFhirProviderByRequestIdQuery = { __typename?: 'Query', getFHIRProviderByRequestId: { __typename?: 'GetFHIRProviderByIdOutput', providers: Array<{ __typename?: 'ProviderOutput', id: string, enabled: boolean, fullscriptId?: string | null, ePrescribeUserId?: string | null, id_verified: boolean, codex_approved: boolean, SENSITIVE_firstname: string, SENSITIVE_email: string, SENSITIVE_gender: string, SENSITIVE_lastname: string, SENSITIVE_phone: string, SENSITIVE_profile_picture_id?: string | null, SENSITIVE_national_provider_identifier: string, SENSITIVE_languages_of_communication: Array<string>, SENSITIVE_about?: string | null, acuityOwnerId?: string | null, acuityCalendarId?: string | null, SENSITIVE_credentials: { __typename?: 'ProviderCredentialsOutput', yearsOfPractice: string, certifications: Array<string>, medicalRole: string, titles: Array<string> }, SENSITIVE_education: Array<{ __typename?: 'ProviderEducationOutput', medicalSchool: string, residency?: string | null, undergraduate: string }>, SENSITIVE_office_information?: { __typename?: 'OfficeAddressInformationOutput', officeName?: string | null, email: string, phone: string, address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, state?: string | null, province?: string | null, zipCode?: string | null } | null, SENSITIVE_address_information?: { __typename?: 'AddressInformationOutput', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, state?: string | null, province?: string | null, zipCode?: string | null } | null }> } };

export type GetLastViewedPatientByProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLastViewedPatientByProviderQuery = { __typename?: 'Query', getLastViewedPatientByProvider: { __typename?: 'GetLastViewedPatientByUserQueryOutput', patients: Array<{ __typename?: 'GetPatientOutput', id: string, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_dob?: string | null, SENSITIVE_gender?: string | null, SENSITIVE_profile_picture_id?: string | null, SENSITIVE_address_information?: { __typename?: 'AddressInformationOutput', city?: string | null, state?: string | null } | null }> } };

export type GetFhirdPrivderInfoByZrtSwabcodeQueryQueryVariables = Exact<{
  getFHIRDPrivderInfoByZrtSwabcode: Scalars['String'];
}>;


export type GetFhirdPrivderInfoByZrtSwabcodeQueryQuery = { __typename?: 'Query', getFHIRDPrivderInfoByZrtSwabcode: { __typename?: 'ProviderOutput', id: string, SENSITIVE_lastname: string, SENSITIVE_firstname: string } };

export type GetFhirPatientsRelatedToProviderCountQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetFhirPatientsRelatedToProviderCountQuery = { __typename?: 'Query', getFHIRPatientsById: { __typename?: 'GetFHIRPatientsByProviderIdOutput', total: number } };

export type GetTotalsProviderByPatientsIdQueryVariables = Exact<{
  patientCodexId?: InputMaybe<Scalars['String']>;
}>;


export type GetTotalsProviderByPatientsIdQuery = { __typename?: 'Query', getProvidersByPatientId: { __typename?: 'GetFHIRProviderByIdOutput', total?: number | null } };

export type InsertFhirQuestionnaireResponseMutationVariables = Exact<{
  createQuestionnaireResponsesInput: QuestionnaireResponseInput;
}>;


export type InsertFhirQuestionnaireResponseMutation = { __typename?: 'Mutation', insertFHIRQuestionnaireResponse: { __typename?: 'CreateFHIRQuestionnaireResponsesOutput', questionnaire_response: { __typename?: 'CreateQuestionnaireResponsesOutput', created_at: string, id: string } } };

export type UpdateFhirQuestionnaireResponseMutationVariables = Exact<{
  identifier?: InputMaybe<Scalars['String']>;
  isComplete?: InputMaybe<Scalars['Boolean']>;
  questionnaireId: Scalars['String'];
  responses: Scalars['JSON'];
  swabCode: Scalars['String'];
  currentStepIndex?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateFhirQuestionnaireResponseMutation = { __typename?: 'Mutation', updateFHIRQuestionnaireResponse: { __typename?: 'UpdateFHIRQuestionnaireResponsesOutput', questionnaire_response: { __typename?: 'UpdateQuestionnaireResponsesOutput', id: string } } };

export type SaveFhirQuestionnaireManuallyMutationVariables = Exact<{
  questionnaireId: Scalars['Int'];
  userID: Scalars['String'];
  responses: Scalars['JSON'];
  isComplete: Scalars['Boolean'];
}>;


export type SaveFhirQuestionnaireManuallyMutation = { __typename?: 'Mutation', saveFHIRQuestionnaireManually: { __typename?: 'SaveFHIRQuestionnaireManually', id: string, responses: any } };

export type UpdateFhirUserLatestQuestionnaireMutationVariables = Exact<{
  id: Scalars['String'];
  responses: Scalars['JSON'];
  isComplete: Scalars['Boolean'];
}>;


export type UpdateFhirUserLatestQuestionnaireMutation = { __typename?: 'Mutation', updateFHIRUserLatestQuestionnaire: { __typename?: 'UpdateFHIRUserLatestQuestionnaire', affected_rows: number } };

export type GetFhirQuestionnaireResponseQueryVariables = Exact<{
  codexPatientId: Scalars['String'];
  identifier: Scalars['String'];
  system: Scalars['String'];
  swabCode?: InputMaybe<Scalars['String']>;
}>;


export type GetFhirQuestionnaireResponseQuery = { __typename?: 'Query', getFHIRQuestionnaireResponse: { __typename?: 'GetFHIRQuestionnaireResponse', questionnaire_response: { __typename?: 'GetQuestionnaireResponse', id: string, current_step_index?: number | null, is_complete: QuestionnaireResponseStatus, updated_at?: string | null, responses: Array<{ __typename: 'HasuraAnswerItem', child_questions?: Array<number> | null, currentIndexOfSection?: number | null, currentSection?: string | null, questionID?: number | null, responseType: string, stringArrayResponse?: Array<string> | null, stringResponse?: string | null, hasuraItemArrayResponse?: Array<{ __typename?: 'HasuraAnswerItem', currentIndexOfSection?: number | null, currentSection?: string | null, questionID?: number | null, responseType: string, stringArrayResponse?: Array<string> | null, stringResponse?: string | null, hasuraItemArrayResponse?: Array<{ __typename?: 'HasuraAnswerItem', currentIndexOfSection?: number | null, currentSection?: string | null, questionID?: number | null, responseType: string, stringArrayResponse?: Array<string> | null, stringResponse?: string | null, hasuraMedicationItemResponse?: { __typename?: 'HasuraMedicationItem', completed?: boolean | null, id: string, stringArrayResponse?: Array<string> | null, stringResponse?: string | null, responseType: string, title?: string | null, value?: string | null } | null }> | null }> | null } | { __typename: 'HasuraMedicationItem', completed?: boolean | null, id: string, child_questions?: Array<number> | null, responseType: string, stringArrayResponse?: Array<string> | null, stringResponse?: string | null, title?: string | null, value?: string | null, hasuraItemArrayResponse?: Array<{ __typename?: 'HasuraAnswerItem', currentIndexOfSection?: number | null, currentSection?: string | null, questionID?: number | null, responseType: string, stringArrayResponse?: Array<string> | null, stringResponse?: string | null }> | null, hasuraMedicationItemResponse?: { __typename?: 'HasuraMedicationItem', completed?: boolean | null, id: string, responseType: string, stringArrayResponse?: Array<string> | null, stringResponse?: string | null, title?: string | null } | null }> } } };

export type GetLatestFhirQuestionnaireByIdQueryVariables = Exact<{
  questionnaire_id: Scalars['Int'];
}>;


export type GetLatestFhirQuestionnaireByIdQuery = { __typename?: 'Query', getLatestFHIRQuestionnaireById: { __typename?: 'GetLatestFHIRQuestionnaireByIdResponse', questionnaire_responses: Array<{ __typename?: 'GetLatestFHIRQuestionnaireById', responses: any, id: string }> } };

export type GetFhirQuestionnaireByIdQueryVariables = Exact<{
  questionnaire_id: Scalars['Int'];
}>;


export type GetFhirQuestionnaireByIdQuery = { __typename?: 'Query', getFHIRQuestionnaireByCodexID: { __typename?: 'GetQuestionnaireOutput', title: string, subtitle?: string | null, data: Array<{ __typename?: 'QuestionnaireDependenciesGroup', name: string, properties: Array<string>, complete?: boolean | null, dependencies?: Array<{ __typename?: 'DynamicQuestionnaireDependencies', if: any, then: { __typename?: 'ThenObject', enabled?: Array<string> | null, required?: Array<string> | null } }> | null }>, questionnaires_questionnaire_questions: Array<{ __typename?: 'QuestionnairesQuestionnaireQuestions', questionnaire_questions_question: { __typename?: 'QuestionnaireQuestionsQuestion', id: number, text: string, subtitle?: string | null, answers?: Array<string> | null, ui_control: string, dont_know_answer?: string | null, dropdown_combo_answers?: any | null, dropdown_label_1?: string | null, dropdown_label_2?: string | null, measurement_unit?: string | null, response_property?: string | null, helper_text?: string | null, none_option?: string | null, all_option?: string | null, double_text_combo_helper_texts?: { __typename?: 'QuestionHelperTextData', helper_text_1: string, helper_text_2: string } | null, array_field_config?: { __typename?: 'ArrayFieldConfig', add_button_label?: string | null, max_items?: number | null, min_items?: number | null } | null, children?: Array<{ __typename?: 'QuestionnaireQuestionsQuestion', all_option?: string | null, answers?: Array<string> | null, dont_know_answer?: string | null, dropdown_combo_answers?: any | null, dropdown_label_1?: string | null, dropdown_label_2?: string | null, helper_text?: string | null, id: number, measurement_unit?: string | null, none_option?: string | null, response_property?: string | null, subtitle?: string | null, text: string, ui_control: string, array_field_config?: { __typename?: 'ArrayFieldConfig', add_button_label?: string | null, max_items?: number | null, min_items?: number | null } | null }> | null } }> } };

export type AddProductToCartMutationVariables = Exact<{
  productId?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  recommendationId?: InputMaybe<Scalars['String']>;
}>;


export type AddProductToCartMutation = { __typename?: 'Mutation', createCartProduct: { __typename?: 'CartProductOutput', created_at: string, id: number, product_id: number, quantity: number, updated_at: string, user_id: string, product?: { __typename?: 'ProductOutput', created_at: string, description?: string | null, id: number, price?: number | null, short_description?: string | null, title: string, updated_at: string, specs?: { __typename?: 'Specs', contents?: string | null, expiration_period?: number | null, made_in?: string | null } | null } | null } };

export type UpdateProductInCartMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateProductInCartMutation = { __typename?: 'Mutation', updateCartProduct: { __typename?: 'CartProductOutput', created_at: string, id: number, product_id: number, quantity: number, updated_at: string, user_id: string, product?: { __typename?: 'ProductOutput', created_at: string, description?: string | null, id: number, price?: number | null, short_description?: string | null, title: string, updated_at: string, specs?: { __typename?: 'Specs', contents?: string | null, expiration_period?: number | null, made_in?: string | null } | null } | null } };

export type DeleteCartProductMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type DeleteCartProductMutation = { __typename?: 'Mutation', deleteCartProduct: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type DeleteLastAddressMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type DeleteLastAddressMutation = { __typename?: 'Mutation', deleteDeliveryAddress: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type CreateOrderMutationVariables = Exact<{
  deliveryAddressId?: InputMaybe<Scalars['Int']>;
  providerId?: InputMaybe<Scalars['String']>;
  promoCode?: InputMaybe<Scalars['String']>;
  useSavedAddress?: InputMaybe<Scalars['Boolean']>;
  deliveryAddress1?: InputMaybe<CreateDeliveryAddressInput>;
  paymentProvider?: InputMaybe<PaymentProviderEnum>;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder: { __typename?: 'GetPaymentLinkOutput', link: string } };

export type RecommendProductsMutationVariables = Exact<{
  codexPatientId: Scalars['String'];
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  recommendations: Array<ProductRecommendationInput> | ProductRecommendationInput;
}>;


export type RecommendProductsMutation = { __typename?: 'Mutation', recommendProducts: { __typename?: 'RecommendProductsOutput', serviceRequestIds: Array<string> } };

export type UpdateRecommendationStatusMutationVariables = Exact<{
  recommendationId: Scalars['String'];
  status: UpdatableRecommendationStatus;
}>;


export type UpdateRecommendationStatusMutation = { __typename?: 'Mutation', updateRecommendationStatus: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type DeleteDraftRecommendationMutationVariables = Exact<{
  recommendationId: Scalars['String'];
}>;


export type DeleteDraftRecommendationMutation = { __typename?: 'Mutation', deleteRecommendationByRequestUserCodexId: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type GetShopProductsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  categories?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetShopProductsQuery = { __typename?: 'Query', getProducts: { __typename?: 'GetProductsOutput', total: number, products: Array<{ __typename?: 'ProductOutput', title: string, short_description?: string | null, price?: number | null, quantity: number, reserved_quantity: number, in_stock: boolean, image_url?: string | null, default_image_id?: string | null, id: number, is_shipmonk_active: boolean, description?: string | null, specs?: { __typename?: 'Specs', contents?: string | null, expiration_period?: number | null, made_in?: string | null } | null }> } };

export type GetCartProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartProductsQuery = { __typename?: 'Query', getCartProducts: { __typename?: 'CartProductsOutput', shipping_for_products: number, shipping_for_test_kits: number, subtotal: number, tax: number, total: number, cart_products: Array<{ __typename?: 'CartProductOutput', id: number, product_id: number, quantity: number, updated_at: string, user_id: string, created_at: string, provider?: { __typename?: 'ProviderOutput', id: string, SENSITIVE_lastname: string, SENSITIVE_firstname: string } | null, patientOwner?: { __typename?: 'GetPatientOutput', id: string, parentCodexId?: string | null, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null } | null, product?: { __typename?: 'ProductOutput', title: string, short_description?: string | null, is_shipmonk_deleted: boolean, price?: number | null, image_url?: string | null, id: number, description?: string | null, category?: number | null, updated_at: string, specs?: { __typename?: 'Specs', contents?: string | null, expiration_period?: number | null, made_in?: string | null } | null } | null }> } };

export type GetLastAddressesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetLastAddressesQuery = { __typename?: 'Query', getDeliveryAddresses: { __typename?: 'DeliveryAddressesOutput', total: number, delivery_addresses: Array<{ __typename?: 'DeliveryAddressOutput', address1: string, address2?: string | null, city: string, country: string, created_at: string, id: number, phone: string, state: string, updated_at: string, user_id: string, zip_code: string }> } };

export type GetRecommendationsByRequestPatientCodexIdQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  direction?: InputMaybe<OrderByDirections>;
  field?: InputMaybe<FhirRecommendationsOrderByCriterias>;
  statuses?: InputMaybe<Array<ServiceRequestStatus> | ServiceRequestStatus>;
}>;


export type GetRecommendationsByRequestPatientCodexIdQuery = { __typename?: 'Query', getRecommendationsByRequestPatientCodexId: { __typename?: 'GetFHIRRecommendationsOutput', total: number, recommendations: Array<{ __typename?: 'GetFHIRRecommendationOutput', createdAt: string, id: string, imageUrl?: string | null, productTitle: string, providerCodexId: string, patientCodexId: string, providerName: string, quantity: number, status: ServiceRequestStatus, productId: number, totalPrice: number }> } };

export type GetInvoiceOrReceiptUrlQueryVariables = Exact<{
  appointmentId?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['Int']>;
  paymentTransactionId?: InputMaybe<Scalars['Int']>;
}>;


export type GetInvoiceOrReceiptUrlQuery = { __typename?: 'Query', getInvoiceOrReceiptUrl: { __typename?: 'DownloadInvoiceOrReceiptUrlOutput', invoiceUrl?: string | null, receiptUrl?: string | null } };

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
  JSONObject: any;
};

/** The type of appointment event */
export enum Appointment_Event {
  AppointmentEnd = 'APPOINTMENT_END',
  AppointmentStart = 'APPOINTMENT_START',
  PatientJoined = 'PATIENT_JOINED',
  PatientLeft = 'PATIENT_LEFT',
  ProviderJoined = 'PROVIDER_JOINED',
  ProviderLeft = 'PROVIDER_LEFT'
}

/** The source of the appointment event */
export enum Appointment_Event_Source {
  Patient = 'PATIENT',
  Provider = 'PROVIDER',
  System = 'SYSTEM'
}

export type AcceptAgreementInput = {
  acceptorRole?: InputMaybe<UserAgreementAcceptorRole>;
  agreementType: UserAgreementTypes;
  autonomyDeterminationStatus?: InputMaybe<AutonomyDeterminationStatus>;
  expiration?: InputMaybe<UserAgreementExpirationType>;
  minorAutonomyEvidence?: InputMaybe<Array<MinorAutonomyEvidenceTypes>>;
};

export type AcceptChildAdultTransitionInvitationInput = {
  firebaseToken: Scalars['String'];
  token: Scalars['String'];
};

export type AcceptLegalDocumentInput = {
  type: Hasura_Legal_Document_Types_Enum;
};

export type AcceptedAgreementOutput = {
  __typename?: 'AcceptedAgreementOutput';
  acceptanceDate: Scalars['String'];
  agreementType: UserAgreementTypes;
};

export type AcceptedLegalDocumentOutput = {
  __typename?: 'AcceptedLegalDocumentOutput';
  acceptanceDate: Scalars['String'];
  acceptedVersion: Scalars['Int'];
  latestVersion: Scalars['Int'];
  type: Hasura_Legal_Document_Types_Enum;
};

export type AcceptedLegalDocumentsOutput = {
  __typename?: 'AcceptedLegalDocumentsOutput';
  acceptedAgreements: Array<AcceptedAgreementOutput>;
  acceptedLegalDocuments: Array<AcceptedLegalDocumentOutput>;
};

export type AccountUser = {
  __typename?: 'AccountUser';
  account_closed_at?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  blocked_at?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName: Scalars['String'];
  parentCodexId?: Maybe<Scalars['String']>;
  profilePhoto?: Maybe<Scalars['String']>;
};

export type AccountUsersOutput = {
  __typename?: 'AccountUsersOutput';
  closedTotal: Scalars['Int'];
  total: Scalars['Int'];
  users: Array<AccountUser>;
};

export enum AchievementCategory {
  Appointment = 'APPOINTMENT',
  HealthAndSafety = 'HEALTH_AND_SAFETY',
  TestKit = 'TEST_KIT',
  TreatmentPlan = 'TREATMENT_PLAN'
}

export type AchievementCategoryGroupOutput = {
  __typename?: 'AchievementCategoryGroupOutput';
  achievements: Array<AchievementOutput>;
  category: AchievementCategory;
};

export enum AchievementId {
  ActiveCarePartner = 'ACTIVE_CARE_PARTNER',
  CareConnector = 'CARE_CONNECTOR',
  ContinuityChampion = 'CONTINUITY_CHAMPION',
  FirstStep = 'FIRST_STEP',
  KitActivated = 'KIT_ACTIVATED',
  MedicationListUpdated = 'MEDICATION_LIST_UPDATED',
  NextStepPlanned = 'NEXT_STEP_PLANNED',
  OnTime = 'ON_TIME',
  OrderConfirmed = 'ORDER_CONFIRMED',
  PlanStarted = 'PLAN_STARTED',
  ProfileComplete = 'PROFILE_COMPLETE',
  ProviderConnector = 'PROVIDER_CONNECTOR',
  ReadyForYourVisit = 'READY_FOR_YOUR_VISIT',
  ResultsReady = 'RESULTS_READY',
  ResultsReviewed = 'RESULTS_REVIEWED',
  SafetyFirst = 'SAFETY_FIRST',
  SampleReady = 'SAMPLE_READY',
  SupplementListUpdated = 'SUPPLEMENT_LIST_UPDATED'
}

export type AchievementOutput = {
  __typename?: 'AchievementOutput';
  category: AchievementCategory;
  currentTier?: Maybe<Scalars['Int']>;
  currentValue: Scalars['Int'];
  description: Scalars['String'];
  hasTiers: Scalars['Boolean'];
  id: AchievementId;
  name: Scalars['String'];
  requiredValue: Scalars['Int'];
  status: AchievementProgressStatus;
};

export enum AchievementProgressStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Locked = 'LOCKED'
}

export type AchievementsOutput = {
  __typename?: 'AchievementsOutput';
  categories: Array<AchievementCategoryGroupOutput>;
  totalPoints: Scalars['Int'];
};

/** Activity log event group for filtering. */
export enum ActivityEventGroup {
  Account = 'ACCOUNT',
  LegalDocuments = 'LEGAL_DOCUMENTS',
  Messages = 'MESSAGES',
  PatientsAndCare = 'PATIENTS_AND_CARE',
  Payments = 'PAYMENTS'
}

/** Type of activity log event. */
export enum ActivityEventType {
  AccountCreated = 'ACCOUNT_CREATED',
  AccountDeleted = 'ACCOUNT_DELETED',
  AdminPermissionsUpdated = 'ADMIN_PERMISSIONS_UPDATED',
  AppointmentBooked = 'APPOINTMENT_BOOKED',
  AppointmentCancelled = 'APPOINTMENT_CANCELLED',
  AppointmentRescheduled = 'APPOINTMENT_RESCHEDULED',
  ChildAccountCreated = 'CHILD_ACCOUNT_CREATED',
  ChildAccountDeleted = 'CHILD_ACCOUNT_DELETED',
  ChildAdultTransitionCompleted = 'CHILD_ADULT_TRANSITION_COMPLETED',
  CourseCreated = 'COURSE_CREATED',
  CourseDeleted = 'COURSE_DELETED',
  CourseUpdated = 'COURSE_UPDATED',
  LegalDocumentAccepted = 'LEGAL_DOCUMENT_ACCEPTED',
  LegalDocumentUpdated = 'LEGAL_DOCUMENT_UPDATED',
  LoggedIn = 'LOGGED_IN',
  LoggedOut = 'LOGGED_OUT',
  MedicationPrescribed = 'MEDICATION_PRESCRIBED',
  MessageReceived = 'MESSAGE_RECEIVED',
  MessageSent = 'MESSAGE_SENT',
  OrderPurchased = 'ORDER_PURCHASED',
  PasswordUpdated = 'PASSWORD_UPDATED',
  PersonaRejected = 'PERSONA_REJECTED',
  PersonaSubmitted = 'PERSONA_SUBMITTED',
  PersonaVerified = 'PERSONA_VERIFIED',
  PostAppointmentSummaryReceived = 'POST_APPOINTMENT_SUMMARY_RECEIVED',
  ProductUpdated = 'PRODUCT_UPDATED',
  ProviderAssigned = 'PROVIDER_ASSIGNED',
  RefundReceived = 'REFUND_RECEIVED',
  StateLicenseUpdated = 'STATE_LICENSE_UPDATED',
  SupplementRecommended = 'SUPPLEMENT_RECOMMENDED',
  TestKitRecommended = 'TEST_KIT_RECOMMENDED',
  TestKitRegistered = 'TEST_KIT_REGISTERED',
  TestKitResultsReceived = 'TEST_KIT_RESULTS_RECEIVED',
  UserAgreementAccepted = 'USER_AGREEMENT_ACCEPTED',
  UserBlocked = 'USER_BLOCKED',
  UserUnblocked = 'USER_UNBLOCKED',
  WeeklyTransactionReceived = 'WEEKLY_TRANSACTION_RECEIVED'
}

export type ActivityLogFilterInput = {
  groups?: InputMaybe<Array<ActivityEventGroup>>;
};

export type ActivityLogItem = {
  __typename?: 'ActivityLogItem';
  createdAt: Scalars['String'];
  eventType: ActivityEventType;
  id: Scalars['String'];
  metadata?: Maybe<ActivityLogMetadata>;
};

export type ActivityLogMetadata = {
  __typename?: 'ActivityLogMetadata';
  admin?: Maybe<SaPerson>;
  agreementType?: Maybe<UserAgreementTypes>;
  appointment_id?: Maybe<Scalars['String']>;
  course?: Maybe<EducationCourseListItemOutput>;
  legalDocument?: Maybe<LegalDocumentOutput>;
  order_id?: Maybe<Scalars['Int']>;
  patient?: Maybe<GetPatientOutput>;
  product?: Maybe<ProductOutput>;
  provider?: Maybe<ProviderOutput>;
  swab_code?: Maybe<Scalars['String']>;
  test_type?: Maybe<Hasura_Test_Types_Enum>;
  verificationType?: Maybe<VerificationType>;
};

export type ActivityLogOutput = {
  __typename?: 'ActivityLogOutput';
  logs: Array<ActivityLogItem>;
  total: Scalars['Int'];
};

export type AddFhirHealthCareServiceInput = {
  offerings: Array<AddServiceOfferingInput>;
};

export type AddServiceOfferingInput = {
  active: Scalars['Boolean'];
  price: Scalars['Float'];
  serviceType: ServiceType;
};

export type AddressInformationInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  phoneCountry?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type AddressInformationOutput = {
  __typename?: 'AddressInformationOutput';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneCountry?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** Enum representation of admin permissions for admin permissions. */
export enum AdminPermissionType {
  AdminDashboardStats = 'ADMIN_DASHBOARD_STATS',
  BlockUsers = 'BLOCK_USERS',
  InitiateRefund = 'INITIATE_REFUND',
  ManageEducation = 'MANAGE_EDUCATION',
  UpdateProductsInfo = 'UPDATE_PRODUCTS_INFO',
  UpdateProvidersInfo = 'UPDATE_PROVIDERS_INFO',
  UpdateSwabcodesInfo = 'UPDATE_SWABCODES_INFO',
  VeradigmAdmin = 'VERADIGM_ADMIN',
  ViewActivityLogs = 'VIEW_ACTIVITY_LOGS',
  ViewAppointmentsInfo = 'VIEW_APPOINTMENTS_INFO',
  ViewOrdersInfo = 'VIEW_ORDERS_INFO',
  ViewPatientsInfo = 'VIEW_PATIENTS_INFO',
  ViewPaymentsInfo = 'VIEW_PAYMENTS_INFO',
  ViewProductsInfo = 'VIEW_PRODUCTS_INFO',
  ViewProvidersInfo = 'VIEW_PROVIDERS_INFO',
  ViewSupportChat = 'VIEW_SUPPORT_CHAT',
  ViewSwabcodesInfo = 'VIEW_SWABCODES_INFO',
  ViewTestKitsInfo = 'VIEW_TEST_KITS_INFO',
  ViewVerificationRequestInfo = 'VIEW_VERIFICATION_REQUEST_INFO'
}

export type AgeOfMajorityOutput = {
  __typename?: 'AgeOfMajorityOutput';
  ageOfMajority: Scalars['Int'];
  state: Scalars['String'];
};

export type AllergenClassOutput = {
  __typename?: 'AllergenClassOutput';
  classId: Scalars['String'];
  className: Scalars['String'];
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type AllergenClassesOutput = {
  __typename?: 'AllergenClassesOutput';
  allergenClasses: Array<AllergenClassOutput>;
  total: Scalars['Int'];
};

export type Annotation = {
  __typename?: 'Annotation';
  authorReference?: Maybe<ReferenceType>;
  authorString?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  time?: Maybe<Scalars['DateTime']>;
};

export type AppTourOutput = {
  __typename?: 'AppTourOutput';
  created_at: Scalars['String'];
  id: Scalars['Int'];
  type: AppTourTypes;
  updated_at: Scalars['String'];
  user_id: Scalars['String'];
};

/** Enum representing the app tour types. */
export enum AppTourTypes {
  PatientAppointments = 'patientAppointments',
  PatientCareHistory = 'patientCareHistory',
  PatientDashboard = 'patientDashboard',
  PatientManageTestKits = 'patientManageTestKits',
  PatientMyProviders = 'patientMyProviders',
  PatientPendingTestKits = 'patientPendingTestKits',
  PatientProviders = 'patientProviders',
  PatientTestKitRegistration = 'patientTestKitRegistration',
  ProviderAppointments = 'providerAppointments',
  ProviderDashboard = 'providerDashboard',
  ProviderMyPatients = 'providerMyPatients',
  ProviderOnboardingInstructions = 'providerOnboardingInstructions',
  ProviderPatientDetails = 'providerPatientDetails'
}

export type AppToursOutput = {
  __typename?: 'AppToursOutput';
  app_tours: Array<AppTourOutput>;
};

export type AppVersionOutput = {
  __typename?: 'AppVersionOutput';
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  releaseNotes: Scalars['String'];
  releaseType: AppVersionReleaseType;
  updatedAt: Scalars['String'];
  version: Scalars['String'];
};

/** App release type. Major cannot be delivered by OTA; Minor can. */
export enum AppVersionReleaseType {
  Major = 'Major',
  Minor = 'Minor'
}

export type AppVersionsOutput = {
  __typename?: 'AppVersionsOutput';
  hasMajorUpdate: Scalars['Boolean'];
  total: Scalars['Int'];
  versions: Array<AppVersionOutput>;
};

export type AppendEncounterOutput = {
  __typename?: 'AppendEncounterOutput';
  encounterId: Scalars['String'];
};

export type AppendFhirEncounterInput = {
  appointmentCodexId: Scalars['String'];
  diagnosticReportIds?: InputMaybe<Array<Scalars['String']>>;
  providerNotes: CreateFhirEncounterNotesInput;
};

export type AppointmentChat = {
  __typename?: 'AppointmentChat';
  appointmentCodexId: Scalars['String'];
  id: Scalars['String'];
  messages: Array<AppointmentChatMessage>;
  patientId: Scalars['String'];
  providerId: Scalars['String'];
};

export type AppointmentChatMessage = {
  __typename?: 'AppointmentChatMessage';
  contentType?: Maybe<ContentType>;
  date: Scalars['String'];
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  from: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
};

/** Enum representing the possible values for "from" field in AppointmentChatMessage. */
export enum AppointmentChatMessageFrom {
  Patient = 'PATIENT',
  Provider = 'PROVIDER'
}

export type AppointmentChatMessageInput = {
  contentType?: InputMaybe<ContentType>;
  date?: InputMaybe<Scalars['String']>;
  fileId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  from: AppointmentChatMessageFrom;
  mediaUrl?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
};

export type AppointmentDetailGql = {
  __typename?: 'AppointmentDetailGql';
  addonIDs?: Maybe<Array<Scalars['Float']>>;
  amountPaid: Scalars['String'];
  appointmentTypeID: Scalars['Float'];
  calendar: Scalars['String'];
  calendarID: Scalars['Float'];
  calendarTimezone: Scalars['String'];
  canClientCancel: Scalars['Boolean'];
  canClientReschedule: Scalars['Boolean'];
  canceled: Scalars['Boolean'];
  category: Scalars['String'];
  certificate?: Maybe<Scalars['String']>;
  classID?: Maybe<Scalars['Float']>;
  confirmationPage: Scalars['String'];
  confirmationPagePaymentLink: Scalars['String'];
  date: Scalars['String'];
  dateCreated: Scalars['String'];
  datetime: Scalars['String'];
  datetimeCreated: Scalars['String'];
  duration: Scalars['String'];
  email: Scalars['String'];
  endTime: Scalars['String'];
  firstName: Scalars['String'];
  formsText: Scalars['String'];
  id: Scalars['Float'];
  isVerified: Scalars['Boolean'];
  labels?: Maybe<Array<Scalars['String']>>;
  lastName: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  noShow?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  paid: Scalars['String'];
  phone: Scalars['String'];
  priceSold: Scalars['String'];
  scheduledBy: Scalars['String'];
  time: Scalars['String'];
  timezone: Scalars['String'];
  type: Scalars['String'];
};

export type AppointmentEvent = {
  __typename?: 'AppointmentEvent';
  author: Appointment_Event_Source;
  date: Scalars['String'];
  disconnectReason?: Maybe<VonageDisconnectReason>;
  event: Appointment_Event;
  fhirId: Scalars['String'];
};

export type AppointmentMediaInsert = {
  bodySite?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  mediaId?: InputMaybe<Scalars['String']>;
};

export type AppointmentPaymentOutput = {
  __typename?: 'AppointmentPaymentOutput';
  amount?: Maybe<Scalars['Float']>;
  balanceImpact?: Maybe<Scalars['Float']>;
  discount?: Maybe<DiscountOutput>;
  status?: Maybe<Scalars['Int']>;
};

export type AppointmentRequestOutput = {
  __typename?: 'AppointmentRequestOutput';
  appointmentCodexId?: Maybe<Scalars['String']>;
  appointmentTypeId?: Maybe<Scalars['Int']>;
  approvedDate?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  currentDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  patient?: Maybe<GetPatientOutput>;
  proposedDate: Scalars['String'];
  providerCodexId: Scalars['String'];
  reason: Scalars['String'];
  status: AppointmentRequestStatus;
  type: AppointmentRequestType;
  updatedAt: Scalars['String'];
};

export enum AppointmentRequestStatus {
  Approved = 'Approved',
  Declined = 'Declined',
  Outdated = 'Outdated',
  Pending = 'Pending'
}

export enum AppointmentRequestType {
  Book = 'Book',
  Reschedule = 'Reschedule'
}

export type AppointmentRequestsOutput = {
  __typename?: 'AppointmentRequestsOutput';
  requests: Array<AppointmentRequestOutput>;
  total: Scalars['Int'];
};

export type AppointmentStatsByDayOutput = {
  __typename?: 'AppointmentStatsByDayOutput';
  appointmentStats: AppointmentStatsOutput;
  date: Scalars['String'];
};

export type AppointmentStatsOutput = {
  __typename?: 'AppointmentStatsOutput';
  breakdown: Array<AppointmentStatsStatusItem>;
  total: Scalars['Int'];
};

/** Enum representing the possible values for appointment statistics status */
export enum AppointmentStatsStatusEnum {
  BookedNotPaid = 'BookedNotPaid',
  Canceled = 'Canceled',
  Completed = 'Completed',
  NoShow = 'NoShow',
  PatientMissed = 'PatientMissed',
  ProviderMissed = 'ProviderMissed',
  Upcoming = 'Upcoming'
}

export type AppointmentStatsStatusItem = {
  __typename?: 'AppointmentStatsStatusItem';
  status: AppointmentStatsStatusEnum;
  total: Scalars['Int'];
};

export type AppointmentStatusHistoryEntry = {
  __typename?: 'AppointmentStatusHistoryEntry';
  datetime: Scalars['String'];
  status: AppointmentStatusHistoryEnum;
};

/** Enum representing the possible values for appointment status history log */
export enum AppointmentStatusHistoryEnum {
  BookedNotPaid = 'BookedNotPaid',
  Canceled = 'Canceled',
  Completed = 'Completed',
  CompletedSummaryReady = 'CompletedSummaryReady',
  NoShow = 'NoShow',
  PatientMissed = 'PatientMissed',
  ProviderMissed = 'ProviderMissed',
  Upcoming = 'Upcoming'
}

export type AppointmentSummaryPdfOutput = {
  __typename?: 'AppointmentSummaryPdfOutput';
  status: AppointmentSummaryPdfStatus;
  summaryPdfFileId?: Maybe<Scalars['String']>;
};

export enum AppointmentSummaryPdfStatus {
  Pending = 'PENDING',
  Ready = 'READY'
}

/** Enum representing the possible values for "appointmentType" field in Appointment. */
export enum AppointmentTypeEnum {
  Chat = 'CHAT',
  Chat_30 = 'CHAT_30',
  Chat_60 = 'CHAT_60',
  Dnavisit = 'DNAVISIT',
  Email = 'EMAIL',
  Video = 'VIDEO',
  Video_30 = 'VIDEO_30',
  Video_60 = 'VIDEO_60'
}

export type AppointmentsDiagnosticReportsOutput = {
  __typename?: 'AppointmentsDiagnosticReportsOutput';
  diagnosticReports: Array<GetFhirAppointmentDiagnosticReportOutput>;
  total: Scalars['Int'];
};

export type ArrayFieldConfig = {
  __typename?: 'ArrayFieldConfig';
  add_button_label?: Maybe<Scalars['String']>;
  max_items?: Maybe<Scalars['Int']>;
  min_items?: Maybe<Scalars['Int']>;
};

export type Attachment = {
  __typename?: 'Attachment';
  contentType?: Maybe<ContentType>;
  creation?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<ResourceExtension>>;
  hash?: Maybe<Scalars['String']>;
  language?: Maybe<Array<Language>>;
  size?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Enum representing the patient autonomy determination status. */
export enum AutonomyDeterminationStatus {
  EmancipatedMinor = 'EMANCIPATED_MINOR',
  HomelessUnaccompanied = 'HOMELESS_UNACCOMPANIED',
  MarriedMinor = 'MARRIED_MINOR',
  MinorParent = 'MINOR_PARENT',
  OtherStateServiceException = 'OTHER_STATE_SERVICE_EXCEPTION',
  SelfSupporting = 'SELF_SUPPORTING'
}

export type BecomePatientRequestItem = {
  __typename?: 'BecomePatientRequestItem';
  date: Scalars['String'];
  parent?: Maybe<GetPatientOutput>;
  patient: GetPatientOutput;
  requestStatus: ProviderRequestStatus;
};

export type BecomePatientRequestsOutput = {
  __typename?: 'BecomePatientRequestsOutput';
  items: Array<BecomePatientRequestItem>;
  serverNow: Scalars['String'];
  total: Scalars['Int'];
};

export type BillingPlan = {
  __typename?: 'BillingPlan';
  amount: Scalars['Float'];
  currency: Scalars['String'];
  name: Scalars['String'];
};

export type CartProductOutput = {
  __typename?: 'CartProductOutput';
  created_at: Scalars['String'];
  id: Scalars['Int'];
  owner_id?: Maybe<Scalars['String']>;
  patientOwner?: Maybe<GetPatientOutput>;
  product?: Maybe<ProductOutput>;
  product_id: Scalars['Int'];
  provider?: Maybe<ProviderOutput>;
  provider_id?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  recommendation_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
  user_id: Scalars['String'];
};

export type CartProductsOutput = {
  __typename?: 'CartProductsOutput';
  cart_products: Array<CartProductOutput>;
  shipping_for_products: Scalars['Float'];
  shipping_for_test_kits: Scalars['Float'];
  subtotal: Scalars['Float'];
  tax: Scalars['Float'];
  total: Scalars['Float'];
};

/** Client platform used to store per-device settings. */
export enum ClientPlatform {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type CodeableConcept = {
  __typename?: 'CodeableConcept';
  coding?: Maybe<Array<Coding>>;
  text?: Maybe<Scalars['String']>;
};

export type CodeableConceptData = {
  __typename?: 'CodeableConceptData';
  code?: Maybe<Scalars['String']>;
  display: Scalars['String'];
  system?: Maybe<Scalars['String']>;
};

export type CodeableConceptInput = {
  coding?: InputMaybe<Array<CodingInput>>;
  text?: InputMaybe<Scalars['String']>;
};

/** Enum representing the codex subscription statuses. */
export enum CodexSubscriptionStatuses {
  Active = 'Active',
  Canceled = 'Canceled',
  Incomplete = 'Incomplete',
  IncompleteExpired = 'IncompleteExpired',
  PastDue = 'PastDue',
  Paused = 'Paused',
  Trialing = 'Trialing',
  Unpaid = 'Unpaid'
}

export enum CodexTags {
  AcceptingPatients = 'AcceptingPatients',
  CodexApproved = 'CodexApproved',
  Enabled = 'Enabled',
  Errored = 'Errored',
  IdVerified = 'IdVerified',
  Ignored = 'Ignored',
  InsuranceVerified = 'InsuranceVerified',
  Test = 'Test'
}

export type Coding = {
  __typename?: 'Coding';
  code?: Maybe<Scalars['String']>;
  display?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
};

export type CodingInput = {
  code?: InputMaybe<Scalars['String']>;
  display?: InputMaybe<Scalars['String']>;
  system?: InputMaybe<Scalars['String']>;
};

export type Communication = {
  __typename?: 'Communication';
  basedOn?: Maybe<Array<ReferenceType>>;
  category?: Maybe<Array<CodeableConcept>>;
  encounter?: Maybe<Array<ReferenceType>>;
  extension?: Maybe<Array<ResourceExtension>>;
  id: Scalars['String'];
  identifier?: Maybe<Array<Identifier>>;
  meta: Meta;
  note?: Maybe<Array<Annotation>>;
  payload?: Maybe<Array<CommunicationPayload>>;
  priority?: Maybe<Array<CommunicationPriority>>;
  recipient: Array<ReferenceType>;
  resourceType: ResourcesTypes;
  sender: ReferenceType;
  sent?: Maybe<Scalars['String']>;
  status?: Maybe<Array<CommunicationStatus>>;
  text?: Maybe<Narrative>;
};

export type CommunicationPayload = {
  __typename?: 'CommunicationPayload';
  contentAttachment?: Maybe<Attachment>;
  contentString?: Maybe<Scalars['String']>;
};

/** Enum representing possible values for "priority" field in CommunicationRequest. */
export enum CommunicationPriority {
  Asap = 'ASAP',
  Routine = 'ROUTINE',
  Stat = 'STAT',
  Urgent = 'URGENT'
}

/** Enum representing possible values for "status" field in Communication. */
export enum CommunicationStatus {
  Completed = 'COMPLETED',
  EnteredInError = 'ENTERED_IN_ERROR',
  InProgress = 'IN_PROGRESS',
  NotDone = 'NOT_DONE',
  OnHold = 'ON_HOLD',
  Preparation = 'PREPARATION',
  Stopped = 'STOPPED',
  Unknown = 'UNKNOWN'
}

/** Enum representing the possible values for "contentType" field in Attachment. */
export enum ContentType {
  Csv = 'CSV',
  Doc = 'DOC',
  Docx = 'DOCX',
  Gif = 'GIF',
  Heic = 'HEIC',
  Heif = 'HEIF',
  Jpeg = 'JPEG',
  Jpg = 'JPG',
  Json = 'JSON',
  Mp3 = 'MP3',
  Mp4 = 'MP4',
  Pdf = 'PDF',
  Png = 'PNG',
  Txt = 'TXT',
  Webp = 'WEBP',
  Xls = 'XLS',
  Xlsx = 'XLSX',
  Zip = 'ZIP'
}

export type CreateAdminInvitationInput = {
  email: Scalars['String'];
  permissions: Array<AdminPermissionType>;
};

export type CreateAppVersionInput = {
  releaseNotes: Scalars['String'];
  releaseType: AppVersionReleaseType;
  version: Scalars['String'];
};

export type CreateAppoinimentOutput = {
  __typename?: 'CreateAppoinimentOutput';
  appointmentCodexId: Scalars['String'];
  appointmentId: Scalars['String'];
  appointmentUrl: Scalars['String'];
  created: Scalars['String'];
  lastProcessedDate: Scalars['String'];
  start: Scalars['String'];
  status: Scalars['String'];
};

export type CreateAppointmentRequestInput = {
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  appointmentTypeId?: InputMaybe<Scalars['Int']>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  proposedDate: Scalars['String'];
  reason: Scalars['String'];
  type: AppointmentRequestType;
};

export type CreateCartProductInput = {
  ownerId?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
  providerId?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  recommendationId?: InputMaybe<Scalars['String']>;
};

export type CreateChildAdultTransitionInvitationInput = {
  childUserId: Scalars['String'];
  email: Scalars['String'];
};

export type CreateDeliveryAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  phone: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type CreateDependentLinkInput = {
  childCodexId: Scalars['String'];
};

export type CreateDnaVisitOutput = {
  __typename?: 'CreateDnaVisitOutput';
  created_at: Scalars['String'];
  dna_test_questionnaire_pdf_id: Scalars['String'];
  dnavisit_order_id: Scalars['String'];
  health_questionnaire_pdf_id: Scalars['String'];
  sapphiros_barcode: Scalars['String'];
  test_id: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
};

export type CreateFhirAppointmentInput = {
  appointmentNotes?: InputMaybe<FhirAppointmentNotesObservation>;
  appointmentType?: InputMaybe<AppointmentTypeEnum>;
  appointmentUrl?: InputMaybe<Scalars['String']>;
  diagnosticReportIds?: InputMaybe<Array<Scalars['String']>>;
  endAt?: InputMaybe<Scalars['String']>;
  mediaToAppend?: InputMaybe<Array<Scalars['String']>>;
  mediaToInsert?: InputMaybe<Array<AppointmentMediaInsert>>;
  patientCodexId: Scalars['String'];
  providerId?: InputMaybe<Scalars['String']>;
  startAt: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  subjectOfAppointment?: InputMaybe<Scalars['String']>;
  supportingInfo?: InputMaybe<Array<Scalars['String']>>;
  symptomsLocation?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateFhirAppointmentInputWithoutPatientCodexId = {
  appointmentNotes?: InputMaybe<FhirAppointmentNotesObservation>;
  appointmentType?: InputMaybe<AppointmentTypeEnum>;
  appointmentUrl?: InputMaybe<Scalars['String']>;
  diagnosticReportIds?: InputMaybe<Array<Scalars['String']>>;
  endAt?: InputMaybe<Scalars['String']>;
  mediaToAppend?: InputMaybe<Array<Scalars['String']>>;
  mediaToInsert?: InputMaybe<Array<AppointmentMediaInsert>>;
  providerId?: InputMaybe<Scalars['String']>;
  startAt: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  subjectOfAppointment?: InputMaybe<Scalars['String']>;
  supportingInfo?: InputMaybe<Array<Scalars['String']>>;
  symptomsLocation?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateFhirAppointmentOutput = {
  __typename?: 'CreateFHIRAppointmentOutput';
  appointment: CreateAppoinimentOutput;
};

export type CreateFhirDnaVisitTestInputWithResponses = {
  codexProviderId?: InputMaybe<Scalars['String']>;
  dna_test_questionnaire_pdf_id: Scalars['String'];
  health_questionnaire_pdf_id: Scalars['String'];
  order_id: Scalars['String'];
  questionnaire_response: Scalars['JSON'];
  sapphiros_barcode: Scalars['String'];
  test_id: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: InputMaybe<Scalars['String']>;
};

export type CreateFhirDnaVisitTestOutput = {
  __typename?: 'CreateFHIRDnaVisitTestOutput';
  dnavisit_test: CreateDnaVisitOutput;
};

export type CreateFhirEncounterNotesInput = {
  files?: InputMaybe<Array<FileAttachmentInput>>;
  followupRecommendations: Scalars['String'];
  providerNotes: Scalars['String'];
  providerSummary: Scalars['String'];
  systemGenerated?: InputMaybe<Scalars['String']>;
  transcription?: InputMaybe<Scalars['String']>;
};

export type CreateFhirMosaicTestOutput = {
  __typename?: 'CreateFHIRMosaicTestOutput';
  mosaic_test: CreateMosaicTestOutput;
};

export type CreateFhirOfficeLocationOutput = {
  __typename?: 'CreateFHIROfficeLocationOutput';
  insert_office_locations_one: CreateOfficeLocationOutput;
};

export type CreateFhirOrganizationInput = {
  address_information?: InputMaybe<AddressInformationInput>;
  email?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OrganizationTypes>;
};

export type CreateFhirOrganizationOutput = {
  __typename?: 'CreateFHIROrganizationOutput';
  insert_organizations_one: CreateOrganizationOutput;
};

export type CreateFhirPatientInput = {
  codexUUID: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstname?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CreateFhirPatientOutput = {
  __typename?: 'CreateFHIRPatientOutput';
  insert_users_one: CreatePatientOutput;
};

export type CreateFhirProviderInput = {
  codexId: Scalars['String'];
  email: Scalars['String'];
};

export type CreateFhirProviderOutput = {
  __typename?: 'CreateFHIRProviderOutput';
  insert_providers_one: ProviderOutput;
};

export type CreateFhirProviderRoleInput = {
  locationId: Scalars['String'];
  providerId: Scalars['String'];
};

export type CreateFhirProviderRoleOutput = {
  __typename?: 'CreateFHIRProviderRoleOutput';
  insert_provider_role_one: CreateProviderRoleOutput;
};

export type CreateFhirQuestionnaireResponsesOutput = {
  __typename?: 'CreateFHIRQuestionnaireResponsesOutput';
  questionnaire_response: CreateQuestionnaireResponsesOutput;
};

export type CreateFhirZrtTestInput = {
  codexProviderId?: InputMaybe<Scalars['String']>;
  health_questionnaire_pdf_id: Scalars['String'];
  questionnaire_response: Scalars['JSON'];
  reference_code: Scalars['String'];
  status: DiagnosticReportStatus;
  swab_code: Scalars['String'];
  swab_code_without_transform: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: InputMaybe<Scalars['String']>;
  zrt_questionnaire_response_id: Scalars['String'];
};

export type CreateFhirZrtTestOutput = {
  __typename?: 'CreateFHIRZrtTestOutput';
  zrt_test: CreateZrtOutput;
};

export type CreateInMailMessageInput = {
  attachments?: InputMaybe<Array<FileAttachmentInput>>;
  recipientCodexId: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
};

export type CreateMosaicTestInput = {
  codexProviderId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  swabCode: Scalars['String'];
  testId: Scalars['String'];
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type CreateMosaicTestOutput = {
  __typename?: 'CreateMosaicTestOutput';
  test_id: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
};

export type CreateOfficeLocationOutput = {
  __typename?: 'CreateOfficeLocationOutput';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['String'];
  officeName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  phoneCountry?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CreateOrderInput = {
  deliveryAddress?: InputMaybe<CreateDeliveryAddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']>;
  isIos?: InputMaybe<Scalars['Boolean']>;
  paymentProvider?: InputMaybe<PaymentProviderEnum>;
  promoCode?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  useSavedAddress?: InputMaybe<Scalars['Boolean']>;
};

export type CreateOrganizationOutput = {
  __typename?: 'CreateOrganizationOutput';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CreatePatientOutput = {
  __typename?: 'CreatePatientOutput';
  SENSITIVE_address_information?: Maybe<AddressInformationOutput>;
  SENSITIVE_country?: Maybe<Scalars['String']>;
  SENSITIVE_dob?: Maybe<Scalars['String']>;
  SENSITIVE_email: Scalars['String'];
  SENSITIVE_etnicity?: Maybe<Array<Scalars['String']>>;
  SENSITIVE_firstname?: Maybe<Scalars['String']>;
  SENSITIVE_gender?: Maybe<Scalars['String']>;
  SENSITIVE_gender_describe?: Maybe<Scalars['String']>;
  SENSITIVE_lastname?: Maybe<Scalars['String']>;
  SENSITIVE_pharmacies?: Maybe<Array<PharmacyInformationOutput>>;
  SENSITIVE_phone?: Maybe<Scalars['String']>;
  SENSITIVE_profile_picture_id?: Maybe<Scalars['String']>;
  SENSITIVE_self_identity_gender?: Maybe<Scalars['String']>;
  SENSITIVE_user_measurements?: Maybe<PatientMeasurementsOutput>;
  id: Scalars['String'];
  stateDobValid?: Maybe<Scalars['Boolean']>;
};

export type CreateProviderRoleOutput = {
  __typename?: 'CreateProviderRoleOutput';
  locationId: Scalars['String'];
  providerId: Scalars['String'];
};

export type CreateQuestionnaireResponsesOutput = {
  __typename?: 'CreateQuestionnaireResponsesOutput';
  created_at: Scalars['String'];
  id: Scalars['String'];
};

export type CreateScheduleAppointmentBodyInput = {
  appointmentData: CreateFhirAppointmentInputWithoutPatientCodexId;
  appointmentRequestId?: InputMaybe<Scalars['String']>;
  appointmentTypeId: Scalars['Int'];
  calendarId: Scalars['Int'];
  datetime: Scalars['String'];
  paymentProvider?: InputMaybe<PaymentProviderEnum>;
  promoCode?: InputMaybe<Scalars['String']>;
};

export type CreateScheduleAppointmentOutput = {
  __typename?: 'CreateScheduleAppointmentOutput';
  appointmentDetails: AppointmentDetailGql;
  paymentLink: Scalars['String'];
  stripeRedirectedLink: Scalars['String'];
};

export type CreateSubPatientInput = {
  SENSITIVE_dob: Scalars['String'];
  firstName: Scalars['String'];
  gender: Scalars['String'];
  lastName: Scalars['String'];
  relationship?: InputMaybe<SubPatientRelationship>;
};

export type CreateZrtOutput = {
  __typename?: 'CreateZrtOutput';
  created_at: Scalars['String'];
  health_questionnaire_pdf_id: Scalars['String'];
  swab_code: Scalars['String'];
  test_id: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
};

export type DateFilterArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
};

/** Enum representing the possible values for provider_dea_licenses.type. */
export enum DeaLicenseType {
  Dea = 'DEA',
  Nadean = 'NADEAN',
  Primary = 'Primary'
}

export type DeaSchedulesAllowedInput = {
  schedule2?: InputMaybe<Scalars['Boolean']>;
  schedule3?: InputMaybe<Scalars['Boolean']>;
  schedule4?: InputMaybe<Scalars['Boolean']>;
  schedule5?: InputMaybe<Scalars['Boolean']>;
};

export type DeaSchedulesAllowedOutput = {
  __typename?: 'DeaSchedulesAllowedOutput';
  schedule2: Scalars['Boolean'];
  schedule3: Scalars['Boolean'];
  schedule4: Scalars['Boolean'];
  schedule5: Scalars['Boolean'];
};

export type DelegatedAdmin = {
  __typename?: 'DelegatedAdmin';
  acceptedAt?: Maybe<Scalars['String']>;
  accountDeletedAt?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invitationId: Scalars['String'];
  invitedAt?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type DelegatedAdminCodexIdInput = {
  delegatedAdminCodexId: Scalars['String'];
};

export type DelegatedAdminDetailsOutput = {
  __typename?: 'DelegatedAdminDetailsOutput';
  acceptedAt?: Maybe<Scalars['String']>;
  accountDeletedAt?: Maybe<Scalars['String']>;
  deletedByEmail?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invitationId: Scalars['String'];
  invitedAt?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  permissions: Array<AdminPermissionType>;
};

/** Enum representing the possible values for sorting delegated admins. */
export enum DelegatedAdminOrderByCriterias {
  AcceptedAt = 'ACCEPTED_AT',
  InvitedAt = 'INVITED_AT'
}

export type DelegatedAdminOrderByInput = {
  direction?: InputMaybe<OrderByDirections>;
  field?: InputMaybe<DelegatedAdminOrderByCriterias>;
};

export type DeliveryAddressOutput = {
  __typename?: 'DeliveryAddressOutput';
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  created_at: Scalars['String'];
  id: Scalars['Int'];
  is_deleted: Scalars['Boolean'];
  phone: Scalars['String'];
  state: Scalars['String'];
  updated_at: Scalars['String'];
  user_id: Scalars['String'];
  zip_code: Scalars['String'];
};

export type DeliveryAddressesOutput = {
  __typename?: 'DeliveryAddressesOutput';
  delivery_addresses: Array<DeliveryAddressOutput>;
  total: Scalars['Int'];
};

export type DependentLinkOutput = {
  __typename?: 'DependentLinkOutput';
  childFullscriptId: Scalars['String'];
  guardianFullscriptId: Scalars['String'];
};

export type DiagnosticReportOrderByInput = {
  direction: OrderByDirections;
  field: OrderByCriterias;
};

/** Enum representing the possible values for "status" field in CreateFHIRZrtTestInput. */
export enum DiagnosticReportStatus {
  Amended = 'AMENDED',
  Appended = 'APPENDED',
  Cancelled = 'CANCELLED',
  Corrected = 'CORRECTED',
  EnteredInError = 'ENTERED_IN_ERROR',
  Final = 'FINAL',
  Partial = 'PARTIAL',
  Preliminary = 'PRELIMINARY',
  Registered = 'REGISTERED',
  Unknown = 'UNKNOWN'
}

export type DiagnosticSolutionTestOutput = {
  __typename?: 'DiagnosticSolutionTestOutput';
  appointment_codex_id?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  fhirId: Scalars['String'];
  patient_fhir_id?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_acuity_calendar_id?: Maybe<Scalars['String']>;
  provider_acuity_owner_id?: Maybe<Scalars['String']>;
  provider_codex_id?: Maybe<Scalars['String']>;
  provider_fhir_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  questionnaire_required?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  swab_code?: Maybe<Scalars['String']>;
  test_id?: Maybe<Scalars['String']>;
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
};

export type DiscountOutput = {
  __typename?: 'DiscountOutput';
  amountOff?: Maybe<Scalars['Float']>;
  code?: Maybe<Scalars['String']>;
  percentOff?: Maybe<Scalars['Int']>;
};

/** Enum representing the possible values for "field" field in DnaVisitOrderByInput. */
export enum DnaVisitOrderByCriterias {
  CreatedAt = 'CREATED_AT',
  ProviderName = 'PROVIDER_NAME',
  SapphirosBarcode = 'SAPPHIROS_BARCODE',
  TestType = 'TEST_TYPE'
}

export type DnaVisitOrderByInput = {
  direction: OrderByDirections;
  field: DnaVisitOrderByCriterias;
};

export type DnaVisitTestDefinition = {
  __typename?: 'DnaVisitTestDefinition';
  test_type: Hasura_Test_Types_Enum;
};

export type DnaVisitTestOutput = {
  __typename?: 'DnaVisitTestOutput';
  appointment_codex_id?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  diagnosticReportId: Scalars['String'];
  dna_test_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  dnavisit_order_id: Scalars['String'];
  health_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  last_processed_date?: Maybe<Scalars['String']>;
  last_processed_state?: Maybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  molecular_order_id?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_acuity_calendar_id?: Maybe<Scalars['String']>;
  provider_acuity_owner_id?: Maybe<Scalars['String']>;
  provider_codex_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  questionnaire_required?: Maybe<Scalars['Boolean']>;
  sapphiros_barcode: Scalars['String'];
  sapphiros_report_pdf_id?: Maybe<Scalars['String']>;
  state: Hasura_Dnavisit_Test_Statuses_Enum;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  test_id: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
  visit_summary_pdf_id?: Maybe<Scalars['String']>;
};

export type DnaVisitTestWithUserOutput = {
  __typename?: 'DnaVisitTestWithUserOutput';
  appointment_codex_id?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  diagnosticReportId: Scalars['String'];
  dna_test_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  dnavisit_order_id: Scalars['String'];
  dnavisit_tests_npi_data: DnaVisitTestsNpiData;
  dnavisit_tests_test: DnaVisitTestsTest;
  health_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  last_processed_date?: Maybe<Scalars['String']>;
  last_processed_state?: Maybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  molecular_order_id?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_acuity_calendar_id?: Maybe<Scalars['String']>;
  provider_acuity_owner_id?: Maybe<Scalars['String']>;
  provider_codex_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  questionnaire_required?: Maybe<Scalars['Boolean']>;
  sapphiros_barcode: Scalars['String'];
  sapphiros_report_pdf_id?: Maybe<Scalars['String']>;
  sapphiros_results?: Maybe<Scalars['JSON']>;
  state: Hasura_Dnavisit_Test_Statuses_Enum;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  test_id: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
  visit_summary_pdf_id?: Maybe<Scalars['String']>;
};

export type DnaVisitTestsNpiData = {
  __typename?: 'DnaVisitTestsNpiData';
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  npi_number: Scalars['String'];
  prefix: Scalars['String'];
};

export type DnaVisitTestsTest = {
  __typename?: 'DnaVisitTestsTest';
  tests_test_definition: DnaVisitTestDefinition;
  tests_user: DnaVisitTestsUser;
};

export type DnaVisitTestsUser = {
  __typename?: 'DnaVisitTestsUser';
  SENSITIVE_address_information?: Maybe<DnaVisitTestsUserAddressInformation>;
  SENSITIVE_dob?: Maybe<Scalars['String']>;
  SENSITIVE_email?: Maybe<Scalars['String']>;
  SENSITIVE_firstname?: Maybe<Scalars['String']>;
  SENSITIVE_gender?: Maybe<Scalars['String']>;
  SENSITIVE_lastname?: Maybe<Scalars['String']>;
  SENSITIVE_phone?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export type DnaVisitTestsUserAddressInformation = {
  __typename?: 'DnaVisitTestsUserAddressInformation';
  addressLine1: Scalars['String'];
  addressLine2: Scalars['String'];
  city: Scalars['String'];
  phone: Scalars['String'];
  phoneCountry: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type Dosage = {
  __typename?: 'Dosage';
  asNeededBoolean?: Maybe<Scalars['Boolean']>;
  asNeededCodeableConcept?: Maybe<CodeableConcept>;
  doseQuantity?: Maybe<Quantity>;
  method?: Maybe<CodeableConcept>;
  route?: Maybe<CodeableConcept>;
  text?: Maybe<Scalars['String']>;
  timing?: Maybe<Timing>;
};

export type DosageInput = {
  asNeededBoolean?: InputMaybe<Scalars['Boolean']>;
  asNeededCodeableConcept?: InputMaybe<CodeableConceptInput>;
  doseQuantity?: InputMaybe<QuantityInput>;
  method?: InputMaybe<CodeableConceptInput>;
  route?: InputMaybe<CodeableConceptInput>;
  text?: InputMaybe<Scalars['String']>;
  timing?: InputMaybe<TimingInput>;
};

export type DownloadInvoiceOrReceiptUrlOutput = {
  __typename?: 'DownloadInvoiceOrReceiptUrlOutput';
  invoiceUrl?: Maybe<Scalars['String']>;
  receiptUrl?: Maybe<Scalars['String']>;
};

export type Duration = {
  __typename?: 'Duration';
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type DurationInput = {
  unit?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type DynamicQuestionnaireDependencies = {
  __typename?: 'DynamicQuestionnaireDependencies';
  if: Scalars['JSONObject'];
  then: ThenObject;
};

export type EPrescribeIframeJwtOutput = {
  __typename?: 'EPrescribeIframeJWTOutput';
  jwt: Scalars['String'];
  licenseId?: Maybe<Scalars['String']>;
  npi?: Maybe<Scalars['String']>;
  userGuid?: Maybe<Scalars['String']>;
};

export type EPrescribeJwtInput = {
  mode: EPrescribeSsoMode;
  patientCodexId?: InputMaybe<Scalars['String']>;
};

export enum EPrescribeSsoMode {
  PatientLockDownMode = 'PatientLockDownMode',
  SsoidProofing = 'SSOIDProofing',
  TaskMode = 'TaskMode',
  UtilityMode = 'UtilityMode'
}

export type EducationCourseContentCounterOutput = {
  __typename?: 'EducationCourseContentCounterOutput';
  type: Scalars['String'];
  value: Scalars['Int'];
};

export type EducationCourseInput = {
  courseImageFileId: Scalars['String'];
  description: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  modules?: InputMaybe<Array<UpsertEducationModuleInput>>;
  title: Scalars['String'];
  visibilityRoles: Array<Roles_Enum>;
};

export type EducationCourseListItemOutput = {
  __typename?: 'EducationCourseListItemOutput';
  contentCounters: Array<EducationCourseContentCounterOutput>;
  courseImageFile: FileOutput;
  createdAt: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['String'];
  visibilityRoles: Array<Scalars['String']>;
};

/** Enum representing the possible values for EducationModuleItem category. */
export enum EducationCourseModuleItemCategory {
  Article = 'Article',
  Audio = 'Audio',
  Slides = 'Slides',
  Video = 'Video'
}

export type EducationCourseOutput = {
  __typename?: 'EducationCourseOutput';
  contentCounters: Array<EducationCourseContentCounterOutput>;
  courseImageFile: FileOutput;
  createdAt: Scalars['String'];
  description: Scalars['String'];
  educationModules: Array<EducationModuleOutput>;
  id: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['String'];
  visibilityRoles: Array<Scalars['String']>;
};

export type EducationCoursesListOutput = {
  __typename?: 'EducationCoursesListOutput';
  courses: Array<EducationCourseListItemOutput>;
  total: Scalars['Int'];
};

export type EducationModuleAdditionalMaterialOutput = {
  __typename?: 'EducationModuleAdditionalMaterialOutput';
  createdAt: Scalars['String'];
  id: Scalars['String'];
  linkedModule: LinkedEducationModuleOutput;
  linkedModuleId: Scalars['String'];
  moduleId: Scalars['String'];
};

export type EducationModuleItemOutput = {
  __typename?: 'EducationModuleItemOutput';
  category: EducationCourseModuleItemCategory;
  createdAt: Scalars['String'];
  file: FileOutput;
  id: Scalars['String'];
  moduleId: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type EducationModuleOutput = {
  __typename?: 'EducationModuleOutput';
  additionalMaterialsModules?: Maybe<Array<EducationModuleAdditionalMaterialOutput>>;
  courseId: Scalars['String'];
  createdAt: Scalars['String'];
  educationModuleItems?: Maybe<Array<EducationModuleItemOutput>>;
  id: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type EducationModulesListOutput = {
  __typename?: 'EducationModulesListOutput';
  modules: Array<EducationModuleOutput>;
  total: Scalars['Int'];
};

export type EncounterFileOutput = {
  __typename?: 'EncounterFileOutput';
  contentType?: Maybe<ContentType>;
  creation?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type EncounterListOutput = {
  __typename?: 'EncounterListOutput';
  encounters: Array<EncounterOutput>;
  total: Scalars['Int'];
};

export type EncounterOutput = {
  __typename?: 'EncounterOutput';
  appointmentCodexId?: Maybe<Scalars['String']>;
  appointmentDate?: Maybe<Scalars['String']>;
  class?: Maybe<Scalars['String']>;
  encounterId: Scalars['String'];
  finishedAt?: Maybe<Scalars['String']>;
  patientCodexId?: Maybe<Scalars['String']>;
  patientFirstName?: Maybe<Scalars['String']>;
  patientLastName?: Maybe<Scalars['String']>;
  providerCodexId?: Maybe<Scalars['String']>;
  providerFirstName?: Maybe<Scalars['String']>;
  providerLastName?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

/** Encounter statuses extracted from FHIR: https://hl7.org/fhir/R4/valueset-encounter-status.html */
export enum EncounterStatuses {
  Arrived = 'arrived',
  Cancelled = 'cancelled',
  EnteredInError = 'entered_in_error',
  Finished = 'finished',
  InProgress = 'in_progress',
  Onleave = 'onleave',
  Planned = 'planned',
  Triaged = 'triaged',
  Unknown = 'unknown'
}

export type FhirAppointmentNotesObservation = {
  anythingElseQuestion?: InputMaybe<Scalars['String']>;
  howLongQuestion?: InputMaybe<Scalars['String']>;
  severityQuestion?: InputMaybe<Scalars['String']>;
  symptomsTypes?: InputMaybe<Array<Scalars['String']>>;
};

export type FhirAppointmentNotesObservationOutput = {
  __typename?: 'FHIRAppointmentNotesObservationOutput';
  anythingElseQuestion?: Maybe<Scalars['String']>;
  howLongQuestion?: Maybe<Scalars['String']>;
  practitionerNotes?: Maybe<Scalars['String']>;
  severityQuestion?: Maybe<Scalars['String']>;
  symptomsTypes?: Maybe<Array<Scalars['String']>>;
};

export type FhirEncounterNotesOutput = {
  __typename?: 'FHIREncounterNotesOutput';
  files?: Maybe<Array<EncounterFileOutput>>;
  followupRecommendations: Scalars['String'];
  lastUpdated: Scalars['String'];
  providerNotes: Scalars['String'];
  providerSummary: Scalars['String'];
  systemGenerated: Scalars['String'];
  transcription: Scalars['String'];
};

/** Enum representing the possible values for sorting FHIR patients. */
export enum FhirPatientOrderByCriterias {
  LastAppointmentDate = 'LAST_APPOINTMENT_DATE',
  PatientName = 'PATIENT_NAME',
  SensitiveEmail = 'SENSITIVE_EMAIL',
  SensitiveFirstname = 'SENSITIVE_FIRSTNAME',
  SensitiveLastname = 'SENSITIVE_LASTNAME',
  StartPatientDate = 'START_PATIENT_DATE'
}

/** Enum representing the possible values for sorting FHIR recommendations. */
export enum FhirRecommendationsOrderByCriterias {
  CreatedAt = 'CreatedAt'
}

/** Enum representing the possible values for "questionnaireName" field in AttachQuestionnaireResponseInputment. */
export enum FhirQuestionnaireNames {
  DiagnosticSolutionQuestionnaire = 'DIAGNOSTIC_SOLUTION_QUESTIONNAIRE',
  DnaVitaminQuestionnaire = 'DNA_VITAMIN_QUESTIONNAIRE',
  HealthQuestionnaire = 'HEALTH_QUESTIONNAIRE',
  MosaicQuestionnaire = 'MOSAIC_QUESTIONNAIRE',
  ZrtQuestionnaire = 'ZRT_QUESTIONNAIRE'
}

export type FileAttachmentInput = {
  contentType: ContentType;
  fileId: Scalars['String'];
  size?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type FileOutput = {
  __typename?: 'FileOutput';
  contentType?: Maybe<Scalars['String']>;
  creation?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

/** Enum representation of file types */
export enum FileTypesEnum {
  Archive = 'Archive',
  Audio = 'Audio',
  Document = 'Document',
  Image = 'Image',
  Other = 'Other',
  Pdf = 'Pdf',
  Presentation = 'Presentation',
  Spreadsheet = 'Spreadsheet',
  Text = 'Text',
  Video = 'Video'
}

export type FromFhirToHasuraAnswerItemUnion = HasuraAnswerItem | HasuraMedicationItem;

export type FullscriptAllergenOutput = {
  __typename?: 'FullscriptAllergenOutput';
  created_at: Scalars['String'];
  fullscript_id: Scalars['String'];
  fullscript_name: Scalars['String'];
  id: Scalars['Int'];
  updated_at: Scalars['String'];
};

export type FullscriptAllergensOutput = {
  __typename?: 'FullscriptAllergensOutput';
  fullscript_allergens: Array<FullscriptAllergenOutput>;
  total: Scalars['Int'];
};

export type FullscriptOperationResult = {
  __typename?: 'FullscriptOperationResult';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type FullscriptSessionGrantResult = {
  __typename?: 'FullscriptSessionGrantResult';
  patientFullscriptId: Scalars['String'];
  sessionGrant: Scalars['String'];
};

export type GetAppointmentChatMessagesOutput = {
  __typename?: 'GetAppointmentChatMessagesOutput';
  chat?: Maybe<AppointmentChat>;
};

export type GetAppointmentMediaOutput = {
  __typename?: 'GetAppointmentMediaOutput';
  bodySite?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fhirId: Scalars['String'];
  fileId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type GetAppointmentNotesByAppointmentIdOutput = {
  __typename?: 'GetAppointmentNotesByAppointmentIdOutput';
  nabla_notes: Array<NablaNote>;
};

export type GetAppointmentOutput = {
  __typename?: 'GetAppointmentOutput';
  acuityId?: Maybe<Scalars['String']>;
  appointmentCodexId: Scalars['String'];
  appointmentId: Scalars['String'];
  appointmentNotes?: Maybe<FhirAppointmentNotesObservationOutput>;
  appointmentStatus?: Maybe<Scalars['Int']>;
  appointmentType?: Maybe<AppointmentTypeEnum>;
  appointmentUrl?: Maybe<Scalars['String']>;
  cancelationReason?: Maybe<Scalars['String']>;
  codexPatientId: Scalars['String'];
  codexProviderId?: Maybe<Scalars['String']>;
  created: Scalars['String'];
  diagnosticReports?: Maybe<Array<GetFhirAppointmentDiagnosticReportOutput>>;
  encounterId?: Maybe<Scalars['String']>;
  encounterNotes?: Maybe<FhirEncounterNotesOutput>;
  end?: Maybe<Scalars['String']>;
  events?: Maybe<Array<AppointmentEvent>>;
  isSummaryCompleted: Scalars['Boolean'];
  lastProcessedDate: Scalars['String'];
  lastUpdate?: Maybe<Scalars['String']>;
  media?: Maybe<Array<GetAppointmentMediaOutput>>;
  participant: Array<ReferenceType>;
  patientFirstName?: Maybe<Scalars['String']>;
  patientLastName?: Maybe<Scalars['String']>;
  paymentInformation?: Maybe<AppointmentPaymentOutput>;
  paymentSessionOpenedAt?: Maybe<Scalars['String']>;
  pendingRescheduleRequest?: Maybe<AppointmentRequestOutput>;
  provider?: Maybe<ProviderOutput>;
  providerFirstName?: Maybe<Scalars['String']>;
  providerLastName?: Maybe<Scalars['String']>;
  recommendations?: Maybe<Array<GetFhirRecommendationOutput>>;
  start?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  statusHistory: Array<AppointmentStatusHistoryEntry>;
  subjectOfAppointment?: Maybe<Scalars['String']>;
  summaryPdfFileId?: Maybe<Scalars['String']>;
  supportingInformation?: Maybe<Array<ReferenceType>>;
  symptomsLocation?: Maybe<Array<Scalars['String']>>;
  transcriptionReadyAt?: Maybe<Scalars['String']>;
  visitSummaryPdfUrl?: Maybe<Scalars['String']>;
};

export type GetAppointmentRescheduleLinkOutput = {
  __typename?: 'GetAppointmentRescheduleLinkOutput';
  rescheduleLink?: Maybe<Scalars['String']>;
};

export type GetAppointmentRescheduleRequestInput = {
  appointmentId?: InputMaybe<Scalars['String']>;
  appointmentRescheduleRequestId?: InputMaybe<Scalars['String']>;
};

export type GetBasicPatientInfoOutput = {
  __typename?: 'GetBasicPatientInfoOutput';
  SENSITIVE_address_information?: Maybe<AddressInformationOutput>;
  SENSITIVE_birth_date?: Maybe<Scalars['String']>;
  SENSITIVE_email?: Maybe<Scalars['String']>;
  SENSITIVE_etnicity?: Maybe<Array<Scalars['String']>>;
  SENSITIVE_firstname?: Maybe<Scalars['String']>;
  SENSITIVE_gender?: Maybe<Scalars['String']>;
  SENSITIVE_lastname?: Maybe<Scalars['String']>;
  SENSITIVE_pharmacies?: Maybe<Array<PharmacyInformationOutput>>;
  SENSITIVE_phone?: Maybe<Scalars['String']>;
  SENSITIVE_profile_picture_id?: Maybe<Scalars['String']>;
  SENSITIVE_self_identity_gender?: Maybe<Scalars['String']>;
  SENSITIVE_user_measurements?: Maybe<PatientMeasurementsOutput>;
  appointments?: Maybe<Array<GetAppointmentOutput>>;
  canReceivePrescriptions: Scalars['Boolean'];
  child_fully_verified?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['String']>;
  fhirId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  kyc_approved: Scalars['Boolean'];
  lastAppointmentDate?: Maybe<Scalars['String']>;
  parentCodexId?: Maybe<Scalars['String']>;
  requestStatus?: Maybe<ProviderRequestStatus>;
};

export type GetBecomePatientRequestsInput = {
  statuses?: InputMaybe<Array<ProviderRequestStatus>>;
};

export type GetDelegatedAdminsInput = {
  inviteDateFrom?: InputMaybe<Scalars['String']>;
  inviteDateTo?: InputMaybe<Scalars['String']>;
  isAccepted?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type GetDelegatedAdminsOutput = {
  __typename?: 'GetDelegatedAdminsOutput';
  delegatedAdmins: Array<DelegatedAdmin>;
  total: Scalars['Int'];
};

export type GetEducationModulesInput = {
  excludeModuleIds?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Roles_Enum>>;
};

export type GetFhirAppointmentDiagnosticReportOutput = {
  __typename?: 'GetFHIRAppointmentDiagnosticReportOutput';
  createdAt?: Maybe<Scalars['String']>;
  diagnosticReportId: Scalars['String'];
  diagnosticReportStatus: Hasura_Dnavisit_Test_Statuses_Enum;
  diagnosticReportTestType: Hasura_Test_Types_Enum;
  patientPdf?: Maybe<FileOutput>;
  patientPdfId?: Maybe<Scalars['String']>;
  providerPdf?: Maybe<FileOutput>;
  providerPdfId?: Maybe<Scalars['String']>;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  swabCode: Scalars['String'];
};

export type GetFhirAppointmentOutput = {
  __typename?: 'GetFHIRAppointmentOutput';
  appointment?: Maybe<GetAppointmentOutput>;
};

export type GetFhirAppointmentsOutput = {
  __typename?: 'GetFHIRAppointmentsOutput';
  appointment: Array<GetAppointmentOutput>;
  total: Scalars['Int'];
};

export type GetFhirAppointmentsOutputWithUpcomingCounts = {
  __typename?: 'GetFHIRAppointmentsOutputWithUpcomingCounts';
  appointment: Array<GetAppointmentOutput>;
  counts: UpcomingAppointmentCounts;
  total: Scalars['Int'];
};

export type GetFhirDnaAndZrtTests = {
  __typename?: 'GetFHIRDnaAndZrtTests';
  diagnostic_solution_tests: Array<RankedDiagnosticSolutionVisitTestOutput>;
  dna_tests: Array<RankedDnaVisitTestOutput>;
  mosaic_tests: Array<RankedMosaicVisitTestOutput>;
  total: Scalars['Int'];
  zrt_tests: Array<RankedZrtTestOutput>;
};

export type GetFhirDnaVisitTestByIdentifier = {
  __typename?: 'GetFHIRDnaVisitTestByIdentifier';
  dnavisit_tests?: Maybe<Array<DnaVisitTestWithUserOutput>>;
};

export type GetFhirDnaVisitTests = {
  __typename?: 'GetFHIRDnaVisitTests';
  dnavisit_tests: Array<DnaVisitTestOutput>;
  total: Scalars['Int'];
};

export type GetFhirDnaVisitTestsByUserId = {
  __typename?: 'GetFHIRDnaVisitTestsByUserId';
  dnavisit_tests: Array<DnaVisitTestOutput>;
  providers: Array<Scalars['String']>;
  total: Scalars['Int'];
};

export type GetFhirMosaicTests = {
  __typename?: 'GetFHIRMosaicTests';
  mosaicTests?: Maybe<Array<MosaicTestOutput>>;
  total: Scalars['Int'];
};

export type GetFhirPatientsByIdDateFilterInput = {
  appointmentDateEnd: Scalars['String'];
  appointmentDateStart: Scalars['String'];
};

export type GetFhirPatientsByIdOrderByInput = {
  direction: OrderByDirections;
  field: FhirPatientOrderByCriterias;
};

export type GetFhirPatientsByProviderIdOutput = {
  __typename?: 'GetFHIRPatientsByProviderIdOutput';
  patients: Array<PatientWithMemberOutput>;
  total: Scalars['Int'];
};

export type GetFhirProviderBioByIdOutput = {
  __typename?: 'GetFHIRProviderBioByIdOutput';
  providers: Array<ProviderOutput>;
};

export type GetFhirProviderByEmailOutput = {
  __typename?: 'GetFHIRProviderByEmailOutput';
  providers: Array<ProviderOutput>;
};

export type GetFhirProviderByIdOutput = {
  __typename?: 'GetFHIRProviderByIdOutput';
  providers: Array<ProviderOutput>;
  total?: Maybe<Scalars['Int']>;
};

export type GetFhirProvidersByDnaAndZrtTests = {
  __typename?: 'GetFHIRProvidersByDnaAndZrtTests';
  provider_names: Array<Scalars['String']>;
  total: Scalars['Int'];
};

export type GetFhirProvidersOutput = {
  __typename?: 'GetFHIRProvidersOutput';
  providers: Array<ProviderOutput>;
  total?: Maybe<Scalars['Float']>;
};

export type GetFhirQuestionnaireResponse = {
  __typename?: 'GetFHIRQuestionnaireResponse';
  questionnaire_response: GetQuestionnaireResponse;
};

export type GetFhirQuestionnaireResponseArr = {
  __typename?: 'GetFHIRQuestionnaireResponseArr';
  data: Array<GetQuestionnaireResponse>;
};

export type GetFhirRecommendationOutput = {
  __typename?: 'GetFHIRRecommendationOutput';
  createdAt: Scalars['String'];
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  patientCodexId: Scalars['String'];
  productId: Scalars['Int'];
  productTitle: Scalars['String'];
  providerCodexId: Scalars['String'];
  providerName: Scalars['String'];
  quantity: Scalars['Int'];
  status: ServiceRequestStatus;
  totalPrice: Scalars['Float'];
};

export type GetFhirRecommendationsOrderByInput = {
  direction?: OrderByDirections;
  field?: FhirRecommendationsOrderByCriterias;
};

export type GetFhirRecommendationsOutput = {
  __typename?: 'GetFHIRRecommendationsOutput';
  recommendations: Array<GetFhirRecommendationOutput>;
  total: Scalars['Int'];
};

export type GetFhirZrtTest = {
  __typename?: 'GetFHIRZrtTest';
  zrt_test: ZrtTestOutput;
};

export type GetFhirZrtTests = {
  __typename?: 'GetFHIRZrtTests';
  zrt_tests: Array<ZrtTestOutput>;
};

export type GetFreeProvidersByTimeSlotsInput = {
  acceptedAppointments?: InputMaybe<Array<Scalars['String']>>;
  appointmentTypeId: Scalars['String'];
  date: Scalars['String'];
  gender?: InputMaybe<Array<Scalars['String']>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  medicalRole?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  serverOfferedRange?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  specialty?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Scalars['String']>;
  yearOfExperienceRange?: InputMaybe<Scalars['String']>;
};

export type GetInMailDetailInput = {
  contactCodexId?: InputMaybe<Scalars['String']>;
  inMailId?: InputMaybe<Scalars['String']>;
};

export type GetInMailsInput = {
  contactCodexId?: InputMaybe<Scalars['String']>;
  queryName?: InputMaybe<Scalars['String']>;
};

export type GetLastViewedPatientByUserQueryOutput = {
  __typename?: 'GetLastViewedPatientByUserQueryOutput';
  patients: Array<GetPatientOutput>;
};

export type GetLastViewedProvidersByUserQueryOutput = {
  __typename?: 'GetLastViewedProvidersByUserQueryOutput';
  providers: Array<ProviderOutput>;
};

export type GetLatestFhirQuestionnaireById = {
  __typename?: 'GetLatestFHIRQuestionnaireById';
  id: Scalars['String'];
  responses: Scalars['JSON'];
};

export type GetLatestFhirQuestionnaireByIdResponse = {
  __typename?: 'GetLatestFHIRQuestionnaireByIdResponse';
  questionnaire_responses: Array<GetLatestFhirQuestionnaireById>;
};

export type GetLegalDocumentInput = {
  type: Hasura_Legal_Document_Types_Enum;
  version?: InputMaybe<Scalars['Int']>;
};

export type GetLegalDocumentsInput = {
  types?: InputMaybe<Array<Hasura_Legal_Document_Types_Enum>>;
};

export type GetMediaFilesOutput = {
  __typename?: 'GetMediaFilesOutput';
  files: Array<MediaFileOutput>;
  total: Scalars['Int'];
};

export type GetMedicationRequestsBrandAndNameOutput = {
  __typename?: 'GetMedicationRequestsBrandAndNameOutput';
  medication_request_bran_and_names: Array<Scalars['String']>;
};

export type GetMedicationRequestsOutput = {
  __typename?: 'GetMedicationRequestsOutput';
  medication_requests: Array<MedicationRequestOutputDto>;
  total: Scalars['Int'];
};

export type GetMemberGroupOutput = {
  __typename?: 'GetMemberGroupOutput';
  inactive?: Maybe<Scalars['Boolean']>;
  period?: Maybe<GroupPeriod>;
};

export type GetPatientOutput = {
  __typename?: 'GetPatientOutput';
  SENSITIVE_address_information?: Maybe<AddressInformationOutput>;
  SENSITIVE_country?: Maybe<Scalars['String']>;
  SENSITIVE_dob?: Maybe<Scalars['String']>;
  SENSITIVE_email?: Maybe<Scalars['String']>;
  SENSITIVE_etnicity?: Maybe<Array<Scalars['String']>>;
  SENSITIVE_firstname?: Maybe<Scalars['String']>;
  SENSITIVE_gender?: Maybe<Scalars['String']>;
  SENSITIVE_gender_describe?: Maybe<Scalars['String']>;
  SENSITIVE_lastname?: Maybe<Scalars['String']>;
  SENSITIVE_pharmacies?: Maybe<Array<PharmacyInformationOutput>>;
  SENSITIVE_phone?: Maybe<Scalars['String']>;
  SENSITIVE_profile_picture_id?: Maybe<Scalars['String']>;
  SENSITIVE_self_identity_gender?: Maybe<Scalars['String']>;
  SENSITIVE_user_measurements?: Maybe<PatientMeasurementsOutput>;
  account_closed_at?: Maybe<Scalars['String']>;
  account_closure_reason?: Maybe<Scalars['String']>;
  autonomy_determination_status?: Maybe<AutonomyDeterminationStatus>;
  blocked_at?: Maybe<Scalars['String']>;
  canReceivePrescriptions: Scalars['Boolean'];
  child_fully_verified?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['String'];
  data_retention_until?: Maybe<Scalars['String']>;
  highContrastMode: Scalars['Boolean'];
  id: Scalars['String'];
  identifiers?: Maybe<PatientIdentifiersOutput>;
  isContactInfoCompleted?: Maybe<Scalars['Boolean']>;
  isProfileCompleted?: Maybe<Scalars['Boolean']>;
  isQuestionnaireCompleted?: Maybe<Scalars['Boolean']>;
  is_state_dob_valid: Scalars['Boolean'];
  measurementsLastUpdatedAt?: Maybe<Scalars['String']>;
  minor_autonomy_evidence: Array<MinorAutonomyEvidenceTypes>;
  parentCodexId?: Maybe<Scalars['String']>;
  required_agreements_approved?: Maybe<Scalars['Boolean']>;
  sapphirosId?: Maybe<Scalars['String']>;
  skinTreatmentBannerDismissedAt?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
};

export type GetPaymentLinkOutput = {
  __typename?: 'GetPaymentLinkOutput';
  link: Scalars['String'];
};

export type GetProductsOutput = {
  __typename?: 'GetProductsOutput';
  lastShipMonkSyncAt?: Maybe<Scalars['String']>;
  products: Array<ProductOutput>;
  total: Scalars['Int'];
};

export type GetProviderBioById = {
  __typename?: 'GetProviderBioById';
  providers: ProviderOutput;
};

export type GetProviderBioByIdQueryOutput = {
  __typename?: 'GetProviderBioByIdQueryOutput';
  providers: Array<GetProviderBioById>;
};

export type GetProviderPaymentDetailsOutput = {
  __typename?: 'GetProviderPaymentDetailsOutput';
  amount: Scalars['Float'];
  lastPaymentAt?: Maybe<Scalars['String']>;
};

export type GetQuestionnaireOutput = {
  __typename?: 'GetQuestionnaireOutput';
  data: Array<QuestionnaireDependenciesGroup>;
  questionnaires_questionnaire_questions: Array<QuestionnairesQuestionnaireQuestions>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type GetQuestionnaireResponse = {
  __typename?: 'GetQuestionnaireResponse';
  created_at?: Maybe<Scalars['String']>;
  current_step_index?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  is_complete: QuestionnaireResponseStatus;
  responses: Array<FromFhirToHasuraAnswerItemUnion>;
  swab_code?: Maybe<Scalars['String']>;
  test_name_type?: Maybe<Scalars['String']>;
  test_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type GetSuperAdminsInput = {
  search?: InputMaybe<Scalars['String']>;
};

export type GetSuperAdminsOutput = {
  __typename?: 'GetSuperAdminsOutput';
  superAdmins: Array<SuperAdminListItem>;
  total: Scalars['Int'];
};

export type GetSupportChatDetailInput = {
  chatId?: InputMaybe<Scalars['String']>;
};

export type GetSupportChatsInput = {
  queryName?: InputMaybe<Scalars['String']>;
  userRole?: InputMaybe<Roles_Enum>;
};

export type GetUserNotificationsWithCounts = {
  __typename?: 'GetUserNotificationsWithCounts';
  notifications: Array<NotificationOutput>;
  total: Scalars['Int'];
  unreadCount: Scalars['Float'];
};

/** Enum representing possible url values for resources extensions */
export enum GoogleEhrExtensionsUrLs {
  CreatedAt = 'CREATED_AT',
  EhrAbout = 'EHR_ABOUT',
  EhrAppointmentChatAttachmentFileId = 'EHR_APPOINTMENT_CHAT_ATTACHMENT_FILE_ID',
  EhrAppointmentChatAttachmentFrom = 'EHR_APPOINTMENT_CHAT_ATTACHMENT_FROM',
  EhrAppointmentDiagnosticReportId = 'EHR_APPOINTMENT_DIAGNOSTIC_REPORT_ID',
  EhrAppointmentLastProcessedStartDate = 'EHR_APPOINTMENT_LAST_PROCESSED_START_DATE',
  EhrAppointmentPaidStatus = 'EHR_APPOINTMENT_PAID_STATUS',
  EhrAppointmentSummaryPdfFileId = 'EHR_APPOINTMENT_SUMMARY_PDF_FILE_ID',
  EhrAppointmentUrl = 'EHR_APPOINTMENT_URL',
  EhrAutonomyDeterminationStatusUrl = 'EHR_AUTONOMY_DETERMINATION_STATUS_URL',
  EhrDeviceCode = 'EHR_DEVICE_CODE',
  EhrDnaVisitProviderNpi = 'EHR_DNA_VISIT_PROVIDER_NPI',
  EhrDnaVisitState = 'EHR_DNA_VISIT_STATE',
  EhrDsGiMapVisitState = 'EHR_DS_GI_MAP_VISIT_STATE',
  EhrEncounterDocumentReference = 'EHR_ENCOUNTER_DOCUMENT_REFERENCE',
  EhrGenderDescribe = 'EHR_GENDER_DESCRIBE',
  EhrLastProcessedTestKitDate = 'EHR_LAST_PROCESSED_TEST_KIT_DATE',
  EhrLastProcessedTestKitStatus = 'EHR_LAST_PROCESSED_TEST_KIT_STATUS',
  EhrMedicationIsBrand = 'EHR_MEDICATION_IS_BRAND',
  EhrMinorAutonomyEvidenceUrl = 'EHR_MINOR_AUTONOMY_EVIDENCE_URL',
  EhrMosaicId = 'EHR_MOSAIC_ID',
  EhrMosaicVisitState = 'EHR_MOSAIC_VISIT_STATE',
  EhrNpiNumber = 'EHR_NPI_NUMBER',
  EhrProviderNoteType = 'EHR_PROVIDER_NOTE_TYPE',
  EhrQuestionnaireResponseCurrentIndexOfSection = 'EHR_QUESTIONNAIRE_RESPONSE_CURRENT_INDEX_OF_SECTION',
  EhrQuestionnaireResponseCurrentSection = 'EHR_QUESTIONNAIRE_RESPONSE_CURRENT_SECTION',
  EhrQuestionnaireResponseCurrentStepIndex = 'EHR_QUESTIONNAIRE_RESPONSE_CURRENT_STEP_INDEX',
  EhrQuestionnaireResponseIsArrayOfStrings = 'EHR_QUESTIONNAIRE_RESPONSE_IS_ARRAY_OF_STRINGS',
  EhrQuestionnaireResponseMedicationStatus = 'EHR_QUESTIONNAIRE_RESPONSE_MEDICATION_STATUS',
  EhrRaceExtension = 'EHR_RACE_EXTENSION',
  EhrResidencyEndDate = 'EHR_RESIDENCY_END_DATE',
  EhrResidencyStartDate = 'EHR_RESIDENCY_START_DATE',
  EhrResidencyStillActive = 'EHR_RESIDENCY_STILL_ACTIVE',
  EhrServiceOfferingPrice = 'EHR_SERVICE_OFFERING_PRICE',
  EhrSwabcode = 'EHR_SWABCODE',
  EhrTrackingNumber = 'EHR_TRACKING_NUMBER',
  EhrZrtState = 'EHR_ZRT_STATE',
  FullscriptUpdatedAt = 'FULLSCRIPT_UPDATED_AT',
  PhoneExtension = 'PHONE_EXTENSION',
  SelfIndentityGenderExtension = 'SELF_INDENTITY_GENDER_EXTENSION',
  StateDobValidUrl = 'STATE_DOB_VALID_URL'
}

export type GroupPeriod = {
  __typename?: 'GroupPeriod';
  start?: Maybe<Scalars['String']>;
};

export type HasuraAnswerItem = {
  __typename?: 'HasuraAnswerItem';
  child_questions?: Maybe<Array<Scalars['Int']>>;
  currentIndexOfSection?: Maybe<Scalars['Int']>;
  currentSection?: Maybe<Scalars['String']>;
  hasuraItemArrayResponse?: Maybe<Array<HasuraAnswerItem>>;
  hasuraMedicationItemResponse?: Maybe<HasuraMedicationItem>;
  questionID?: Maybe<Scalars['Int']>;
  responseType: Scalars['String'];
  stringArrayResponse?: Maybe<Array<Scalars['String']>>;
  stringResponse?: Maybe<Scalars['String']>;
};

export type HasuraMedicationItem = {
  __typename?: 'HasuraMedicationItem';
  child_questions?: Maybe<Array<Scalars['Int']>>;
  completed?: Maybe<Scalars['Boolean']>;
  hasuraItemArrayResponse?: Maybe<Array<HasuraAnswerItem>>;
  hasuraMedicationItemResponse?: Maybe<HasuraMedicationItem>;
  id: Scalars['String'];
  responseType: Scalars['String'];
  stringArrayResponse?: Maybe<Array<Scalars['String']>>;
  stringResponse?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Enum representing the possible values for "state" field in DnaVisitTestOutput. */
export enum Hasura_Dnavisit_Test_Statuses_Enum {
  AppointmentScheduled = 'AppointmentScheduled',
  ApprovedByProvider = 'ApprovedByProvider',
  Canceled = 'Canceled',
  Complete = 'Complete',
  Issue = 'Issue',
  KitNotReceived = 'KitNotReceived',
  ProviderPending = 'ProviderPending',
  ReceivedByLab = 'ReceivedByLab',
  RegistrationFailed = 'RegistrationFailed',
  ResultsWithProvider = 'ResultsWithProvider'
}

/** Enum representing the possible values for laboratory names */
export enum Hasura_Labs_Enum {
  DiagnosticSolutions = 'DiagnosticSolutions',
  DnaVisit = 'DnaVisit',
  MolecularLabs = 'MolecularLabs',
  Mosaic = 'Mosaic',
  Zrt = 'Zrt'
}

/** Legal document types for remote schema fields (maps to Hasura legal_document_types values). */
export enum Hasura_Legal_Document_Types_Enum {
  BaaAgreement = 'BaaAgreement',
  CancellationPolicy = 'CancellationPolicy',
  ConsentToUseAndDiscloseSudRecords = 'ConsentToUseAndDiscloseSudRecords',
  CoppaAgreement = 'CoppaAgreement',
  DnaVisitRecordConsent = 'DnaVisitRecordConsent',
  GeneralTestRecordConsent = 'GeneralTestRecordConsent',
  HippaAgreement = 'HippaAgreement',
  LabSampleResultsPrivacyStatement = 'LabSampleResultsPrivacyStatement',
  NoticeOfPrivacy = 'NoticeOfPrivacy',
  PrivacyPolicy = 'PrivacyPolicy',
  ProviderDataUserAgreement = 'ProviderDataUserAgreement',
  TermsOfService = 'TermsOfService'
}

/** Enum representing the possible values for "test_type" field in PatchZrtOutput. */
export enum Hasura_Test_Types_Enum {
  DnaSkin = 'DnaSkin',
  DnaVitamin = 'DnaVitamin',
  DsGiMap = 'DsGiMap',
  MosaicOat = 'MosaicOat',
  Skintelligent = 'Skintelligent',
  ZrtHeavyMetals = 'ZrtHeavyMetals',
  ZrtHormone = 'ZrtHormone',
  ZrtInflammatory = 'ZrtInflammatory',
  ZrtNeurotransmitters = 'ZrtNeurotransmitters'
}

export type HttpStatusOutput = {
  __typename?: 'HttpStatusOutput';
  message?: Maybe<Scalars['String']>;
  status: Scalars['Int'];
};

export type IdOutput = {
  __typename?: 'IdOutput';
  id: Scalars['String'];
};

export type Identifier = {
  __typename?: 'Identifier';
  system?: Maybe<Scalars['String']>;
  type?: Maybe<CodeableConcept>;
  use?: Maybe<IdentifierUse>;
  value?: Maybe<Scalars['String']>;
};

/** Enum representing the possible values for "use" field in Identifier. */
export enum IdentifierUse {
  Official = 'OFFICIAL',
  Old = 'OLD',
  Secondary = 'SECONDARY',
  Temp = 'TEMP',
  Usual = 'USUAL'
}

export type InMailDetailsOutput = {
  __typename?: 'InMailDetailsOutput';
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastMessageAt?: Maybe<Scalars['String']>;
  messages: Array<InMailMessageOutput>;
  nextPageToken?: Maybe<Scalars['String']>;
  patient: InMailParticipantOutput;
  provider: InMailParticipantOutput;
};

export type InMailMessageOutput = {
  __typename?: 'InMailMessageOutput';
  attachments: Array<Attachment>;
  date: Scalars['String'];
  senderCodexId: Scalars['String'];
  text?: Maybe<Scalars['String']>;
};

export type InMailOutput = {
  __typename?: 'InMailOutput';
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastMessageAt?: Maybe<Scalars['String']>;
  patient: InMailParticipantOutput;
  provider: InMailParticipantOutput;
  read?: Maybe<Scalars['Boolean']>;
};

export type InMailParticipantOutput = {
  __typename?: 'InMailParticipantOutput';
  codexId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  profilePictureId?: Maybe<Scalars['String']>;
};

export type InMailUsageOutput = {
  __typename?: 'InMailUsageOutput';
  updatedAt: Scalars['String'];
  used: Scalars['Int'];
};

export type InMailsOutput = {
  __typename?: 'InMailsOutput';
  contactsWithoutChats: Array<InMailParticipantOutput>;
  inMails: Array<InMailOutput>;
  newTotal: Scalars['Int'];
  total: Scalars['Int'];
};

export type InitialFillOutput = {
  __typename?: 'InitialFillOutput';
  duration?: Maybe<ValueOutput>;
  quantity?: Maybe<ValueOutput>;
};

export type InsertAppointmentChatMessages = {
  appointmentCodexId: Scalars['String'];
  communicationFhirId: Scalars['String'];
  messages: Array<AppointmentChatMessageInput>;
};

export type InsertAppointmentChatMessagesByAppointmentCodexId = {
  appointmentCodexId: Scalars['String'];
  messages: Array<AppointmentChatMessageInput>;
};

/** Enum representing the possible values for "language" field in Attachment. */
export enum Language {
  EnUs = 'EN_US'
}

export type LegalDocumentOutput = {
  __typename?: 'LegalDocumentOutput';
  contentMobile: Scalars['String'];
  contentWeb: Scalars['String'];
  type: Hasura_Legal_Document_Types_Enum;
  updatedAt: Scalars['String'];
  updatedByFullName: Scalars['String'];
  version: Scalars['Int'];
};

export type LegalDocumentsOutput = {
  __typename?: 'LegalDocumentsOutput';
  legalDocuments: Array<LegalDocumentOutput>;
};

export type LinkProviderAccountInput = {
  tokenCode: Scalars['String'];
};

export type LinkedEducationModuleOutput = {
  __typename?: 'LinkedEducationModuleOutput';
  courseId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type MapDependentInput = {
  childCodexId: Scalars['String'];
  fullscriptPatientId: Scalars['String'];
};

export type MediaFileOutput = {
  __typename?: 'MediaFileOutput';
  appointment?: Maybe<GetAppointmentOutput>;
  authorCodexId?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  creation?: Maybe<Scalars['String']>;
  encounterId?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  patient?: Maybe<GetPatientOutput>;
  provider?: Maybe<ProviderOutput>;
  size?: Maybe<Scalars['Int']>;
  sourceType?: Maybe<MediaFileSourceType>;
  url?: Maybe<Scalars['String']>;
};

/** Enum representation of media file types */
export enum MediaFileSourceType {
  AppointmentDiagnostics = 'APPOINTMENT_DIAGNOSTICS',
  Archive = 'ARCHIVE',
  EducationCourseDetails = 'EDUCATION_COURSE_DETAILS',
  EducationCourseModuleMaterial = 'EDUCATION_COURSE_MODULE_MATERIAL',
  InMail = 'IN_MAIL',
  MedicalRecord = 'MEDICAL_RECORD',
  PaymentReceipt = 'PAYMENT_RECEIPT',
  Product = 'PRODUCT',
  Questionnaire = 'QUESTIONNAIRE',
  QuestionnaireResponse = 'QUESTIONNAIRE_RESPONSE',
  Summary = 'SUMMARY',
  SupportChat = 'SUPPORT_CHAT',
  TestKit = 'TEST_KIT',
  User = 'USER',
  Vonage = 'VONAGE'
}

export type MediaFilesFilterInput = {
  contentTypes?: InputMaybe<Array<FileTypesEnum>>;
  dates?: InputMaybe<DateFilterArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  sourceTypes?: InputMaybe<Array<MediaFileSourceType>>;
};

export type MediaOutput = {
  __typename?: 'MediaOutput';
  bodySite?: Maybe<CodeableConcept>;
  content: Attachment;
  description?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<ResourceExtension>>;
  fileId: Scalars['String'];
  id: Scalars['String'];
  identifier?: Maybe<Array<Identifier>>;
  meta: Meta;
  resourceType: ResourcesTypes;
  status: MediaStatus;
  text?: Maybe<Narrative>;
};

/** Enum representing the possible values for "status" field in Media. */
export enum MediaStatus {
  Completed = 'COMPLETED',
  EnteredInError = 'ENTERED_IN_ERROR',
  InProgress = 'IN_PROGRESS',
  NotDone = 'NOT_DONE',
  OnHold = 'ON_HOLD',
  Preparation = 'PREPARATION',
  Stopped = 'STOPPED',
  Unknown = 'UNKNOWN'
}

export type Medication = {
  __typename?: 'Medication';
  code?: Maybe<CodeableConcept>;
  extension?: Maybe<Array<ResourceExtension>>;
  form?: Maybe<CodeableConcept>;
  id: Scalars['String'];
  identifier?: Maybe<Array<Identifier>>;
  meta: Meta;
  resourceType: ResourcesTypes;
  text?: Maybe<Narrative>;
};

export type MedicationOutput = {
  __typename?: 'MedicationOutput';
  activeIngredUnit?: Maybe<Scalars['String']>;
  activeNumeratorStrength?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  productId?: Maybe<Scalars['String']>;
  productNdc?: Maybe<Scalars['String']>;
  proprietaryName?: Maybe<Scalars['String']>;
};

export type MedicationPatientInfoOutput = {
  __typename?: 'MedicationPatientInfoOutput';
  firstName: Scalars['String'];
  id: Scalars['String'];
  isChild: Scalars['Boolean'];
  lastName: Scalars['String'];
};

export type MedicationRequestOutputDto = {
  __typename?: 'MedicationRequestOutputDto';
  activeIngredUnit?: Maybe<Scalars['String']>;
  activeNumeratorStrength?: Maybe<Scalars['String']>;
  appointmentCodexId?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  daysSupply?: Maybe<Scalars['Float']>;
  delivery?: Maybe<Scalars['String']>;
  directions?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  dosage?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  expectedSupplyDuration?: Maybe<ValueOutput>;
  frequency?: Maybe<Scalars['String']>;
  fullScriptVariantId?: Maybe<Scalars['String']>;
  fullScriptVariantSKU?: Maybe<Scalars['String']>;
  initialFill?: Maybe<InitialFillOutput>;
  isOTC: Scalars['Boolean'];
  mediSpanClassification?: Maybe<Scalars['String']>;
  mediSpanId?: Maybe<Scalars['String']>;
  ndc?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  numberOfRepeatsAllowed?: Maybe<Scalars['Int']>;
  patientCodexId: Scalars['String'];
  patientInfo: MedicationPatientInfoOutput;
  pharmacyAddress?: Maybe<Scalars['String']>;
  pharmacyName?: Maybe<Scalars['String']>;
  prescriptionFhirId: Scalars['String'];
  prescriptionFullScriptId?: Maybe<Scalars['String']>;
  productNotes?: Maybe<Scalars['String']>;
  provider?: Maybe<ProviderOutput>;
  providerCodexId?: Maybe<Scalars['String']>;
  providerFullName?: Maybe<Scalars['String']>;
  quantity?: Maybe<ValueOutput>;
  requestedAt?: Maybe<Scalars['String']>;
  rxcui?: Maybe<Scalars['String']>;
  source?: Maybe<MedicationRequestSource>;
  status: MedicationRequestStatusEnum;
  substitutionAllowed?: Maybe<Scalars['Boolean']>;
  summarySubmittedDate?: Maybe<Scalars['String']>;
  takeWith?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Source of medication request origin. */
export enum MedicationRequestSource {
  Fullscript = 'FULLSCRIPT',
  SelfReported = 'SELF_REPORTED',
  Veradigm = 'VERADIGM'
}

/** Enum representing the possible values for "status" field in MedicationRequest. */
export enum MedicationRequestStatusEnum {
  Active = 'active',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Draft = 'draft',
  EnteredInError = 'entered_in_error',
  OnHold = 'on_hold',
  Stopped = 'stopped',
  Unknown = 'unknown'
}

export type MedicationsOutput = {
  __typename?: 'MedicationsOutput';
  medications: Array<MedicationOutput>;
};

export type Meta = {
  __typename?: 'Meta';
  lastUpdated: Scalars['String'];
  tag: Array<Coding>;
  versionId: Scalars['String'];
};

/** Enum representing the patient minor autonomy evidence types. */
export enum MinorAutonomyEvidenceTypes {
  EmancipatedCertifiedCourtOrder = 'EMANCIPATED_CERTIFIED_COURT_ORDER',
  EmancipatedStateId = 'EMANCIPATED_STATE_ID',
  HomelessSchoolLiaisonLetter = 'HOMELESS_SCHOOL_LIAISON_LETTER',
  HomelessSelfAttestation = 'HOMELESS_SELF_ATTESTATION',
  HomelessShelterVerification = 'HOMELESS_SHELTER_VERIFICATION',
  MarriedDivorceDecree = 'MARRIED_DIVORCE_DECREE',
  MarriedMarriageCertificate = 'MARRIED_MARRIAGE_CERTIFICATE',
  MinorParentBirthCertificate = 'MINOR_PARENT_BIRTH_CERTIFICATE',
  MinorParentMedicalRecord = 'MINOR_PARENT_MEDICAL_RECORD',
  MinorParentSelfAttestation = 'MINOR_PARENT_SELF_ATTESTATION',
  OtherExceptionOtherDocument = 'OTHER_EXCEPTION_OTHER_DOCUMENT',
  OtherExceptionVerbal = 'OTHER_EXCEPTION_VERBAL',
  SelfSupportingEmployerLetter = 'SELF_SUPPORTING_EMPLOYER_LETTER',
  SelfSupportingIncomeDocument = 'SELF_SUPPORTING_INCOME_DOCUMENT',
  SelfSupportingLease = 'SELF_SUPPORTING_LEASE'
}

export type MosaicTestOutput = {
  __typename?: 'MosaicTestOutput';
  appointment_codex_id?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  fhirId: Scalars['String'];
  patient_fhir_id?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_acuity_calendar_id?: Maybe<Scalars['String']>;
  provider_acuity_owner_id?: Maybe<Scalars['String']>;
  provider_codex_id?: Maybe<Scalars['String']>;
  provider_fhir_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  questionnaire_required?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  swab_code?: Maybe<Scalars['String']>;
  test_id?: Maybe<Scalars['String']>;
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
};

export type MosaicTestsInput = {
  direction: OrderByDirections;
  field: ZrtOrderByCriterias;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptChildAdultTransitionInvitation: HttpStatusOutput;
  acceptLegalDocument: HttpStatusOutput;
  acceptUserAgreement: HttpStatusOutput;
  acknowledgeAchievementUnlock: HttpStatusOutput;
  addMessageToAppointmentMessageList: Communication;
  addMessageToAppointmentMessageListByAppointmentCodexId: Communication;
  addServiceOfferings: PatchFhirProviderOutput;
  appendEncounterToFHIRAppointment: PatchAppointmentAndEncounterOutput;
  archiveOrder: HttpStatusOutput;
  attachPaymentMethod: PaymentMethodOutput;
  blockUser: HttpStatusOutput;
  cancelDraftQuestionnairesById: UpdateFhirQuestionnaireResponsesOutput;
  cancelFHIRAppointment: PatchFhirAppointmentOutput;
  cancelSubscription: HttpStatusOutput;
  closeAccount: HttpStatusOutput;
  closeProviderAccount: HttpStatusOutput;
  confirmProviderPatientAgreement: PatchFhirRequestBecomePatientOutput;
  createAppVersion: AppVersionOutput;
  createAppointmentMessageList: Communication;
  createAppointmentRequest: AppointmentRequestOutput;
  createBecomePatientRequest: PatchFhirRequestBecomePatientOutput;
  createCartProduct: CartProductOutput;
  createChildAdultTransitionInvitation: HttpStatusOutput;
  createDelegatedAdminInvitation: HttpStatusOutput;
  createFHIRAppointment: CreateFhirAppointmentOutput;
  createFHIRAppointmentForCurrentUser: CreateFhirAppointmentOutput;
  createFHIRDnaVisitTest: CreateFhirDnaVisitTestOutput;
  createFHIRMosaicTest: CreateFhirMosaicTestOutput;
  createFHIROfficeLocation: CreateFhirOfficeLocationOutput;
  createFHIROrganization: CreateFhirOrganizationOutput;
  createFHIRPatient: CreateFhirPatientOutput;
  createFHIRProvider: CreateFhirProviderOutput;
  createFHIRProviderRole: CreateFhirProviderRoleOutput;
  createFHIRZrtTest: CreateFhirZrtTestOutput;
  createOrder: GetPaymentLinkOutput;
  createProviderSetupIntent: SetupIntentOutput;
  createScheduledAppointment: CreateScheduleAppointmentOutput;
  createSubPatient: IdOutput;
  createSubscription: SubscriptionOutput;
  cronCheckAndUpdateOrdersDeliveryStatus: Scalars['Boolean'];
  deleteAppointmentRequest: HttpStatusOutput;
  deleteCartProduct: HttpStatusOutput;
  deleteDelegatedAdmin: HttpStatusOutput;
  deleteDeliveryAddress: HttpStatusOutput;
  deleteEducationCourse: HttpStatusOutput;
  deleteMediaFile: HttpStatusOutput;
  deletePaymentMethod: HttpStatusOutput;
  deleteProduct: HttpStatusOutput;
  deleteProvider: HttpStatusOutput;
  deleteRecommendationByRequestUserCodexId: HttpStatusOutput;
  deleteUserNotification: HttpStatusOutput;
  dismissSkinTreatmentBanner: GetPatientOutput;
  ePrescribeJwt: EPrescribeIframeJwtOutput;
  ensureAppointmentSummaryPdf: AppointmentSummaryPdfOutput;
  finishAppTour: HttpStatusOutput;
  fullscriptDependentMap: FullscriptOperationResult;
  insertFHIRQuestionnaireResponse: CreateFhirQuestionnaireResponsesOutput;
  linkProviderAccount: FullscriptOperationResult;
  onTreatmentPlanActivated: FullscriptOperationResult;
  patchCodexApproval: PatchFhirProviderOutput;
  patchFHIRAppointment: PatchFhirAppointmentOutput;
  patchFHIRDnaVisitTest: PatchFhirDnaVisitTestOutput;
  patchFHIREncounter: PatchFhirEncounterOutput;
  patchFHIRPatientPersonalData: PatchFhirPatientOutput;
  patchFHIRProvider: PatchFhirProviderOutput;
  patchFHIRZrtTest: PatchFhirZrtTestOutput;
  patchServiceOffering: PatchFhirProviderOutput;
  publishLegalDocument: LegalDocumentOutput;
  recommendProducts: RecommendProductsOutput;
  refundPaymentTransaction: PaymentTransactionOutput;
  rejectAppointmentRequest: HttpStatusOutput;
  removeFileFromLibrary: HttpStatusOutput;
  requestDnaTestKit: RequestDnaTestKitOutput;
  requestZrtTest: RequestZrtTestOutput;
  rescheduleAppointment: RescheduleFhirAppointmentOutput;
  resendChildAdultTransitionInvitation: HttpStatusOutput;
  resendDelegatedAdminInvitation: HttpStatusOutput;
  resetAppTour: HttpStatusOutput;
  saPatchFHIRProvider: PatchFhirProviderOutput;
  saveFHIRQuestionnaireManually: SaveFhirQuestionnaireManually;
  seedFHIROrganizations: SeedFhirOrganizationsOutput;
  sendInMailMessage: HttpStatusOutput;
  sendSupportMessage: HttpStatusOutput;
  setAdmins: HttpStatusOutput;
  setDefaultPaymentMethod: HttpStatusOutput;
  syncEPrescribeMedicationsByPatient: HttpStatusOutput;
  syncShipMonkProducts: HttpStatusOutput;
  unlinkFullscript: PatchFhirProviderOutput;
  updateAllUserNotificationsStatus: HttpStatusOutput;
  updateBecomePatientRequestStatus: PatchFhirRequestBecomePatientOutput;
  updateCallSettings: HttpStatusOutput;
  updateCartProduct: CartProductOutput;
  updateCartProductsProvider: HttpStatusOutput;
  updateDelegatedAdminPermissions: HttpStatusOutput;
  updateFHIRQuestionnaireResponse: UpdateFhirQuestionnaireResponsesOutput;
  updateFHIRUserLatestQuestionnaire: UpdateFhirUserLatestQuestionnaire;
  updateHighContrastMode: GetPatientOutput;
  updateInAppNotificationById: HttpStatusOutput;
  updateNotificationPreferences: HttpStatusOutput;
  updateOrderStatus: HttpStatusOutput;
  updateProduct: ProductOutput;
  updateProductAvailability: HttpStatusOutput;
  updateRecommendationStatus: HttpStatusOutput;
  updateSelfReportedMedication: HttpStatusOutput;
  updateTestKitProvider: HttpStatusOutput;
  upsertEducationCourse: HttpStatusOutput;
};


export type MutationAcceptChildAdultTransitionInvitationArgs = {
  input: AcceptChildAdultTransitionInvitationInput;
};


export type MutationAcceptLegalDocumentArgs = {
  input: AcceptLegalDocumentInput;
};


export type MutationAcceptUserAgreementArgs = {
  input: AcceptAgreementInput;
};


export type MutationAcknowledgeAchievementUnlockArgs = {
  unlockId: Scalars['Int'];
};


export type MutationAddMessageToAppointmentMessageListArgs = {
  insertAppointmentChatMessages: InsertAppointmentChatMessages;
};


export type MutationAddMessageToAppointmentMessageListByAppointmentCodexIdArgs = {
  insertAppointmentChatMessages: InsertAppointmentChatMessagesByAppointmentCodexId;
};


export type MutationAddServiceOfferingsArgs = {
  registerPatchFHIRProviderServiceOfferingsInput: AddFhirHealthCareServiceInput;
};


export type MutationAppendEncounterToFhirAppointmentArgs = {
  appendEncounterToFHIRAppointmentInput: AppendFhirEncounterInput;
};


export type MutationArchiveOrderArgs = {
  id: Scalars['Int'];
};


export type MutationAttachPaymentMethodArgs = {
  makeDefault?: InputMaybe<Scalars['Boolean']>;
  paymentMethodName?: InputMaybe<Scalars['String']>;
  stripePaymentMethodId: Scalars['String'];
};


export type MutationBlockUserArgs = {
  blocked?: InputMaybe<Scalars['Boolean']>;
  userCodexId: Scalars['String'];
};


export type MutationCancelDraftQuestionnairesByIdArgs = {
  questionnaireId: Scalars['String'];
};


export type MutationCancelFhirAppointmentArgs = {
  appointmentCodexId: Scalars['String'];
  cancelationReason: Scalars['String'];
};


export type MutationConfirmProviderPatientAgreementArgs = {
  providerCodexId: Scalars['String'];
};


export type MutationCreateAppVersionArgs = {
  input: CreateAppVersionInput;
};


export type MutationCreateAppointmentMessageListArgs = {
  appointmentCodexId: Scalars['String'];
};


export type MutationCreateAppointmentRequestArgs = {
  input: CreateAppointmentRequestInput;
};


export type MutationCreateBecomePatientRequestArgs = {
  providerCodexId: Scalars['String'];
};


export type MutationCreateCartProductArgs = {
  input: CreateCartProductInput;
};


export type MutationCreateChildAdultTransitionInvitationArgs = {
  input: CreateChildAdultTransitionInvitationInput;
};


export type MutationCreateDelegatedAdminInvitationArgs = {
  input: CreateAdminInvitationInput;
};


export type MutationCreateFhirAppointmentArgs = {
  createFHIRAppointment: CreateFhirAppointmentInput;
};


export type MutationCreateFhirAppointmentForCurrentUserArgs = {
  createFHIRAppointment: CreateFhirAppointmentInputWithoutPatientCodexId;
};


export type MutationCreateFhirDnaVisitTestArgs = {
  createFHIRDnaVisitTest: CreateFhirDnaVisitTestInputWithResponses;
};


export type MutationCreateFhirMosaicTestArgs = {
  createFHIRDnaVisitTest: CreateMosaicTestInput;
};


export type MutationCreateFhirOfficeLocationArgs = {
  createFHIROfficeLocationInput: OfficeAddressInformationInput;
};


export type MutationCreateFhirOrganizationArgs = {
  createFHIROrganizationInput: CreateFhirOrganizationInput;
};


export type MutationCreateFhirPatientArgs = {
  createFHIRPatientInput: CreateFhirPatientInput;
};


export type MutationCreateFhirProviderArgs = {
  createFHIRProviderInput: CreateFhirProviderInput;
};


export type MutationCreateFhirProviderRoleArgs = {
  createFHIRProviderRoleInput: CreateFhirProviderRoleInput;
};


export type MutationCreateFhirZrtTestArgs = {
  createFHIRZrtTest: CreateFhirZrtTestInput;
};


export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


export type MutationCreateScheduledAppointmentArgs = {
  body: CreateScheduleAppointmentBodyInput;
  isTest?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateSubPatientArgs = {
  input: CreateSubPatientInput;
};


export type MutationCreateSubscriptionArgs = {
  paymentMethodName?: InputMaybe<Scalars['String']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteAppointmentRequestArgs = {
  input: GetAppointmentRescheduleRequestInput;
};


export type MutationDeleteCartProductArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteDelegatedAdminArgs = {
  input: DelegatedAdminCodexIdInput;
};


export type MutationDeleteDeliveryAddressArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteEducationCourseArgs = {
  id: Scalars['String'];
};


export type MutationDeleteMediaFileArgs = {
  fileId: Scalars['String'];
};


export type MutationDeletePaymentMethodArgs = {
  paymentMethodCodexId: Scalars['Int'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteProviderArgs = {
  providerEmail: Scalars['String'];
};


export type MutationDeleteRecommendationByRequestUserCodexIdArgs = {
  recommendationId: Scalars['String'];
};


export type MutationDeleteUserNotificationArgs = {
  notificationId: Scalars['String'];
};


export type MutationEPrescribeJwtArgs = {
  input: EPrescribeJwtInput;
};


export type MutationEnsureAppointmentSummaryPdfArgs = {
  appointmentCodexId: Scalars['String'];
};


export type MutationFinishAppTourArgs = {
  appTourType: AppTourTypes;
};


export type MutationFullscriptDependentMapArgs = {
  input: MapDependentInput;
};


export type MutationInsertFhirQuestionnaireResponseArgs = {
  createQuestionnaireResponsesInput: QuestionnaireResponseInput;
};


export type MutationLinkProviderAccountArgs = {
  linkProviderAccountInput: LinkProviderAccountInput;
};


export type MutationOnTreatmentPlanActivatedArgs = {
  onTreatmentPlanActivatedInput: OnTreatmentPlanEventInput;
};


export type MutationPatchCodexApprovalArgs = {
  approved: Scalars['Boolean'];
  codexProviderID: Scalars['String'];
};


export type MutationPatchFhirAppointmentArgs = {
  patchFHIRAppointmentInput: PatchFhirAppointmentInput;
};


export type MutationPatchFhirDnaVisitTestArgs = {
  patchFHIRDnaVisitTest: PatchFhirDnaVisitTestInput;
};


export type MutationPatchFhirEncounterArgs = {
  patchFHIREncounter: PatchEncounterInput;
};


export type MutationPatchFhirPatientPersonalDataArgs = {
  patientPersonalInfo: PatchFhirPatientPersonalInfoInput;
};


export type MutationPatchFhirProviderArgs = {
  patchFHIRProviderInput: PatchFhirProviderInput;
};


export type MutationPatchFhirZrtTestArgs = {
  patchFHIRZrtTest: PatchFhirZrtTestInput;
};


export type MutationPatchServiceOfferingArgs = {
  patchFHIRProviderServiceOfferingsInput: PatchFhirHealthCareServiceInput;
};


export type MutationPublishLegalDocumentArgs = {
  input: PublishLegalDocumentInput;
};


export type MutationRecommendProductsArgs = {
  codexPatientId: Scalars['String'];
  input: ProductRecommendationsInput;
};


export type MutationRefundPaymentTransactionArgs = {
  id: Scalars['Float'];
};


export type MutationRejectAppointmentRequestArgs = {
  input: GetAppointmentRescheduleRequestInput;
};


export type MutationRemoveFileFromLibraryArgs = {
  fileId: Scalars['String'];
};


export type MutationRequestDnaTestKitArgs = {
  input: RequestDnaTestKitInput;
};


export type MutationRequestZrtTestArgs = {
  providerCodexId: Scalars['String'];
  testType: Scalars['String'];
  trackingNumber?: InputMaybe<Scalars['String']>;
  zrtSwabCode: Scalars['String'];
};


export type MutationRescheduleAppointmentArgs = {
  rescheduleAppointmentInput: RescheduleAppointmentInput;
};


export type MutationResendChildAdultTransitionInvitationArgs = {
  input: ResendChildAdultTransitionInvitationInput;
};


export type MutationResendDelegatedAdminInvitationArgs = {
  input: DelegatedAdminCodexIdInput;
};


export type MutationResetAppTourArgs = {
  appTourType: AppTourTypes;
};


export type MutationSaPatchFhirProviderArgs = {
  patchFHIRProviderInput: PatchFhirProviderInput;
  providerCodexId: Scalars['String'];
};


export type MutationSaveFhirQuestionnaireManuallyArgs = {
  isComplete: Scalars['Boolean'];
  questionnaireId: Scalars['Int'];
  responses: Scalars['JSON'];
  userID: Scalars['String'];
};


export type MutationSendInMailMessageArgs = {
  input: CreateInMailMessageInput;
};


export type MutationSendSupportMessageArgs = {
  input: SendSupportReplyInput;
};


export type MutationSetAdminsArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationSetDefaultPaymentMethodArgs = {
  input: SetDefaultPaymentMethodInput;
};


export type MutationSyncEPrescribeMedicationsByPatientArgs = {
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  patientCodexId: Scalars['String'];
  providerCodexId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateAllUserNotificationsStatusArgs = {
  input: UpdateNotificationStatusInput;
  notificationIds?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationUpdateBecomePatientRequestStatusArgs = {
  updateBecomePatientRequestStatusInput: UpdateBecomePatientRequestStatusInput;
};


export type MutationUpdateCallSettingsArgs = {
  input: UpdateCallSettingsInput;
};


export type MutationUpdateCartProductArgs = {
  input: UpdateCartProductInput;
};


export type MutationUpdateCartProductsProviderArgs = {
  input: UpdateCartProductsProviderInput;
};


export type MutationUpdateDelegatedAdminPermissionsArgs = {
  input: UpdateDelegatedAdminPermissionsInput;
};


export type MutationUpdateFhirQuestionnaireResponseArgs = {
  currentStepIndex?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  isComplete: Scalars['Boolean'];
  questionnaireId?: InputMaybe<Scalars['String']>;
  responses: Scalars['JSON'];
  swabCode?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateFhirUserLatestQuestionnaireArgs = {
  id: Scalars['String'];
  isComplete: Scalars['Boolean'];
  responses: Scalars['JSON'];
};


export type MutationUpdateHighContrastModeArgs = {
  enabled: Scalars['Boolean'];
};


export type MutationUpdateInAppNotificationByIdArgs = {
  input: UpdateNotificationStatusInput;
  notificationId: Scalars['String'];
};


export type MutationUpdateNotificationPreferencesArgs = {
  input: UpdateNotificationPreferencesInput;
};


export type MutationUpdateOrderStatusArgs = {
  input: UpdateOrderStatusInput;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};


export type MutationUpdateProductAvailabilityArgs = {
  input: UpdateProductAvailabilityInput;
};


export type MutationUpdateRecommendationStatusArgs = {
  recommendationId: Scalars['String'];
  status: UpdatableRecommendationStatus;
};


export type MutationUpdateSelfReportedMedicationArgs = {
  input: SelfReportedMedicationsInput;
};


export type MutationUpdateTestKitProviderArgs = {
  providerCodexId: Scalars['String'];
  swabCode: Scalars['String'];
};


export type MutationUpsertEducationCourseArgs = {
  input: EducationCourseInput;
};

export type NablaNote = {
  __typename?: 'NablaNote';
  appointment_id: Scalars['String'];
  nabla_notes: Scalars['String'];
};

export type Narrative = {
  __typename?: 'Narrative';
  div: Scalars['String'];
  status: NarrativeStatusEnum;
};

/** Enum representing the possible values for "status" field in Narrative. */
export enum NarrativeStatusEnum {
  Additional = 'Additional',
  Empty = 'Empty',
  Extensions = 'Extensions',
  Generated = 'Generated'
}

export type NotificationCategoryPreferenceInput = {
  category: NotificationSettingsCategory;
  channels: NotificationChannelPreferencesInput;
};

export type NotificationCategoryPreferenceOutput = {
  __typename?: 'NotificationCategoryPreferenceOutput';
  category: NotificationSettingsCategory;
  channels: NotificationChannelPreferencesOutput;
};

export type NotificationChannelPreferencesInput = {
  email: Scalars['Boolean'];
  push: Scalars['Boolean'];
};

export type NotificationChannelPreferencesOutput = {
  __typename?: 'NotificationChannelPreferencesOutput';
  email: Scalars['Boolean'];
  push: Scalars['Boolean'];
};

export type NotificationOutput = {
  __typename?: 'NotificationOutput';
  activity_type?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  data?: Maybe<Scalars['JSON']>;
  has_priority: Scalars['Boolean'];
  id: Scalars['String'];
  is_admin_notification: Scalars['Boolean'];
  is_latest_activity: Scalars['Boolean'];
  status: Scalars['String'];
  user_communication_delivery_id: Scalars['Int'];
};

export type NotificationPreferencesOutput = {
  __typename?: 'NotificationPreferencesOutput';
  preferences: Array<NotificationCategoryPreferenceOutput>;
};

/** Notification preference category used for Email/Push gating and settings UI. */
export enum NotificationSettingsCategory {
  Account = 'ACCOUNT',
  Appointment = 'APPOINTMENT',
  Chat = 'CHAT',
  Child = 'CHILD',
  PatientReminders = 'PATIENT_REMINDERS',
  PatientRequests = 'PATIENT_REQUESTS',
  PaymentsLicense = 'PAYMENTS_LICENSE',
  Prescription = 'PRESCRIPTION',
  TestKits = 'TEST_KITS'
}

export type OfficeAddressInformationInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  email: Scalars['String'];
  officeName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  phoneCountry?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type OfficeAddressInformationOutput = {
  __typename?: 'OfficeAddressInformationOutput';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  officeName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  phoneCountry?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type OnTreatmentPlanEventInput = {
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  patientCodexId: Scalars['String'];
  treatmentPlanId: Scalars['String'];
};

/** A generic list of OrderByCriterias valid across both DNA Visit and ZRT */
export enum OrderByCriterias {
  Barcode = 'BARCODE',
  CreatedAt = 'CREATED_AT',
  MosaicOat = 'MosaicOat',
  ProviderName = 'PROVIDER_NAME',
  SapphirosBarcode = 'SAPPHIROS_BARCODE',
  SwabCode = 'SWAB_CODE',
  TestType = 'TEST_TYPE'
}

/** Enum representing the sorting directions. */
export enum OrderByDirections {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderFilterInput = {
  from?: InputMaybe<Scalars['String']>;
  idQuery?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  patientQuery?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<OrderStatusEnum>>;
  to?: InputMaybe<Scalars['String']>;
};

export type OrderListOutput = {
  __typename?: 'OrderListOutput';
  orders: Array<OrderOutput>;
  total: Scalars['Int'];
};

export type OrderOrderByInput = {
  direction: OrderByDirections;
  field: OrdersOrderByCriterias;
};

export type OrderOutput = {
  __typename?: 'OrderOutput';
  carrier?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  delivery_address?: Maybe<DeliveryAddressOutput>;
  delivery_address_id: Scalars['Int'];
  delivery_date?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_archived?: Maybe<Scalars['Boolean']>;
  order_products?: Maybe<Array<OrderProductOutput>>;
  order_type?: Maybe<Scalars['Int']>;
  patient?: Maybe<GetPatientOutput>;
  patient_id?: Maybe<Scalars['String']>;
  payment?: Maybe<PaymentTransactionLiteOutput>;
  provider?: Maybe<ProviderOutput>;
  provider_id?: Maybe<Scalars['String']>;
  shipped_at?: Maybe<Scalars['String']>;
  shipping_cost: Scalars['Float'];
  status?: Maybe<Scalars['Int']>;
  statusHistory: Array<OrderStatusHistoryEntry>;
  subtotal_amount: Scalars['Float'];
  tax_amount: Scalars['Float'];
  total_amount: Scalars['Float'];
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
  user_id: Scalars['String'];
};

export type OrderProductOutput = {
  __typename?: 'OrderProductOutput';
  created_at: Scalars['String'];
  id: Scalars['Int'];
  order_id: Scalars['Int'];
  owner_id: Scalars['String'];
  patientOwner?: Maybe<GetPatientOutput>;
  product?: Maybe<Product>;
  product_id: Scalars['Int'];
  provider?: Maybe<ProviderOutput>;
  provider_id?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  updated_at: Scalars['String'];
};

export type OrderStatsByDayOutput = {
  __typename?: 'OrderStatsByDayOutput';
  date: Scalars['String'];
  orderStats: OrderStatsOutput;
};

export type OrderStatsOutput = {
  __typename?: 'OrderStatsOutput';
  breakdown: Array<OrderStatsStatusItem>;
  total: Scalars['Int'];
};

export type OrderStatsStatusItem = {
  __typename?: 'OrderStatsStatusItem';
  status: OrderStatusEnum;
  total: Scalars['Int'];
};

/** Enum representing the order status values in the database. */
export enum OrderStatusEnum {
  Canceled = 'Canceled',
  Delivered = 'Delivered',
  New = 'New',
  PendingPayment = 'PendingPayment',
  Shipped = 'Shipped'
}

export type OrderStatusHistoryEntry = {
  __typename?: 'OrderStatusHistoryEntry';
  datetime: Scalars['String'];
  status: OrderStatusEnum;
};

/** Enum representing the possible values for sorting orders. */
export enum OrdersOrderByCriterias {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Status = 'STATUS',
  TotalAmount = 'TOTAL_AMOUNT'
}

/** Enum representing the possible values for "type" field in CreateFHIROrganizationInput. */
export enum OrganizationTypes {
  ClinicalResearchSponsor = 'CLINICAL_RESEARCH_SPONSOR',
  CommunityGroup = 'COMMUNITY_GROUP',
  EducationalInstitute = 'EDUCATIONAL_INSTITUTE',
  Government = 'GOVERNMENT',
  HealthcareProvider = 'HEALTHCARE_PROVIDER',
  HospitalDepartment = 'HOSPITAL_DEPARTMENT',
  InsuranceCompany = 'INSURANCE_COMPANY',
  NonHealthcareBusiness = 'NON_HEALTHCARE_BUSINESS',
  OrganizationalTeam = 'ORGANIZATIONAL_TEAM',
  Other = 'OTHER',
  Payer = 'PAYER',
  ReligiousInstitution = 'RELIGIOUS_INSTITUTION'
}

export type PaginationArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PatchAppointmentAndEncounterOutput = {
  __typename?: 'PatchAppointmentAndEncounterOutput';
  appointment: PatchAppointmentOutput;
  encounter: AppendEncounterOutput;
  summaryPdfFileId?: Maybe<Scalars['String']>;
};

export type PatchAppointmentOutput = {
  __typename?: 'PatchAppointmentOutput';
  appointmentId: Scalars['String'];
};

export type PatchDnaVisitOutput = {
  __typename?: 'PatchDnaVisitOutput';
  created_at: Scalars['String'];
  dna_test_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  dnavisit_order_id: Scalars['String'];
  health_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  last_processed_date?: Maybe<Scalars['String']>;
  last_processed_state?: Maybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  sapphiros_barcode: Scalars['String'];
  sapphiros_report_pdf_id?: Maybe<Scalars['String']>;
  state: Hasura_Dnavisit_Test_Statuses_Enum;
  test_id: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
  visit_summary_pdf_id?: Maybe<Scalars['String']>;
};

export type PatchEncounterInput = {
  diagnosticReportIds?: InputMaybe<Array<Scalars['String']>>;
  encounterId: Scalars['String'];
  encounterNotes?: InputMaybe<CreateFhirEncounterNotesInput>;
  providerId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type PatchEncounterOutput = {
  __typename?: 'PatchEncounterOutput';
  encounterId: Scalars['String'];
  status: Scalars['String'];
};

export type PatchFhirAppointmentInput = {
  acuityId?: InputMaybe<Scalars['String']>;
  appointmentCodexId: Scalars['String'];
  appointmentNotes?: InputMaybe<FhirAppointmentNotesObservation>;
  appointmentPaidStatus?: InputMaybe<Scalars['String']>;
  appointmentType?: InputMaybe<AppointmentTypeEnum>;
  appointmentUrl?: InputMaybe<Scalars['String']>;
  cancelationReason?: InputMaybe<Scalars['String']>;
  codexProviderId?: InputMaybe<Scalars['String']>;
  diagnosticReportIds?: InputMaybe<Array<Scalars['String']>>;
  endAt?: InputMaybe<Scalars['String']>;
  lastProcessedDate?: InputMaybe<Scalars['String']>;
  mediaToAppend?: InputMaybe<Array<Scalars['String']>>;
  mediaToInsert?: InputMaybe<Array<AppointmentMediaInsert>>;
  startAt?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subjectOfAppointment?: InputMaybe<Scalars['String']>;
  supportingInformation?: InputMaybe<Array<ReferenceInput>>;
  symptomsLocation?: InputMaybe<Array<Scalars['String']>>;
  vonageSessionId?: InputMaybe<Scalars['String']>;
};

export type PatchFhirAppointmentOutput = {
  __typename?: 'PatchFHIRAppointmentOutput';
  appointment: PatchAppointmentOutput;
};

export type PatchFhirDnaVisitTestInput = {
  encounterId?: InputMaybe<Scalars['String']>;
  last_processed_state?: InputMaybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  npi_number?: InputMaybe<Scalars['String']>;
  patient_pdf_id?: InputMaybe<Scalars['String']>;
  provider_fhir_id?: InputMaybe<Scalars['String']>;
  provider_report_pdf_id?: InputMaybe<Scalars['String']>;
  sapphiros_data?: InputMaybe<Scalars['JSON']>;
  sapphiros_report_pdf_id?: InputMaybe<Scalars['String']>;
  sapphiros_results?: InputMaybe<Scalars['JSON']>;
  state?: InputMaybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  test_id: Scalars['String'];
  visit_summary_pdf_id?: InputMaybe<Scalars['String']>;
};

export type PatchFhirDnaVisitTestOutput = {
  __typename?: 'PatchFHIRDnaVisitTestOutput';
  dnavisit_test: PatchDnaVisitOutput;
};

export type PatchFhirEncounterOutput = {
  __typename?: 'PatchFHIREncounterOutput';
  encounter?: Maybe<PatchEncounterOutput>;
};

export type PatchFhirHealthCareServiceInput = {
  active: Scalars['Boolean'];
  fhirId: Scalars['String'];
  price: Scalars['String'];
};

export type PatchFhirPatientOutput = {
  __typename?: 'PatchFHIRPatientOutput';
  update_patients_one: CreatePatientOutput;
};

export type PatchFhirPatientPersonalInfoInput = {
  SENSITIVE_address_information?: InputMaybe<PatientAddressInfo>;
  SENSITIVE_country?: InputMaybe<Scalars['String']>;
  SENSITIVE_dob?: InputMaybe<Scalars['String']>;
  SENSITIVE_etnicity?: InputMaybe<Array<Scalars['String']>>;
  SENSITIVE_firstname?: InputMaybe<Scalars['String']>;
  SENSITIVE_gender?: InputMaybe<Scalars['String']>;
  SENSITIVE_gender_describe?: InputMaybe<Scalars['String']>;
  SENSITIVE_lastname?: InputMaybe<Scalars['String']>;
  SENSITIVE_pharmacies?: InputMaybe<Array<PharmacyInformationInput>>;
  SENSITIVE_phone?: InputMaybe<Scalars['String']>;
  SENSITIVE_profile_picture_id?: InputMaybe<Scalars['String']>;
  SENSITIVE_self_identity_gender?: InputMaybe<Scalars['String']>;
  SENSITIVE_user_measurements?: InputMaybe<PatientMeasurements>;
  autonomyDeterminationStatus?: InputMaybe<AutonomyDeterminationStatus>;
  codexID: Scalars['String'];
  ePrescribePatientId?: InputMaybe<Scalars['String']>;
  minorAutonomyEvidence?: InputMaybe<Array<MinorAutonomyEvidenceTypes>>;
  mosaicId?: InputMaybe<Scalars['String']>;
  sapphirosID?: InputMaybe<Scalars['String']>;
};

export type PatchFhirProviderInput = {
  about?: InputMaybe<Scalars['String']>;
  accepting_patients?: InputMaybe<Scalars['Boolean']>;
  acuityCalendarId?: InputMaybe<Scalars['String']>;
  acuityOwnerId?: InputMaybe<Scalars['String']>;
  addressInformation?: InputMaybe<AddressInformationInput>;
  credentials?: InputMaybe<ProviderCredentialsInput>;
  date_of_birth?: InputMaybe<Scalars['String']>;
  education?: InputMaybe<Array<ProviderEducationInput>>;
  firstname?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  genderDescribe?: InputMaybe<Scalars['String']>;
  hide_contact_info?: InputMaybe<Scalars['Boolean']>;
  hide_office_address?: InputMaybe<Scalars['Boolean']>;
  languagesOfCommunication?: InputMaybe<Array<Scalars['String']>>;
  lastname?: InputMaybe<Scalars['String']>;
  nationalProviderIdentifier?: InputMaybe<Scalars['String']>;
  officeInformation?: InputMaybe<OfficeAddressInformationInput>;
  phone?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<Scalars['String']>;
};

export type PatchFhirProviderOutput = {
  __typename?: 'PatchFHIRProviderOutput';
  update_providers_one: ProviderOutput;
};

export type PatchFhirRequestBecomePatientOutput = {
  __typename?: 'PatchFHIRRequestBecomePatientOutput';
  requestStatus: ProviderRequestStatus;
};

export type PatchFhirZrtTestInput = {
  comments?: InputMaybe<Scalars['String']>;
  date_received?: InputMaybe<Scalars['String']>;
  date_reported?: InputMaybe<Scalars['String']>;
  last_processed_state?: InputMaybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  npi_number?: InputMaybe<Scalars['String']>;
  patient_pdf_id?: InputMaybe<Scalars['String']>;
  patient_pdf_size?: InputMaybe<Scalars['Int']>;
  provider_report_pdf_id?: InputMaybe<Scalars['String']>;
  provider_report_pdf_size?: InputMaybe<Scalars['Int']>;
  reference_code: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
};

export type PatchFhirZrtTestOutput = {
  __typename?: 'PatchFHIRZrtTestOutput';
  zrt_test: PatchZrtOutput;
};

export type PatchZrtOutput = {
  __typename?: 'PatchZrtOutput';
  created_at: Scalars['String'];
  health_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  npi_number?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  sapphiros_barcode: Scalars['String'];
  state: Hasura_Dnavisit_Test_Statuses_Enum;
  test_id: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
};

export type PatientAddressInfo = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneCountry?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type PatientIdentifiersOutput = {
  __typename?: 'PatientIdentifiersOutput';
  acuityCalendar?: Maybe<Scalars['String']>;
  acuityId?: Maybe<Scalars['String']>;
  acuityOwner?: Maybe<Scalars['String']>;
  codexId?: Maybe<Scalars['String']>;
  fhirId?: Maybe<Scalars['String']>;
  mosaicId?: Maybe<Scalars['String']>;
  sapphirosId?: Maybe<Scalars['String']>;
};

export type PatientMeasurements = {
  heightFt?: InputMaybe<Scalars['Int']>;
  heightIn?: InputMaybe<Scalars['Int']>;
  hips?: InputMaybe<Scalars['Int']>;
  waist?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Int']>;
};

export type PatientMeasurementsOutput = {
  __typename?: 'PatientMeasurementsOutput';
  heightFt?: Maybe<Scalars['Int']>;
  heightIn?: Maybe<Scalars['Int']>;
  hips?: Maybe<Scalars['Int']>;
  waist?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Int']>;
};

export type PatientRequest = {
  __typename?: 'PatientRequest';
  date: Scalars['String'];
  patientFhirId: Scalars['String'];
  requestStatus: ProviderRequestStatus;
};

export type PatientWithMemberOutput = {
  __typename?: 'PatientWithMemberOutput';
  memberDetails?: Maybe<GetMemberGroupOutput>;
  patient: GetBasicPatientInfoOutput;
};

export type PaymentIntentOutput = {
  __typename?: 'PaymentIntentOutput';
  clientSecret?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  stripePaymentIntent: Scalars['String'];
};

export type PaymentMethodOutput = {
  __typename?: 'PaymentMethodOutput';
  brand?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  last4?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  updated_at: Scalars['String'];
};

export type PaymentMethodsOutput = {
  __typename?: 'PaymentMethodsOutput';
  paymentMethods: Array<PaymentMethodOutput>;
  total: Scalars['Int'];
};

/** Payment provider used for checkout. */
export enum PaymentProviderEnum {
  Gale = 'Gale',
  Stripe = 'Stripe'
}

export type PaymentStatsByDayOutput = {
  __typename?: 'PaymentStatsByDayOutput';
  date: Scalars['String'];
  paymentStats: PaymentStatsOutput;
};

export type PaymentStatsOutput = {
  __typename?: 'PaymentStatsOutput';
  feeReceivedByCodex: Scalars['Float'];
  paymentForAppointments: Scalars['Float'];
  paymentForOrders: Scalars['Float'];
  refunds: Scalars['Float'];
};

export type PaymentTransactionFilterInput = {
  categories?: InputMaybe<Array<PaymentTransactionPaymentCategoryEnum>>;
  discountApplied?: InputMaybe<Scalars['Boolean']>;
  from?: InputMaybe<Scalars['String']>;
  paymentProvider?: InputMaybe<PaymentProviderEnum>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<PaymentTransactionStatusEnum>>;
  to?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<PaymentTransactionPaymentTypeEnum>>;
  userCodexId?: InputMaybe<Scalars['String']>;
};

export type PaymentTransactionListOutput = {
  __typename?: 'PaymentTransactionListOutput';
  total: Scalars['Int'];
  transactions: Array<PaymentTransactionOutput>;
};

export type PaymentTransactionLiteOutput = {
  __typename?: 'PaymentTransactionLiteOutput';
  appointment_id?: Maybe<Scalars['String']>;
  category: Scalars['Int'];
  created_at: Scalars['String'];
  discount?: Maybe<DiscountOutput>;
  id: Scalars['Int'];
  invoice_number?: Maybe<Scalars['String']>;
  order_ids?: Maybe<Array<Scalars['Int']>>;
  paid_at?: Maybe<Scalars['String']>;
  patient_id?: Maybe<Scalars['String']>;
  payer_role: Scalars['Int'];
  payment_provider?: Maybe<PaymentProviderEnum>;
  provider_id?: Maybe<Scalars['String']>;
  related_payments?: Maybe<Array<PaymentTransactionOutput>>;
  service_fee: Scalars['Float'];
  service_total: Scalars['Float'];
  status: Scalars['Int'];
  stripe_fee: Scalars['Float'];
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Int']>;
  total: Scalars['Float'];
  transaction_type: Scalars['Int'];
  updated_at: Scalars['String'];
};

/** Enum representing the possible values for sorting payment transactions. */
export enum PaymentTransactionOrderByCriterias {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Total = 'TOTAL'
}

export type PaymentTransactionOrderByInput = {
  direction: OrderByDirections;
  field: PaymentTransactionOrderByCriterias;
};

export type PaymentTransactionOutput = {
  __typename?: 'PaymentTransactionOutput';
  appointment?: Maybe<GetAppointmentOutput>;
  appointment_id?: Maybe<Scalars['String']>;
  category: Scalars['Int'];
  created_at: Scalars['String'];
  discount?: Maybe<DiscountOutput>;
  id: Scalars['Int'];
  invoice_number?: Maybe<Scalars['String']>;
  order_ids?: Maybe<Array<Scalars['Int']>>;
  orders?: Maybe<Array<OrderOutput>>;
  paid_at?: Maybe<Scalars['String']>;
  patient?: Maybe<GetPatientOutput>;
  patient_id?: Maybe<Scalars['String']>;
  payer_role: Scalars['Int'];
  payment_provider?: Maybe<PaymentProviderEnum>;
  provider?: Maybe<ProviderOutput>;
  provider_id?: Maybe<Scalars['String']>;
  related_payments?: Maybe<Array<PaymentTransactionOutput>>;
  service_fee: Scalars['Float'];
  service_total: Scalars['Float'];
  status: Scalars['Int'];
  stripe_fee: Scalars['Float'];
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription?: Maybe<SubscriptionOutput>;
  subscription_id?: Maybe<Scalars['Int']>;
  total: Scalars['Float'];
  transaction_type: Scalars['Int'];
  updated_at: Scalars['String'];
  weeklyPaymentDetails?: Maybe<WeeklyPaymentDetailsOutput>;
};

/** Enum representing the transaction category values in the database. */
export enum PaymentTransactionPaymentCategoryEnum {
  Appointment = 'Appointment',
  Refund = 'Refund',
  Subscription = 'Subscription',
  TestKitOrder = 'TestKitOrder',
  WeeklyPayment = 'WeeklyPayment'
}

/** Enum representing the transaction payment type values in the database. */
export enum PaymentTransactionPaymentTypeEnum {
  Charge = 'Charge',
  Payout = 'Payout',
  Refund = 'Refund'
}

/** Enum representing the transaction status values in the database. */
export enum PaymentTransactionStatusEnum {
  Failed = 'Failed',
  Pending = 'Pending',
  Refunded = 'Refunded',
  Success = 'Success'
}

export type Period = {
  __typename?: 'Period';
  end?: Maybe<Scalars['DateTime']>;
  start?: Maybe<Scalars['DateTime']>;
};

export type PeriodInput = {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

/** Enum representing inquiry hasura status. */
export enum PersonaInquiryHasuraStatus {
  Approved = 'Approved',
  Completed = 'Completed',
  Created = 'Created',
  Declined = 'Declined',
  Expired = 'Expired',
  Failed = 'Failed',
  Locked = 'Locked',
  MarkedForReview = 'MarkedForReview',
  Started = 'Started',
  Transitioned = 'Transitioned'
}

export type PharmacyInformationInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  ext?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  phoneCountry?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type PharmacyInformationOutput = {
  __typename?: 'PharmacyInformationOutput';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDefault: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  phoneCountry?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** Enum representing the price categories associated with service offerings. */
export enum PriceCategory {
  NotApplicable = 'NotApplicable',
  Price1 = 'Price1',
  Price2 = 'Price2',
  Price3 = 'Price3',
  Price4 = 'Price4'
}

export type Product = {
  __typename?: 'Product';
  aeromed_number?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['Float']>;
  contents?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  default_image_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  expiration_period?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  image_ids?: Maybe<Array<Scalars['String']>>;
  image_url?: Maybe<Scalars['String']>;
  in_stock: Scalars['Boolean'];
  is_shipmonk_active: Scalars['Boolean'];
  is_shipmonk_deleted: Scalars['Boolean'];
  made_in?: Maybe<Scalars['String']>;
  po_number?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  provider_price?: Maybe<Scalars['Float']>;
  quantity: Scalars['Int'];
  short_description?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  test_type?: Maybe<Hasura_Test_Types_Enum>;
  title: Scalars['String'];
  updated_at: Scalars['String'];
};

export type ProductOutput = {
  __typename?: 'ProductOutput';
  aeromed_number?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['Float']>;
  created_at: Scalars['String'];
  default_image_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image_ids?: Maybe<Array<Scalars['String']>>;
  image_url?: Maybe<Scalars['String']>;
  in_stock: Scalars['Boolean'];
  is_shipmonk_active: Scalars['Boolean'];
  is_shipmonk_deleted: Scalars['Boolean'];
  po_number?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  provider_price?: Maybe<Scalars['Float']>;
  quantity: Scalars['Int'];
  reserved_quantity: Scalars['Int'];
  short_description?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  specs?: Maybe<Specs>;
  test_type?: Maybe<Hasura_Test_Types_Enum>;
  title: Scalars['String'];
  updated_at: Scalars['String'];
};

export type ProductRecommendationInput = {
  productCodexId: Scalars['Int'];
  quantity: Scalars['Int'];
};

export type ProductRecommendationsInput = {
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  recommendations: Array<ProductRecommendationInput>;
};

export type ProviderBillingOutput = {
  __typename?: 'ProviderBillingOutput';
  created_at: Scalars['String'];
  id: Scalars['Int'];
  previous_payout_date?: Maybe<Scalars['String']>;
  previous_week_payout?: Maybe<Scalars['Float']>;
  previous_week_refund?: Maybe<Scalars['Float']>;
  provider_id: Scalars['String'];
  reserved_balance: Scalars['Float'];
  total_payouts: Scalars['Float'];
  upcoming_payment: Scalars['Float'];
  updated_at: Scalars['String'];
};

export type ProviderCredentialsInput = {
  certifications: Array<Scalars['String']>;
  deaLicenses?: InputMaybe<Array<ProviderDeaLicenseInput>>;
  fellowships?: InputMaybe<Scalars['String']>;
  medicalRole?: InputMaybe<Scalars['String']>;
  stateLicenses?: InputMaybe<Array<ProviderStateLicenseInput>>;
  titles: Array<Scalars['String']>;
  yearsOfPractice: Scalars['String'];
};

export type ProviderCredentialsOutput = {
  __typename?: 'ProviderCredentialsOutput';
  certifications: Array<Scalars['String']>;
  deaLicenses?: Maybe<Array<ProviderDeaLicenseOutput>>;
  fellowships?: Maybe<Scalars['String']>;
  medicalRole: Scalars['String'];
  stateLicenses?: Maybe<Array<ProviderStateLicenseOutput>>;
  titles: Array<Scalars['String']>;
  yearsOfPractice: Scalars['String'];
};

export type ProviderDeaLicenseInput = {
  deaNumber: Scalars['String'];
  expiration: Scalars['String'];
  schedulesAllowed?: InputMaybe<DeaSchedulesAllowedInput>;
  type: DeaLicenseType;
};

export type ProviderDeaLicenseOutput = {
  __typename?: 'ProviderDeaLicenseOutput';
  deaNumber: Scalars['String'];
  expiration: Scalars['String'];
  id: Scalars['String'];
  schedulesAllowed: DeaSchedulesAllowedOutput;
  type: DeaLicenseType;
};

export type ProviderEducationInput = {
  isStillResident?: InputMaybe<Scalars['Boolean']>;
  medicalSchool: Scalars['String'];
  residency?: InputMaybe<Scalars['String']>;
  residencyEndDate?: InputMaybe<Scalars['String']>;
  residencyStartDate?: InputMaybe<Scalars['String']>;
  undergraduate: Scalars['String'];
};

export type ProviderEducationOutput = {
  __typename?: 'ProviderEducationOutput';
  isStillResident?: Maybe<Scalars['Boolean']>;
  medicalSchool: Scalars['String'];
  residency?: Maybe<Scalars['String']>;
  residencyEndDate?: Maybe<Scalars['String']>;
  residencyStartDate?: Maybe<Scalars['String']>;
  undergraduate: Scalars['String'];
};

export type ProviderIdentifiersOutput = {
  __typename?: 'ProviderIdentifiersOutput';
  acuityCalendarId?: Maybe<Scalars['String']>;
  acuityOwnerId?: Maybe<Scalars['String']>;
  codexId?: Maybe<Scalars['String']>;
  ePrescribeUserId?: Maybe<Scalars['String']>;
  fhirId: Scalars['String'];
  fullscriptId?: Maybe<Scalars['String']>;
  mosaicId?: Maybe<Scalars['String']>;
  patientRequestsListId?: Maybe<Scalars['String']>;
};

export type ProviderOutput = {
  __typename?: 'ProviderOutput';
  SENSITIVE_about?: Maybe<Scalars['String']>;
  SENSITIVE_address_information?: Maybe<AddressInformationOutput>;
  SENSITIVE_credentials: ProviderCredentialsOutput;
  SENSITIVE_dob?: Maybe<Scalars['String']>;
  SENSITIVE_education: Array<ProviderEducationOutput>;
  SENSITIVE_email: Scalars['String'];
  SENSITIVE_firstname: Scalars['String'];
  SENSITIVE_gender: Scalars['String'];
  SENSITIVE_gender_describe?: Maybe<Scalars['String']>;
  SENSITIVE_languages_of_communication: Array<Scalars['String']>;
  SENSITIVE_lastname: Scalars['String'];
  SENSITIVE_national_provider_identifier: Scalars['String'];
  SENSITIVE_office_information?: Maybe<OfficeAddressInformationOutput>;
  SENSITIVE_phone: Scalars['String'];
  SENSITIVE_profile_picture_id?: Maybe<Scalars['String']>;
  accepting_patients: Scalars['Boolean'];
  acuityCalendarId?: Maybe<Scalars['String']>;
  acuityOwnerId?: Maybe<Scalars['String']>;
  blocked_at?: Maybe<Scalars['String']>;
  codex_approved: Scalars['Boolean'];
  ePrescribeUserId?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  fullscriptId?: Maybe<Scalars['String']>;
  fully_verified: Scalars['Boolean'];
  hide_contact_info?: Maybe<Scalars['Boolean']>;
  hide_office_address?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  id_verified: Scalars['Boolean'];
  identifiers?: Maybe<ProviderIdentifiersOutput>;
  insurance_verified: Scalars['Boolean'];
  isStripeConnected?: Maybe<Scalars['Boolean']>;
  patientRequests: Array<PatientRequest>;
  patientRequestsListId?: Maybe<Scalars['String']>;
  providerBalance?: Maybe<Scalars['Float']>;
  serviceOfferings: Array<ServiceOfferingsOutput>;
  stripeAccountId?: Maybe<Scalars['String']>;
  stripePayoutsReadyAt?: Maybe<Scalars['String']>;
  subscriptionPeriodEnd?: Maybe<Scalars['String']>;
  subscriptionStatus?: Maybe<CodexSubscriptionStatuses>;
};

export type ProviderPayoutOutput = {
  __typename?: 'ProviderPayoutOutput';
  appointment?: Maybe<GetAppointmentOutput>;
  appointment_id?: Maybe<Scalars['String']>;
  appointments_total: Scalars['Int'];
  category: Scalars['Int'];
  created_at: Scalars['String'];
  discount?: Maybe<DiscountOutput>;
  id: Scalars['Int'];
  invoice_number?: Maybe<Scalars['String']>;
  order_ids?: Maybe<Array<Scalars['Int']>>;
  orders?: Maybe<Array<OrderOutput>>;
  paid_at?: Maybe<Scalars['String']>;
  patient?: Maybe<GetPatientOutput>;
  patient_id?: Maybe<Scalars['String']>;
  payer_role: Scalars['Int'];
  payment_provider?: Maybe<PaymentProviderEnum>;
  provider?: Maybe<ProviderOutput>;
  provider_id?: Maybe<Scalars['String']>;
  related_payments?: Maybe<Array<PaymentTransactionOutput>>;
  service_fee: Scalars['Float'];
  service_total: Scalars['Float'];
  status: Scalars['Int'];
  stripe_fee: Scalars['Float'];
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription?: Maybe<SubscriptionOutput>;
  subscription_id?: Maybe<Scalars['Int']>;
  total: Scalars['Float'];
  transaction_type: Scalars['Int'];
  updated_at: Scalars['String'];
  weeklyPaymentDetails?: Maybe<WeeklyPaymentDetailsOutput>;
};

export type ProviderPayoutsOutput = {
  __typename?: 'ProviderPayoutsOutput';
  payouts: Array<ProviderPayoutOutput>;
  total: Scalars['Int'];
};

/** The status of a request to become a patient. */
export enum ProviderRequestStatus {
  Accepted = 'Accepted',
  AwaitingAgreement = 'AwaitingAgreement',
  Cancelled = 'Cancelled',
  None = 'None',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type ProviderStateLicenseInput = {
  expirationDate: Scalars['String'];
  licenseNumber: Scalars['String'];
  licenseType?: InputMaybe<StateLicenseType>;
  state: Scalars['String'];
};

export type ProviderStateLicenseOutput = {
  __typename?: 'ProviderStateLicenseOutput';
  expirationDate: Scalars['String'];
  id: Scalars['String'];
  licenseNumber: Scalars['String'];
  licenseType: StateLicenseType;
  state: Scalars['String'];
};

export type ProviderTimezoneOutput = {
  __typename?: 'ProviderTimezoneOutput';
  timezone: Scalars['String'];
};

/** Enum representing the possible values for "provider" field in getFHIRDnaVisitTests. */
export enum ProvidersTypes {
  All = 'ALL',
  DnaVisit = 'DNA_VISIT',
  OtherProviders = 'OTHER_PROVIDERS'
}

export type PublishLegalDocumentInput = {
  contentMobile: Scalars['String'];
  contentWeb: Scalars['String'];
  type: Hasura_Legal_Document_Types_Enum;
};

export type Quantity = {
  __typename?: 'Quantity';
  code?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type QuantityInput = {
  code?: InputMaybe<Scalars['String']>;
  system?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  cronAppointmentSummaryReminder: Scalars['Boolean'];
  cronCancelAppointmentsForExpiredSubscriptionGracePeriod: Scalars['Boolean'];
  cronCancelUnpaidAppointments: Scalars['Boolean'];
  cronCleanupExpiredAiTranscripts: Scalars['Boolean'];
  cronCleanupOldActivityEvents: Scalars['Boolean'];
  cronCleanupStaleChannelSignals: Scalars['Boolean'];
  cronClearAllToastNotifications: Scalars['Boolean'];
  cronExpireStaleAppointmentRequests: Scalars['Boolean'];
  cronHandleProviderStateLicenses: Scalars['Boolean'];
  cronHealthQuestionerUpdateReminder: Scalars['Boolean'];
  cronRecommendationReminder: Scalars['Boolean'];
  cronSyncPaymentTransactions: Scalars['Boolean'];
  ePrescribeMyTasksCount: TotalOutput;
  frontEndAuthConfigs: Scalars['JSON'];
  fullscriptDependentCreateLink: DependentLinkOutput;
  getAcceptedLegalDocuments: AcceptedLegalDocumentsOutput;
  getAccountUsers: AccountUsersOutput;
  getAchievements: AchievementsOutput;
  getActiveRecommendationsByPatientCodexId: GetFhirRecommendationsOutput;
  getAllDraftTestQuestionnairesByPatient: GetFhirQuestionnaireResponseArr;
  getAllergenClasses: AllergenClassesOutput;
  getAppTours: AppToursOutput;
  getAppVersions: AppVersionsOutput;
  getAppointmentDetails: SaAppointmentDetailsOutput;
  getAppointmentMessageByCommunicationFhirId: GetAppointmentChatMessagesOutput;
  getAppointmentMessageListByAppointmentCodexId: GetAppointmentChatMessagesOutput;
  getAppointmentNotesByAppointmentId: GetAppointmentNotesByAppointmentIdOutput;
  getAppointmentRescheduleLink: GetAppointmentRescheduleLinkOutput;
  getAppointmentRetryPaymentLink: GetPaymentLinkOutput;
  getAppointmentStats: Array<AppointmentStatsByDayOutput>;
  getAppointmentSummary: VonageSummaryOutput;
  getAppointments: SaAppointments;
  getBecomePatientRequests: BecomePatientRequestsOutput;
  getCallSettings: Scalars['JSON'];
  getCartProducts: CartProductsOutput;
  getDelegatedAdminDetails: DelegatedAdminDetailsOutput;
  getDelegatedAdmins: GetDelegatedAdminsOutput;
  getDeliveryAddresses: DeliveryAddressesOutput;
  getDiagnosticReports: SaDiagnosticReports;
  getDiagnosticReportsByParticipants: AppointmentsDiagnosticReportsOutput;
  getDiagnosticReportsByPatient: AppointmentsDiagnosticReportsOutput;
  getDiscountCode: DiscountOutput;
  getDraftTestQuestionnairesById: GetFhirQuestionnaireResponse;
  getEducationCourseDetails: EducationCourseOutput;
  getEducationCourses: EducationCoursesListOutput;
  getEducationModules: EducationModulesListOutput;
  getFHIRAppointmentByAcuityId: GetFhirAppointmentOutput;
  getFHIRAppointmentByCodexId: GetFhirAppointmentOutput;
  getFHIRAppointmentByPatientCodexId: GetFhirAppointmentsOutput;
  getFHIRAppointmentByRequestPatientCodexId: GetFhirAppointmentsOutputWithUpcomingCounts;
  getFHIRAppointmentByRequestProviderId: GetFhirAppointmentsOutputWithUpcomingCounts;
  getFHIRDPrivderInfoByZrtSwabcode: ProviderOutput;
  getFHIRDiagnosticSolutionTests: GetFhirMosaicTests;
  getFHIRDnaAndZrtTests: GetFhirDnaAndZrtTests;
  getFHIRDnaVisitTestByOrderId: GetFhirDnaVisitTestByIdentifier;
  getFHIRDnaVisitTestBySwabcode: GetFhirDnaVisitTestByIdentifier;
  getFHIRDnaVisitTestByTestId: GetFhirDnaVisitTestByIdentifier;
  getFHIRDnaVisitTests: GetFhirDnaVisitTests;
  getFHIRDnaVisitTestsByUserId: GetFhirDnaVisitTestsByUserId;
  getFHIREncountersByPatient: EncounterListOutput;
  getFHIREncountersByProvider: EncounterListOutput;
  getFHIRMediaByRequestPatientCodexID: GetFhirPatientMediaOutput;
  getFHIRMedicationRequestBranAndNamesByPatientCodexId: GetMedicationRequestsBrandAndNameOutput;
  getFHIRMedicationRequestByFhirId: GetMedicationRequestsOutput;
  getFHIRMedicationRequestByPatientCodexId: GetMedicationRequestsOutput;
  getFHIRMosaicTests: GetFhirMosaicTests;
  getFHIRPatientAppointmentsByProvider: GetFhirAppointmentsOutputWithUpcomingCounts;
  getFHIRPatientByFHIRID: GetFhirPatientOutput;
  getFHIRPatientbyCodexID: GetFhirPatientOutput;
  getFHIRPatientbyCodexIDParameter: GetFhirPatientOutput;
  getFHIRPatientbyEmail: GetFhirPatientOutput;
  getFHIRPatientbyMediaCodexIDParameter: GetFhirPatientMediaOutput;
  getFHIRPatientsById: GetFhirPatientsByProviderIdOutput;
  getFHIRProviderBioById: GetFhirProviderBioByIdOutput;
  getFHIRProviderByRequestId: GetFhirProviderByIdOutput;
  getFHIRProviderbyCodexIdArgument: GetProviderBioByIdQueryOutput;
  getFHIRProviderbyEmail: GetFhirProviderByEmailOutput;
  getFHIRProviderbyId: GetFhirProviderByIdOutput;
  getFHIRProviders: GetFhirProvidersOutput;
  getFHIRProvidersByDnaAndZrtTests: GetFhirProvidersByDnaAndZrtTests;
  getFHIRQuestionnaireByCodexID: GetQuestionnaireOutput;
  getFHIRQuestionnaireResponse: GetFhirQuestionnaireResponse;
  getFHIRZrtTestByTestId: GetFhirZrtTest;
  getFHIRZrtTests: GetFhirZrtTests;
  getFilesByRequestUserCodexId: GetMediaFilesOutput;
  getFreeProvidersByTimeSlots: GetFhirProvidersOutput;
  getFullscriptAllergens: FullscriptAllergensOutput;
  getFullscriptAllergensFromQuestionnaireResponse: FullscriptAllergensOutput;
  getGeneralDashboardStats: SaGeneralDashboardStats;
  getInMailDetail: InMailDetailsOutput;
  getInMailUsage: InMailUsageOutput;
  getInvoiceOrReceiptUrl: DownloadInvoiceOrReceiptUrlOutput;
  getLastViewedPatientByProvider: GetLastViewedPatientByUserQueryOutput;
  getLastViewedProvidersByUser: GetLastViewedProvidersByUserQueryOutput;
  getLatestFHIRQuestionnaire: GetFhirQuestionnaireResponse;
  getLatestFHIRQuestionnaireById: GetLatestFhirQuestionnaireByIdResponse;
  getLegalDocument: LegalDocumentOutput;
  getLegalDocuments: LegalDocumentsOutput;
  getMedications: MedicationsOutput;
  getMyBillingPlan: BillingPlan;
  getNotificationsByRequestUserIdWithCounts: GetUserNotificationsWithCounts;
  getOrderById: OrderOutput;
  getOrderRetryPaymentLink: GetPaymentLinkOutput;
  getOrderStats: Array<OrderStatsByDayOutput>;
  getOrders: OrderListOutput;
  getPatientStateAgeOfMajority: AgeOfMajorityOutput;
  getPatients: SaPatients;
  getPaymentMethodList: PaymentMethodsOutput;
  getPaymentStats: Array<PaymentStatsByDayOutput>;
  getPaymentTransactionById: PaymentTransactionOutput;
  getPaymentTransactions: PaymentTransactionListOutput;
  getProductDetails: ProductOutput;
  getProducts: GetProductsOutput;
  getProviderAppointmentRequests: AppointmentRequestsOutput;
  getProviderBilling: ProviderBillingOutput;
  getProviderByPatientId: GetFhirProvidersOutput;
  getProviderPaymentDetails: GetProviderPaymentDetailsOutput;
  getProviderPayoutDetails: GetFhirAppointmentsOutput;
  getProviderPayoutTransactions: ProviderPayoutsOutput;
  getProviderTimezone: ProviderTimezoneOutput;
  getProviders: SaProviders;
  getProvidersByPatientId: GetFhirProviderByIdOutput;
  getReceiptsHistory: ReceiptsHistoryOutput;
  getRecommendationsByRequestPatientCodexId: GetFhirRecommendationsOutput;
  getSessionGrant: FullscriptSessionGrantResult;
  getSubPatientsByParent: SubPatientsOutput;
  getSubscriptionBillingHistory: PaymentTransactionListOutput;
  getSuperAdmins: GetSuperAdminsOutput;
  getSupportChatDetail: SupportChatDetailsOutput;
  getSupportChats: SupportChatsOutput;
  getSwabCodes: SwabCodeListOutput;
  getTestKitDetails: TestKitDetailsOutput;
  getTestKitResultsByRequestPatientCodexId: TestKitResultsOutput;
  getTestKitStats: Array<TestKitStatsByDayOutput>;
  getUnfilledSummariesByRequestProviderId: GetFhirAppointmentsOutput;
  getUserActivityLog: ActivityLogOutput;
  getUserInMailsByRequestId: InMailsOutput;
  getUserRegistrationStats: Array<UserRegistrationStatsByDayOutput>;
  getVerificationRequests: SaVerificationRequests;
  health: Scalars['String'];
  notificationPreferences: NotificationPreferencesOutput;
  updateAppointmentSummaryNotificationState: HttpStatusOutput;
  validateChildAdultTransitionInvitationToken: ValidateChildAdultTransitionInvitationTokenOutput;
  validateDelegatedAdminInvitationToken: ValidateDelegatedAdminInvitationTokenOutput;
};


export type QueryFullscriptDependentCreateLinkArgs = {
  input: CreateDependentLinkInput;
};


export type QueryGetAcceptedLegalDocumentsArgs = {
  userCodexId?: InputMaybe<Scalars['String']>;
};


export type QueryGetAccountUsersArgs = {
  isClosed?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetActiveRecommendationsByPatientCodexIdArgs = {
  codexPatientId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GetFhirRecommendationsOrderByInput>;
};


export type QueryGetAllergenClassesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetAppVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  version?: InputMaybe<Scalars['String']>;
};


export type QueryGetAppointmentDetailsArgs = {
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  appointmentFhirId?: InputMaybe<Scalars['String']>;
};


export type QueryGetAppointmentMessageByCommunicationFhirIdArgs = {
  communicationFhirId: Scalars['String'];
};


export type QueryGetAppointmentMessageListByAppointmentCodexIdArgs = {
  appointmentCodexId: Scalars['String'];
};


export type QueryGetAppointmentNotesByAppointmentIdArgs = {
  appointmentCodexId: Scalars['String'];
};


export type QueryGetAppointmentRescheduleLinkArgs = {
  appointmentCodexId: Scalars['String'];
};


export type QueryGetAppointmentRetryPaymentLinkArgs = {
  appointmentCodexId: Scalars['String'];
};


export type QueryGetAppointmentStatsArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetAppointmentSummaryArgs = {
  appointmentCodexId: Scalars['String'];
};


export type QueryGetAppointmentsArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  narrowing?: InputMaybe<SaNarrowingQueryOptions>;
  orderBy?: InputMaybe<SaAppointmentOrderBy>;
  paging?: InputMaybe<SaPageableQueryOptions>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
  toDate?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<AppointmentTypeEnum>>;
};


export type QueryGetBecomePatientRequestsArgs = {
  input?: InputMaybe<GetBecomePatientRequestsInput>;
};


export type QueryGetCallSettingsArgs = {
  platform: ClientPlatform;
};


export type QueryGetDelegatedAdminDetailsArgs = {
  input: DelegatedAdminCodexIdInput;
};


export type QueryGetDelegatedAdminsArgs = {
  filters?: InputMaybe<GetDelegatedAdminsInput>;
  orderBy?: InputMaybe<DelegatedAdminOrderByInput>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryGetDeliveryAddressesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetDiagnosticReportsArgs = {
  narrowing?: InputMaybe<SaNarrowingQueryOptions>;
  paging?: InputMaybe<SaPageableQueryOptions>;
  types?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetDiagnosticReportsByParticipantsArgs = {
  patientCodexId: Scalars['String'];
  providerCodexId: Scalars['String'];
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum>>;
};


export type QueryGetDiagnosticReportsByPatientArgs = {
  exceptAppointmentCodexId?: InputMaybe<Scalars['String']>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum>>;
};


export type QueryGetDiscountCodeArgs = {
  promoCode: Scalars['String'];
};


export type QueryGetDraftTestQuestionnairesByIdArgs = {
  questionnaireId: Scalars['String'];
};


export type QueryGetEducationCourseDetailsArgs = {
  id: Scalars['String'];
};


export type QueryGetEducationCoursesArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryGetEducationModulesArgs = {
  filters?: InputMaybe<GetEducationModulesInput>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryGetFhirAppointmentByAcuityIdArgs = {
  appointmentAcuityId: Scalars['String'];
};


export type QueryGetFhirAppointmentByCodexIdArgs = {
  appointmentCodexId: Scalars['String'];
};


export type QueryGetFhirAppointmentByPatientCodexIdArgs = {
  appointmentStatus?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patientCodexId?: InputMaybe<Scalars['String']>;
};


export type QueryGetFhirAppointmentByRequestPatientCodexIdArgs = {
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  appointmentStatus?: InputMaybe<Array<Scalars['String']>>;
  codexProviderId?: InputMaybe<Scalars['String']>;
  dayFilter?: InputMaybe<Scalars['String']>;
  find?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  isSummaryCompleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  providerName?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  tzOffset?: InputMaybe<Scalars['Float']>;
};


export type QueryGetFhirAppointmentByRequestProviderIdArgs = {
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  appointmentStatus?: InputMaybe<Array<Scalars['String']>>;
  dayFilter?: InputMaybe<Scalars['String']>;
  find?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  isSummaryCompleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  patientName?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  tzOffset?: InputMaybe<Scalars['Float']>;
};


export type QueryGetFhirdPrivderInfoByZrtSwabcodeArgs = {
  getFHIRDPrivderInfoByZrtSwabcode: Scalars['String'];
};


export type QueryGetFhirDiagnosticSolutionTestsArgs = {
  find?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MosaicTestsInput>;
  providerName?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum>>;
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum>>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryGetFhirDnaAndZrtTestsArgs = {
  find?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DiagnosticReportOrderByInput>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  providerName?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum>>;
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum>>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryGetFhirDnaVisitTestByOrderIdArgs = {
  getFHIRDnaVisitTestByOrderId: Scalars['String'];
};


export type QueryGetFhirDnaVisitTestBySwabcodeArgs = {
  getFHIRDnaVisitTestBySwabcode: Scalars['String'];
};


export type QueryGetFhirDnaVisitTestByTestIdArgs = {
  getFHIRDnaVisitTestByTestId: Scalars['String'];
};


export type QueryGetFhirDnaVisitTestsArgs = {
  find?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DnaVisitOrderByInput>;
  providerName?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum>>;
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum>>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryGetFhirDnaVisitTestsByUserIdArgs = {
  codexPatientId?: InputMaybe<Scalars['String']>;
  find?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DnaVisitOrderByInput>;
  providerName?: InputMaybe<Scalars['String']>;
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum>>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryGetFhirEncountersByPatientArgs = {
  finishedAtEnd?: InputMaybe<Scalars['String']>;
  finishedAtStart?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};


export type QueryGetFhirEncountersByProviderArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  status?: EncounterStatuses;
};


export type QueryGetFhirMediaByRequestPatientCodexIdArgs = {
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryGetFhirMedicationRequestBranAndNamesByPatientCodexIdArgs = {
  patientCodexId?: InputMaybe<Scalars['String']>;
};


export type QueryGetFhirMedicationRequestByFhirIdArgs = {
  fhirId: Scalars['String'];
};


export type QueryGetFhirMedicationRequestByPatientCodexIdArgs = {
  brandAndName?: InputMaybe<Scalars['String']>;
  encounterId?: InputMaybe<Scalars['String']>;
  find?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  includeSubPatients?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Float']>;
  source?: InputMaybe<Array<MedicationRequestSource>>;
  statuses?: InputMaybe<Array<MedicationRequestStatusEnum>>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryGetFhirMosaicTestsArgs = {
  find?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MosaicTestsInput>;
  providerName?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum>>;
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum>>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryGetFhirPatientAppointmentsByProviderArgs = {
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  appointmentStatus?: InputMaybe<Array<Scalars['String']>>;
  dayFilter?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  isSummaryCompleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patientCodexId: Scalars['String'];
  sort?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  tzOffset?: InputMaybe<Scalars['Float']>;
  withOtherProviders?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetFhirPatientByFhiridArgs = {
  fhirId: Scalars['String'];
};


export type QueryGetFhirPatientbyCodexIdParameterArgs = {
  patientCodexId?: InputMaybe<Scalars['String']>;
};


export type QueryGetFhirPatientbyEmailArgs = {
  email: Scalars['String'];
};


export type QueryGetFhirPatientbyMediaCodexIdParameterArgs = {
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patientCodexId: Scalars['String'];
  sort?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryGetFhirPatientsByIdArgs = {
  dateFilter?: InputMaybe<GetFhirPatientsByIdDateFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GetFhirPatientsByIdOrderByInput>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  searchCriteria?: InputMaybe<Scalars['String']>;
};


export type QueryGetFhirProviderbyCodexIdArgumentArgs = {
  codexProviderId: Scalars['String'];
};


export type QueryGetFhirProviderbyEmailArgs = {
  email: Scalars['String'];
};


export type QueryGetFhirProviderbyIdArgs = {
  providerId: Scalars['String'];
};


export type QueryGetFhirProvidersArgs = {
  acceptedAppointments?: InputMaybe<Array<Scalars['String']>>;
  gender?: InputMaybe<Array<Scalars['String']>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  medicalRole?: InputMaybe<Array<Scalars['String']>>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  serverOfferedRange?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  specialty?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Scalars['String']>;
  yearOfExperienceRange?: InputMaybe<Scalars['String']>;
};


export type QueryGetFhirProvidersByDnaAndZrtTestsArgs = {
  patientCodexId?: InputMaybe<Scalars['String']>;
};


export type QueryGetFhirQuestionnaireByCodexIdArgs = {
  questionnaireId: Scalars['Int'];
};


export type QueryGetFhirQuestionnaireResponseArgs = {
  codexPatientId: Scalars['String'];
  identifier: Scalars['String'];
  swabCode?: InputMaybe<Scalars['String']>;
  system: Scalars['String'];
};


export type QueryGetFhirZrtTestByTestIdArgs = {
  getFHIRZrtTestByTestId: Scalars['String'];
};


export type QueryGetFhirZrtTestsArgs = {
  find?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ZrtOrderByInput>;
  provider?: InputMaybe<ProvidersTypes>;
  providerName?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum>>;
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum>>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryGetFilesByRequestUserCodexIdArgs = {
  input: MediaFilesFilterInput;
};


export type QueryGetFreeProvidersByTimeSlotsArgs = {
  input: GetFreeProvidersByTimeSlotsInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetFullscriptAllergensArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetFullscriptAllergensFromQuestionnaireResponseArgs = {
  codexPatientId: Scalars['String'];
  identifier: Scalars['String'];
  system: Scalars['String'];
};


export type QueryGetInMailDetailArgs = {
  filter?: InputMaybe<GetInMailDetailInput>;
  limit?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetInvoiceOrReceiptUrlArgs = {
  appointmentId?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['Int']>;
  paymentTransactionId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetLatestFhirQuestionnaireArgs = {
  identifier: Scalars['String'];
  system: Scalars['String'];
};


export type QueryGetLatestFhirQuestionnaireByIdArgs = {
  questionnaire_id: Scalars['Int'];
};


export type QueryGetLegalDocumentArgs = {
  input: GetLegalDocumentInput;
};


export type QueryGetLegalDocumentsArgs = {
  input: GetLegalDocumentsInput;
};


export type QueryGetMedicationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetNotificationsByRequestUserIdWithCountsArgs = {
  includeStatuses?: InputMaybe<Array<Scalars['String']>>;
  isImportantUpdate?: InputMaybe<Scalars['Boolean']>;
  isLatestActivity?: InputMaybe<Scalars['Boolean']>;
  isModal?: InputMaybe<Scalars['Boolean']>;
  isToast?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<OrderByDirections>;
};


export type QueryGetOrderByIdArgs = {
  id: Scalars['Int'];
};


export type QueryGetOrderRetryPaymentLinkArgs = {
  orderId: Scalars['Int'];
};


export type QueryGetOrderStatsArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetOrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderOrderByInput>;
};


export type QueryGetPatientsArgs = {
  filter?: InputMaybe<SaPatientFilterOptions>;
  orderBy?: InputMaybe<SaPatientOrderBy>;
  paging?: InputMaybe<SaPageableQueryOptions>;
};


export type QueryGetPaymentStatsArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetPaymentTransactionByIdArgs = {
  id: Scalars['Int'];
};


export type QueryGetPaymentTransactionsArgs = {
  filter?: InputMaybe<PaymentTransactionFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<PaymentTransactionOrderByInput>;
};


export type QueryGetProductDetailsArgs = {
  id: Scalars['Int'];
};


export type QueryGetProductsArgs = {
  categories?: InputMaybe<Array<Scalars['Int']>>;
  inStock?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetProviderAppointmentRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetProviderBillingArgs = {
  providerCodexId?: InputMaybe<Scalars['String']>;
};


export type QueryGetProviderPayoutDetailsArgs = {
  appointmentStatus?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  paymentTransactionId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetProviderPayoutTransactionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetProviderTimezoneArgs = {
  providerCodexId?: InputMaybe<Scalars['String']>;
};


export type QueryGetProvidersArgs = {
  filter?: InputMaybe<SaProviderFilterOptions>;
  orderBy?: InputMaybe<SaProviderOrderBy>;
  paging?: InputMaybe<SaPageableQueryOptions>;
};


export type QueryGetProvidersByPatientIdArgs = {
  appointmentTypeId?: InputMaybe<Scalars['Float']>;
  date?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  onlyAvailable?: InputMaybe<Scalars['Boolean']>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetReceiptsHistoryArgs = {
  input: ReceiptHistoryInput;
};


export type QueryGetRecommendationsByRequestPatientCodexIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GetFhirRecommendationsOrderByInput>;
  statuses?: InputMaybe<Array<ServiceRequestStatus>>;
};


export type QueryGetSessionGrantArgs = {
  patientCodexId: Scalars['String'];
};


export type QueryGetSubPatientsByParentArgs = {
  isClosed?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetSubscriptionBillingHistoryArgs = {
  invoiceNumber?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetSuperAdminsArgs = {
  filters?: InputMaybe<GetSuperAdminsInput>;
  orderBy?: InputMaybe<SuperAdminOrderByInput>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryGetSupportChatDetailArgs = {
  filter?: InputMaybe<GetSupportChatDetailInput>;
  limit?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetSupportChatsArgs = {
  filter?: InputMaybe<GetSupportChatsInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetSwabCodesArgs = {
  filter?: InputMaybe<SwabCodeFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetTestKitDetailsArgs = {
  swabcode: Scalars['String'];
};


export type QueryGetTestKitResultsByRequestPatientCodexIdArgs = {
  input: TestKitResultsInput;
};


export type QueryGetTestKitStatsArgs = {
  filters: TestKitStatsFiltersInput;
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetUnfilledSummariesByRequestProviderIdArgs = {
  appointmentStatus?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryGetUserActivityLogArgs = {
  filters?: InputMaybe<ActivityLogFilterInput>;
  fromDate?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['String']>;
  userCodexId: Scalars['String'];
};


export type QueryGetUserInMailsByRequestIdArgs = {
  filter?: InputMaybe<GetInMailsInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetUserRegistrationStatsArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetVerificationRequestsArgs = {
  filter?: InputMaybe<SaVerificationRequestFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SaVerificationRequestOrderBy>;
};


export type QueryUpdateAppointmentSummaryNotificationStateArgs = {
  appointmentCodexId: Scalars['String'];
  summaryNotification: Scalars['Boolean'];
};


export type QueryValidateChildAdultTransitionInvitationTokenArgs = {
  input: ValidateInvitationTokenInput;
};


export type QueryValidateDelegatedAdminInvitationTokenArgs = {
  input: ValidateInvitationTokenInput;
};

export type QuestionHelperTextData = {
  __typename?: 'QuestionHelperTextData';
  helper_text_1: Scalars['String'];
  helper_text_2: Scalars['String'];
};

export type QuestionnaireDependenciesGroup = {
  __typename?: 'QuestionnaireDependenciesGroup';
  complete?: Maybe<Scalars['Boolean']>;
  dependencies?: Maybe<Array<DynamicQuestionnaireDependencies>>;
  name: Scalars['String'];
  properties: Array<Scalars['String']>;
};

export type QuestionnaireQuestionsQuestion = {
  __typename?: 'QuestionnaireQuestionsQuestion';
  all_option?: Maybe<Scalars['String']>;
  answers?: Maybe<Array<Scalars['String']>>;
  array_field_config?: Maybe<ArrayFieldConfig>;
  children?: Maybe<Array<QuestionnaireQuestionsQuestion>>;
  dont_know_answer?: Maybe<Scalars['String']>;
  double_text_combo_helper_texts?: Maybe<QuestionHelperTextData>;
  dropdown_combo_answers?: Maybe<Scalars['JSON']>;
  dropdown_label_1?: Maybe<Scalars['String']>;
  dropdown_label_2?: Maybe<Scalars['String']>;
  helper_text?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  measurement_unit?: Maybe<Scalars['String']>;
  none_option?: Maybe<Scalars['String']>;
  response_property?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  ui_control: Scalars['String'];
};

export type QuestionnaireResponseInput = {
  authored?: InputMaybe<Scalars['String']>;
  codexPatientId: Scalars['String'];
  completed?: InputMaybe<Scalars['Boolean']>;
  currentStepIndex?: InputMaybe<Scalars['Int']>;
  questionnaireName: FhirQuestionnaireNames;
  questionnaireResponse: Scalars['JSON'];
  serviceRequestId?: InputMaybe<Scalars['String']>;
  swabCode?: InputMaybe<Scalars['String']>;
};

/** Enum representing the possible values for "status" field in QuestionnaireResponse. */
export enum QuestionnaireResponseStatus {
  Amended = 'AMENDED',
  Completed = 'COMPLETED',
  EnteredInError = 'ENTERED_IN_ERROR',
  InProgress = 'IN_PROGRESS',
  Stopped = 'STOPPED'
}

export type QuestionnairesQuestionnaireQuestions = {
  __typename?: 'QuestionnairesQuestionnaireQuestions';
  questionnaire_questions_question: QuestionnaireQuestionsQuestion;
};

/** Enum representing the possible values for roles */
export enum Roles_Enum {
  Admin = 'ADMIN',
  DelegatedAdmin = 'DELEGATED_ADMIN',
  Patient = 'PATIENT',
  Provider = 'PROVIDER',
  Superadmin = 'SUPERADMIN'
}

export type RangeValue = {
  __typename?: 'RangeValue';
  high?: Maybe<Quantity>;
  low?: Maybe<Quantity>;
};

export type RangeValueInput = {
  high?: InputMaybe<QuantityInput>;
  low?: InputMaybe<QuantityInput>;
};

export type RankedDiagnosticSolutionVisitTestOutput = {
  __typename?: 'RankedDiagnosticSolutionVisitTestOutput';
  appointment_codex_id?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  fhirId: Scalars['String'];
  patient_fhir_id?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_acuity_calendar_id?: Maybe<Scalars['String']>;
  provider_acuity_owner_id?: Maybe<Scalars['String']>;
  provider_codex_id?: Maybe<Scalars['String']>;
  provider_fhir_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  questionnaire_required?: Maybe<Scalars['Boolean']>;
  rank: Scalars['Float'];
  state?: Maybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  swab_code?: Maybe<Scalars['String']>;
  test_id?: Maybe<Scalars['String']>;
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
};

export type RankedDnaVisitTestOutput = {
  __typename?: 'RankedDnaVisitTestOutput';
  appointment_codex_id?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  diagnosticReportId: Scalars['String'];
  dna_test_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  dnavisit_order_id: Scalars['String'];
  health_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  last_processed_date?: Maybe<Scalars['String']>;
  last_processed_state?: Maybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  molecular_order_id?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_acuity_calendar_id?: Maybe<Scalars['String']>;
  provider_acuity_owner_id?: Maybe<Scalars['String']>;
  provider_codex_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  questionnaire_required?: Maybe<Scalars['Boolean']>;
  rank: Scalars['Float'];
  sapphiros_barcode: Scalars['String'];
  sapphiros_report_pdf_id?: Maybe<Scalars['String']>;
  state: Hasura_Dnavisit_Test_Statuses_Enum;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  test_id: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
  visit_summary_pdf_id?: Maybe<Scalars['String']>;
};

export type RankedMosaicVisitTestOutput = {
  __typename?: 'RankedMosaicVisitTestOutput';
  appointment_codex_id?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  fhirId: Scalars['String'];
  patient_fhir_id?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_acuity_calendar_id?: Maybe<Scalars['String']>;
  provider_acuity_owner_id?: Maybe<Scalars['String']>;
  provider_codex_id?: Maybe<Scalars['String']>;
  provider_fhir_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  questionnaire_required?: Maybe<Scalars['Boolean']>;
  rank: Scalars['Float'];
  state?: Maybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  swab_code?: Maybe<Scalars['String']>;
  test_id?: Maybe<Scalars['String']>;
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
};

export type RankedZrtTestOutput = {
  __typename?: 'RankedZrtTestOutput';
  appointment_codex_id?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  fhirId: Scalars['String'];
  health_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  npi_number?: Maybe<Scalars['String']>;
  observation_id?: Maybe<Scalars['String']>;
  patient_fhir_id?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_acuity_calendar_id?: Maybe<Scalars['String']>;
  provider_acuity_owner_id?: Maybe<Scalars['String']>;
  provider_codex_id?: Maybe<Scalars['String']>;
  provider_fhir_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  questionnaire_required?: Maybe<Scalars['Boolean']>;
  rank: Scalars['Float'];
  reference_code: Scalars['String'];
  service_request_id?: Maybe<Scalars['String']>;
  state: Hasura_Dnavisit_Test_Statuses_Enum;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  swab_code: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
};

export type ReceiptHistoryInput = {
  categories?: InputMaybe<Array<PaymentTransactionPaymentCategoryEnum>>;
  dateFilterArgs?: InputMaybe<DateFilterArgs>;
  pagingArgs?: InputMaybe<PaginationArgs>;
};

export type ReceiptHistoryItemOutput = {
  __typename?: 'ReceiptHistoryItemOutput';
  amount: Scalars['Float'];
  category: PaymentTransactionPaymentCategoryEnum;
  paidAt: Scalars['String'];
  paymentTransactionId: Scalars['Int'];
};

export type ReceiptsHistoryOutput = {
  __typename?: 'ReceiptsHistoryOutput';
  receipts: Array<ReceiptHistoryItemOutput>;
  total: Scalars['Int'];
  totalSpentOnAppointments: Scalars['Float'];
  totalSpentOnOrders: Scalars['Float'];
};

export type RecommendProductsOutput = {
  __typename?: 'RecommendProductsOutput';
  serviceRequestIds: Array<Scalars['String']>;
};

export type ReferenceInput = {
  reference?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ReferenceType = {
  __typename?: 'ReferenceType';
  reference?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type RequestDnaTestKitInput = {
  providerCodexId?: InputMaybe<Scalars['String']>;
  swabCode: Scalars['String'];
  testType: Hasura_Test_Types_Enum;
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type RequestDnaTestKitOutput = {
  __typename?: 'RequestDnaTestKitOutput';
  success: Scalars['Boolean'];
  swabCode: Scalars['String'];
};

export type RequestZrtTestOutput = {
  __typename?: 'RequestZrtTestOutput';
  requestStatus: ProviderRequestStatus;
  serviceRequestId: Scalars['String'];
};

export type RescheduleAppointmentInput = {
  appointmentCodexId: Scalars['String'];
  datetime: Scalars['String'];
  isTest?: InputMaybe<Scalars['Boolean']>;
};

export type RescheduleAppointmentOutput = {
  __typename?: 'RescheduleAppointmentOutput';
  appointmentCodexId: Scalars['String'];
  appointmentId: Scalars['String'];
  appointmentUrl: Scalars['String'];
  created: Scalars['String'];
  lastProcessedDate: Scalars['String'];
  start: Scalars['String'];
  status: Scalars['String'];
};

export type RescheduleFhirAppointmentOutput = {
  __typename?: 'RescheduleFHIRAppointmentOutput';
  appointment: RescheduleAppointmentOutput;
};

export type ResendChildAdultTransitionInvitationInput = {
  childUserId: Scalars['String'];
};

export type ResourceExtension = {
  __typename?: 'ResourceExtension';
  url?: Maybe<GoogleEhrExtensionsUrLs>;
  valueBoolean?: Maybe<Scalars['Boolean']>;
  valueCodeableConcept?: Maybe<ValuableCodeableConcept>;
  valueString?: Maybe<Scalars['String']>;
};

/** Enum representing the possible values for "resourceType" field in BaseResource. */
export enum ResourcesTypes {
  Appointment = 'APPOINTMENT',
  Basic = 'BASIC',
  Communication = 'COMMUNICATION',
  CommunicationRequest = 'COMMUNICATION_REQUEST',
  Condition = 'CONDITION',
  DiagnosticReport = 'DIAGNOSTIC_REPORT',
  DocumentReference = 'DOCUMENT_REFERENCE',
  Encounter = 'ENCOUNTER',
  Group = 'GROUP',
  HealthCareService = 'HEALTH_CARE_SERVICE',
  List = 'LIST',
  Location = 'LOCATION',
  Media = 'MEDIA',
  Medication = 'MEDICATION',
  MedicationRequest = 'MEDICATION_REQUEST',
  Observation = 'OBSERVATION',
  Organization = 'ORGANIZATION',
  Patient = 'PATIENT',
  Provider = 'PROVIDER',
  ProviderRole = 'PROVIDER_ROLE',
  Questionnaire = 'QUESTIONNAIRE',
  QuestionnaireResponse = 'QUESTIONNAIRE_RESPONSE',
  RelatedPerson = 'RELATED_PERSON',
  SearchParameter = 'SEARCH_PARAMETER',
  ServiceRequest = 'SERVICE_REQUEST'
}

export type SaAppointment = {
  __typename?: 'SAAppointment';
  dates: Array<Array<Scalars['String']>>;
  flags: Array<CodexTags>;
  identifiers: Array<Array<Scalars['String']>>;
  logs: Array<Array<Scalars['String']>>;
  patient?: Maybe<SaPerson>;
  provider?: Maybe<SaPerson>;
  status: Scalars['String'];
  type?: Maybe<AppointmentTypeEnum>;
};

export type SaAppointmentBrief = {
  __typename?: 'SAAppointmentBrief';
  dates: Array<Array<Scalars['String']>>;
  flags: Array<CodexTags>;
  identifiers: Array<Array<Scalars['String']>>;
};

export type SaAppointmentDetailsOutput = {
  __typename?: 'SAAppointmentDetailsOutput';
  appointmentIds: Array<Array<Scalars['String']>>;
  appointmentStart?: Maybe<Scalars['String']>;
  appointmentStatus: Scalars['Int'];
  createdAt?: Maybe<Scalars['String']>;
  originalTransaction?: Maybe<PaymentTransactionOutput>;
  patient?: Maybe<SaPatient>;
  provider?: Maybe<SaProvider>;
  refundTransactions: Array<PaymentTransactionOutput>;
  status: Scalars['String'];
  statusHistory: Array<AppointmentStatusHistoryEntry>;
  transactionCategory: Scalars['String'];
};

export type SaAppointmentOrderBy = {
  direction?: InputMaybe<OrderByDirections>;
  field?: InputMaybe<SaAppointmentOrderByField>;
};

/** Field to order SA appointments by */
export enum SaAppointmentOrderByField {
  CreatedAt = 'CreatedAt',
  Start = 'Start'
}

export type SaAppointmentOutput = {
  __typename?: 'SAAppointmentOutput';
  acuityId?: Maybe<Scalars['String']>;
  appointmentId: Scalars['String'];
  created?: Maybe<Scalars['String']>;
  diagnosticReportId?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  lastProcessedDate?: Maybe<Scalars['String']>;
  lastUpdate?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export type SaAppointments = {
  __typename?: 'SAAppointments';
  appointments: Array<SaAppointment>;
  count: Scalars['Int'];
  nextPageToken?: Maybe<Scalars['String']>;
  prevPageToken?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
};

export type SaArtifact = {
  __typename?: 'SAArtifact';
  contentType: SaContentType;
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  kind: SaArtifactTypes;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
};

export enum SaArtifactTypes {
  DnaTestQuestionnairePdfId = 'dna_test_questionnaire_pdf_id',
  HealthQuestionnairePdfId = 'health_questionnaire_pdf_id',
  PatientPdf = 'patient_pdf',
  ProviderReportPdf = 'provider_report_pdf',
  SapphirosReportPdfId = 'sapphiros_report_pdf_id',
  VisitSummaryPdfId = 'visit_summary_pdf_id',
  ZrtQuestionnaireResponses = 'zrt_questionnaire_responses'
}

export enum SaContentType {
  Json = 'json',
  MediaId = 'mediaId',
  Url = 'url'
}

export type SaDiagnosticReport = {
  __typename?: 'SADiagnosticReport';
  appointment?: Maybe<SaAppointmentOutput>;
  artifacts: Array<SaArtifact>;
  dates: Array<Array<Scalars['String']>>;
  flags: Array<CodexTags>;
  identifiers: Array<Array<Scalars['String']>>;
  patient?: Maybe<SaPerson>;
  provider?: Maybe<SaPerson>;
  status: Scalars['String'];
  statusHistory: Array<TestKitStatusHistoryEntry>;
  type: Hasura_Test_Types_Enum;
};

export type SaDiagnosticReports = {
  __typename?: 'SADiagnosticReports';
  count: Scalars['Int'];
  nextPageToken?: Maybe<Scalars['String']>;
  prevPageToken?: Maybe<Scalars['String']>;
  reports: Array<SaDiagnosticReport>;
  total: Scalars['Int'];
};

export type SaGeneralDashboardStats = {
  __typename?: 'SAGeneralDashboardStats';
  totalAppointments: Scalars['Int'];
  totalPatients: Scalars['Int'];
  totalProviders: Scalars['Int'];
  totalRevenue: Scalars['Float'];
  totalTestKits: Scalars['Int'];
};

export type SaNarrowingQueryOptions = {
  patientFhirId?: InputMaybe<Scalars['String']>;
  providerFhirId?: InputMaybe<Scalars['String']>;
};

export type SaPageableQueryOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};

export type SaPatient = {
  __typename?: 'SAPatient';
  appointmentCount: Array<Array<Scalars['String']>>;
  assignedAt?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  dates: Array<Array<Scalars['String']>>;
  email?: Maybe<Scalars['String']>;
  first: Scalars['String'];
  flags: Array<CodexTags>;
  gender?: Maybe<Scalars['String']>;
  identifiers: Array<Array<Scalars['String']>>;
  last: Scalars['String'];
  nextAppointment?: Maybe<SaAppointmentBrief>;
  parentCodexId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePhoto?: Maybe<Scalars['String']>;
  testKitCount: Scalars['Int'];
};

export type SaPatientFilterOptions = {
  assignedAtFrom?: InputMaybe<Scalars['String']>;
  assignedAtTo?: InputMaybe<Scalars['String']>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  providerCodexId?: InputMaybe<Scalars['String']>;
};

export type SaPatientOrderBy = {
  direction?: InputMaybe<OrderByDirections>;
  field?: InputMaybe<SaPatientOrderByField>;
};

/** Field to order SA patients by */
export enum SaPatientOrderByField {
  AssignedAt = 'AssignedAt',
  CreatedAt = 'CreatedAt'
}

export type SaPatients = {
  __typename?: 'SAPatients';
  count: Scalars['Int'];
  nextPageToken?: Maybe<Scalars['String']>;
  patients: Array<SaPatient>;
  prevPageToken?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
};

export type SaPerson = {
  __typename?: 'SAPerson';
  birthDate?: Maybe<Scalars['String']>;
  dates: Array<Array<Scalars['String']>>;
  email?: Maybe<Scalars['String']>;
  first: Scalars['String'];
  flags: Array<CodexTags>;
  gender?: Maybe<Scalars['String']>;
  identifiers: Array<Array<Scalars['String']>>;
  last: Scalars['String'];
  profilePhoto?: Maybe<Scalars['String']>;
};

export type SaProvider = {
  __typename?: 'SAProvider';
  appointmentCount: Array<Array<Scalars['String']>>;
  birthDate?: Maybe<Scalars['String']>;
  dates: Array<Array<Scalars['String']>>;
  email?: Maybe<Scalars['String']>;
  first: Scalars['String'];
  flags: Array<CodexTags>;
  gender?: Maybe<Scalars['String']>;
  identifiers: Array<Array<Scalars['String']>>;
  last: Scalars['String'];
  patientCount: Scalars['Int'];
  phone?: Maybe<Scalars['String']>;
  profilePhoto?: Maybe<Scalars['String']>;
  providerOutput?: Maybe<ProviderOutput>;
  statuses: SaProviderStatuses;
};

export type SaProviderFilterOptions = {
  blocked?: InputMaybe<Scalars['Boolean']>;
  licenseAlert?: InputMaybe<SaProviderLicenseAlert>;
  licensedStates?: InputMaybe<Array<Scalars['String']>>;
};

/** License alert filter for SA providers list */
export enum SaProviderLicenseAlert {
  Expired = 'Expired',
  ExpiringSoon = 'ExpiringSoon'
}

export type SaProviderOrderBy = {
  direction?: InputMaybe<OrderByDirections>;
  field?: InputMaybe<SaProviderOrderByField>;
};

/** Field to order SA providers by */
export enum SaProviderOrderByField {
  LastLogin = 'LastLogin',
  Name = 'Name',
  Registered = 'Registered'
}

export type SaProviderStatus = {
  __typename?: 'SAProviderStatus';
  status?: Maybe<PersonaInquiryHasuraStatus>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type SaProviderStatuses = {
  __typename?: 'SAProviderStatuses';
  BAA?: Maybe<SaProviderStatus>;
  HIPAA?: Maybe<SaProviderStatus>;
  fullScriptAccount?: Maybe<SaProviderStatus>;
  personaId?: Maybe<SaProviderStatus>;
  personaInsurance?: Maybe<SaProviderStatus>;
  stripeAccount?: Maybe<SaProviderStatus>;
};

export type SaProviders = {
  __typename?: 'SAProviders';
  count: Scalars['Int'];
  nextPageToken?: Maybe<Scalars['String']>;
  prevPageToken?: Maybe<Scalars['String']>;
  providers: Array<SaProvider>;
  total: Scalars['Int'];
};

export type SaVerificationRequest = {
  __typename?: 'SAVerificationRequest';
  childCodexId?: Maybe<Scalars['String']>;
  childFullName?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['String'];
  personaInquiryId: Scalars['String'];
  status: VerificationStatus;
  statusHistory: Array<VerificationStatusHistoryEntry>;
  type: VerificationType;
  updatedAt: Scalars['String'];
  userCodexId: Scalars['String'];
};

export type SaVerificationRequestFilter = {
  from?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<VerificationStatus>>;
  to?: InputMaybe<Scalars['String']>;
  verificationTypes?: InputMaybe<Array<VerificationType>>;
};

export type SaVerificationRequestOrderBy = {
  direction?: InputMaybe<OrderByDirections>;
  field?: InputMaybe<VerificationRequestOrderByField>;
};

export type SaVerificationRequests = {
  __typename?: 'SAVerificationRequests';
  requests: Array<SaVerificationRequest>;
  total: Scalars['Int'];
};

export type SaveFhirQuestionnaireManually = {
  __typename?: 'SaveFHIRQuestionnaireManually';
  id: Scalars['String'];
  responses: Scalars['JSON'];
};

export type SaveFhirQuestionnaireManuallyObject = {
  __typename?: 'SaveFHIRQuestionnaireManuallyObject';
  object: SaveFhirQuestionnaireManually;
};

export type SeedFhirOrganizationsOutput = {
  __typename?: 'SeedFHIROrganizationsOutput';
  message: Scalars['String'];
  status: Scalars['Int'];
};

export type SelfReportedMedicationInput = {
  duration?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  ndc: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  startDate: Scalars['String'];
};

export type SelfReportedMedicationsInput = {
  medications: Array<SelfReportedMedicationInput>;
};

export type SendSupportReplyInput = {
  attachments?: InputMaybe<Array<FileAttachmentInput>>;
  chatId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type ServiceOfferingsOutput = {
  __typename?: 'ServiceOfferingsOutput';
  active: Scalars['Boolean'];
  healthCareServiceFhirId: Scalars['String'];
  price: Scalars['String'];
  priceCategory: PriceCategory;
  serviceType: ServiceType;
};

/** Enum representing the possible values of FHIR recommendation status. */
export enum ServiceRequestStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  EnteredInError = 'ENTERED_IN_ERROR',
  OnHold = 'ON_HOLD',
  Revoked = 'REVOKED',
  Unknown = 'UNKNOWN'
}

/** Enum representing the different types of service offerings. */
export enum ServiceType {
  Chat = 'Chat',
  Chat_30 = 'Chat_30',
  Chat_60 = 'Chat_60',
  Video = 'Video',
  Video_30 = 'Video_30',
  Video_60 = 'Video_60'
}

export type SetDefaultPaymentMethodInput = {
  paymentMethodCodexId: Scalars['Int'];
};

export type SetupIntentOutput = {
  __typename?: 'SetupIntentOutput';
  clientSecret?: Maybe<Scalars['String']>;
};

export type Specs = {
  __typename?: 'Specs';
  contents?: Maybe<Scalars['String']>;
  expiration_period?: Maybe<Scalars['Int']>;
  made_in?: Maybe<Scalars['String']>;
};

/** Enum representing the possible values for provider_state_licenses.license_type. */
export enum StateLicenseType {
  CertificateToPrescribe = 'CertificateToPrescribe',
  StateControlledSubstanceLicense = 'StateControlledSubstanceLicense',
  StateLicense = 'StateLicense'
}

export type SubPatient = {
  __typename?: 'SubPatient';
  account_closed_at?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  blocked_at?: Maybe<Scalars['String']>;
  child_fully_verified?: Maybe<Scalars['Boolean']>;
  firstName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  hasPendingAdultTransitionInvitation?: Maybe<Scalars['Boolean']>;
  hasReachedAgeOfMajority?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  lastName: Scalars['String'];
  parentCodexId: Scalars['String'];
  parentRelationship?: Maybe<SubPatientRelationship>;
  profilePhoto?: Maybe<Scalars['String']>;
};

/** Enum representing the sub patient relationship. */
export enum SubPatientRelationship {
  LegalGuardian = 'LEGAL_GUARDIAN',
  Parent = 'PARENT',
  Relative = 'RELATIVE'
}

export type SubPatientsOutput = {
  __typename?: 'SubPatientsOutput';
  closedTotal: Scalars['Int'];
  subPatients: Array<SubPatient>;
  total: Scalars['Int'];
};

export type SubscriptionOutput = {
  __typename?: 'SubscriptionOutput';
  billingPlan: BillingPlan;
  created_at: Scalars['String'];
  currentPeriodEnd?: Maybe<Scalars['String']>;
  currentPeriodStart?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  paymentIntent?: Maybe<PaymentIntentOutput>;
  status: CodexSubscriptionStatuses;
  updated_at: Scalars['String'];
};

export type SuperAdminListItem = {
  __typename?: 'SuperAdminListItem';
  createdAt?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['String'];
};

/** Sort fields for the superadmin list. */
export enum SuperAdminOrderByCriterias {
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL'
}

export type SuperAdminOrderByInput = {
  direction?: InputMaybe<OrderByDirections>;
  field?: InputMaybe<SuperAdminOrderByCriterias>;
};

export type SupportChatDetailsOutput = {
  __typename?: 'SupportChatDetailsOutput';
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastMessageAt?: Maybe<Scalars['String']>;
  messages: Array<InMailMessageOutput>;
  nextPageToken?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  role: Roles_Enum;
  usage?: Maybe<InMailUsageOutput>;
  user: InMailParticipantOutput;
};

export type SupportChatPreviewOutput = {
  __typename?: 'SupportChatPreviewOutput';
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastMessageAt?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  role: Roles_Enum;
  user: InMailParticipantOutput;
};

export type SupportChatsOutput = {
  __typename?: 'SupportChatsOutput';
  chats: Array<SupportChatPreviewOutput>;
  newTotal: Scalars['Int'];
  total: Scalars['Int'];
};

export type SwabCodeFilterInput = {
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Hasura_Test_Types_Enum>>;
};

export type SwabCodeListOutput = {
  __typename?: 'SwabCodeListOutput';
  swab_codes: Array<SwabCodeOutput>;
  total: Scalars['Int'];
};

export type SwabCodeOutput = {
  __typename?: 'SwabCodeOutput';
  created_at: Scalars['String'];
  id: Scalars['Int'];
  lab_name: Scalars['String'];
  status: Scalars['String'];
  swab_code: Scalars['String'];
  swab_codes_test?: Maybe<Array<SwabCodeTestOutput>>;
  swab_usage_type: Scalars['String'];
  test_type: Scalars['String'];
  updated_at: Scalars['String'];
};

export type SwabCodeTestOutput = {
  __typename?: 'SwabCodeTestOutput';
  created_at: Scalars['String'];
  state: Scalars['String'];
  test_id: Scalars['String'];
  updated_at: Scalars['String'];
  user_id: Scalars['String'];
};

export type TestKitDetailsOutput = {
  __typename?: 'TestKitDetailsOutput';
  codexId: Scalars['String'];
  fhirId: Scalars['String'];
  labOrderId?: Maybe<Scalars['String']>;
  patient: TestKitDetailsParticipant;
  provider?: Maybe<TestKitDetailsParticipant>;
  questionnaireCompleted: Scalars['Boolean'];
  status: Hasura_Dnavisit_Test_Statuses_Enum;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  swabCode?: Maybe<Scalars['String']>;
  trackingNumber?: Maybe<Scalars['String']>;
  type: Hasura_Test_Types_Enum;
};

export type TestKitDetailsParticipant = {
  __typename?: 'TestKitDetailsParticipant';
  codexId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fhirId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type TestKitResultOutput = {
  __typename?: 'TestKitResultOutput';
  createdAt?: Maybe<Scalars['String']>;
  diagnosticReportId: Scalars['String'];
  diagnosticReportStatus: Hasura_Dnavisit_Test_Statuses_Enum;
  diagnosticReportTestType: Hasura_Test_Types_Enum;
  patientPdf?: Maybe<FileOutput>;
  providerCodexId?: Maybe<Scalars['String']>;
  providerFirstName?: Maybe<Scalars['String']>;
  providerLastName?: Maybe<Scalars['String']>;
  providerPdf?: Maybe<FileOutput>;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  swabCode: Scalars['String'];
};

export type TestKitResultsInput = {
  dates?: InputMaybe<DateFilterArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  providerFullNameQuery?: InputMaybe<Scalars['String']>;
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum>>;
};

export type TestKitResultsOutput = {
  __typename?: 'TestKitResultsOutput';
  diagnosticReports: Array<TestKitResultOutput>;
  total: Scalars['Int'];
};

export type TestKitStatsByDayOutput = {
  __typename?: 'TestKitStatsByDayOutput';
  date: Scalars['String'];
  testKitStats: TestKitStatsOutput;
};

export type TestKitStatsFiltersInput = {
  labs?: InputMaybe<Array<Hasura_Labs_Enum>>;
  testTypes?: InputMaybe<Array<Hasura_Test_Types_Enum>>;
};

export type TestKitStatsOutput = {
  __typename?: 'TestKitStatsOutput';
  breakdown: Array<TestKitStatsStatusItem>;
  total: Scalars['Int'];
};

/** Enum representing the possible values for test kit statistics status */
export enum TestKitStatsStatusEnum {
  AppointmentScheduled = 'AppointmentScheduled',
  Canceled = 'Canceled',
  Complete = 'Complete',
  Issue = 'Issue',
  KitNotReceived = 'KitNotReceived',
  ReceivedByLab = 'ReceivedByLab',
  ResultsWithProvider = 'ResultsWithProvider'
}

export type TestKitStatsStatusItem = {
  __typename?: 'TestKitStatsStatusItem';
  status: TestKitStatsStatusEnum;
  total: Scalars['Int'];
};

export type TestKitStatusHistoryEntry = {
  __typename?: 'TestKitStatusHistoryEntry';
  datetime: Scalars['String'];
  status: Hasura_Dnavisit_Test_Statuses_Enum;
};

export type ThenObject = {
  __typename?: 'ThenObject';
  disabled?: Maybe<Array<Scalars['String']>>;
  enabled?: Maybe<Array<Scalars['String']>>;
  required?: Maybe<Array<Scalars['String']>>;
};

export type Timing = {
  __typename?: 'Timing';
  code?: Maybe<CodeableConcept>;
  event?: Maybe<Array<Scalars['DateTime']>>;
  repeat?: Maybe<TimingRepeat>;
};

export type TimingInput = {
  code?: InputMaybe<CodeableConceptInput>;
  event?: InputMaybe<Array<Scalars['DateTime']>>;
  repeat?: InputMaybe<TimingRepeatInput>;
};

export type TimingRepeat = {
  __typename?: 'TimingRepeat';
  boundsDuration?: Maybe<Duration>;
  boundsPeriod?: Maybe<Period>;
  boundsRange?: Maybe<RangeValue>;
  count?: Maybe<Scalars['Float']>;
  countMax?: Maybe<Scalars['Float']>;
  dayOfWeek?: Maybe<Array<Scalars['String']>>;
  duration?: Maybe<Scalars['Float']>;
  durationMax?: Maybe<Scalars['Float']>;
  durationUnit?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['Float']>;
  frequencyMax?: Maybe<Scalars['Float']>;
  offset?: Maybe<Scalars['Float']>;
  period?: Maybe<Scalars['Float']>;
  periodMax?: Maybe<Scalars['Float']>;
  periodUnit?: Maybe<Scalars['String']>;
  timeOfDay?: Maybe<Array<Scalars['String']>>;
  when?: Maybe<Array<Scalars['String']>>;
};

export type TimingRepeatInput = {
  boundsDuration?: InputMaybe<DurationInput>;
  boundsPeriod?: InputMaybe<PeriodInput>;
  boundsRange?: InputMaybe<RangeValueInput>;
  count?: InputMaybe<Scalars['Float']>;
  countMax?: InputMaybe<Scalars['Float']>;
  dayOfWeek?: InputMaybe<Array<Scalars['String']>>;
  duration?: InputMaybe<Scalars['Float']>;
  durationMax?: InputMaybe<Scalars['Float']>;
  durationUnit?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['Float']>;
  frequencyMax?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  period?: InputMaybe<Scalars['Float']>;
  periodMax?: InputMaybe<Scalars['Float']>;
  periodUnit?: InputMaybe<Scalars['String']>;
  timeOfDay?: InputMaybe<Array<Scalars['String']>>;
  when?: InputMaybe<Array<Scalars['String']>>;
};

export type TotalOutput = {
  __typename?: 'TotalOutput';
  total: Scalars['Int'];
};

export type UpcomingAppointmentCounts = {
  __typename?: 'UpcomingAppointmentCounts';
  month: Scalars['Int'];
  today: Scalars['Int'];
  tomorrow: Scalars['Int'];
  week: Scalars['Int'];
};

/** Enum representing the possible values for updating FHIR recommendation status. */
export enum UpdatableRecommendationStatus {
  Active = 'ACTIVE',
  OnHold = 'ON_HOLD',
  Revoked = 'REVOKED'
}

export type UpdateBecomePatientRequestStatusInput = {
  patientFhirId: Scalars['String'];
  requestStatus: ProviderRequestStatus;
};

export type UpdateCallSettingsInput = {
  platform: ClientPlatform;
  settings: Scalars['JSON'];
};

export type UpdateCartProductInput = {
  id: Scalars['Int'];
  quantity: Scalars['Int'];
};

export type UpdateCartProductsProviderInput = {
  cartProductIds: Array<Scalars['Int']>;
  providerCodexId: Scalars['String'];
};

export type UpdateDelegatedAdminPermissionsInput = {
  delegatedAdminCodexId: Scalars['String'];
  permissions: Array<AdminPermissionType>;
};

export type UpdateFhirQuestionnaireResponsesOutput = {
  __typename?: 'UpdateFHIRQuestionnaireResponsesOutput';
  questionnaire_response: UpdateQuestionnaireResponsesOutput;
};

export type UpdateFhirUserLatestQuestionnaire = {
  __typename?: 'UpdateFHIRUserLatestQuestionnaire';
  affected_rows: Scalars['Int'];
};

export type UpdateNotificationPreferencesInput = {
  preferences: Array<NotificationCategoryPreferenceInput>;
};

export type UpdateNotificationStatusInput = {
  isLatestActivity?: InputMaybe<Scalars['Boolean']>;
  status: Scalars['String'];
};

export type UpdateOrderStatusInput = {
  orderId: Scalars['Int'];
  status: OrderStatusEnum;
};

export type UpdateProductAvailabilityInput = {
  id: Scalars['Int'];
  inStock: Scalars['Boolean'];
};

export type UpdateProductInput = {
  category: Scalars['Int'];
  contents?: InputMaybe<Scalars['String']>;
  defaultFileId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  fileIds?: InputMaybe<Array<Scalars['String']>>;
  inStock: Scalars['Boolean'];
  madeIn?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  productId: Scalars['Int'];
  providerPrice?: InputMaybe<Scalars['Float']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type UpdateQuestionnaireResponsesOutput = {
  __typename?: 'UpdateQuestionnaireResponsesOutput';
  id: Scalars['String'];
};

export type UpsertEducationModuleInput = {
  additionalMaterialModuleIds?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<UpsertEducationModuleItemInput>>;
  title: Scalars['String'];
};

export type UpsertEducationModuleItemInput = {
  category: EducationCourseModuleItemCategory;
  fileId: Scalars['String'];
  title: Scalars['String'];
};

/** Role of the person accepting a user agreement on behalf of a child patient. */
export enum UserAgreementAcceptorRole {
  Guardian = 'Guardian',
  OtherAuthorizedAdult = 'OtherAuthorizedAdult',
  Parent = 'Parent',
  Patient = 'Patient'
}

/** Expiration mode for SUD consent agreements: manual revoke or end of treatment. */
export enum UserAgreementExpirationType {
  EndOfTreatment = 'END_OF_TREATMENT',
  Manual = 'MANUAL'
}

/** Enum representing the possible values for "agreement_type" field in user_agreements. */
export enum UserAgreementTypes {
  AgeOfMajority = 'AGE_OF_MAJORITY',
  Baa = 'BAA',
  ConsentToUseAndDiscloseSudRecords = 'CONSENT_TO_USE_AND_DISCLOSE_SUD_RECORDS',
  CoppaChild = 'COPPA_CHILD',
  Hippa = 'HIPPA',
  NoticeOfPrivacySudRecords = 'NOTICE_OF_PRIVACY_SUD_RECORDS',
  PrivacyPolicy = 'PRIVACY_POLICY',
  TermsOfService = 'TERMS_OF_SERVICE'
}

export type UserRegistrationStatsByDayOutput = {
  __typename?: 'UserRegistrationStatsByDayOutput';
  date: Scalars['String'];
  userRegistrationStats: UserRegistrationStatsOutput;
};

export type UserRegistrationStatsOutput = {
  __typename?: 'UserRegistrationStatsOutput';
  totalAdultPatients: Scalars['Int'];
  totalMinorPatients: Scalars['Int'];
  totalPatients: Scalars['Int'];
  totalProviders: Scalars['Int'];
};

export type ValidateChildAdultTransitionInvitationTokenOutput = {
  __typename?: 'ValidateChildAdultTransitionInvitationTokenOutput';
  email?: Maybe<Scalars['String']>;
  isValid: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
};

export type ValidateDelegatedAdminInvitationTokenOutput = {
  __typename?: 'ValidateDelegatedAdminInvitationTokenOutput';
  email?: Maybe<Scalars['String']>;
  isValid: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
};

export type ValidateInvitationTokenInput = {
  email: Scalars['String'];
  token: Scalars['String'];
};

export type ValuableCodeableConcept = {
  __typename?: 'ValuableCodeableConcept';
  coding: Array<CodeableConceptData>;
};

export type ValueOutput = {
  __typename?: 'ValueOutput';
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

/** Field to order verification requests by */
export enum VerificationRequestOrderByField {
  CreatedAt = 'CreatedAt',
  UpdatedAt = 'UpdatedAt'
}

/** Status of verification request */
export enum VerificationStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type VerificationStatusHistoryEntry = {
  __typename?: 'VerificationStatusHistoryEntry';
  datetime: Scalars['String'];
  status: VerificationStatus;
};

/** Type of verification request */
export enum VerificationType {
  PatientChild = 'PatientChild',
  PatientGuardian = 'PatientGuardian',
  PatientId = 'PatientId',
  ProviderId = 'ProviderId',
  ProviderInsurance = 'ProviderInsurance'
}

export enum VonageDisconnectReason {
  ClientDisconnected = 'ClientDisconnected',
  ForceDisconnected = 'ForceDisconnected',
  NetworkDisconnected = 'NetworkDisconnected'
}

export type VonageSummaryOutput = {
  __typename?: 'VonageSummaryOutput';
  summary?: Maybe<Scalars['String']>;
  summaryPdfFileId?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
};

export type WeeklyPaymentDetailsOutput = {
  __typename?: 'WeeklyPaymentDetailsOutput';
  completedAppointments: Scalars['Int'];
  periodEnd: Scalars['String'];
  periodStart: Scalars['String'];
};

/** Enum representing the possible values for "field" field in ZrtOrderByCriterias. */
export enum ZrtOrderByCriterias {
  Barcode = 'BARCODE',
  CreatedAt = 'CREATED_AT',
  ProviderName = 'PROVIDER_NAME',
  TestType = 'TEST_TYPE'
}

export type ZrtOrderByInput = {
  direction: OrderByDirections;
  field: ZrtOrderByCriterias;
};

export type ZrtTestOutput = {
  __typename?: 'ZrtTestOutput';
  appointment_codex_id?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  fhirId: Scalars['String'];
  health_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  npi_number?: Maybe<Scalars['String']>;
  observation_id?: Maybe<Scalars['String']>;
  patient_fhir_id?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_acuity_calendar_id?: Maybe<Scalars['String']>;
  provider_acuity_owner_id?: Maybe<Scalars['String']>;
  provider_codex_id?: Maybe<Scalars['String']>;
  provider_fhir_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  questionnaire_required?: Maybe<Scalars['Boolean']>;
  reference_code: Scalars['String'];
  service_request_id?: Maybe<Scalars['String']>;
  state: Hasura_Dnavisit_Test_Statuses_Enum;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  swab_code: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
};

export type GetFhirPatientMediaOutput = {
  __typename?: 'getFHIRPatientMediaOutput';
  media: Array<MediaOutput>;
  patientCodexId: Scalars['String'];
  total: Scalars['Int'];
};

export type GetFhirPatientOutput = {
  __typename?: 'getFHIRPatientOutput';
  users: Array<GetPatientOutput>;
};


export const CreateFhirAppointmentDocument = gql`
    mutation CreateFHIRAppointment($appointmentPrework: CreateFHIRAppointmentInputWithoutPatientCodexId!) {
  createFHIRAppointmentForCurrentUser(createFHIRAppointment: $appointmentPrework) {
    appointment {
      appointmentCodexId
      appointmentId
    }
  }
}
    `;
export type CreateFhirAppointmentMutationFn = Apollo.MutationFunction<CreateFhirAppointmentMutation, CreateFhirAppointmentMutationVariables>;

/**
 * __useCreateFhirAppointmentMutation__
 *
 * To run a mutation, you first call `useCreateFhirAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFhirAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFhirAppointmentMutation, { data, loading, error }] = useCreateFhirAppointmentMutation({
 *   variables: {
 *      appointmentPrework: // value for 'appointmentPrework'
 *   },
 * });
 */
export function useCreateFhirAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateFhirAppointmentMutation, CreateFhirAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFhirAppointmentMutation, CreateFhirAppointmentMutationVariables>(CreateFhirAppointmentDocument, options);
      }
export type CreateFhirAppointmentMutationHookResult = ReturnType<typeof useCreateFhirAppointmentMutation>;
export type CreateFhirAppointmentMutationResult = Apollo.MutationResult<CreateFhirAppointmentMutation>;
export type CreateFhirAppointmentMutationOptions = Apollo.BaseMutationOptions<CreateFhirAppointmentMutation, CreateFhirAppointmentMutationVariables>;
export const PatchFhirAppointmentDocument = gql`
    mutation PatchFHIRAppointment($appointmentInformation: PatchFHIRAppointmentInput!) {
  patchFHIRAppointment(patchFHIRAppointmentInput: $appointmentInformation) {
    appointment {
      appointmentId
    }
  }
}
    `;
export type PatchFhirAppointmentMutationFn = Apollo.MutationFunction<PatchFhirAppointmentMutation, PatchFhirAppointmentMutationVariables>;

/**
 * __usePatchFhirAppointmentMutation__
 *
 * To run a mutation, you first call `usePatchFhirAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchFhirAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchFhirAppointmentMutation, { data, loading, error }] = usePatchFhirAppointmentMutation({
 *   variables: {
 *      appointmentInformation: // value for 'appointmentInformation'
 *   },
 * });
 */
export function usePatchFhirAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<PatchFhirAppointmentMutation, PatchFhirAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatchFhirAppointmentMutation, PatchFhirAppointmentMutationVariables>(PatchFhirAppointmentDocument, options);
      }
export type PatchFhirAppointmentMutationHookResult = ReturnType<typeof usePatchFhirAppointmentMutation>;
export type PatchFhirAppointmentMutationResult = Apollo.MutationResult<PatchFhirAppointmentMutation>;
export type PatchFhirAppointmentMutationOptions = Apollo.BaseMutationOptions<PatchFhirAppointmentMutation, PatchFhirAppointmentMutationVariables>;
export const CancelAppointmentDocument = gql`
    mutation CancelAppointment($codexAppointmentId: String!, $cancelationReason: String!) {
  cancelFHIRAppointment(
    appointmentCodexId: $codexAppointmentId
    cancelationReason: $cancelationReason
  ) {
    appointment {
      appointmentId
    }
  }
}
    `;
export type CancelAppointmentMutationFn = Apollo.MutationFunction<CancelAppointmentMutation, CancelAppointmentMutationVariables>;

/**
 * __useCancelAppointmentMutation__
 *
 * To run a mutation, you first call `useCancelAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAppointmentMutation, { data, loading, error }] = useCancelAppointmentMutation({
 *   variables: {
 *      codexAppointmentId: // value for 'codexAppointmentId'
 *      cancelationReason: // value for 'cancelationReason'
 *   },
 * });
 */
export function useCancelAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CancelAppointmentMutation, CancelAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAppointmentMutation, CancelAppointmentMutationVariables>(CancelAppointmentDocument, options);
      }
export type CancelAppointmentMutationHookResult = ReturnType<typeof useCancelAppointmentMutation>;
export type CancelAppointmentMutationResult = Apollo.MutationResult<CancelAppointmentMutation>;
export type CancelAppointmentMutationOptions = Apollo.BaseMutationOptions<CancelAppointmentMutation, CancelAppointmentMutationVariables>;
export const PatchFhirEncounterDocument = gql`
    mutation PatchFHIREncounter($encounterCodexId: String!, $files: [FileAttachmentInput!], $followupRecommendations: String!, $providerNotes: String!, $providerSummary: String!, $systemGenerated: String, $transcription: String, $diagnosticReportIds: [String!]) {
  patchFHIREncounter(
    patchFHIREncounter: {encounterId: $encounterCodexId, diagnosticReportIds: $diagnosticReportIds, encounterNotes: {followupRecommendations: $followupRecommendations, providerNotes: $providerNotes, providerSummary: $providerSummary, systemGenerated: $systemGenerated, transcription: $transcription, files: $files}}
  ) {
    encounter {
      encounterId
      status
    }
  }
}
    `;
export type PatchFhirEncounterMutationFn = Apollo.MutationFunction<PatchFhirEncounterMutation, PatchFhirEncounterMutationVariables>;

/**
 * __usePatchFhirEncounterMutation__
 *
 * To run a mutation, you first call `usePatchFhirEncounterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchFhirEncounterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchFhirEncounterMutation, { data, loading, error }] = usePatchFhirEncounterMutation({
 *   variables: {
 *      encounterCodexId: // value for 'encounterCodexId'
 *      files: // value for 'files'
 *      followupRecommendations: // value for 'followupRecommendations'
 *      providerNotes: // value for 'providerNotes'
 *      providerSummary: // value for 'providerSummary'
 *      systemGenerated: // value for 'systemGenerated'
 *      transcription: // value for 'transcription'
 *      diagnosticReportIds: // value for 'diagnosticReportIds'
 *   },
 * });
 */
export function usePatchFhirEncounterMutation(baseOptions?: Apollo.MutationHookOptions<PatchFhirEncounterMutation, PatchFhirEncounterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatchFhirEncounterMutation, PatchFhirEncounterMutationVariables>(PatchFhirEncounterDocument, options);
      }
export type PatchFhirEncounterMutationHookResult = ReturnType<typeof usePatchFhirEncounterMutation>;
export type PatchFhirEncounterMutationResult = Apollo.MutationResult<PatchFhirEncounterMutation>;
export type PatchFhirEncounterMutationOptions = Apollo.BaseMutationOptions<PatchFhirEncounterMutation, PatchFhirEncounterMutationVariables>;
export const AppendEncounterNotesToFhirAppointmentDocument = gql`
    mutation AppendEncounterNotesToFHIRAppointment($codexAppointmentId: String!, $providerNotes: String!, $followupRecommendations: String!, $providerSummary: String!, $files: [FileAttachmentInput!], $systemGenerated: String, $transcription: String, $diagnosticReportIds: [String!]) {
  appendEncounterToFHIRAppointment(
    appendEncounterToFHIRAppointmentInput: {appointmentCodexId: $codexAppointmentId, diagnosticReportIds: $diagnosticReportIds, providerNotes: {followupRecommendations: $followupRecommendations, providerNotes: $providerNotes, providerSummary: $providerSummary, files: $files, systemGenerated: $systemGenerated, transcription: $transcription}}
  ) {
    encounter {
      encounterId
    }
    appointment {
      appointmentId
    }
  }
}
    `;
export type AppendEncounterNotesToFhirAppointmentMutationFn = Apollo.MutationFunction<AppendEncounterNotesToFhirAppointmentMutation, AppendEncounterNotesToFhirAppointmentMutationVariables>;

/**
 * __useAppendEncounterNotesToFhirAppointmentMutation__
 *
 * To run a mutation, you first call `useAppendEncounterNotesToFhirAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppendEncounterNotesToFhirAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appendEncounterNotesToFhirAppointmentMutation, { data, loading, error }] = useAppendEncounterNotesToFhirAppointmentMutation({
 *   variables: {
 *      codexAppointmentId: // value for 'codexAppointmentId'
 *      providerNotes: // value for 'providerNotes'
 *      followupRecommendations: // value for 'followupRecommendations'
 *      providerSummary: // value for 'providerSummary'
 *      files: // value for 'files'
 *      systemGenerated: // value for 'systemGenerated'
 *      transcription: // value for 'transcription'
 *      diagnosticReportIds: // value for 'diagnosticReportIds'
 *   },
 * });
 */
export function useAppendEncounterNotesToFhirAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<AppendEncounterNotesToFhirAppointmentMutation, AppendEncounterNotesToFhirAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppendEncounterNotesToFhirAppointmentMutation, AppendEncounterNotesToFhirAppointmentMutationVariables>(AppendEncounterNotesToFhirAppointmentDocument, options);
      }
export type AppendEncounterNotesToFhirAppointmentMutationHookResult = ReturnType<typeof useAppendEncounterNotesToFhirAppointmentMutation>;
export type AppendEncounterNotesToFhirAppointmentMutationResult = Apollo.MutationResult<AppendEncounterNotesToFhirAppointmentMutation>;
export type AppendEncounterNotesToFhirAppointmentMutationOptions = Apollo.BaseMutationOptions<AppendEncounterNotesToFhirAppointmentMutation, AppendEncounterNotesToFhirAppointmentMutationVariables>;
export const AddMessageToAppointmentMessageListByAppointmentCodexIdDocument = gql`
    mutation AddMessageToAppointmentMessageListByAppointmentCodexId($appointmentCodexId: String!, $messages: [AppointmentChatMessageInput!] = {from: PATIENT}) {
  addMessageToAppointmentMessageListByAppointmentCodexId(
    insertAppointmentChatMessages: {appointmentCodexId: $appointmentCodexId, messages: $messages}
  ) {
    id
  }
}
    `;
export type AddMessageToAppointmentMessageListByAppointmentCodexIdMutationFn = Apollo.MutationFunction<AddMessageToAppointmentMessageListByAppointmentCodexIdMutation, AddMessageToAppointmentMessageListByAppointmentCodexIdMutationVariables>;

/**
 * __useAddMessageToAppointmentMessageListByAppointmentCodexIdMutation__
 *
 * To run a mutation, you first call `useAddMessageToAppointmentMessageListByAppointmentCodexIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMessageToAppointmentMessageListByAppointmentCodexIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMessageToAppointmentMessageListByAppointmentCodexIdMutation, { data, loading, error }] = useAddMessageToAppointmentMessageListByAppointmentCodexIdMutation({
 *   variables: {
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *      messages: // value for 'messages'
 *   },
 * });
 */
export function useAddMessageToAppointmentMessageListByAppointmentCodexIdMutation(baseOptions?: Apollo.MutationHookOptions<AddMessageToAppointmentMessageListByAppointmentCodexIdMutation, AddMessageToAppointmentMessageListByAppointmentCodexIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMessageToAppointmentMessageListByAppointmentCodexIdMutation, AddMessageToAppointmentMessageListByAppointmentCodexIdMutationVariables>(AddMessageToAppointmentMessageListByAppointmentCodexIdDocument, options);
      }
export type AddMessageToAppointmentMessageListByAppointmentCodexIdMutationHookResult = ReturnType<typeof useAddMessageToAppointmentMessageListByAppointmentCodexIdMutation>;
export type AddMessageToAppointmentMessageListByAppointmentCodexIdMutationResult = Apollo.MutationResult<AddMessageToAppointmentMessageListByAppointmentCodexIdMutation>;
export type AddMessageToAppointmentMessageListByAppointmentCodexIdMutationOptions = Apollo.BaseMutationOptions<AddMessageToAppointmentMessageListByAppointmentCodexIdMutation, AddMessageToAppointmentMessageListByAppointmentCodexIdMutationVariables>;
export const CompleteAppointmentDocument = gql`
    mutation CompleteAppointment($appointmentCodexId: String!) {
  patchFHIRAppointment(
    patchFHIRAppointmentInput: {appointmentCodexId: $appointmentCodexId, status: "fulfilled"}
  ) {
    appointment {
      appointmentId
    }
  }
}
    `;
export type CompleteAppointmentMutationFn = Apollo.MutationFunction<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>;

/**
 * __useCompleteAppointmentMutation__
 *
 * To run a mutation, you first call `useCompleteAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAppointmentMutation, { data, loading, error }] = useCompleteAppointmentMutation({
 *   variables: {
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *   },
 * });
 */
export function useCompleteAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>(CompleteAppointmentDocument, options);
      }
export type CompleteAppointmentMutationHookResult = ReturnType<typeof useCompleteAppointmentMutation>;
export type CompleteAppointmentMutationResult = Apollo.MutationResult<CompleteAppointmentMutation>;
export type CompleteAppointmentMutationOptions = Apollo.BaseMutationOptions<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>;
export const RescheduleAppointmentDocument = gql`
    mutation RescheduleAppointment($appointmentCodexId: String!, $datetime: String!) {
  rescheduleAppointment(
    rescheduleAppointmentInput: {appointmentCodexId: $appointmentCodexId, datetime: $datetime}
  ) {
    appointment {
      appointmentCodexId
      appointmentId
      created
      lastProcessedDate
      start
      status
    }
  }
}
    `;
export type RescheduleAppointmentMutationFn = Apollo.MutationFunction<RescheduleAppointmentMutation, RescheduleAppointmentMutationVariables>;

/**
 * __useRescheduleAppointmentMutation__
 *
 * To run a mutation, you first call `useRescheduleAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleAppointmentMutation, { data, loading, error }] = useRescheduleAppointmentMutation({
 *   variables: {
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *      datetime: // value for 'datetime'
 *   },
 * });
 */
export function useRescheduleAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleAppointmentMutation, RescheduleAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleAppointmentMutation, RescheduleAppointmentMutationVariables>(RescheduleAppointmentDocument, options);
      }
export type RescheduleAppointmentMutationHookResult = ReturnType<typeof useRescheduleAppointmentMutation>;
export type RescheduleAppointmentMutationResult = Apollo.MutationResult<RescheduleAppointmentMutation>;
export type RescheduleAppointmentMutationOptions = Apollo.BaseMutationOptions<RescheduleAppointmentMutation, RescheduleAppointmentMutationVariables>;
export const RequestAppointmentNewDateDocument = gql`
    mutation RequestAppointmentNewDate($appointmentCodexId: String, $appointmentTypeId: Int, $patientCodexId: String, $reason: String!, $proposedDate: String!, $type: AppointmentRequestType!) {
  createAppointmentRequest(
    input: {reason: $reason, type: $type, appointmentCodexId: $appointmentCodexId, appointmentTypeId: $appointmentTypeId, patientCodexId: $patientCodexId, proposedDate: $proposedDate}
  ) {
    status
    appointmentCodexId
    approvedDate
    id
    createdAt
    proposedDate
    providerCodexId
    reason
    type
    updatedAt
    patient {
      SENSITIVE_firstname
      SENSITIVE_lastname
    }
  }
}
    `;
export type RequestAppointmentNewDateMutationFn = Apollo.MutationFunction<RequestAppointmentNewDateMutation, RequestAppointmentNewDateMutationVariables>;

/**
 * __useRequestAppointmentNewDateMutation__
 *
 * To run a mutation, you first call `useRequestAppointmentNewDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAppointmentNewDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAppointmentNewDateMutation, { data, loading, error }] = useRequestAppointmentNewDateMutation({
 *   variables: {
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *      appointmentTypeId: // value for 'appointmentTypeId'
 *      patientCodexId: // value for 'patientCodexId'
 *      reason: // value for 'reason'
 *      proposedDate: // value for 'proposedDate'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useRequestAppointmentNewDateMutation(baseOptions?: Apollo.MutationHookOptions<RequestAppointmentNewDateMutation, RequestAppointmentNewDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAppointmentNewDateMutation, RequestAppointmentNewDateMutationVariables>(RequestAppointmentNewDateDocument, options);
      }
export type RequestAppointmentNewDateMutationHookResult = ReturnType<typeof useRequestAppointmentNewDateMutation>;
export type RequestAppointmentNewDateMutationResult = Apollo.MutationResult<RequestAppointmentNewDateMutation>;
export type RequestAppointmentNewDateMutationOptions = Apollo.BaseMutationOptions<RequestAppointmentNewDateMutation, RequestAppointmentNewDateMutationVariables>;
export const RejectAppointmentRescheduleRequestDocument = gql`
    mutation RejectAppointmentRescheduleRequest($input: GetAppointmentRescheduleRequestInput!) {
  rejectAppointmentRequest(input: $input) {
    message
    status
  }
}
    `;
export type RejectAppointmentRescheduleRequestMutationFn = Apollo.MutationFunction<RejectAppointmentRescheduleRequestMutation, RejectAppointmentRescheduleRequestMutationVariables>;

/**
 * __useRejectAppointmentRescheduleRequestMutation__
 *
 * To run a mutation, you first call `useRejectAppointmentRescheduleRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectAppointmentRescheduleRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectAppointmentRescheduleRequestMutation, { data, loading, error }] = useRejectAppointmentRescheduleRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectAppointmentRescheduleRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectAppointmentRescheduleRequestMutation, RejectAppointmentRescheduleRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectAppointmentRescheduleRequestMutation, RejectAppointmentRescheduleRequestMutationVariables>(RejectAppointmentRescheduleRequestDocument, options);
      }
export type RejectAppointmentRescheduleRequestMutationHookResult = ReturnType<typeof useRejectAppointmentRescheduleRequestMutation>;
export type RejectAppointmentRescheduleRequestMutationResult = Apollo.MutationResult<RejectAppointmentRescheduleRequestMutation>;
export type RejectAppointmentRescheduleRequestMutationOptions = Apollo.BaseMutationOptions<RejectAppointmentRescheduleRequestMutation, RejectAppointmentRescheduleRequestMutationVariables>;
export const DeleteAppointmentRequestDocument = gql`
    mutation DeleteAppointmentRequest($input: GetAppointmentRescheduleRequestInput!) {
  deleteAppointmentRequest(input: $input) {
    message
    status
  }
}
    `;
export type DeleteAppointmentRequestMutationFn = Apollo.MutationFunction<DeleteAppointmentRequestMutation, DeleteAppointmentRequestMutationVariables>;

/**
 * __useDeleteAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useDeleteAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAppointmentRequestMutation, { data, loading, error }] = useDeleteAppointmentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAppointmentRequestMutation, DeleteAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAppointmentRequestMutation, DeleteAppointmentRequestMutationVariables>(DeleteAppointmentRequestDocument, options);
      }
export type DeleteAppointmentRequestMutationHookResult = ReturnType<typeof useDeleteAppointmentRequestMutation>;
export type DeleteAppointmentRequestMutationResult = Apollo.MutationResult<DeleteAppointmentRequestMutation>;
export type DeleteAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<DeleteAppointmentRequestMutation, DeleteAppointmentRequestMutationVariables>;
export const EnsureAppointmentSummaryPdfDocument = gql`
    mutation EnsureAppointmentSummaryPdf($appointmentCodexId: String!) {
  ensureAppointmentSummaryPdf(appointmentCodexId: $appointmentCodexId) {
    status
    summaryPdfFileId
  }
}
    `;
export type EnsureAppointmentSummaryPdfMutationFn = Apollo.MutationFunction<EnsureAppointmentSummaryPdfMutation, EnsureAppointmentSummaryPdfMutationVariables>;

/**
 * __useEnsureAppointmentSummaryPdfMutation__
 *
 * To run a mutation, you first call `useEnsureAppointmentSummaryPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnsureAppointmentSummaryPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ensureAppointmentSummaryPdfMutation, { data, loading, error }] = useEnsureAppointmentSummaryPdfMutation({
 *   variables: {
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *   },
 * });
 */
export function useEnsureAppointmentSummaryPdfMutation(baseOptions?: Apollo.MutationHookOptions<EnsureAppointmentSummaryPdfMutation, EnsureAppointmentSummaryPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnsureAppointmentSummaryPdfMutation, EnsureAppointmentSummaryPdfMutationVariables>(EnsureAppointmentSummaryPdfDocument, options);
      }
export type EnsureAppointmentSummaryPdfMutationHookResult = ReturnType<typeof useEnsureAppointmentSummaryPdfMutation>;
export type EnsureAppointmentSummaryPdfMutationResult = Apollo.MutationResult<EnsureAppointmentSummaryPdfMutation>;
export type EnsureAppointmentSummaryPdfMutationOptions = Apollo.BaseMutationOptions<EnsureAppointmentSummaryPdfMutation, EnsureAppointmentSummaryPdfMutationVariables>;
export const GetAppointmentsByPatientCodexIdDocument = gql`
    query GetAppointmentsByPatientCodexId($appointmentStatus: [String!], $limit: Int, $offset: Int, $from: String, $to: String, $sort: String, $sortDirection: Float, $tzOffset: Float = 0, $dayFilter: String, $type: String, $providerName: String, $codexProviderId: String, $isSummaryCompleted: Boolean, $find: String) {
  getFHIRAppointmentByRequestPatientCodexId(
    appointmentStatus: $appointmentStatus
    limit: $limit
    offset: $offset
    from: $from
    to: $to
    sort: $sort
    sortDirection: $sortDirection
    tzOffset: $tzOffset
    dayFilter: $dayFilter
    type: $type
    providerName: $providerName
    codexProviderId: $codexProviderId
    find: $find
    isSummaryCompleted: $isSummaryCompleted
  ) {
    appointment {
      appointmentNotes {
        anythingElseQuestion
        howLongQuestion
        practitionerNotes
        severityQuestion
        symptomsTypes
      }
      acuityId
      appointmentCodexId
      appointmentId
      diagnosticReports {
        diagnosticReportId
        diagnosticReportStatus
        diagnosticReportTestType
        statusHistory {
          datetime
          status
        }
        swabCode
        patientPdf {
          contentType
          fileId
          fileName
          url
          size
        }
        patientPdfId
      }
      appointmentStatus
      appointmentType
      appointmentUrl
      cancelationReason
      codexPatientId
      codexProviderId
      created
      paymentSessionOpenedAt
      encounterId
      encounterNotes {
        files {
          contentType
          fileId
          size
          title
          url
        }
        followupRecommendations
        lastUpdated
        providerNotes
        providerSummary
        systemGenerated
        transcription
      }
      end
      events {
        author
        date
        event
        fhirId
      }
      isSummaryCompleted
      lastProcessedDate
      lastUpdate
      media {
        bodySite
        description
        fileId
        fhirId
        url
      }
      participant {
        reference
        type
      }
      patientFirstName
      patientLastName
      paymentInformation {
        amount
        status
        discount {
          amountOff
          percentOff
        }
      }
      pendingRescheduleRequest {
        proposedDate
        reason
        id
      }
      providerFirstName
      providerLastName
      start
      status
      subjectOfAppointment
      recommendations {
        createdAt
        id
        imageUrl
        productId
        productTitle
        providerName
        providerCodexId
        quantity
        status
        totalPrice
      }
      supportingInformation {
        reference
        type
      }
      symptomsLocation
      visitSummaryPdfUrl
    }
    counts {
      month
      today
      tomorrow
      week
    }
    total
  }
}
    `;

/**
 * __useGetAppointmentsByPatientCodexIdQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsByPatientCodexIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsByPatientCodexIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsByPatientCodexIdQuery({
 *   variables: {
 *      appointmentStatus: // value for 'appointmentStatus'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      sort: // value for 'sort'
 *      sortDirection: // value for 'sortDirection'
 *      tzOffset: // value for 'tzOffset'
 *      dayFilter: // value for 'dayFilter'
 *      type: // value for 'type'
 *      providerName: // value for 'providerName'
 *      codexProviderId: // value for 'codexProviderId'
 *      isSummaryCompleted: // value for 'isSummaryCompleted'
 *      find: // value for 'find'
 *   },
 * });
 */
export function useGetAppointmentsByPatientCodexIdQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentsByPatientCodexIdQuery, GetAppointmentsByPatientCodexIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsByPatientCodexIdQuery, GetAppointmentsByPatientCodexIdQueryVariables>(GetAppointmentsByPatientCodexIdDocument, options);
      }
export function useGetAppointmentsByPatientCodexIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsByPatientCodexIdQuery, GetAppointmentsByPatientCodexIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsByPatientCodexIdQuery, GetAppointmentsByPatientCodexIdQueryVariables>(GetAppointmentsByPatientCodexIdDocument, options);
        }
export type GetAppointmentsByPatientCodexIdQueryHookResult = ReturnType<typeof useGetAppointmentsByPatientCodexIdQuery>;
export type GetAppointmentsByPatientCodexIdLazyQueryHookResult = ReturnType<typeof useGetAppointmentsByPatientCodexIdLazyQuery>;
export type GetAppointmentsByPatientCodexIdQueryResult = Apollo.QueryResult<GetAppointmentsByPatientCodexIdQuery, GetAppointmentsByPatientCodexIdQueryVariables>;
export const GetUnfilledSummariesByRequestProviderIdDocument = gql`
    query GetUnfilledSummariesByRequestProviderId($appointmentStatus: [String!], $limit: Int, $offset: Int, $from: String, $to: String, $sort: String, $sortDirection: Float) {
  getUnfilledSummariesByRequestProviderId(
    appointmentStatus: $appointmentStatus
    limit: $limit
    offset: $offset
    from: $from
    to: $to
    sort: $sort
    sortDirection: $sortDirection
  ) {
    appointment {
      appointmentNotes {
        anythingElseQuestion
        howLongQuestion
        practitionerNotes
        severityQuestion
        symptomsTypes
      }
      acuityId
      appointmentCodexId
      appointmentId
      diagnosticReports {
        diagnosticReportId
        diagnosticReportStatus
        diagnosticReportTestType
        swabCode
        patientPdf {
          contentType
          fileId
          fileName
          url
          size
        }
        providerPdf {
          contentType
          fileId
          fileName
          size
          url
        }
        patientPdfId
        providerPdfId
      }
      appointmentStatus
      appointmentType
      appointmentUrl
      cancelationReason
      codexPatientId
      codexProviderId
      created
      encounterId
      encounterNotes {
        files {
          contentType
          fileId
          size
          title
          url
        }
        followupRecommendations
        lastUpdated
        providerNotes
        providerSummary
        systemGenerated
        transcription
      }
      end
      events {
        author
        date
        event
        fhirId
      }
      isSummaryCompleted
      lastProcessedDate
      lastUpdate
      media {
        bodySite
        description
        fileId
        fhirId
        url
      }
      participant {
        reference
        type
      }
      patientFirstName
      patientLastName
      paymentInformation {
        amount
        status
      }
      providerFirstName
      providerLastName
      start
      status
      subjectOfAppointment
      recommendations {
        createdAt
        id
        imageUrl
        productId
        productTitle
        providerName
        providerCodexId
        quantity
        status
        totalPrice
      }
      supportingInformation {
        reference
        type
      }
      symptomsLocation
    }
    total
  }
}
    `;

/**
 * __useGetUnfilledSummariesByRequestProviderIdQuery__
 *
 * To run a query within a React component, call `useGetUnfilledSummariesByRequestProviderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnfilledSummariesByRequestProviderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnfilledSummariesByRequestProviderIdQuery({
 *   variables: {
 *      appointmentStatus: // value for 'appointmentStatus'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      sort: // value for 'sort'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useGetUnfilledSummariesByRequestProviderIdQuery(baseOptions?: Apollo.QueryHookOptions<GetUnfilledSummariesByRequestProviderIdQuery, GetUnfilledSummariesByRequestProviderIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnfilledSummariesByRequestProviderIdQuery, GetUnfilledSummariesByRequestProviderIdQueryVariables>(GetUnfilledSummariesByRequestProviderIdDocument, options);
      }
export function useGetUnfilledSummariesByRequestProviderIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnfilledSummariesByRequestProviderIdQuery, GetUnfilledSummariesByRequestProviderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnfilledSummariesByRequestProviderIdQuery, GetUnfilledSummariesByRequestProviderIdQueryVariables>(GetUnfilledSummariesByRequestProviderIdDocument, options);
        }
export type GetUnfilledSummariesByRequestProviderIdQueryHookResult = ReturnType<typeof useGetUnfilledSummariesByRequestProviderIdQuery>;
export type GetUnfilledSummariesByRequestProviderIdLazyQueryHookResult = ReturnType<typeof useGetUnfilledSummariesByRequestProviderIdLazyQuery>;
export type GetUnfilledSummariesByRequestProviderIdQueryResult = Apollo.QueryResult<GetUnfilledSummariesByRequestProviderIdQuery, GetUnfilledSummariesByRequestProviderIdQueryVariables>;
export const GetFulfilledAppointmentsByPatientDocument = gql`
    query getFulfilledAppointmentsByPatient($codexProviderId: String, $appointmentCodexId: String, $from: String, $to: String, $type: String, $find: String, $sort: String, $sortDirection: Float = 0, $limit: Int = 10, $offset: Int = 0, $tzOffset: Float = 0, $dayFilter: String) {
  getFHIRAppointmentByRequestPatientCodexId(
    appointmentStatus: "fulfilled"
    codexProviderId: $codexProviderId
    appointmentCodexId: $appointmentCodexId
    from: $from
    find: $find
    to: $to
    type: $type
    sort: $sort
    sortDirection: $sortDirection
    limit: $limit
    offset: $offset
    tzOffset: $tzOffset
    dayFilter: $dayFilter
  ) {
    appointment {
      appointmentCodexId
      appointmentStatus
      appointmentType
      start
      status
      codexPatientId
      codexProviderId
      subjectOfAppointment
      providerLastName
      providerFirstName
      patientFirstName
      patientLastName
      encounterId
      paymentSessionOpenedAt
      paymentInformation {
        amount
        status
      }
      encounterNotes {
        followupRecommendations
        providerSummary
      }
      media {
        url
        fileId
        bodySite
        description
      }
    }
    total
    counts {
      today
      tomorrow
      week
      month
    }
  }
}
    `;

/**
 * __useGetFulfilledAppointmentsByPatientQuery__
 *
 * To run a query within a React component, call `useGetFulfilledAppointmentsByPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFulfilledAppointmentsByPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFulfilledAppointmentsByPatientQuery({
 *   variables: {
 *      codexProviderId: // value for 'codexProviderId'
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      type: // value for 'type'
 *      find: // value for 'find'
 *      sort: // value for 'sort'
 *      sortDirection: // value for 'sortDirection'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      tzOffset: // value for 'tzOffset'
 *      dayFilter: // value for 'dayFilter'
 *   },
 * });
 */
export function useGetFulfilledAppointmentsByPatientQuery(baseOptions?: Apollo.QueryHookOptions<GetFulfilledAppointmentsByPatientQuery, GetFulfilledAppointmentsByPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFulfilledAppointmentsByPatientQuery, GetFulfilledAppointmentsByPatientQueryVariables>(GetFulfilledAppointmentsByPatientDocument, options);
      }
export function useGetFulfilledAppointmentsByPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFulfilledAppointmentsByPatientQuery, GetFulfilledAppointmentsByPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFulfilledAppointmentsByPatientQuery, GetFulfilledAppointmentsByPatientQueryVariables>(GetFulfilledAppointmentsByPatientDocument, options);
        }
export type GetFulfilledAppointmentsByPatientQueryHookResult = ReturnType<typeof useGetFulfilledAppointmentsByPatientQuery>;
export type GetFulfilledAppointmentsByPatientLazyQueryHookResult = ReturnType<typeof useGetFulfilledAppointmentsByPatientLazyQuery>;
export type GetFulfilledAppointmentsByPatientQueryResult = Apollo.QueryResult<GetFulfilledAppointmentsByPatientQuery, GetFulfilledAppointmentsByPatientQueryVariables>;
export const GetLastPendingAppointmentByPatientDocument = gql`
    query getLastPendingAppointmentByPatient {
  getFHIRAppointmentByRequestPatientCodexId(
    appointmentStatus: "pending"
    sort: "lastUpdate"
    sortDirection: 1
    limit: 1
    offset: 0
  ) {
    appointment {
      appointmentCodexId
      appointmentStatus
      start
      codexProviderId
      subjectOfAppointment
      appointmentNotes {
        anythingElseQuestion
        howLongQuestion
        severityQuestion
        symptomsTypes
      }
      paymentSessionOpenedAt
      symptomsLocation
      media {
        url
        fileId
        bodySite
        description
      }
    }
  }
}
    `;

/**
 * __useGetLastPendingAppointmentByPatientQuery__
 *
 * To run a query within a React component, call `useGetLastPendingAppointmentByPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastPendingAppointmentByPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastPendingAppointmentByPatientQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLastPendingAppointmentByPatientQuery(baseOptions?: Apollo.QueryHookOptions<GetLastPendingAppointmentByPatientQuery, GetLastPendingAppointmentByPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastPendingAppointmentByPatientQuery, GetLastPendingAppointmentByPatientQueryVariables>(GetLastPendingAppointmentByPatientDocument, options);
      }
export function useGetLastPendingAppointmentByPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastPendingAppointmentByPatientQuery, GetLastPendingAppointmentByPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastPendingAppointmentByPatientQuery, GetLastPendingAppointmentByPatientQueryVariables>(GetLastPendingAppointmentByPatientDocument, options);
        }
export type GetLastPendingAppointmentByPatientQueryHookResult = ReturnType<typeof useGetLastPendingAppointmentByPatientQuery>;
export type GetLastPendingAppointmentByPatientLazyQueryHookResult = ReturnType<typeof useGetLastPendingAppointmentByPatientLazyQuery>;
export type GetLastPendingAppointmentByPatientQueryResult = Apollo.QueryResult<GetLastPendingAppointmentByPatientQuery, GetLastPendingAppointmentByPatientQueryVariables>;
export const GetFhirAppointmentByAcuityIdDocument = gql`
    query GetFHIRAppointmentByAcuityId($appointmentAcuityId: String!) {
  getFHIRAppointmentByAcuityId(appointmentAcuityId: $appointmentAcuityId) {
    appointment {
      appointmentCodexId
      appointmentType
      encounterId
    }
  }
}
    `;

/**
 * __useGetFhirAppointmentByAcuityIdQuery__
 *
 * To run a query within a React component, call `useGetFhirAppointmentByAcuityIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirAppointmentByAcuityIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirAppointmentByAcuityIdQuery({
 *   variables: {
 *      appointmentAcuityId: // value for 'appointmentAcuityId'
 *   },
 * });
 */
export function useGetFhirAppointmentByAcuityIdQuery(baseOptions: Apollo.QueryHookOptions<GetFhirAppointmentByAcuityIdQuery, GetFhirAppointmentByAcuityIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirAppointmentByAcuityIdQuery, GetFhirAppointmentByAcuityIdQueryVariables>(GetFhirAppointmentByAcuityIdDocument, options);
      }
export function useGetFhirAppointmentByAcuityIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirAppointmentByAcuityIdQuery, GetFhirAppointmentByAcuityIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirAppointmentByAcuityIdQuery, GetFhirAppointmentByAcuityIdQueryVariables>(GetFhirAppointmentByAcuityIdDocument, options);
        }
export type GetFhirAppointmentByAcuityIdQueryHookResult = ReturnType<typeof useGetFhirAppointmentByAcuityIdQuery>;
export type GetFhirAppointmentByAcuityIdLazyQueryHookResult = ReturnType<typeof useGetFhirAppointmentByAcuityIdLazyQuery>;
export type GetFhirAppointmentByAcuityIdQueryResult = Apollo.QueryResult<GetFhirAppointmentByAcuityIdQuery, GetFhirAppointmentByAcuityIdQueryVariables>;
export const GetAppointmentByCodexAppointmentIdInMediaDocument = gql`
    query getAppointmentByCodexAppointmentIdInMedia($appointmentCodexId: String!) {
  getFHIRAppointmentByCodexId(appointmentCodexId: $appointmentCodexId) {
    appointment {
      summaryPdfFileId
      appointmentCodexId
      appointmentId
      appointmentType
      providerFirstName
      providerLastName
      start
    }
  }
}
    `;

/**
 * __useGetAppointmentByCodexAppointmentIdInMediaQuery__
 *
 * To run a query within a React component, call `useGetAppointmentByCodexAppointmentIdInMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentByCodexAppointmentIdInMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentByCodexAppointmentIdInMediaQuery({
 *   variables: {
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *   },
 * });
 */
export function useGetAppointmentByCodexAppointmentIdInMediaQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentByCodexAppointmentIdInMediaQuery, GetAppointmentByCodexAppointmentIdInMediaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentByCodexAppointmentIdInMediaQuery, GetAppointmentByCodexAppointmentIdInMediaQueryVariables>(GetAppointmentByCodexAppointmentIdInMediaDocument, options);
      }
export function useGetAppointmentByCodexAppointmentIdInMediaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentByCodexAppointmentIdInMediaQuery, GetAppointmentByCodexAppointmentIdInMediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentByCodexAppointmentIdInMediaQuery, GetAppointmentByCodexAppointmentIdInMediaQueryVariables>(GetAppointmentByCodexAppointmentIdInMediaDocument, options);
        }
export type GetAppointmentByCodexAppointmentIdInMediaQueryHookResult = ReturnType<typeof useGetAppointmentByCodexAppointmentIdInMediaQuery>;
export type GetAppointmentByCodexAppointmentIdInMediaLazyQueryHookResult = ReturnType<typeof useGetAppointmentByCodexAppointmentIdInMediaLazyQuery>;
export type GetAppointmentByCodexAppointmentIdInMediaQueryResult = Apollo.QueryResult<GetAppointmentByCodexAppointmentIdInMediaQuery, GetAppointmentByCodexAppointmentIdInMediaQueryVariables>;
export const GetAppointmentByCodexAppointmentIdDocument = gql`
    query getAppointmentByCodexAppointmentId($appointmentCodexId: String!) {
  getFHIRAppointmentByCodexId(appointmentCodexId: $appointmentCodexId) {
    appointment {
      summaryPdfFileId
      appointmentNotes {
        anythingElseQuestion
        howLongQuestion
        practitionerNotes
        severityQuestion
        symptomsTypes
      }
      statusHistory {
        datetime
        status
      }
      pendingRescheduleRequest {
        proposedDate
        reason
        id
      }
      acuityId
      appointmentCodexId
      appointmentId
      diagnosticReports {
        patientPdf {
          url
          size
          fileName
          fileId
          contentType
          creation
        }
        createdAt
        diagnosticReportId
        diagnosticReportStatus
        diagnosticReportTestType
        swabCode
        patientPdfId
        statusHistory {
          datetime
          status
        }
      }
      appointmentStatus
      appointmentType
      appointmentUrl
      cancelationReason
      codexPatientId
      codexProviderId
      created
      encounterId
      encounterNotes {
        files {
          contentType
          fileId
          size
          title
          url
        }
        followupRecommendations
        lastUpdated
        providerNotes
        providerSummary
        systemGenerated
        transcription
      }
      end
      events {
        author
        date
        event
        fhirId
      }
      isSummaryCompleted
      lastProcessedDate
      lastUpdate
      media {
        bodySite
        description
        fileId
        fhirId
        url
      }
      participant {
        reference
        type
      }
      patientFirstName
      patientLastName
      paymentInformation {
        amount
        status
        discount {
          amountOff
          percentOff
        }
      }
      providerFirstName
      providerLastName
      start
      status
      subjectOfAppointment
      recommendations {
        createdAt
        id
        imageUrl
        productId
        productTitle
        providerName
        providerCodexId
        quantity
        status
        totalPrice
      }
      provider {
        SENSITIVE_firstname
        SENSITIVE_lastname
      }
      supportingInformation {
        reference
        type
      }
      symptomsLocation
    }
  }
}
    `;

/**
 * __useGetAppointmentByCodexAppointmentIdQuery__
 *
 * To run a query within a React component, call `useGetAppointmentByCodexAppointmentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentByCodexAppointmentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentByCodexAppointmentIdQuery({
 *   variables: {
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *   },
 * });
 */
export function useGetAppointmentByCodexAppointmentIdQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentByCodexAppointmentIdQuery, GetAppointmentByCodexAppointmentIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentByCodexAppointmentIdQuery, GetAppointmentByCodexAppointmentIdQueryVariables>(GetAppointmentByCodexAppointmentIdDocument, options);
      }
export function useGetAppointmentByCodexAppointmentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentByCodexAppointmentIdQuery, GetAppointmentByCodexAppointmentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentByCodexAppointmentIdQuery, GetAppointmentByCodexAppointmentIdQueryVariables>(GetAppointmentByCodexAppointmentIdDocument, options);
        }
export type GetAppointmentByCodexAppointmentIdQueryHookResult = ReturnType<typeof useGetAppointmentByCodexAppointmentIdQuery>;
export type GetAppointmentByCodexAppointmentIdLazyQueryHookResult = ReturnType<typeof useGetAppointmentByCodexAppointmentIdLazyQuery>;
export type GetAppointmentByCodexAppointmentIdQueryResult = Apollo.QueryResult<GetAppointmentByCodexAppointmentIdQuery, GetAppointmentByCodexAppointmentIdQueryVariables>;
export const GetProviderAppointmentByCodexAppointmentIdDocument = gql`
    query getProviderAppointmentByCodexAppointmentId($appointmentCodexId: String!) {
  getFHIRAppointmentByCodexId(appointmentCodexId: $appointmentCodexId) {
    appointment {
      summaryPdfFileId
      appointmentNotes {
        anythingElseQuestion
        howLongQuestion
        practitionerNotes
        severityQuestion
        symptomsTypes
      }
      statusHistory {
        datetime
        status
      }
      pendingRescheduleRequest {
        appointmentCodexId
        createdAt
        reason
        type
        id
        proposedDate
      }
      acuityId
      appointmentCodexId
      appointmentId
      diagnosticReports {
        createdAt
        diagnosticReportId
        diagnosticReportStatus
        diagnosticReportTestType
        swabCode
        statusHistory {
          datetime
          status
        }
        providerPdf {
          contentType
          fileId
          fileName
          size
          url
          creation
        }
        providerPdfId
      }
      appointmentStatus
      appointmentType
      appointmentUrl
      cancelationReason
      codexPatientId
      codexProviderId
      created
      encounterId
      encounterNotes {
        files {
          contentType
          fileId
          size
          title
          url
        }
        followupRecommendations
        lastUpdated
        providerNotes
        providerSummary
        systemGenerated
        transcription
      }
      end
      events {
        author
        date
        event
        fhirId
      }
      isSummaryCompleted
      lastProcessedDate
      lastUpdate
      media {
        bodySite
        description
        fileId
        fhirId
        url
      }
      participant {
        reference
        type
      }
      patientFirstName
      patientLastName
      paymentInformation {
        amount
        status
        discount {
          amountOff
          percentOff
        }
      }
      providerFirstName
      providerLastName
      start
      status
      subjectOfAppointment
      recommendations {
        createdAt
        id
        imageUrl
        productId
        productTitle
        providerName
        providerCodexId
        quantity
        status
        totalPrice
      }
      supportingInformation {
        reference
        type
      }
      symptomsLocation
    }
  }
}
    `;

/**
 * __useGetProviderAppointmentByCodexAppointmentIdQuery__
 *
 * To run a query within a React component, call `useGetProviderAppointmentByCodexAppointmentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderAppointmentByCodexAppointmentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderAppointmentByCodexAppointmentIdQuery({
 *   variables: {
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *   },
 * });
 */
export function useGetProviderAppointmentByCodexAppointmentIdQuery(baseOptions: Apollo.QueryHookOptions<GetProviderAppointmentByCodexAppointmentIdQuery, GetProviderAppointmentByCodexAppointmentIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderAppointmentByCodexAppointmentIdQuery, GetProviderAppointmentByCodexAppointmentIdQueryVariables>(GetProviderAppointmentByCodexAppointmentIdDocument, options);
      }
export function useGetProviderAppointmentByCodexAppointmentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderAppointmentByCodexAppointmentIdQuery, GetProviderAppointmentByCodexAppointmentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderAppointmentByCodexAppointmentIdQuery, GetProviderAppointmentByCodexAppointmentIdQueryVariables>(GetProviderAppointmentByCodexAppointmentIdDocument, options);
        }
export type GetProviderAppointmentByCodexAppointmentIdQueryHookResult = ReturnType<typeof useGetProviderAppointmentByCodexAppointmentIdQuery>;
export type GetProviderAppointmentByCodexAppointmentIdLazyQueryHookResult = ReturnType<typeof useGetProviderAppointmentByCodexAppointmentIdLazyQuery>;
export type GetProviderAppointmentByCodexAppointmentIdQueryResult = Apollo.QueryResult<GetProviderAppointmentByCodexAppointmentIdQuery, GetProviderAppointmentByCodexAppointmentIdQueryVariables>;
export const GetAppointmentsByProviderDocument = gql`
    query GetAppointmentsByProvider($appointmentStatus: [String!], $appointmentCodexId: String, $patientCodexId: String, $from: String, $to: String, $type: String, $find: String, $sort: String, $sortDirection: Float = 0, $limit: Int = 10, $offset: Int = 0, $tzOffset: Float, $dayFilter: String, $patientName: String) {
  getFHIRAppointmentByRequestProviderId(
    appointmentStatus: $appointmentStatus
    appointmentCodexId: $appointmentCodexId
    patientCodexId: $patientCodexId
    from: $from
    to: $to
    type: $type
    find: $find
    sort: $sort
    sortDirection: $sortDirection
    limit: $limit
    offset: $offset
    tzOffset: $tzOffset
    dayFilter: $dayFilter
    patientName: $patientName
  ) {
    appointment {
      appointmentCodexId
      appointmentType
      start
      end
      status
      isSummaryCompleted
      codexPatientId
      codexProviderId
      subjectOfAppointment
      patientLastName
      patientFirstName
      providerFirstName
      providerLastName
      appointmentStatus
      diagnosticReports {
        providerPdf {
          contentType
          fileId
          fileName
          size
          url
        }
        statusHistory {
          datetime
          status
        }
        providerPdfId
        swabCode
        diagnosticReportId
        diagnosticReportStatus
        diagnosticReportTestType
      }
      pendingRescheduleRequest {
        proposedDate
        reason
        id
      }
      paymentInformation {
        amount
        status
      }
      encounterNotes {
        followupRecommendations
        providerSummary
      }
      media {
        url
        fileId
      }
      events {
        event
        date
        author
      }
    }
    total
    counts {
      today
      tomorrow
      week
      month
    }
  }
}
    `;

/**
 * __useGetAppointmentsByProviderQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsByProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsByProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsByProviderQuery({
 *   variables: {
 *      appointmentStatus: // value for 'appointmentStatus'
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *      patientCodexId: // value for 'patientCodexId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      type: // value for 'type'
 *      find: // value for 'find'
 *      sort: // value for 'sort'
 *      sortDirection: // value for 'sortDirection'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      tzOffset: // value for 'tzOffset'
 *      dayFilter: // value for 'dayFilter'
 *      patientName: // value for 'patientName'
 *   },
 * });
 */
export function useGetAppointmentsByProviderQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentsByProviderQuery, GetAppointmentsByProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsByProviderQuery, GetAppointmentsByProviderQueryVariables>(GetAppointmentsByProviderDocument, options);
      }
export function useGetAppointmentsByProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsByProviderQuery, GetAppointmentsByProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsByProviderQuery, GetAppointmentsByProviderQueryVariables>(GetAppointmentsByProviderDocument, options);
        }
export type GetAppointmentsByProviderQueryHookResult = ReturnType<typeof useGetAppointmentsByProviderQuery>;
export type GetAppointmentsByProviderLazyQueryHookResult = ReturnType<typeof useGetAppointmentsByProviderLazyQuery>;
export type GetAppointmentsByProviderQueryResult = Apollo.QueryResult<GetAppointmentsByProviderQuery, GetAppointmentsByProviderQueryVariables>;
export const GetAppointmentsByPatientIdDocument = gql`
    query GetAppointmentsByPatientId($appointmentStatus: [String!], $appointmentCodexId: String, $patientCodexId: String!, $from: String, $to: String, $type: String, $sort: String, $sortDirection: Float = 0, $limit: Int = 10, $offset: Int = 0, $tzOffset: Float, $dayFilter: String, $isSummaryCompleted: Boolean, $withOtherProviders: Boolean) {
  getFHIRPatientAppointmentsByProvider(
    appointmentStatus: $appointmentStatus
    appointmentCodexId: $appointmentCodexId
    patientCodexId: $patientCodexId
    from: $from
    to: $to
    type: $type
    sort: $sort
    sortDirection: $sortDirection
    limit: $limit
    offset: $offset
    tzOffset: $tzOffset
    dayFilter: $dayFilter
    isSummaryCompleted: $isSummaryCompleted
    withOtherProviders: $withOtherProviders
  ) {
    appointment {
      appointmentCodexId
      appointmentType
      start
      end
      status
      codexPatientId
      codexProviderId
      subjectOfAppointment
      patientLastName
      patientFirstName
      providerFirstName
      providerLastName
      appointmentStatus
      paymentInformation {
        amount
        status
      }
      encounterNotes {
        followupRecommendations
        providerSummary
      }
      media {
        url
        fileId
      }
      events {
        event
        date
        author
      }
    }
    total
    counts {
      today
      tomorrow
      week
      month
    }
  }
}
    `;

/**
 * __useGetAppointmentsByPatientIdQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsByPatientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsByPatientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsByPatientIdQuery({
 *   variables: {
 *      appointmentStatus: // value for 'appointmentStatus'
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *      patientCodexId: // value for 'patientCodexId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      type: // value for 'type'
 *      sort: // value for 'sort'
 *      sortDirection: // value for 'sortDirection'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      tzOffset: // value for 'tzOffset'
 *      dayFilter: // value for 'dayFilter'
 *      isSummaryCompleted: // value for 'isSummaryCompleted'
 *      withOtherProviders: // value for 'withOtherProviders'
 *   },
 * });
 */
export function useGetAppointmentsByPatientIdQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentsByPatientIdQuery, GetAppointmentsByPatientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsByPatientIdQuery, GetAppointmentsByPatientIdQueryVariables>(GetAppointmentsByPatientIdDocument, options);
      }
export function useGetAppointmentsByPatientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsByPatientIdQuery, GetAppointmentsByPatientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsByPatientIdQuery, GetAppointmentsByPatientIdQueryVariables>(GetAppointmentsByPatientIdDocument, options);
        }
export type GetAppointmentsByPatientIdQueryHookResult = ReturnType<typeof useGetAppointmentsByPatientIdQuery>;
export type GetAppointmentsByPatientIdLazyQueryHookResult = ReturnType<typeof useGetAppointmentsByPatientIdLazyQuery>;
export type GetAppointmentsByPatientIdQueryResult = Apollo.QueryResult<GetAppointmentsByPatientIdQuery, GetAppointmentsByPatientIdQueryVariables>;
export const GetPatientAppointmentByCodexAppointmentIdDocument = gql`
    query getPatientAppointmentByCodexAppointmentId($appointmentCodexId: String!) {
  getFHIRAppointmentByCodexId(appointmentCodexId: $appointmentCodexId) {
    appointment {
      summaryPdfFileId
      appointmentNotes {
        anythingElseQuestion
        howLongQuestion
        practitionerNotes
        severityQuestion
        symptomsTypes
      }
      acuityId
      appointmentCodexId
      appointmentId
      diagnosticReports {
        diagnosticReportId
        diagnosticReportStatus
        diagnosticReportTestType
        swabCode
        patientPdf {
          contentType
          fileId
          fileName
          url
          size
        }
        providerPdf {
          contentType
          fileId
          fileName
          size
          url
        }
        patientPdfId
        providerPdfId
      }
      appointmentStatus
      appointmentType
      appointmentUrl
      cancelationReason
      codexPatientId
      codexProviderId
      created
      encounterId
      encounterNotes {
        files {
          contentType
          fileId
          size
          title
          url
        }
        followupRecommendations
        lastUpdated
        providerNotes
        providerSummary
        systemGenerated
        transcription
      }
      end
      events {
        author
        date
        event
        fhirId
      }
      isSummaryCompleted
      lastProcessedDate
      lastUpdate
      media {
        bodySite
        description
        fileId
        fhirId
        url
      }
      participant {
        reference
        type
      }
      patientFirstName
      patientLastName
      paymentInformation {
        amount
        status
        discount {
          amountOff
          percentOff
        }
      }
      providerFirstName
      providerLastName
      start
      status
      subjectOfAppointment
      recommendations {
        createdAt
        id
        imageUrl
        productId
        productTitle
        providerName
        providerCodexId
        quantity
        status
        totalPrice
      }
      supportingInformation {
        reference
        type
      }
      symptomsLocation
    }
  }
}
    `;

/**
 * __useGetPatientAppointmentByCodexAppointmentIdQuery__
 *
 * To run a query within a React component, call `useGetPatientAppointmentByCodexAppointmentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientAppointmentByCodexAppointmentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientAppointmentByCodexAppointmentIdQuery({
 *   variables: {
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *   },
 * });
 */
export function useGetPatientAppointmentByCodexAppointmentIdQuery(baseOptions: Apollo.QueryHookOptions<GetPatientAppointmentByCodexAppointmentIdQuery, GetPatientAppointmentByCodexAppointmentIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientAppointmentByCodexAppointmentIdQuery, GetPatientAppointmentByCodexAppointmentIdQueryVariables>(GetPatientAppointmentByCodexAppointmentIdDocument, options);
      }
export function useGetPatientAppointmentByCodexAppointmentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientAppointmentByCodexAppointmentIdQuery, GetPatientAppointmentByCodexAppointmentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientAppointmentByCodexAppointmentIdQuery, GetPatientAppointmentByCodexAppointmentIdQueryVariables>(GetPatientAppointmentByCodexAppointmentIdDocument, options);
        }
export type GetPatientAppointmentByCodexAppointmentIdQueryHookResult = ReturnType<typeof useGetPatientAppointmentByCodexAppointmentIdQuery>;
export type GetPatientAppointmentByCodexAppointmentIdLazyQueryHookResult = ReturnType<typeof useGetPatientAppointmentByCodexAppointmentIdLazyQuery>;
export type GetPatientAppointmentByCodexAppointmentIdQueryResult = Apollo.QueryResult<GetPatientAppointmentByCodexAppointmentIdQuery, GetPatientAppointmentByCodexAppointmentIdQueryVariables>;
export const GetHistoricAppointmentCountDocument = gql`
    query GetHistoricAppointmentCount($from: String, $appointmentStatus: [String!]) {
  getFHIRAppointmentByRequestPatientCodexId(
    from: $from
    appointmentStatus: $appointmentStatus
  ) {
    total
  }
}
    `;

/**
 * __useGetHistoricAppointmentCountQuery__
 *
 * To run a query within a React component, call `useGetHistoricAppointmentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoricAppointmentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoricAppointmentCountQuery({
 *   variables: {
 *      from: // value for 'from'
 *      appointmentStatus: // value for 'appointmentStatus'
 *   },
 * });
 */
export function useGetHistoricAppointmentCountQuery(baseOptions?: Apollo.QueryHookOptions<GetHistoricAppointmentCountQuery, GetHistoricAppointmentCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHistoricAppointmentCountQuery, GetHistoricAppointmentCountQueryVariables>(GetHistoricAppointmentCountDocument, options);
      }
export function useGetHistoricAppointmentCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHistoricAppointmentCountQuery, GetHistoricAppointmentCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHistoricAppointmentCountQuery, GetHistoricAppointmentCountQueryVariables>(GetHistoricAppointmentCountDocument, options);
        }
export type GetHistoricAppointmentCountQueryHookResult = ReturnType<typeof useGetHistoricAppointmentCountQuery>;
export type GetHistoricAppointmentCountLazyQueryHookResult = ReturnType<typeof useGetHistoricAppointmentCountLazyQuery>;
export type GetHistoricAppointmentCountQueryResult = Apollo.QueryResult<GetHistoricAppointmentCountQuery, GetHistoricAppointmentCountQueryVariables>;
export const GetHistoricAppointmentCountByProviderDocument = gql`
    query GetHistoricAppointmentCountByProvider {
  getFHIRAppointmentByRequestProviderId {
    total
  }
}
    `;

/**
 * __useGetHistoricAppointmentCountByProviderQuery__
 *
 * To run a query within a React component, call `useGetHistoricAppointmentCountByProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoricAppointmentCountByProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoricAppointmentCountByProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHistoricAppointmentCountByProviderQuery(baseOptions?: Apollo.QueryHookOptions<GetHistoricAppointmentCountByProviderQuery, GetHistoricAppointmentCountByProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHistoricAppointmentCountByProviderQuery, GetHistoricAppointmentCountByProviderQueryVariables>(GetHistoricAppointmentCountByProviderDocument, options);
      }
export function useGetHistoricAppointmentCountByProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHistoricAppointmentCountByProviderQuery, GetHistoricAppointmentCountByProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHistoricAppointmentCountByProviderQuery, GetHistoricAppointmentCountByProviderQueryVariables>(GetHistoricAppointmentCountByProviderDocument, options);
        }
export type GetHistoricAppointmentCountByProviderQueryHookResult = ReturnType<typeof useGetHistoricAppointmentCountByProviderQuery>;
export type GetHistoricAppointmentCountByProviderLazyQueryHookResult = ReturnType<typeof useGetHistoricAppointmentCountByProviderLazyQuery>;
export type GetHistoricAppointmentCountByProviderQueryResult = Apollo.QueryResult<GetHistoricAppointmentCountByProviderQuery, GetHistoricAppointmentCountByProviderQueryVariables>;
export const GetAppointmentRescheduleLinkDocument = gql`
    query GetAppointmentRescheduleLink($appointmentCodexId: String!) {
  getAppointmentRescheduleLink(appointmentCodexId: $appointmentCodexId) {
    rescheduleLink
  }
}
    `;

/**
 * __useGetAppointmentRescheduleLinkQuery__
 *
 * To run a query within a React component, call `useGetAppointmentRescheduleLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentRescheduleLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentRescheduleLinkQuery({
 *   variables: {
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *   },
 * });
 */
export function useGetAppointmentRescheduleLinkQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentRescheduleLinkQuery, GetAppointmentRescheduleLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentRescheduleLinkQuery, GetAppointmentRescheduleLinkQueryVariables>(GetAppointmentRescheduleLinkDocument, options);
      }
export function useGetAppointmentRescheduleLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentRescheduleLinkQuery, GetAppointmentRescheduleLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentRescheduleLinkQuery, GetAppointmentRescheduleLinkQueryVariables>(GetAppointmentRescheduleLinkDocument, options);
        }
export type GetAppointmentRescheduleLinkQueryHookResult = ReturnType<typeof useGetAppointmentRescheduleLinkQuery>;
export type GetAppointmentRescheduleLinkLazyQueryHookResult = ReturnType<typeof useGetAppointmentRescheduleLinkLazyQuery>;
export type GetAppointmentRescheduleLinkQueryResult = Apollo.QueryResult<GetAppointmentRescheduleLinkQuery, GetAppointmentRescheduleLinkQueryVariables>;
export const GetAppointmentPaymentLinkDocument = gql`
    query GetAppointmentPaymentLink($appointmentCodexId: String!) {
  getAppointmentRetryPaymentLink(appointmentCodexId: $appointmentCodexId) {
    link
  }
}
    `;

/**
 * __useGetAppointmentPaymentLinkQuery__
 *
 * To run a query within a React component, call `useGetAppointmentPaymentLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentPaymentLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentPaymentLinkQuery({
 *   variables: {
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *   },
 * });
 */
export function useGetAppointmentPaymentLinkQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentPaymentLinkQuery, GetAppointmentPaymentLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentPaymentLinkQuery, GetAppointmentPaymentLinkQueryVariables>(GetAppointmentPaymentLinkDocument, options);
      }
export function useGetAppointmentPaymentLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentPaymentLinkQuery, GetAppointmentPaymentLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentPaymentLinkQuery, GetAppointmentPaymentLinkQueryVariables>(GetAppointmentPaymentLinkDocument, options);
        }
export type GetAppointmentPaymentLinkQueryHookResult = ReturnType<typeof useGetAppointmentPaymentLinkQuery>;
export type GetAppointmentPaymentLinkLazyQueryHookResult = ReturnType<typeof useGetAppointmentPaymentLinkLazyQuery>;
export type GetAppointmentPaymentLinkQueryResult = Apollo.QueryResult<GetAppointmentPaymentLinkQuery, GetAppointmentPaymentLinkQueryVariables>;
export const GetFhirEncountersByProviderDocument = gql`
    query GetFHIREncountersByProvider($status: EncounterStatuses, $limit: Int = 10, $offset: Int = 0) {
  getFHIREncountersByProvider(status: $status, limit: $limit, offset: $offset) {
    encounters {
      appointmentCodexId
      appointmentDate
      class
      encounterId
      patientCodexId
      patientFirstName
      patientLastName
      providerCodexId
      providerFirstName
      providerLastName
      status
      type
    }
    total
  }
}
    `;

/**
 * __useGetFhirEncountersByProviderQuery__
 *
 * To run a query within a React component, call `useGetFhirEncountersByProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirEncountersByProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirEncountersByProviderQuery({
 *   variables: {
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetFhirEncountersByProviderQuery(baseOptions?: Apollo.QueryHookOptions<GetFhirEncountersByProviderQuery, GetFhirEncountersByProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirEncountersByProviderQuery, GetFhirEncountersByProviderQueryVariables>(GetFhirEncountersByProviderDocument, options);
      }
export function useGetFhirEncountersByProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirEncountersByProviderQuery, GetFhirEncountersByProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirEncountersByProviderQuery, GetFhirEncountersByProviderQueryVariables>(GetFhirEncountersByProviderDocument, options);
        }
export type GetFhirEncountersByProviderQueryHookResult = ReturnType<typeof useGetFhirEncountersByProviderQuery>;
export type GetFhirEncountersByProviderLazyQueryHookResult = ReturnType<typeof useGetFhirEncountersByProviderLazyQuery>;
export type GetFhirEncountersByProviderQueryResult = Apollo.QueryResult<GetFhirEncountersByProviderQuery, GetFhirEncountersByProviderQueryVariables>;
export const UpdateSummaryNotificationStateDocument = gql`
    query UpdateSummaryNotificationState($appointmentCodexId: String!, $summaryNotification: Boolean!) {
  updateAppointmentSummaryNotificationState(
    appointmentCodexId: $appointmentCodexId
    summaryNotification: $summaryNotification
  ) {
    message
    status
  }
}
    `;

/**
 * __useUpdateSummaryNotificationStateQuery__
 *
 * To run a query within a React component, call `useUpdateSummaryNotificationStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateSummaryNotificationStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateSummaryNotificationStateQuery({
 *   variables: {
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *      summaryNotification: // value for 'summaryNotification'
 *   },
 * });
 */
export function useUpdateSummaryNotificationStateQuery(baseOptions: Apollo.QueryHookOptions<UpdateSummaryNotificationStateQuery, UpdateSummaryNotificationStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateSummaryNotificationStateQuery, UpdateSummaryNotificationStateQueryVariables>(UpdateSummaryNotificationStateDocument, options);
      }
export function useUpdateSummaryNotificationStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateSummaryNotificationStateQuery, UpdateSummaryNotificationStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateSummaryNotificationStateQuery, UpdateSummaryNotificationStateQueryVariables>(UpdateSummaryNotificationStateDocument, options);
        }
export type UpdateSummaryNotificationStateQueryHookResult = ReturnType<typeof useUpdateSummaryNotificationStateQuery>;
export type UpdateSummaryNotificationStateLazyQueryHookResult = ReturnType<typeof useUpdateSummaryNotificationStateLazyQuery>;
export type UpdateSummaryNotificationStateQueryResult = Apollo.QueryResult<UpdateSummaryNotificationStateQuery, UpdateSummaryNotificationStateQueryVariables>;
export const GetProviderAppointmentRequestsDocument = gql`
    query GetProviderAppointmentRequests($limit: Int = 10, $offset: Int = 0) {
  getProviderAppointmentRequests(limit: $limit, offset: $offset) {
    requests {
      patient {
        id
        SENSITIVE_email
        SENSITIVE_firstname
        SENSITIVE_lastname
      }
      appointmentCodexId
      appointmentTypeId
      approvedDate
      createdAt
      currentDate
      id
      proposedDate
      providerCodexId
      reason
      status
      type
      updatedAt
    }
    total
  }
}
    `;

/**
 * __useGetProviderAppointmentRequestsQuery__
 *
 * To run a query within a React component, call `useGetProviderAppointmentRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderAppointmentRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderAppointmentRequestsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetProviderAppointmentRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetProviderAppointmentRequestsQuery, GetProviderAppointmentRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderAppointmentRequestsQuery, GetProviderAppointmentRequestsQueryVariables>(GetProviderAppointmentRequestsDocument, options);
      }
export function useGetProviderAppointmentRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderAppointmentRequestsQuery, GetProviderAppointmentRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderAppointmentRequestsQuery, GetProviderAppointmentRequestsQueryVariables>(GetProviderAppointmentRequestsDocument, options);
        }
export type GetProviderAppointmentRequestsQueryHookResult = ReturnType<typeof useGetProviderAppointmentRequestsQuery>;
export type GetProviderAppointmentRequestsLazyQueryHookResult = ReturnType<typeof useGetProviderAppointmentRequestsLazyQuery>;
export type GetProviderAppointmentRequestsQueryResult = Apollo.QueryResult<GetProviderAppointmentRequestsQuery, GetProviderAppointmentRequestsQueryVariables>;
export const GetAppointmentSummaryDocument = gql`
    query GetAppointmentSummary($appointmentCodexId: String!) {
  getAppointmentSummary(appointmentCodexId: $appointmentCodexId) {
    summaryPdfFileId
    summary
    transcription
  }
}
    `;

/**
 * __useGetAppointmentSummaryQuery__
 *
 * To run a query within a React component, call `useGetAppointmentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentSummaryQuery({
 *   variables: {
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *   },
 * });
 */
export function useGetAppointmentSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentSummaryQuery, GetAppointmentSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentSummaryQuery, GetAppointmentSummaryQueryVariables>(GetAppointmentSummaryDocument, options);
      }
export function useGetAppointmentSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentSummaryQuery, GetAppointmentSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentSummaryQuery, GetAppointmentSummaryQueryVariables>(GetAppointmentSummaryDocument, options);
        }
export type GetAppointmentSummaryQueryHookResult = ReturnType<typeof useGetAppointmentSummaryQuery>;
export type GetAppointmentSummaryLazyQueryHookResult = ReturnType<typeof useGetAppointmentSummaryLazyQuery>;
export type GetAppointmentSummaryQueryResult = Apollo.QueryResult<GetAppointmentSummaryQuery, GetAppointmentSummaryQueryVariables>;
export const GetFhirDnaVisitTestsDocument = gql`
    query GetFHIRDnaVisitTests($limit: Int = 10, $from: String, $to: String, $testType: [Hasura_Test_Types_Enum!], $state: [Hasura_Dnavisit_Test_Statuses_Enum!]) {
  getFHIRDnaVisitTests(
    to: $to
    testType: $testType
    state: $state
    limit: $limit
    from: $from
  ) {
    dnavisit_tests {
      test_id
      created_at
      test_type
      sapphiros_barcode
      provider_name
      state
      tracking_number
      visit_summary_pdf_id
      patient_pdf_id
    }
    total
  }
}
    `;

/**
 * __useGetFhirDnaVisitTestsQuery__
 *
 * To run a query within a React component, call `useGetFhirDnaVisitTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirDnaVisitTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirDnaVisitTestsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      testType: // value for 'testType'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetFhirDnaVisitTestsQuery(baseOptions?: Apollo.QueryHookOptions<GetFhirDnaVisitTestsQuery, GetFhirDnaVisitTestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirDnaVisitTestsQuery, GetFhirDnaVisitTestsQueryVariables>(GetFhirDnaVisitTestsDocument, options);
      }
export function useGetFhirDnaVisitTestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirDnaVisitTestsQuery, GetFhirDnaVisitTestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirDnaVisitTestsQuery, GetFhirDnaVisitTestsQueryVariables>(GetFhirDnaVisitTestsDocument, options);
        }
export type GetFhirDnaVisitTestsQueryHookResult = ReturnType<typeof useGetFhirDnaVisitTestsQuery>;
export type GetFhirDnaVisitTestsLazyQueryHookResult = ReturnType<typeof useGetFhirDnaVisitTestsLazyQuery>;
export type GetFhirDnaVisitTestsQueryResult = Apollo.QueryResult<GetFhirDnaVisitTestsQuery, GetFhirDnaVisitTestsQueryVariables>;
export const GetFhirDnaVisitAndZrtTestsDocument = gql`
    query GetFHIRDnaVisitAndZrtTests($limit: Int = 10, $offset: Int = 0, $from: String, $to: String, $testType: [Hasura_Test_Types_Enum!], $state: [Hasura_Dnavisit_Test_Statuses_Enum!], $patientCodexId: String, $providerName: [String!], $orderBy: DiagnosticReportOrderByInput, $find: String, $hasAppointment: Boolean) {
  getFHIRDnaAndZrtTests(
    to: $to
    testType: $testType
    state: $state
    limit: $limit
    offset: $offset
    from: $from
    patientCodexId: $patientCodexId
    providerName: $providerName
    orderBy: $orderBy
    find: $find
    hasAppointment: $hasAppointment
  ) {
    dna_tests {
      statusHistory {
        datetime
        status
      }
      diagnosticReportId
      test_id
      created_at
      test_type
      rank
      sapphiros_barcode
      provider_name
      state
      patient_pdf_id
      created_at
      updated_at
      provider_acuity_owner_id
      provider_acuity_calendar_id
      provider_codex_id
      visit_summary_pdf_id
      tracking_number
    }
    zrt_tests {
      statusHistory {
        datetime
        status
      }
      appointment_codex_id
      fhirId
      reference_code
      created_at
      test_type
      rank
      swab_code
      provider_name
      state
      patient_pdf_id
      created_at
      updated_at
      provider_acuity_owner_id
      provider_acuity_calendar_id
      provider_codex_id
      tracking_number
      questionnaire_required
    }
    mosaic_tests {
      statusHistory {
        datetime
        status
      }
      appointment_codex_id
      created_at
      fhirId
      patient_fhir_id
      patient_pdf_id
      provider_acuity_calendar_id
      provider_acuity_owner_id
      provider_codex_id
      provider_fhir_id
      provider_name
      rank
      state
      swab_code
      test_id
      test_type
      tracking_number
      updated_at
    }
    diagnostic_solution_tests {
      statusHistory {
        datetime
        status
      }
      appointment_codex_id
      created_at
      fhirId
      patient_fhir_id
      patient_pdf_id
      provider_acuity_calendar_id
      provider_acuity_owner_id
      provider_codex_id
      provider_fhir_id
      provider_name
      rank
      state
      swab_code
      test_id
      test_type
      tracking_number
      updated_at
      questionnaire_required
    }
    total
  }
}
    `;

/**
 * __useGetFhirDnaVisitAndZrtTestsQuery__
 *
 * To run a query within a React component, call `useGetFhirDnaVisitAndZrtTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirDnaVisitAndZrtTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirDnaVisitAndZrtTestsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      testType: // value for 'testType'
 *      state: // value for 'state'
 *      patientCodexId: // value for 'patientCodexId'
 *      providerName: // value for 'providerName'
 *      orderBy: // value for 'orderBy'
 *      find: // value for 'find'
 *      hasAppointment: // value for 'hasAppointment'
 *   },
 * });
 */
export function useGetFhirDnaVisitAndZrtTestsQuery(baseOptions?: Apollo.QueryHookOptions<GetFhirDnaVisitAndZrtTestsQuery, GetFhirDnaVisitAndZrtTestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirDnaVisitAndZrtTestsQuery, GetFhirDnaVisitAndZrtTestsQueryVariables>(GetFhirDnaVisitAndZrtTestsDocument, options);
      }
export function useGetFhirDnaVisitAndZrtTestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirDnaVisitAndZrtTestsQuery, GetFhirDnaVisitAndZrtTestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirDnaVisitAndZrtTestsQuery, GetFhirDnaVisitAndZrtTestsQueryVariables>(GetFhirDnaVisitAndZrtTestsDocument, options);
        }
export type GetFhirDnaVisitAndZrtTestsQueryHookResult = ReturnType<typeof useGetFhirDnaVisitAndZrtTestsQuery>;
export type GetFhirDnaVisitAndZrtTestsLazyQueryHookResult = ReturnType<typeof useGetFhirDnaVisitAndZrtTestsLazyQuery>;
export type GetFhirDnaVisitAndZrtTestsQueryResult = Apollo.QueryResult<GetFhirDnaVisitAndZrtTestsQuery, GetFhirDnaVisitAndZrtTestsQueryVariables>;
export const GetFhirMyPatientTestsDocument = gql`
    query GetFHIRMyPatientTests($limit: Int = 10, $offset: Int = 0, $from: String, $to: String, $testType: [Hasura_Test_Types_Enum!], $state: [Hasura_Dnavisit_Test_Statuses_Enum!], $patientCodexId: String, $providerName: [String!], $orderBy: DiagnosticReportOrderByInput, $find: String, $hasAppointment: Boolean) {
  getFHIRDnaAndZrtTests(
    to: $to
    testType: $testType
    state: $state
    limit: $limit
    offset: $offset
    from: $from
    patientCodexId: $patientCodexId
    providerName: $providerName
    orderBy: $orderBy
    find: $find
    hasAppointment: $hasAppointment
  ) {
    dna_tests {
      diagnosticReportId
      visit_summary_pdf_id
      test_id
      created_at
      test_type
      rank
      sapphiros_barcode
      provider_name
      state
      created_at
      updated_at
      provider_acuity_owner_id
      provider_acuity_calendar_id
      provider_report_pdf_id
      provider_codex_id
      questionnaire_required
    }
    zrt_tests {
      appointment_codex_id
      fhirId
      reference_code
      created_at
      test_type
      rank
      swab_code
      provider_name
      state
      provider_report_pdf_id
      created_at
      updated_at
      provider_acuity_owner_id
      provider_acuity_calendar_id
      provider_codex_id
      questionnaire_required
    }
    mosaic_tests {
      appointment_codex_id
      created_at
      fhirId
      patient_fhir_id
      provider_acuity_calendar_id
      provider_acuity_owner_id
      provider_codex_id
      provider_fhir_id
      provider_name
      provider_report_pdf_id
      questionnaire_required
      rank
      state
      swab_code
      test_id
      test_type
      tracking_number
      updated_at
    }
    diagnostic_solution_tests {
      appointment_codex_id
      created_at
      fhirId
      patient_fhir_id
      provider_acuity_calendar_id
      provider_acuity_owner_id
      provider_codex_id
      provider_fhir_id
      provider_name
      provider_report_pdf_id
      rank
      state
      swab_code
      test_id
      test_type
      tracking_number
      updated_at
      questionnaire_required
    }
    total
  }
}
    `;

/**
 * __useGetFhirMyPatientTestsQuery__
 *
 * To run a query within a React component, call `useGetFhirMyPatientTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirMyPatientTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirMyPatientTestsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      testType: // value for 'testType'
 *      state: // value for 'state'
 *      patientCodexId: // value for 'patientCodexId'
 *      providerName: // value for 'providerName'
 *      orderBy: // value for 'orderBy'
 *      find: // value for 'find'
 *      hasAppointment: // value for 'hasAppointment'
 *   },
 * });
 */
export function useGetFhirMyPatientTestsQuery(baseOptions?: Apollo.QueryHookOptions<GetFhirMyPatientTestsQuery, GetFhirMyPatientTestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirMyPatientTestsQuery, GetFhirMyPatientTestsQueryVariables>(GetFhirMyPatientTestsDocument, options);
      }
export function useGetFhirMyPatientTestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirMyPatientTestsQuery, GetFhirMyPatientTestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirMyPatientTestsQuery, GetFhirMyPatientTestsQueryVariables>(GetFhirMyPatientTestsDocument, options);
        }
export type GetFhirMyPatientTestsQueryHookResult = ReturnType<typeof useGetFhirMyPatientTestsQuery>;
export type GetFhirMyPatientTestsLazyQueryHookResult = ReturnType<typeof useGetFhirMyPatientTestsLazyQuery>;
export type GetFhirMyPatientTestsQueryResult = Apollo.QueryResult<GetFhirMyPatientTestsQuery, GetFhirMyPatientTestsQueryVariables>;
export const GetFhirDnaVisitTestsByUserIdDocument = gql`
    query GetFHIRDnaVisitTestsByUserId($limit: Int = 10, $offset: Int = 0, $from: String, $providerName: String, $find: String, $to: String, $codexPatientId: String!, $testType: [Hasura_Test_Types_Enum!], $orderBy: DnaVisitOrderByInput) {
  getFHIRDnaVisitTestsByUserId(
    to: $to
    testType: $testType
    codexPatientId: $codexPatientId
    providerName: $providerName
    find: $find
    limit: $limit
    from: $from
    offset: $offset
    orderBy: $orderBy
  ) {
    dnavisit_tests {
      test_id
      created_at
      test_type
      sapphiros_barcode
      provider_name
      state
      tracking_number
      visit_summary_pdf_id
      patient_pdf_id
    }
    total
    providers
  }
}
    `;

/**
 * __useGetFhirDnaVisitTestsByUserIdQuery__
 *
 * To run a query within a React component, call `useGetFhirDnaVisitTestsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirDnaVisitTestsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirDnaVisitTestsByUserIdQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      from: // value for 'from'
 *      providerName: // value for 'providerName'
 *      find: // value for 'find'
 *      to: // value for 'to'
 *      codexPatientId: // value for 'codexPatientId'
 *      testType: // value for 'testType'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetFhirDnaVisitTestsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetFhirDnaVisitTestsByUserIdQuery, GetFhirDnaVisitTestsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirDnaVisitTestsByUserIdQuery, GetFhirDnaVisitTestsByUserIdQueryVariables>(GetFhirDnaVisitTestsByUserIdDocument, options);
      }
export function useGetFhirDnaVisitTestsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirDnaVisitTestsByUserIdQuery, GetFhirDnaVisitTestsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirDnaVisitTestsByUserIdQuery, GetFhirDnaVisitTestsByUserIdQueryVariables>(GetFhirDnaVisitTestsByUserIdDocument, options);
        }
export type GetFhirDnaVisitTestsByUserIdQueryHookResult = ReturnType<typeof useGetFhirDnaVisitTestsByUserIdQuery>;
export type GetFhirDnaVisitTestsByUserIdLazyQueryHookResult = ReturnType<typeof useGetFhirDnaVisitTestsByUserIdLazyQuery>;
export type GetFhirDnaVisitTestsByUserIdQueryResult = Apollo.QueryResult<GetFhirDnaVisitTestsByUserIdQuery, GetFhirDnaVisitTestsByUserIdQueryVariables>;
export const GetActiveRecommendationsByPatientCodexIdDocument = gql`
    query GetActiveRecommendationsByPatientCodexId($codexPatientId: String!, $limit: Int!, $offset: Int!, $orderBy: GetFHIRRecommendationsOrderByInput = {}) {
  getActiveRecommendationsByPatientCodexId(
    codexPatientId: $codexPatientId
    limit: $limit
    offset: $offset
    orderBy: $orderBy
  ) {
    recommendations {
      createdAt
      id
      productTitle
      providerName
      quantity
    }
    total
  }
}
    `;

/**
 * __useGetActiveRecommendationsByPatientCodexIdQuery__
 *
 * To run a query within a React component, call `useGetActiveRecommendationsByPatientCodexIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveRecommendationsByPatientCodexIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveRecommendationsByPatientCodexIdQuery({
 *   variables: {
 *      codexPatientId: // value for 'codexPatientId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetActiveRecommendationsByPatientCodexIdQuery(baseOptions: Apollo.QueryHookOptions<GetActiveRecommendationsByPatientCodexIdQuery, GetActiveRecommendationsByPatientCodexIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveRecommendationsByPatientCodexIdQuery, GetActiveRecommendationsByPatientCodexIdQueryVariables>(GetActiveRecommendationsByPatientCodexIdDocument, options);
      }
export function useGetActiveRecommendationsByPatientCodexIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveRecommendationsByPatientCodexIdQuery, GetActiveRecommendationsByPatientCodexIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveRecommendationsByPatientCodexIdQuery, GetActiveRecommendationsByPatientCodexIdQueryVariables>(GetActiveRecommendationsByPatientCodexIdDocument, options);
        }
export type GetActiveRecommendationsByPatientCodexIdQueryHookResult = ReturnType<typeof useGetActiveRecommendationsByPatientCodexIdQuery>;
export type GetActiveRecommendationsByPatientCodexIdLazyQueryHookResult = ReturnType<typeof useGetActiveRecommendationsByPatientCodexIdLazyQuery>;
export type GetActiveRecommendationsByPatientCodexIdQueryResult = Apollo.QueryResult<GetActiveRecommendationsByPatientCodexIdQuery, GetActiveRecommendationsByPatientCodexIdQueryVariables>;
export const LinkFullscriptProviderAccountDocument = gql`
    mutation LinkFullscriptProviderAccount($tokenCode: String!) {
  linkProviderAccount(linkProviderAccountInput: {tokenCode: $tokenCode}) {
    success
  }
}
    `;
export type LinkFullscriptProviderAccountMutationFn = Apollo.MutationFunction<LinkFullscriptProviderAccountMutation, LinkFullscriptProviderAccountMutationVariables>;

/**
 * __useLinkFullscriptProviderAccountMutation__
 *
 * To run a mutation, you first call `useLinkFullscriptProviderAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkFullscriptProviderAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkFullscriptProviderAccountMutation, { data, loading, error }] = useLinkFullscriptProviderAccountMutation({
 *   variables: {
 *      tokenCode: // value for 'tokenCode'
 *   },
 * });
 */
export function useLinkFullscriptProviderAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkFullscriptProviderAccountMutation, LinkFullscriptProviderAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkFullscriptProviderAccountMutation, LinkFullscriptProviderAccountMutationVariables>(LinkFullscriptProviderAccountDocument, options);
      }
export type LinkFullscriptProviderAccountMutationHookResult = ReturnType<typeof useLinkFullscriptProviderAccountMutation>;
export type LinkFullscriptProviderAccountMutationResult = Apollo.MutationResult<LinkFullscriptProviderAccountMutation>;
export type LinkFullscriptProviderAccountMutationOptions = Apollo.BaseMutationOptions<LinkFullscriptProviderAccountMutation, LinkFullscriptProviderAccountMutationVariables>;
export const OnTreatmentPlanActivatedDocument = gql`
    mutation onTreatmentPlanActivated($patientCodexId: String!, $treatmentPlanId: String!, $appointmentCodexId: String) {
  onTreatmentPlanActivated(
    onTreatmentPlanActivatedInput: {patientCodexId: $patientCodexId, treatmentPlanId: $treatmentPlanId, appointmentCodexId: $appointmentCodexId}
  ) {
    success
  }
}
    `;
export type OnTreatmentPlanActivatedMutationFn = Apollo.MutationFunction<OnTreatmentPlanActivatedMutation, OnTreatmentPlanActivatedMutationVariables>;

/**
 * __useOnTreatmentPlanActivatedMutation__
 *
 * To run a mutation, you first call `useOnTreatmentPlanActivatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnTreatmentPlanActivatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onTreatmentPlanActivatedMutation, { data, loading, error }] = useOnTreatmentPlanActivatedMutation({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *      treatmentPlanId: // value for 'treatmentPlanId'
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *   },
 * });
 */
export function useOnTreatmentPlanActivatedMutation(baseOptions?: Apollo.MutationHookOptions<OnTreatmentPlanActivatedMutation, OnTreatmentPlanActivatedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnTreatmentPlanActivatedMutation, OnTreatmentPlanActivatedMutationVariables>(OnTreatmentPlanActivatedDocument, options);
      }
export type OnTreatmentPlanActivatedMutationHookResult = ReturnType<typeof useOnTreatmentPlanActivatedMutation>;
export type OnTreatmentPlanActivatedMutationResult = Apollo.MutationResult<OnTreatmentPlanActivatedMutation>;
export type OnTreatmentPlanActivatedMutationOptions = Apollo.BaseMutationOptions<OnTreatmentPlanActivatedMutation, OnTreatmentPlanActivatedMutationVariables>;
export const FullscriptDependentMapDocument = gql`
    mutation FullscriptDependentMap($childCodexId: String!, $fullscriptPatientId: String!) {
  fullscriptDependentMap(
    input: {childCodexId: $childCodexId, fullscriptPatientId: $fullscriptPatientId}
  ) {
    message
    success
  }
}
    `;
export type FullscriptDependentMapMutationFn = Apollo.MutationFunction<FullscriptDependentMapMutation, FullscriptDependentMapMutationVariables>;

/**
 * __useFullscriptDependentMapMutation__
 *
 * To run a mutation, you first call `useFullscriptDependentMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullscriptDependentMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullscriptDependentMapMutation, { data, loading, error }] = useFullscriptDependentMapMutation({
 *   variables: {
 *      childCodexId: // value for 'childCodexId'
 *      fullscriptPatientId: // value for 'fullscriptPatientId'
 *   },
 * });
 */
export function useFullscriptDependentMapMutation(baseOptions?: Apollo.MutationHookOptions<FullscriptDependentMapMutation, FullscriptDependentMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullscriptDependentMapMutation, FullscriptDependentMapMutationVariables>(FullscriptDependentMapDocument, options);
      }
export type FullscriptDependentMapMutationHookResult = ReturnType<typeof useFullscriptDependentMapMutation>;
export type FullscriptDependentMapMutationResult = Apollo.MutationResult<FullscriptDependentMapMutation>;
export type FullscriptDependentMapMutationOptions = Apollo.BaseMutationOptions<FullscriptDependentMapMutation, FullscriptDependentMapMutationVariables>;
export const UnlinkProviderFullscriptAccountDocument = gql`
    mutation UnlinkProviderFullscriptAccount {
  unlinkFullscript {
    update_providers_one {
      id
      fullscriptId
    }
  }
}
    `;
export type UnlinkProviderFullscriptAccountMutationFn = Apollo.MutationFunction<UnlinkProviderFullscriptAccountMutation, UnlinkProviderFullscriptAccountMutationVariables>;

/**
 * __useUnlinkProviderFullscriptAccountMutation__
 *
 * To run a mutation, you first call `useUnlinkProviderFullscriptAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkProviderFullscriptAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkProviderFullscriptAccountMutation, { data, loading, error }] = useUnlinkProviderFullscriptAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnlinkProviderFullscriptAccountMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkProviderFullscriptAccountMutation, UnlinkProviderFullscriptAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkProviderFullscriptAccountMutation, UnlinkProviderFullscriptAccountMutationVariables>(UnlinkProviderFullscriptAccountDocument, options);
      }
export type UnlinkProviderFullscriptAccountMutationHookResult = ReturnType<typeof useUnlinkProviderFullscriptAccountMutation>;
export type UnlinkProviderFullscriptAccountMutationResult = Apollo.MutationResult<UnlinkProviderFullscriptAccountMutation>;
export type UnlinkProviderFullscriptAccountMutationOptions = Apollo.BaseMutationOptions<UnlinkProviderFullscriptAccountMutation, UnlinkProviderFullscriptAccountMutationVariables>;
export const GetFullscriptSessionGrantDocument = gql`
    query GetFullscriptSessionGrant($patientCodexId: String!) {
  getSessionGrant(patientCodexId: $patientCodexId) {
    sessionGrant
    patientFullscriptId
  }
}
    `;

/**
 * __useGetFullscriptSessionGrantQuery__
 *
 * To run a query within a React component, call `useGetFullscriptSessionGrantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullscriptSessionGrantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullscriptSessionGrantQuery({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *   },
 * });
 */
export function useGetFullscriptSessionGrantQuery(baseOptions: Apollo.QueryHookOptions<GetFullscriptSessionGrantQuery, GetFullscriptSessionGrantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullscriptSessionGrantQuery, GetFullscriptSessionGrantQueryVariables>(GetFullscriptSessionGrantDocument, options);
      }
export function useGetFullscriptSessionGrantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullscriptSessionGrantQuery, GetFullscriptSessionGrantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullscriptSessionGrantQuery, GetFullscriptSessionGrantQueryVariables>(GetFullscriptSessionGrantDocument, options);
        }
export type GetFullscriptSessionGrantQueryHookResult = ReturnType<typeof useGetFullscriptSessionGrantQuery>;
export type GetFullscriptSessionGrantLazyQueryHookResult = ReturnType<typeof useGetFullscriptSessionGrantLazyQuery>;
export type GetFullscriptSessionGrantQueryResult = Apollo.QueryResult<GetFullscriptSessionGrantQuery, GetFullscriptSessionGrantQueryVariables>;
export const FullscriptDependentCreateLinkDocument = gql`
    query FullscriptDependentCreateLink($childCodexId: String!) {
  fullscriptDependentCreateLink(input: {childCodexId: $childCodexId}) {
    childFullscriptId
    guardianFullscriptId
  }
}
    `;

/**
 * __useFullscriptDependentCreateLinkQuery__
 *
 * To run a query within a React component, call `useFullscriptDependentCreateLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullscriptDependentCreateLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullscriptDependentCreateLinkQuery({
 *   variables: {
 *      childCodexId: // value for 'childCodexId'
 *   },
 * });
 */
export function useFullscriptDependentCreateLinkQuery(baseOptions: Apollo.QueryHookOptions<FullscriptDependentCreateLinkQuery, FullscriptDependentCreateLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FullscriptDependentCreateLinkQuery, FullscriptDependentCreateLinkQueryVariables>(FullscriptDependentCreateLinkDocument, options);
      }
export function useFullscriptDependentCreateLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FullscriptDependentCreateLinkQuery, FullscriptDependentCreateLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FullscriptDependentCreateLinkQuery, FullscriptDependentCreateLinkQueryVariables>(FullscriptDependentCreateLinkDocument, options);
        }
export type FullscriptDependentCreateLinkQueryHookResult = ReturnType<typeof useFullscriptDependentCreateLinkQuery>;
export type FullscriptDependentCreateLinkLazyQueryHookResult = ReturnType<typeof useFullscriptDependentCreateLinkLazyQuery>;
export type FullscriptDependentCreateLinkQueryResult = Apollo.QueryResult<FullscriptDependentCreateLinkQuery, FullscriptDependentCreateLinkQueryVariables>;
export const GetAllFullscriptAllergensDocument = gql`
    query GetAllFullscriptAllergens($limit: Int = 10, $offset: Int = 0, $search: String) {
  getFullscriptAllergens(limit: $limit, search: $search, offset: $offset) {
    total
    fullscript_allergens {
      created_at
      fullscript_id
      fullscript_name
      id
      updated_at
    }
  }
}
    `;

/**
 * __useGetAllFullscriptAllergensQuery__
 *
 * To run a query within a React component, call `useGetAllFullscriptAllergensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFullscriptAllergensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFullscriptAllergensQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAllFullscriptAllergensQuery(baseOptions?: Apollo.QueryHookOptions<GetAllFullscriptAllergensQuery, GetAllFullscriptAllergensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFullscriptAllergensQuery, GetAllFullscriptAllergensQueryVariables>(GetAllFullscriptAllergensDocument, options);
      }
export function useGetAllFullscriptAllergensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFullscriptAllergensQuery, GetAllFullscriptAllergensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFullscriptAllergensQuery, GetAllFullscriptAllergensQueryVariables>(GetAllFullscriptAllergensDocument, options);
        }
export type GetAllFullscriptAllergensQueryHookResult = ReturnType<typeof useGetAllFullscriptAllergensQuery>;
export type GetAllFullscriptAllergensLazyQueryHookResult = ReturnType<typeof useGetAllFullscriptAllergensLazyQuery>;
export type GetAllFullscriptAllergensQueryResult = Apollo.QueryResult<GetAllFullscriptAllergensQuery, GetAllFullscriptAllergensQueryVariables>;
export const GetFullscriptAllergensByPatientHealthQuestionnaireDocument = gql`
    query getFullscriptAllergensByPatientHealthQuestionnaire($codexPatientId: String!, $identifier: String!, $system: String!) {
  getFullscriptAllergensFromQuestionnaireResponse(
    codexPatientId: $codexPatientId
    identifier: $identifier
    system: $system
  ) {
    fullscript_allergens {
      created_at
      fullscript_id
      fullscript_name
      id
      updated_at
    }
    total
  }
}
    `;

/**
 * __useGetFullscriptAllergensByPatientHealthQuestionnaireQuery__
 *
 * To run a query within a React component, call `useGetFullscriptAllergensByPatientHealthQuestionnaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullscriptAllergensByPatientHealthQuestionnaireQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullscriptAllergensByPatientHealthQuestionnaireQuery({
 *   variables: {
 *      codexPatientId: // value for 'codexPatientId'
 *      identifier: // value for 'identifier'
 *      system: // value for 'system'
 *   },
 * });
 */
export function useGetFullscriptAllergensByPatientHealthQuestionnaireQuery(baseOptions: Apollo.QueryHookOptions<GetFullscriptAllergensByPatientHealthQuestionnaireQuery, GetFullscriptAllergensByPatientHealthQuestionnaireQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullscriptAllergensByPatientHealthQuestionnaireQuery, GetFullscriptAllergensByPatientHealthQuestionnaireQueryVariables>(GetFullscriptAllergensByPatientHealthQuestionnaireDocument, options);
      }
export function useGetFullscriptAllergensByPatientHealthQuestionnaireLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullscriptAllergensByPatientHealthQuestionnaireQuery, GetFullscriptAllergensByPatientHealthQuestionnaireQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullscriptAllergensByPatientHealthQuestionnaireQuery, GetFullscriptAllergensByPatientHealthQuestionnaireQueryVariables>(GetFullscriptAllergensByPatientHealthQuestionnaireDocument, options);
        }
export type GetFullscriptAllergensByPatientHealthQuestionnaireQueryHookResult = ReturnType<typeof useGetFullscriptAllergensByPatientHealthQuestionnaireQuery>;
export type GetFullscriptAllergensByPatientHealthQuestionnaireLazyQueryHookResult = ReturnType<typeof useGetFullscriptAllergensByPatientHealthQuestionnaireLazyQuery>;
export type GetFullscriptAllergensByPatientHealthQuestionnaireQueryResult = Apollo.QueryResult<GetFullscriptAllergensByPatientHealthQuestionnaireQuery, GetFullscriptAllergensByPatientHealthQuestionnaireQueryVariables>;
export const GetFhirPatientMediaDocument = gql`
    query getFHIRPatientMedia($limit: Int = 10, $from: String, $to: String, $sort: Float) {
  getFHIRMediaByRequestPatientCodexID(
    limit: $limit
    from: $from
    to: $to
    sort: $sort
  ) {
    total
    media {
      id
      fileId
      bodySite {
        coding {
          code
        }
      }
      content {
        url
      }
      meta {
        lastUpdated
      }
      identifier {
        type {
          text
        }
        value
      }
      description
    }
  }
}
    `;

/**
 * __useGetFhirPatientMediaQuery__
 *
 * To run a query within a React component, call `useGetFhirPatientMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirPatientMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirPatientMediaQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetFhirPatientMediaQuery(baseOptions?: Apollo.QueryHookOptions<GetFhirPatientMediaQuery, GetFhirPatientMediaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirPatientMediaQuery, GetFhirPatientMediaQueryVariables>(GetFhirPatientMediaDocument, options);
      }
export function useGetFhirPatientMediaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirPatientMediaQuery, GetFhirPatientMediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirPatientMediaQuery, GetFhirPatientMediaQueryVariables>(GetFhirPatientMediaDocument, options);
        }
export type GetFhirPatientMediaQueryHookResult = ReturnType<typeof useGetFhirPatientMediaQuery>;
export type GetFhirPatientMediaLazyQueryHookResult = ReturnType<typeof useGetFhirPatientMediaLazyQuery>;
export type GetFhirPatientMediaQueryResult = Apollo.QueryResult<GetFhirPatientMediaQuery, GetFhirPatientMediaQueryVariables>;
export const GetFhirPatientbyMediaCodexIdParameterDocument = gql`
    query GetFHIRPatientbyMediaCodexIDParameter($patientCodexId: String!, $limit: Int = 10, $from: String, $to: String, $type: String, $sort: Float) {
  getFHIRPatientbyMediaCodexIDParameter(
    patientCodexId: $patientCodexId
    limit: $limit
    from: $from
    to: $to
    sort: $sort
  ) {
    patientCodexId
    media {
      id
      fileId
      description
      bodySite {
        coding {
          code
        }
      }
      content {
        url
      }
      meta {
        lastUpdated
      }
      identifier {
        type {
          text
        }
        value
      }
    }
    total
  }
}
    `;

/**
 * __useGetFhirPatientbyMediaCodexIdParameterQuery__
 *
 * To run a query within a React component, call `useGetFhirPatientbyMediaCodexIdParameterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirPatientbyMediaCodexIdParameterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirPatientbyMediaCodexIdParameterQuery({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *      limit: // value for 'limit'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      type: // value for 'type'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetFhirPatientbyMediaCodexIdParameterQuery(baseOptions: Apollo.QueryHookOptions<GetFhirPatientbyMediaCodexIdParameterQuery, GetFhirPatientbyMediaCodexIdParameterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirPatientbyMediaCodexIdParameterQuery, GetFhirPatientbyMediaCodexIdParameterQueryVariables>(GetFhirPatientbyMediaCodexIdParameterDocument, options);
      }
export function useGetFhirPatientbyMediaCodexIdParameterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirPatientbyMediaCodexIdParameterQuery, GetFhirPatientbyMediaCodexIdParameterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirPatientbyMediaCodexIdParameterQuery, GetFhirPatientbyMediaCodexIdParameterQueryVariables>(GetFhirPatientbyMediaCodexIdParameterDocument, options);
        }
export type GetFhirPatientbyMediaCodexIdParameterQueryHookResult = ReturnType<typeof useGetFhirPatientbyMediaCodexIdParameterQuery>;
export type GetFhirPatientbyMediaCodexIdParameterLazyQueryHookResult = ReturnType<typeof useGetFhirPatientbyMediaCodexIdParameterLazyQuery>;
export type GetFhirPatientbyMediaCodexIdParameterQueryResult = Apollo.QueryResult<GetFhirPatientbyMediaCodexIdParameterQuery, GetFhirPatientbyMediaCodexIdParameterQueryVariables>;
export const GetFhirMedicationRequestListDocument = gql`
    query getFHIRMedicationRequestList($limit: Int, $offset: Int, $sort: String, $sortDirection: Float, $from: String, $to: String, $find: String, $brandAndName: String, $providerId: String, $patientCodexId: String!, $encounterId: String, $source: [MedicationRequestSource!], $includeSubPatients: Boolean = false) {
  getFHIRMedicationRequestByPatientCodexId(
    limit: $limit
    offset: $offset
    sort: $sort
    source: $source
    sortDirection: $sortDirection
    from: $from
    to: $to
    find: $find
    brandAndName: $brandAndName
    providerId: $providerId
    patientCodexId: $patientCodexId
    encounterId: $encounterId
    includeSubPatients: $includeSubPatients
  ) {
    medication_requests {
      patientInfo {
        firstName
        id
        isChild
        lastName
      }
      quantity {
        unit
        value
      }
      pharmacyName
      frequency
      initialFill {
        duration {
          unit
          value
        }
        quantity {
          unit
          value
        }
      }
      appointmentCodexId
      brandName
      daysSupply
      delivery
      directions
      displayName
      dosage
      effectiveDate
      expectedSupplyDuration {
        unit
        value
      }
      fullScriptVariantId
      fullScriptVariantSKU
      isOTC
      mediSpanClassification
      mediSpanId
      ndc
      note
      duration
      productNotes
      takeWith
      numberOfRepeatsAllowed
      patientCodexId
      prescriptionFhirId
      prescriptionFullScriptId
      providerCodexId
      providerFullName
      requestedAt
      rxcui
      status
      substitutionAllowed
      type
    }
    total
  }
}
    `;

/**
 * __useGetFhirMedicationRequestListQuery__
 *
 * To run a query within a React component, call `useGetFhirMedicationRequestListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirMedicationRequestListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirMedicationRequestListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      sortDirection: // value for 'sortDirection'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      find: // value for 'find'
 *      brandAndName: // value for 'brandAndName'
 *      providerId: // value for 'providerId'
 *      patientCodexId: // value for 'patientCodexId'
 *      encounterId: // value for 'encounterId'
 *      source: // value for 'source'
 *      includeSubPatients: // value for 'includeSubPatients'
 *   },
 * });
 */
export function useGetFhirMedicationRequestListQuery(baseOptions: Apollo.QueryHookOptions<GetFhirMedicationRequestListQuery, GetFhirMedicationRequestListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirMedicationRequestListQuery, GetFhirMedicationRequestListQueryVariables>(GetFhirMedicationRequestListDocument, options);
      }
export function useGetFhirMedicationRequestListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirMedicationRequestListQuery, GetFhirMedicationRequestListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirMedicationRequestListQuery, GetFhirMedicationRequestListQueryVariables>(GetFhirMedicationRequestListDocument, options);
        }
export type GetFhirMedicationRequestListQueryHookResult = ReturnType<typeof useGetFhirMedicationRequestListQuery>;
export type GetFhirMedicationRequestListLazyQueryHookResult = ReturnType<typeof useGetFhirMedicationRequestListLazyQuery>;
export type GetFhirMedicationRequestListQueryResult = Apollo.QueryResult<GetFhirMedicationRequestListQuery, GetFhirMedicationRequestListQueryVariables>;
export const GetTotalFhirMedicationRequestListDocument = gql`
    query getTotalFHIRMedicationRequestList($patientCodexId: String!) {
  getFHIRMedicationRequestByPatientCodexId(
    patientCodexId: $patientCodexId
    limit: 1
    offset: 0
  ) {
    total
  }
}
    `;

/**
 * __useGetTotalFhirMedicationRequestListQuery__
 *
 * To run a query within a React component, call `useGetTotalFhirMedicationRequestListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalFhirMedicationRequestListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalFhirMedicationRequestListQuery({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *   },
 * });
 */
export function useGetTotalFhirMedicationRequestListQuery(baseOptions: Apollo.QueryHookOptions<GetTotalFhirMedicationRequestListQuery, GetTotalFhirMedicationRequestListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotalFhirMedicationRequestListQuery, GetTotalFhirMedicationRequestListQueryVariables>(GetTotalFhirMedicationRequestListDocument, options);
      }
export function useGetTotalFhirMedicationRequestListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotalFhirMedicationRequestListQuery, GetTotalFhirMedicationRequestListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotalFhirMedicationRequestListQuery, GetTotalFhirMedicationRequestListQueryVariables>(GetTotalFhirMedicationRequestListDocument, options);
        }
export type GetTotalFhirMedicationRequestListQueryHookResult = ReturnType<typeof useGetTotalFhirMedicationRequestListQuery>;
export type GetTotalFhirMedicationRequestListLazyQueryHookResult = ReturnType<typeof useGetTotalFhirMedicationRequestListLazyQuery>;
export type GetTotalFhirMedicationRequestListQueryResult = Apollo.QueryResult<GetTotalFhirMedicationRequestListQuery, GetTotalFhirMedicationRequestListQueryVariables>;
export const GetFhirMedicationRequestBranAndNamesByPatientCodexIdDocument = gql`
    query GetFHIRMedicationRequestBranAndNamesByPatientCodexId($patientCodexId: String) {
  getFHIRMedicationRequestBranAndNamesByPatientCodexId(
    patientCodexId: $patientCodexId
  ) {
    medication_request_bran_and_names
  }
}
    `;

/**
 * __useGetFhirMedicationRequestBranAndNamesByPatientCodexIdQuery__
 *
 * To run a query within a React component, call `useGetFhirMedicationRequestBranAndNamesByPatientCodexIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirMedicationRequestBranAndNamesByPatientCodexIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirMedicationRequestBranAndNamesByPatientCodexIdQuery({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *   },
 * });
 */
export function useGetFhirMedicationRequestBranAndNamesByPatientCodexIdQuery(baseOptions?: Apollo.QueryHookOptions<GetFhirMedicationRequestBranAndNamesByPatientCodexIdQuery, GetFhirMedicationRequestBranAndNamesByPatientCodexIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirMedicationRequestBranAndNamesByPatientCodexIdQuery, GetFhirMedicationRequestBranAndNamesByPatientCodexIdQueryVariables>(GetFhirMedicationRequestBranAndNamesByPatientCodexIdDocument, options);
      }
export function useGetFhirMedicationRequestBranAndNamesByPatientCodexIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirMedicationRequestBranAndNamesByPatientCodexIdQuery, GetFhirMedicationRequestBranAndNamesByPatientCodexIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirMedicationRequestBranAndNamesByPatientCodexIdQuery, GetFhirMedicationRequestBranAndNamesByPatientCodexIdQueryVariables>(GetFhirMedicationRequestBranAndNamesByPatientCodexIdDocument, options);
        }
export type GetFhirMedicationRequestBranAndNamesByPatientCodexIdQueryHookResult = ReturnType<typeof useGetFhirMedicationRequestBranAndNamesByPatientCodexIdQuery>;
export type GetFhirMedicationRequestBranAndNamesByPatientCodexIdLazyQueryHookResult = ReturnType<typeof useGetFhirMedicationRequestBranAndNamesByPatientCodexIdLazyQuery>;
export type GetFhirMedicationRequestBranAndNamesByPatientCodexIdQueryResult = Apollo.QueryResult<GetFhirMedicationRequestBranAndNamesByPatientCodexIdQuery, GetFhirMedicationRequestBranAndNamesByPatientCodexIdQueryVariables>;
export const GetMedicationByProfileTabPatientCodexIdDocument = gql`
    query GetMedicationByProfileTabPatientCodexId($patientCodexId: String!, $search: String, $to: String, $from: String, $includeSubPatients: Boolean = false, $offset: Int!, $limit: Int = 10) {
  getFHIRMedicationRequestByPatientCodexId(
    patientCodexId: $patientCodexId
    find: $search
    offset: $offset
    to: $to
    from: $from
    includeSubPatients: $includeSubPatients
    limit: $limit
    source: VERADIGM
    sort: "date"
    sortDirection: -1
  ) {
    medication_requests {
      note
      dosage
      ndc
      rxcui
      displayName
      activeIngredUnit
      appointmentCodexId
      providerCodexId
      prescriptionFhirId
      pharmacyAddress
      patientInfo {
        id
      }
      quantity {
        unit
        value
      }
      expectedSupplyDuration {
        unit
        value
      }
      patientInfo {
        firstName
        isChild
        lastName
        id
      }
      providerFullName
      effectiveDate
      daysSupply
      activeNumeratorStrength
      requestedAt
    }
    total
  }
}
    `;

/**
 * __useGetMedicationByProfileTabPatientCodexIdQuery__
 *
 * To run a query within a React component, call `useGetMedicationByProfileTabPatientCodexIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMedicationByProfileTabPatientCodexIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMedicationByProfileTabPatientCodexIdQuery({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *      search: // value for 'search'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      includeSubPatients: // value for 'includeSubPatients'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMedicationByProfileTabPatientCodexIdQuery(baseOptions: Apollo.QueryHookOptions<GetMedicationByProfileTabPatientCodexIdQuery, GetMedicationByProfileTabPatientCodexIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMedicationByProfileTabPatientCodexIdQuery, GetMedicationByProfileTabPatientCodexIdQueryVariables>(GetMedicationByProfileTabPatientCodexIdDocument, options);
      }
export function useGetMedicationByProfileTabPatientCodexIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMedicationByProfileTabPatientCodexIdQuery, GetMedicationByProfileTabPatientCodexIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMedicationByProfileTabPatientCodexIdQuery, GetMedicationByProfileTabPatientCodexIdQueryVariables>(GetMedicationByProfileTabPatientCodexIdDocument, options);
        }
export type GetMedicationByProfileTabPatientCodexIdQueryHookResult = ReturnType<typeof useGetMedicationByProfileTabPatientCodexIdQuery>;
export type GetMedicationByProfileTabPatientCodexIdLazyQueryHookResult = ReturnType<typeof useGetMedicationByProfileTabPatientCodexIdLazyQuery>;
export type GetMedicationByProfileTabPatientCodexIdQueryResult = Apollo.QueryResult<GetMedicationByProfileTabPatientCodexIdQuery, GetMedicationByProfileTabPatientCodexIdQueryVariables>;
export const GetMedicationByHealthQuestionnairePatientCodexIdDocument = gql`
    query GetMedicationByHealthQuestionnairePatientCodexId($patientCodexId: String!, $search: String) {
  getFHIRMedicationRequestByPatientCodexId(
    patientCodexId: $patientCodexId
    find: $search
    statuses: active
    source: SELF_REPORTED
    offset: 0
  ) {
    medication_requests {
      note
      frequency
      dosage
      duration
      ndc
      displayName
      requestedAt
      effectiveDate
      endDate
      patientInfo {
        firstName
        isChild
        lastName
        id
      }
    }
  }
}
    `;

/**
 * __useGetMedicationByHealthQuestionnairePatientCodexIdQuery__
 *
 * To run a query within a React component, call `useGetMedicationByHealthQuestionnairePatientCodexIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMedicationByHealthQuestionnairePatientCodexIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMedicationByHealthQuestionnairePatientCodexIdQuery({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMedicationByHealthQuestionnairePatientCodexIdQuery(baseOptions: Apollo.QueryHookOptions<GetMedicationByHealthQuestionnairePatientCodexIdQuery, GetMedicationByHealthQuestionnairePatientCodexIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMedicationByHealthQuestionnairePatientCodexIdQuery, GetMedicationByHealthQuestionnairePatientCodexIdQueryVariables>(GetMedicationByHealthQuestionnairePatientCodexIdDocument, options);
      }
export function useGetMedicationByHealthQuestionnairePatientCodexIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMedicationByHealthQuestionnairePatientCodexIdQuery, GetMedicationByHealthQuestionnairePatientCodexIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMedicationByHealthQuestionnairePatientCodexIdQuery, GetMedicationByHealthQuestionnairePatientCodexIdQueryVariables>(GetMedicationByHealthQuestionnairePatientCodexIdDocument, options);
        }
export type GetMedicationByHealthQuestionnairePatientCodexIdQueryHookResult = ReturnType<typeof useGetMedicationByHealthQuestionnairePatientCodexIdQuery>;
export type GetMedicationByHealthQuestionnairePatientCodexIdLazyQueryHookResult = ReturnType<typeof useGetMedicationByHealthQuestionnairePatientCodexIdLazyQuery>;
export type GetMedicationByHealthQuestionnairePatientCodexIdQueryResult = Apollo.QueryResult<GetMedicationByHealthQuestionnairePatientCodexIdQuery, GetMedicationByHealthQuestionnairePatientCodexIdQueryVariables>;
export const GetAllergenClassesDocument = gql`
    query GetAllergenClasses($limit: Int = 10, $offset: Int = 0, $search: String) {
  getAllergenClasses(search: $search, offset: $offset, limit: $limit) {
    allergenClasses {
      classId
      className
    }
  }
}
    `;

/**
 * __useGetAllergenClassesQuery__
 *
 * To run a query within a React component, call `useGetAllergenClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllergenClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllergenClassesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAllergenClassesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllergenClassesQuery, GetAllergenClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllergenClassesQuery, GetAllergenClassesQueryVariables>(GetAllergenClassesDocument, options);
      }
export function useGetAllergenClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllergenClassesQuery, GetAllergenClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllergenClassesQuery, GetAllergenClassesQueryVariables>(GetAllergenClassesDocument, options);
        }
export type GetAllergenClassesQueryHookResult = ReturnType<typeof useGetAllergenClassesQuery>;
export type GetAllergenClassesLazyQueryHookResult = ReturnType<typeof useGetAllergenClassesLazyQuery>;
export type GetAllergenClassesQueryResult = Apollo.QueryResult<GetAllergenClassesQuery, GetAllergenClassesQueryVariables>;
export const PatchFhirPatientPersonalDataDocument = gql`
    mutation PatchFHIRPatientPersonalData($patientPersonalInfo: PatchFHIRPatientPersonalInfoInput!) {
  patchFHIRPatientPersonalData(patientPersonalInfo: $patientPersonalInfo) {
    update_patients_one {
      SENSITIVE_address_information {
        address1
        address2
        city
        country
        state
        province
        zipCode
        phone
        phoneCountry
      }
      SENSITIVE_dob
      SENSITIVE_etnicity
      SENSITIVE_email
      SENSITIVE_country
      id
      SENSITIVE_user_measurements {
        weight
        heightFt
        heightIn
      }
      SENSITIVE_self_identity_gender
      SENSITIVE_gender_describe
      SENSITIVE_phone
      SENSITIVE_lastname
      SENSITIVE_gender
      SENSITIVE_firstname
      SENSITIVE_profile_picture_id
      SENSITIVE_pharmacies {
        address1
        address2
        city
        country
        isDefault
        name
        phone
        state
        zipCode
      }
    }
  }
}
    `;
export type PatchFhirPatientPersonalDataMutationFn = Apollo.MutationFunction<PatchFhirPatientPersonalDataMutation, PatchFhirPatientPersonalDataMutationVariables>;

/**
 * __usePatchFhirPatientPersonalDataMutation__
 *
 * To run a mutation, you first call `usePatchFhirPatientPersonalDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchFhirPatientPersonalDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchFhirPatientPersonalDataMutation, { data, loading, error }] = usePatchFhirPatientPersonalDataMutation({
 *   variables: {
 *      patientPersonalInfo: // value for 'patientPersonalInfo'
 *   },
 * });
 */
export function usePatchFhirPatientPersonalDataMutation(baseOptions?: Apollo.MutationHookOptions<PatchFhirPatientPersonalDataMutation, PatchFhirPatientPersonalDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatchFhirPatientPersonalDataMutation, PatchFhirPatientPersonalDataMutationVariables>(PatchFhirPatientPersonalDataDocument, options);
      }
export type PatchFhirPatientPersonalDataMutationHookResult = ReturnType<typeof usePatchFhirPatientPersonalDataMutation>;
export type PatchFhirPatientPersonalDataMutationResult = Apollo.MutationResult<PatchFhirPatientPersonalDataMutation>;
export type PatchFhirPatientPersonalDataMutationOptions = Apollo.BaseMutationOptions<PatchFhirPatientPersonalDataMutation, PatchFhirPatientPersonalDataMutationVariables>;
export const GetFhirPatientbyCodexIdDocument = gql`
    query GetFHIRPatientbyCodexID {
  getFHIRPatientbyCodexID {
    users {
      SENSITIVE_address_information {
        address1
        address2
        city
        country
        state
        province
        zipCode
        phone
        phoneCountry
      }
      SENSITIVE_dob
      SENSITIVE_etnicity
      SENSITIVE_email
      SENSITIVE_country
      child_fully_verified
      is_state_dob_valid
      id
      updated_at
      created_at
      minor_autonomy_evidence
      measurementsLastUpdatedAt
      autonomy_determination_status
      SENSITIVE_user_measurements {
        weight
        heightFt
        heightIn
        hips
        waist
      }
      SENSITIVE_self_identity_gender
      SENSITIVE_gender_describe
      SENSITIVE_profile_picture_id
      SENSITIVE_phone
      SENSITIVE_lastname
      SENSITIVE_gender
      SENSITIVE_firstname
      SENSITIVE_pharmacies {
        address1
        address2
        city
        country
        isDefault
        name
        phone
        state
        zipCode
      }
      parentCodexId
    }
  }
}
    `;

/**
 * __useGetFhirPatientbyCodexIdQuery__
 *
 * To run a query within a React component, call `useGetFhirPatientbyCodexIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirPatientbyCodexIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirPatientbyCodexIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFhirPatientbyCodexIdQuery(baseOptions?: Apollo.QueryHookOptions<GetFhirPatientbyCodexIdQuery, GetFhirPatientbyCodexIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirPatientbyCodexIdQuery, GetFhirPatientbyCodexIdQueryVariables>(GetFhirPatientbyCodexIdDocument, options);
      }
export function useGetFhirPatientbyCodexIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirPatientbyCodexIdQuery, GetFhirPatientbyCodexIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirPatientbyCodexIdQuery, GetFhirPatientbyCodexIdQueryVariables>(GetFhirPatientbyCodexIdDocument, options);
        }
export type GetFhirPatientbyCodexIdQueryHookResult = ReturnType<typeof useGetFhirPatientbyCodexIdQuery>;
export type GetFhirPatientbyCodexIdLazyQueryHookResult = ReturnType<typeof useGetFhirPatientbyCodexIdLazyQuery>;
export type GetFhirPatientbyCodexIdQueryResult = Apollo.QueryResult<GetFhirPatientbyCodexIdQuery, GetFhirPatientbyCodexIdQueryVariables>;
export const GetCombinedPatientDetailsDocument = gql`
    query GetCombinedPatientDetails($patientCodexId: String!, $skipProviderDetails: Boolean!) {
  getFHIRPatientbyCodexID @include(if: $skipProviderDetails) {
    users {
      SENSITIVE_address_information {
        address1
        address2
        city
        country
        state
        province
        zipCode
        phone
        phoneCountry
      }
      SENSITIVE_dob
      SENSITIVE_etnicity
      SENSITIVE_email
      SENSITIVE_country
      child_fully_verified
      is_state_dob_valid
      id
      updated_at
      created_at
      minor_autonomy_evidence
      measurementsLastUpdatedAt
      autonomy_determination_status
      SENSITIVE_user_measurements {
        weight
        heightFt
        heightIn
        hips
        waist
      }
      SENSITIVE_self_identity_gender
      SENSITIVE_gender_describe
      SENSITIVE_profile_picture_id
      SENSITIVE_phone
      SENSITIVE_lastname
      SENSITIVE_gender
      SENSITIVE_firstname
      SENSITIVE_pharmacies {
        address1
        address2
        city
        country
        isDefault
        name
        phone
        state
        zipCode
      }
      parentCodexId
    }
  }
  getFHIRPatientbyCodexIDParameter(patientCodexId: $patientCodexId) @skip(if: $skipProviderDetails) {
    users {
      SENSITIVE_firstname
      SENSITIVE_lastname
      SENSITIVE_gender
      SENSITIVE_email
      SENSITIVE_self_identity_gender
      SENSITIVE_dob
      SENSITIVE_etnicity
      child_fully_verified
      SENSITIVE_profile_picture_id
      parentCodexId
      SENSITIVE_user_measurements {
        heightFt
        heightIn
        weight
        hips
        waist
      }
      SENSITIVE_pharmacies {
        address1
        address2
        city
        country
        name
        province
        state
        phone
        zipCode
        id
        isDefault
      }
    }
  }
}
    `;

/**
 * __useGetCombinedPatientDetailsQuery__
 *
 * To run a query within a React component, call `useGetCombinedPatientDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCombinedPatientDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCombinedPatientDetailsQuery({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *      skipProviderDetails: // value for 'skipProviderDetails'
 *   },
 * });
 */
export function useGetCombinedPatientDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCombinedPatientDetailsQuery, GetCombinedPatientDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCombinedPatientDetailsQuery, GetCombinedPatientDetailsQueryVariables>(GetCombinedPatientDetailsDocument, options);
      }
export function useGetCombinedPatientDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCombinedPatientDetailsQuery, GetCombinedPatientDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCombinedPatientDetailsQuery, GetCombinedPatientDetailsQueryVariables>(GetCombinedPatientDetailsDocument, options);
        }
export type GetCombinedPatientDetailsQueryHookResult = ReturnType<typeof useGetCombinedPatientDetailsQuery>;
export type GetCombinedPatientDetailsLazyQueryHookResult = ReturnType<typeof useGetCombinedPatientDetailsLazyQuery>;
export type GetCombinedPatientDetailsQueryResult = Apollo.QueryResult<GetCombinedPatientDetailsQuery, GetCombinedPatientDetailsQueryVariables>;
export const GetFhirPatientbyEmailDocument = gql`
    query GetFHIRPatientbyEmail($email: String!) {
  getFHIRPatientbyEmail(email: $email) {
    users {
      id
      child_fully_verified
      SENSITIVE_firstname
      SENSITIVE_country
      SENSITIVE_dob
      SENSITIVE_email
      SENSITIVE_etnicity
      SENSITIVE_gender
      SENSITIVE_lastname
      SENSITIVE_phone
      SENSITIVE_profile_picture_id
      SENSITIVE_self_identity_gender
      minor_autonomy_evidence
      measurementsLastUpdatedAt
      autonomy_determination_status
      SENSITIVE_user_measurements {
        heightFt
        heightIn
        weight
        hips
        waist
      }
      SENSITIVE_address_information {
        address1
        address2
        city
        country
        state
        province
        zipCode
        phone
        phoneCountry
      }
      SENSITIVE_pharmacies {
        address1
        address2
        city
        country
        isDefault
        name
        phone
        state
        zipCode
      }
      parentCodexId
    }
  }
}
    `;

/**
 * __useGetFhirPatientbyEmailQuery__
 *
 * To run a query within a React component, call `useGetFhirPatientbyEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirPatientbyEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirPatientbyEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetFhirPatientbyEmailQuery(baseOptions: Apollo.QueryHookOptions<GetFhirPatientbyEmailQuery, GetFhirPatientbyEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirPatientbyEmailQuery, GetFhirPatientbyEmailQueryVariables>(GetFhirPatientbyEmailDocument, options);
      }
export function useGetFhirPatientbyEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirPatientbyEmailQuery, GetFhirPatientbyEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirPatientbyEmailQuery, GetFhirPatientbyEmailQueryVariables>(GetFhirPatientbyEmailDocument, options);
        }
export type GetFhirPatientbyEmailQueryHookResult = ReturnType<typeof useGetFhirPatientbyEmailQuery>;
export type GetFhirPatientbyEmailLazyQueryHookResult = ReturnType<typeof useGetFhirPatientbyEmailLazyQuery>;
export type GetFhirPatientbyEmailQueryResult = Apollo.QueryResult<GetFhirPatientbyEmailQuery, GetFhirPatientbyEmailQueryVariables>;
export const GetProvidersByPatientIdDocument = gql`
    query GetProvidersByPatientId($patientCodexId: String, $search: String, $limit: Int = 10, $offset: Int = 0, $appointmentTypeId: Float, $date: String, $onlyAvailable: Boolean) {
  getProvidersByPatientId(
    patientCodexId: $patientCodexId
    search: $search
    offset: $offset
    limit: $limit
    appointmentTypeId: $appointmentTypeId
    date: $date
    onlyAvailable: $onlyAvailable
  ) {
    providers {
      id
      SENSITIVE_firstname
      SENSITIVE_lastname
      SENSITIVE_profile_picture_id
      SENSITIVE_credentials {
        yearsOfPractice
        certifications
        medicalRole
        titles
      }
      hide_contact_info
      hide_office_address
      acuityOwnerId
      acuityCalendarId
      subscriptionPeriodEnd
      subscriptionStatus
      serviceOfferings {
        active
        serviceType
        price
      }
      patientRequests {
        date
        patientFhirId
        requestStatus
      }
      SENSITIVE_address_information {
        address1
        city
        state
      }
      SENSITIVE_office_information {
        address1
        city
        state
      }
    }
    total
  }
}
    `;

/**
 * __useGetProvidersByPatientIdQuery__
 *
 * To run a query within a React component, call `useGetProvidersByPatientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvidersByPatientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvidersByPatientIdQuery({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      appointmentTypeId: // value for 'appointmentTypeId'
 *      date: // value for 'date'
 *      onlyAvailable: // value for 'onlyAvailable'
 *   },
 * });
 */
export function useGetProvidersByPatientIdQuery(baseOptions?: Apollo.QueryHookOptions<GetProvidersByPatientIdQuery, GetProvidersByPatientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProvidersByPatientIdQuery, GetProvidersByPatientIdQueryVariables>(GetProvidersByPatientIdDocument, options);
      }
export function useGetProvidersByPatientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProvidersByPatientIdQuery, GetProvidersByPatientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProvidersByPatientIdQuery, GetProvidersByPatientIdQueryVariables>(GetProvidersByPatientIdDocument, options);
        }
export type GetProvidersByPatientIdQueryHookResult = ReturnType<typeof useGetProvidersByPatientIdQuery>;
export type GetProvidersByPatientIdLazyQueryHookResult = ReturnType<typeof useGetProvidersByPatientIdLazyQuery>;
export type GetProvidersByPatientIdQueryResult = Apollo.QueryResult<GetProvidersByPatientIdQuery, GetProvidersByPatientIdQueryVariables>;
export const GetFhirProvidersDocument = gql`
    query GetFHIRProviders($speciality: [String!], $providerCanSpeak: [String!], $search: String, $state: String, $limit: Int = 10, $offset: Int = 0, $gender: [String!], $appointmentAccepted: [String!], $medicalRole: [String!], $serverOfferedRange: String, $sortBy: String, $sortByDirections: String, $yearOfExpirienceRange: String) {
  getFHIRProviders(
    languages: $providerCanSpeak
    gender: $gender
    specialty: $speciality
    search: $search
    state: $state
    offset: $offset
    limit: $limit
    acceptedAppointments: $appointmentAccepted
    medicalRole: $medicalRole
    serverOfferedRange: $serverOfferedRange
    sortBy: $sortBy
    sortOrder: $sortByDirections
    yearOfExperienceRange: $yearOfExpirienceRange
  ) {
    providers {
      id
      SENSITIVE_firstname
      SENSITIVE_lastname
      SENSITIVE_profile_picture_id
      SENSITIVE_credentials {
        yearsOfPractice
        certifications
        medicalRole
        titles
      }
      SENSITIVE_address_information {
        address1
        city
        state
      }
      SENSITIVE_office_information {
        officeName
        email
        address1
        city
        state
      }
      hide_office_address
      hide_contact_info
      acuityOwnerId
      acuityCalendarId
      accepting_patients
      subscriptionPeriodEnd
      subscriptionStatus
      patientRequests {
        date
        patientFhirId
        requestStatus
      }
      serviceOfferings {
        active
        serviceType
        price
      }
    }
    total
  }
}
    `;

/**
 * __useGetFhirProvidersQuery__
 *
 * To run a query within a React component, call `useGetFhirProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirProvidersQuery({
 *   variables: {
 *      speciality: // value for 'speciality'
 *      providerCanSpeak: // value for 'providerCanSpeak'
 *      search: // value for 'search'
 *      state: // value for 'state'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      gender: // value for 'gender'
 *      appointmentAccepted: // value for 'appointmentAccepted'
 *      medicalRole: // value for 'medicalRole'
 *      serverOfferedRange: // value for 'serverOfferedRange'
 *      sortBy: // value for 'sortBy'
 *      sortByDirections: // value for 'sortByDirections'
 *      yearOfExpirienceRange: // value for 'yearOfExpirienceRange'
 *   },
 * });
 */
export function useGetFhirProvidersQuery(baseOptions?: Apollo.QueryHookOptions<GetFhirProvidersQuery, GetFhirProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirProvidersQuery, GetFhirProvidersQueryVariables>(GetFhirProvidersDocument, options);
      }
export function useGetFhirProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirProvidersQuery, GetFhirProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirProvidersQuery, GetFhirProvidersQueryVariables>(GetFhirProvidersDocument, options);
        }
export type GetFhirProvidersQueryHookResult = ReturnType<typeof useGetFhirProvidersQuery>;
export type GetFhirProvidersLazyQueryHookResult = ReturnType<typeof useGetFhirProvidersLazyQuery>;
export type GetFhirProvidersQueryResult = Apollo.QueryResult<GetFhirProvidersQuery, GetFhirProvidersQueryVariables>;
export const GetFhirPatientByCodexIdDocument = gql`
    query GetFHIRPatientByCodexId($patientCodexId: String!) {
  getFHIRPatientbyCodexIDParameter(patientCodexId: $patientCodexId) {
    users {
      id
      SENSITIVE_firstname
      SENSITIVE_lastname
      SENSITIVE_profile_picture_id
    }
  }
}
    `;

/**
 * __useGetFhirPatientByCodexIdQuery__
 *
 * To run a query within a React component, call `useGetFhirPatientByCodexIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirPatientByCodexIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirPatientByCodexIdQuery({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *   },
 * });
 */
export function useGetFhirPatientByCodexIdQuery(baseOptions: Apollo.QueryHookOptions<GetFhirPatientByCodexIdQuery, GetFhirPatientByCodexIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirPatientByCodexIdQuery, GetFhirPatientByCodexIdQueryVariables>(GetFhirPatientByCodexIdDocument, options);
      }
export function useGetFhirPatientByCodexIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirPatientByCodexIdQuery, GetFhirPatientByCodexIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirPatientByCodexIdQuery, GetFhirPatientByCodexIdQueryVariables>(GetFhirPatientByCodexIdDocument, options);
        }
export type GetFhirPatientByCodexIdQueryHookResult = ReturnType<typeof useGetFhirPatientByCodexIdQuery>;
export type GetFhirPatientByCodexIdLazyQueryHookResult = ReturnType<typeof useGetFhirPatientByCodexIdLazyQuery>;
export type GetFhirPatientByCodexIdQueryResult = Apollo.QueryResult<GetFhirPatientByCodexIdQuery, GetFhirPatientByCodexIdQueryVariables>;
export const GetProvidersForCurrentPatientDocument = gql`
    query GetProvidersForCurrentPatient {
  getProviderByPatientId {
    providers {
      id
      SENSITIVE_firstname
      SENSITIVE_lastname
      SENSITIVE_profile_picture_id
      SENSITIVE_credentials {
        yearsOfPractice
        certifications
        medicalRole
        titles
      }
    }
  }
}
    `;

/**
 * __useGetProvidersForCurrentPatientQuery__
 *
 * To run a query within a React component, call `useGetProvidersForCurrentPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvidersForCurrentPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvidersForCurrentPatientQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProvidersForCurrentPatientQuery(baseOptions?: Apollo.QueryHookOptions<GetProvidersForCurrentPatientQuery, GetProvidersForCurrentPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProvidersForCurrentPatientQuery, GetProvidersForCurrentPatientQueryVariables>(GetProvidersForCurrentPatientDocument, options);
      }
export function useGetProvidersForCurrentPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProvidersForCurrentPatientQuery, GetProvidersForCurrentPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProvidersForCurrentPatientQuery, GetProvidersForCurrentPatientQueryVariables>(GetProvidersForCurrentPatientDocument, options);
        }
export type GetProvidersForCurrentPatientQueryHookResult = ReturnType<typeof useGetProvidersForCurrentPatientQuery>;
export type GetProvidersForCurrentPatientLazyQueryHookResult = ReturnType<typeof useGetProvidersForCurrentPatientLazyQuery>;
export type GetProvidersForCurrentPatientQueryResult = Apollo.QueryResult<GetProvidersForCurrentPatientQuery, GetProvidersForCurrentPatientQueryVariables>;
export const GetProviderInfoByProviderCodexIdDocument = gql`
    query GetProviderInfoByProviderCodexId($providerCodexId: String!) {
  getFHIRProviderbyId(providerId: $providerCodexId) {
    providers {
      id
      SENSITIVE_firstname
      SENSITIVE_lastname
      SENSITIVE_profile_picture_id
      SENSITIVE_credentials {
        yearsOfPractice
        certifications
        medicalRole
        titles
      }
      SENSITIVE_office_information {
        officeName
        email
        address1
        city
        state
      }
      providerBalance
      serviceOfferings {
        active
        serviceType
        price
      }
    }
  }
}
    `;

/**
 * __useGetProviderInfoByProviderCodexIdQuery__
 *
 * To run a query within a React component, call `useGetProviderInfoByProviderCodexIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderInfoByProviderCodexIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderInfoByProviderCodexIdQuery({
 *   variables: {
 *      providerCodexId: // value for 'providerCodexId'
 *   },
 * });
 */
export function useGetProviderInfoByProviderCodexIdQuery(baseOptions: Apollo.QueryHookOptions<GetProviderInfoByProviderCodexIdQuery, GetProviderInfoByProviderCodexIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderInfoByProviderCodexIdQuery, GetProviderInfoByProviderCodexIdQueryVariables>(GetProviderInfoByProviderCodexIdDocument, options);
      }
export function useGetProviderInfoByProviderCodexIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderInfoByProviderCodexIdQuery, GetProviderInfoByProviderCodexIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderInfoByProviderCodexIdQuery, GetProviderInfoByProviderCodexIdQueryVariables>(GetProviderInfoByProviderCodexIdDocument, options);
        }
export type GetProviderInfoByProviderCodexIdQueryHookResult = ReturnType<typeof useGetProviderInfoByProviderCodexIdQuery>;
export type GetProviderInfoByProviderCodexIdLazyQueryHookResult = ReturnType<typeof useGetProviderInfoByProviderCodexIdLazyQuery>;
export type GetProviderInfoByProviderCodexIdQueryResult = Apollo.QueryResult<GetProviderInfoByProviderCodexIdQuery, GetProviderInfoByProviderCodexIdQueryVariables>;
export const GetLastViewedProvidersByUserDocument = gql`
    query GetLastViewedProvidersByUser {
  getLastViewedProvidersByUser {
    providers {
      id
      SENSITIVE_firstname
      SENSITIVE_lastname
      SENSITIVE_profile_picture_id
      SENSITIVE_credentials {
        yearsOfPractice
        certifications
        medicalRole
        titles
      }
      SENSITIVE_address_information {
        address1
        city
        state
      }
      acuityOwnerId
      acuityCalendarId
      serviceOfferings {
        active
        serviceType
        price
      }
    }
  }
}
    `;

/**
 * __useGetLastViewedProvidersByUserQuery__
 *
 * To run a query within a React component, call `useGetLastViewedProvidersByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastViewedProvidersByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastViewedProvidersByUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLastViewedProvidersByUserQuery(baseOptions?: Apollo.QueryHookOptions<GetLastViewedProvidersByUserQuery, GetLastViewedProvidersByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastViewedProvidersByUserQuery, GetLastViewedProvidersByUserQueryVariables>(GetLastViewedProvidersByUserDocument, options);
      }
export function useGetLastViewedProvidersByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastViewedProvidersByUserQuery, GetLastViewedProvidersByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastViewedProvidersByUserQuery, GetLastViewedProvidersByUserQueryVariables>(GetLastViewedProvidersByUserDocument, options);
        }
export type GetLastViewedProvidersByUserQueryHookResult = ReturnType<typeof useGetLastViewedProvidersByUserQuery>;
export type GetLastViewedProvidersByUserLazyQueryHookResult = ReturnType<typeof useGetLastViewedProvidersByUserLazyQuery>;
export type GetLastViewedProvidersByUserQueryResult = Apollo.QueryResult<GetLastViewedProvidersByUserQuery, GetLastViewedProvidersByUserQueryVariables>;
export const CreatePatientRequestDocument = gql`
    mutation createPatientRequest($providerCodexId: String!) {
  createBecomePatientRequest(providerCodexId: $providerCodexId) {
    requestStatus
  }
}
    `;
export type CreatePatientRequestMutationFn = Apollo.MutationFunction<CreatePatientRequestMutation, CreatePatientRequestMutationVariables>;

/**
 * __useCreatePatientRequestMutation__
 *
 * To run a mutation, you first call `useCreatePatientRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientRequestMutation, { data, loading, error }] = useCreatePatientRequestMutation({
 *   variables: {
 *      providerCodexId: // value for 'providerCodexId'
 *   },
 * });
 */
export function useCreatePatientRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatientRequestMutation, CreatePatientRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePatientRequestMutation, CreatePatientRequestMutationVariables>(CreatePatientRequestDocument, options);
      }
export type CreatePatientRequestMutationHookResult = ReturnType<typeof useCreatePatientRequestMutation>;
export type CreatePatientRequestMutationResult = Apollo.MutationResult<CreatePatientRequestMutation>;
export type CreatePatientRequestMutationOptions = Apollo.BaseMutationOptions<CreatePatientRequestMutation, CreatePatientRequestMutationVariables>;
export const PatchFhirProviderAccountInfoByCodexIdDocument = gql`
    mutation PatchFHIRProviderAccountInfoByCodexId($providerAccountInfo: PatchFHIRProviderInput!) {
  patchFHIRProvider(patchFHIRProviderInput: $providerAccountInfo) {
    update_providers_one {
      id
      SENSITIVE_firstname
      SENSITIVE_lastname
      SENSITIVE_phone
      SENSITIVE_email
      SENSITIVE_national_provider_identifier
    }
  }
}
    `;
export type PatchFhirProviderAccountInfoByCodexIdMutationFn = Apollo.MutationFunction<PatchFhirProviderAccountInfoByCodexIdMutation, PatchFhirProviderAccountInfoByCodexIdMutationVariables>;

/**
 * __usePatchFhirProviderAccountInfoByCodexIdMutation__
 *
 * To run a mutation, you first call `usePatchFhirProviderAccountInfoByCodexIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchFhirProviderAccountInfoByCodexIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchFhirProviderAccountInfoByCodexIdMutation, { data, loading, error }] = usePatchFhirProviderAccountInfoByCodexIdMutation({
 *   variables: {
 *      providerAccountInfo: // value for 'providerAccountInfo'
 *   },
 * });
 */
export function usePatchFhirProviderAccountInfoByCodexIdMutation(baseOptions?: Apollo.MutationHookOptions<PatchFhirProviderAccountInfoByCodexIdMutation, PatchFhirProviderAccountInfoByCodexIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatchFhirProviderAccountInfoByCodexIdMutation, PatchFhirProviderAccountInfoByCodexIdMutationVariables>(PatchFhirProviderAccountInfoByCodexIdDocument, options);
      }
export type PatchFhirProviderAccountInfoByCodexIdMutationHookResult = ReturnType<typeof usePatchFhirProviderAccountInfoByCodexIdMutation>;
export type PatchFhirProviderAccountInfoByCodexIdMutationResult = Apollo.MutationResult<PatchFhirProviderAccountInfoByCodexIdMutation>;
export type PatchFhirProviderAccountInfoByCodexIdMutationOptions = Apollo.BaseMutationOptions<PatchFhirProviderAccountInfoByCodexIdMutation, PatchFhirProviderAccountInfoByCodexIdMutationVariables>;
export const PatchFhirProviderAllFieldsDocument = gql`
    mutation patchFhirProviderAllFields($providerInfo: PatchFHIRProviderInput!) {
  patchFHIRProvider(patchFHIRProviderInput: $providerInfo) {
    update_providers_one {
      id
    }
  }
}
    `;
export type PatchFhirProviderAllFieldsMutationFn = Apollo.MutationFunction<PatchFhirProviderAllFieldsMutation, PatchFhirProviderAllFieldsMutationVariables>;

/**
 * __usePatchFhirProviderAllFieldsMutation__
 *
 * To run a mutation, you first call `usePatchFhirProviderAllFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchFhirProviderAllFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchFhirProviderAllFieldsMutation, { data, loading, error }] = usePatchFhirProviderAllFieldsMutation({
 *   variables: {
 *      providerInfo: // value for 'providerInfo'
 *   },
 * });
 */
export function usePatchFhirProviderAllFieldsMutation(baseOptions?: Apollo.MutationHookOptions<PatchFhirProviderAllFieldsMutation, PatchFhirProviderAllFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatchFhirProviderAllFieldsMutation, PatchFhirProviderAllFieldsMutationVariables>(PatchFhirProviderAllFieldsDocument, options);
      }
export type PatchFhirProviderAllFieldsMutationHookResult = ReturnType<typeof usePatchFhirProviderAllFieldsMutation>;
export type PatchFhirProviderAllFieldsMutationResult = Apollo.MutationResult<PatchFhirProviderAllFieldsMutation>;
export type PatchFhirProviderAllFieldsMutationOptions = Apollo.BaseMutationOptions<PatchFhirProviderAllFieldsMutation, PatchFhirProviderAllFieldsMutationVariables>;
export const RequestZrtTestDocument = gql`
    mutation RequestZrtTest($providerCodexId: String!, $testType: String!, $zrtSwabCode: String!, $trackingNumber: String) {
  requestZrtTest(
    providerCodexId: $providerCodexId
    testType: $testType
    zrtSwabCode: $zrtSwabCode
    trackingNumber: $trackingNumber
  ) {
    requestStatus
    serviceRequestId
  }
}
    `;
export type RequestZrtTestMutationFn = Apollo.MutationFunction<RequestZrtTestMutation, RequestZrtTestMutationVariables>;

/**
 * __useRequestZrtTestMutation__
 *
 * To run a mutation, you first call `useRequestZrtTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestZrtTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestZrtTestMutation, { data, loading, error }] = useRequestZrtTestMutation({
 *   variables: {
 *      providerCodexId: // value for 'providerCodexId'
 *      testType: // value for 'testType'
 *      zrtSwabCode: // value for 'zrtSwabCode'
 *      trackingNumber: // value for 'trackingNumber'
 *   },
 * });
 */
export function useRequestZrtTestMutation(baseOptions?: Apollo.MutationHookOptions<RequestZrtTestMutation, RequestZrtTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestZrtTestMutation, RequestZrtTestMutationVariables>(RequestZrtTestDocument, options);
      }
export type RequestZrtTestMutationHookResult = ReturnType<typeof useRequestZrtTestMutation>;
export type RequestZrtTestMutationResult = Apollo.MutationResult<RequestZrtTestMutation>;
export type RequestZrtTestMutationOptions = Apollo.BaseMutationOptions<RequestZrtTestMutation, RequestZrtTestMutationVariables>;
export const UnlinkFullscriptDocument = gql`
    mutation unlinkFullscript {
  unlinkFullscript {
    update_providers_one {
      id
    }
  }
}
    `;
export type UnlinkFullscriptMutationFn = Apollo.MutationFunction<UnlinkFullscriptMutation, UnlinkFullscriptMutationVariables>;

/**
 * __useUnlinkFullscriptMutation__
 *
 * To run a mutation, you first call `useUnlinkFullscriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkFullscriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkFullscriptMutation, { data, loading, error }] = useUnlinkFullscriptMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnlinkFullscriptMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkFullscriptMutation, UnlinkFullscriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkFullscriptMutation, UnlinkFullscriptMutationVariables>(UnlinkFullscriptDocument, options);
      }
export type UnlinkFullscriptMutationHookResult = ReturnType<typeof useUnlinkFullscriptMutation>;
export type UnlinkFullscriptMutationResult = Apollo.MutationResult<UnlinkFullscriptMutation>;
export type UnlinkFullscriptMutationOptions = Apollo.BaseMutationOptions<UnlinkFullscriptMutation, UnlinkFullscriptMutationVariables>;
export const GetFhirProviderbyEmailDocument = gql`
    query GetFHIRProviderbyEmail($email: String!) {
  getFHIRProviderbyEmail(email: $email) {
    providers {
      acuityCalendarId
      ePrescribeUserId
      id
      enabled
      id_verified
      fully_verified
      insurance_verified
      codex_approved
      isStripeConnected
      stripeAccountId
      stripePayoutsReadyAt
      serviceOfferings {
        active
        price
        priceCategory
        serviceType
        healthCareServiceFhirId
      }
      SENSITIVE_firstname
      SENSITIVE_email
      SENSITIVE_gender
      SENSITIVE_gender_describe
      SENSITIVE_dob
      SENSITIVE_lastname
      SENSITIVE_phone
      fullscriptId
      SENSITIVE_profile_picture_id
      SENSITIVE_national_provider_identifier
      SENSITIVE_languages_of_communication
      SENSITIVE_about
      SENSITIVE_credentials {
        yearsOfPractice
        certifications
        fellowships
        medicalRole
        titles
        stateLicenses {
          id
          state
          licenseType
          licenseNumber
          expirationDate
        }
      }
      SENSITIVE_education {
        medicalSchool
        residency
        isStillResident
        residencyEndDate
        residencyStartDate
        undergraduate
      }
      SENSITIVE_office_information {
        officeName
        email
        phone
        address1
        address2
        city
        country
        state
        province
        zipCode
      }
      providerBalance
      SENSITIVE_address_information {
        address1
        address2
        city
        country
        state
        province
        zipCode
      }
      hide_contact_info
      hide_office_address
    }
  }
}
    `;

/**
 * __useGetFhirProviderbyEmailQuery__
 *
 * To run a query within a React component, call `useGetFhirProviderbyEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirProviderbyEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirProviderbyEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetFhirProviderbyEmailQuery(baseOptions: Apollo.QueryHookOptions<GetFhirProviderbyEmailQuery, GetFhirProviderbyEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirProviderbyEmailQuery, GetFhirProviderbyEmailQueryVariables>(GetFhirProviderbyEmailDocument, options);
      }
export function useGetFhirProviderbyEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirProviderbyEmailQuery, GetFhirProviderbyEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirProviderbyEmailQuery, GetFhirProviderbyEmailQueryVariables>(GetFhirProviderbyEmailDocument, options);
        }
export type GetFhirProviderbyEmailQueryHookResult = ReturnType<typeof useGetFhirProviderbyEmailQuery>;
export type GetFhirProviderbyEmailLazyQueryHookResult = ReturnType<typeof useGetFhirProviderbyEmailLazyQuery>;
export type GetFhirProviderbyEmailQueryResult = Apollo.QueryResult<GetFhirProviderbyEmailQuery, GetFhirProviderbyEmailQueryVariables>;
export const GetFhirAvailableProvidersNamesDocument = gql`
    query getFHIRAvailableProvidersNames {
  getFHIRProviders {
    providers {
      id
      SENSITIVE_firstname
      SENSITIVE_lastname
    }
  }
}
    `;

/**
 * __useGetFhirAvailableProvidersNamesQuery__
 *
 * To run a query within a React component, call `useGetFhirAvailableProvidersNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirAvailableProvidersNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirAvailableProvidersNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFhirAvailableProvidersNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetFhirAvailableProvidersNamesQuery, GetFhirAvailableProvidersNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirAvailableProvidersNamesQuery, GetFhirAvailableProvidersNamesQueryVariables>(GetFhirAvailableProvidersNamesDocument, options);
      }
export function useGetFhirAvailableProvidersNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirAvailableProvidersNamesQuery, GetFhirAvailableProvidersNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirAvailableProvidersNamesQuery, GetFhirAvailableProvidersNamesQueryVariables>(GetFhirAvailableProvidersNamesDocument, options);
        }
export type GetFhirAvailableProvidersNamesQueryHookResult = ReturnType<typeof useGetFhirAvailableProvidersNamesQuery>;
export type GetFhirAvailableProvidersNamesLazyQueryHookResult = ReturnType<typeof useGetFhirAvailableProvidersNamesLazyQuery>;
export type GetFhirAvailableProvidersNamesQueryResult = Apollo.QueryResult<GetFhirAvailableProvidersNamesQuery, GetFhirAvailableProvidersNamesQueryVariables>;
export const GetFhirProviderByCodexIdDocument = gql`
    query GetFHIRProviderByCodexId($codexProviderId: String!) {
  getFHIRProviderbyCodexIdArgument(codexProviderId: $codexProviderId) {
    providers {
      providers {
        id
        patientRequests {
          date
          requestStatus
        }
        SENSITIVE_firstname
        SENSITIVE_lastname
        SENSITIVE_email
        SENSITIVE_profile_picture_id
        SENSITIVE_gender
        SENSITIVE_gender_describe
        SENSITIVE_credentials {
          yearsOfPractice
          certifications
          medicalRole
          titles
          stateLicenses {
            state
          }
        }
        SENSITIVE_languages_of_communication
        SENSITIVE_about
        SENSITIVE_education {
          medicalSchool
          residency
          undergraduate
        }
        SENSITIVE_office_information {
          officeName
          email
          phone
          address1
          address2
          city
          country
          state
          province
          zipCode
        }
        SENSITIVE_address_information {
          address1
          address2
          city
          country
          phone
          state
          zipCode
        }
        hide_contact_info
        hide_office_address
        serviceOfferings {
          active
          serviceType
          price
        }
        subscriptionPeriodEnd
        subscriptionStatus
        acuityCalendarId
        acuityOwnerId
      }
    }
  }
}
    `;

/**
 * __useGetFhirProviderByCodexIdQuery__
 *
 * To run a query within a React component, call `useGetFhirProviderByCodexIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirProviderByCodexIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirProviderByCodexIdQuery({
 *   variables: {
 *      codexProviderId: // value for 'codexProviderId'
 *   },
 * });
 */
export function useGetFhirProviderByCodexIdQuery(baseOptions: Apollo.QueryHookOptions<GetFhirProviderByCodexIdQuery, GetFhirProviderByCodexIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirProviderByCodexIdQuery, GetFhirProviderByCodexIdQueryVariables>(GetFhirProviderByCodexIdDocument, options);
      }
export function useGetFhirProviderByCodexIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirProviderByCodexIdQuery, GetFhirProviderByCodexIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirProviderByCodexIdQuery, GetFhirProviderByCodexIdQueryVariables>(GetFhirProviderByCodexIdDocument, options);
        }
export type GetFhirProviderByCodexIdQueryHookResult = ReturnType<typeof useGetFhirProviderByCodexIdQuery>;
export type GetFhirProviderByCodexIdLazyQueryHookResult = ReturnType<typeof useGetFhirProviderByCodexIdLazyQuery>;
export type GetFhirProviderByCodexIdQueryResult = Apollo.QueryResult<GetFhirProviderByCodexIdQuery, GetFhirProviderByCodexIdQueryVariables>;
export const GetProviderPatientInfoDocument = gql`
    query getProviderPatientInfo($patientCodexId: String!) {
  getFHIRPatientbyCodexIDParameter(patientCodexId: $patientCodexId) {
    users {
      SENSITIVE_firstname
      SENSITIVE_lastname
      SENSITIVE_profile_picture_id
    }
  }
}
    `;

/**
 * __useGetProviderPatientInfoQuery__
 *
 * To run a query within a React component, call `useGetProviderPatientInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderPatientInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderPatientInfoQuery({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *   },
 * });
 */
export function useGetProviderPatientInfoQuery(baseOptions: Apollo.QueryHookOptions<GetProviderPatientInfoQuery, GetProviderPatientInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderPatientInfoQuery, GetProviderPatientInfoQueryVariables>(GetProviderPatientInfoDocument, options);
      }
export function useGetProviderPatientInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderPatientInfoQuery, GetProviderPatientInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderPatientInfoQuery, GetProviderPatientInfoQueryVariables>(GetProviderPatientInfoDocument, options);
        }
export type GetProviderPatientInfoQueryHookResult = ReturnType<typeof useGetProviderPatientInfoQuery>;
export type GetProviderPatientInfoLazyQueryHookResult = ReturnType<typeof useGetProviderPatientInfoLazyQuery>;
export type GetProviderPatientInfoQueryResult = Apollo.QueryResult<GetProviderPatientInfoQuery, GetProviderPatientInfoQueryVariables>;
export const GetProviderFullPatientInfoDocument = gql`
    query getProviderFullPatientInfo($patientCodexId: String!) {
  getFHIRPatientbyCodexIDParameter(patientCodexId: $patientCodexId) {
    users {
      id
      parentCodexId
      SENSITIVE_firstname
      SENSITIVE_lastname
      SENSITIVE_dob
      SENSITIVE_profile_picture_id
      SENSITIVE_etnicity
      SENSITIVE_gender
      SENSITIVE_self_identity_gender
      SENSITIVE_user_measurements {
        heightFt
        heightIn
        hips
        waist
        weight
      }
    }
  }
}
    `;

/**
 * __useGetProviderFullPatientInfoQuery__
 *
 * To run a query within a React component, call `useGetProviderFullPatientInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderFullPatientInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderFullPatientInfoQuery({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *   },
 * });
 */
export function useGetProviderFullPatientInfoQuery(baseOptions: Apollo.QueryHookOptions<GetProviderFullPatientInfoQuery, GetProviderFullPatientInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderFullPatientInfoQuery, GetProviderFullPatientInfoQueryVariables>(GetProviderFullPatientInfoDocument, options);
      }
export function useGetProviderFullPatientInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderFullPatientInfoQuery, GetProviderFullPatientInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderFullPatientInfoQuery, GetProviderFullPatientInfoQueryVariables>(GetProviderFullPatientInfoDocument, options);
        }
export type GetProviderFullPatientInfoQueryHookResult = ReturnType<typeof useGetProviderFullPatientInfoQuery>;
export type GetProviderFullPatientInfoLazyQueryHookResult = ReturnType<typeof useGetProviderFullPatientInfoLazyQuery>;
export type GetProviderFullPatientInfoQueryResult = Apollo.QueryResult<GetProviderFullPatientInfoQuery, GetProviderFullPatientInfoQueryVariables>;
export const GetFhirPatientsRelatedToProviderDocument = gql`
    query GetFhirPatientsRelatedToProvider($limit: Int, $offset: Int, $direction: OrderByDirections!, $field: FHIRPatientOrderByCriterias!, $searchCriteria: String, $dateFilter: GetFHIRPatientsByIdDateFilterInput) {
  getFHIRPatientsById(
    limit: $limit
    offset: $offset
    orderBy: {direction: $direction, field: $field}
    dateFilter: $dateFilter
    searchCriteria: $searchCriteria
  ) {
    patients {
      memberDetails {
        period {
          start
        }
        inactive
      }
      patient {
        id
        SENSITIVE_firstname
        SENSITIVE_lastname
        SENSITIVE_birth_date
        SENSITIVE_gender
        SENSITIVE_email
        SENSITIVE_phone
        SENSITIVE_profile_picture_id
        kyc_approved
        canReceivePrescriptions
        SENSITIVE_address_information {
          city
          state
          country
        }
        SENSITIVE_etnicity
        SENSITIVE_self_identity_gender
        SENSITIVE_user_measurements {
          hips
          waist
          weight
          heightFt
          heightIn
        }
        lastAppointmentDate
        appointments {
          codexPatientId
          codexProviderId
          appointmentCodexId
          appointmentType
          appointmentUrl
          start
        }
      }
    }
    total
  }
}
    `;

/**
 * __useGetFhirPatientsRelatedToProviderQuery__
 *
 * To run a query within a React component, call `useGetFhirPatientsRelatedToProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirPatientsRelatedToProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirPatientsRelatedToProviderQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      direction: // value for 'direction'
 *      field: // value for 'field'
 *      searchCriteria: // value for 'searchCriteria'
 *      dateFilter: // value for 'dateFilter'
 *   },
 * });
 */
export function useGetFhirPatientsRelatedToProviderQuery(baseOptions: Apollo.QueryHookOptions<GetFhirPatientsRelatedToProviderQuery, GetFhirPatientsRelatedToProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirPatientsRelatedToProviderQuery, GetFhirPatientsRelatedToProviderQueryVariables>(GetFhirPatientsRelatedToProviderDocument, options);
      }
export function useGetFhirPatientsRelatedToProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirPatientsRelatedToProviderQuery, GetFhirPatientsRelatedToProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirPatientsRelatedToProviderQuery, GetFhirPatientsRelatedToProviderQueryVariables>(GetFhirPatientsRelatedToProviderDocument, options);
        }
export type GetFhirPatientsRelatedToProviderQueryHookResult = ReturnType<typeof useGetFhirPatientsRelatedToProviderQuery>;
export type GetFhirPatientsRelatedToProviderLazyQueryHookResult = ReturnType<typeof useGetFhirPatientsRelatedToProviderLazyQuery>;
export type GetFhirPatientsRelatedToProviderQueryResult = Apollo.QueryResult<GetFhirPatientsRelatedToProviderQuery, GetFhirPatientsRelatedToProviderQueryVariables>;
export const GetProviderPatientDetailsDocument = gql`
    query getProviderPatientDetails($patientCodexId: String!) {
  getFHIRPatientbyCodexIDParameter(patientCodexId: $patientCodexId) {
    users {
      SENSITIVE_firstname
      SENSITIVE_lastname
      SENSITIVE_gender
      SENSITIVE_email
      SENSITIVE_self_identity_gender
      SENSITIVE_dob
      SENSITIVE_etnicity
      child_fully_verified
      SENSITIVE_profile_picture_id
      parentCodexId
      SENSITIVE_user_measurements {
        heightFt
        heightIn
        weight
        hips
        waist
      }
      SENSITIVE_pharmacies {
        address1
        address2
        city
        country
        name
        province
        state
        phone
        zipCode
        id
        isDefault
      }
    }
  }
}
    `;

/**
 * __useGetProviderPatientDetailsQuery__
 *
 * To run a query within a React component, call `useGetProviderPatientDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderPatientDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderPatientDetailsQuery({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *   },
 * });
 */
export function useGetProviderPatientDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetProviderPatientDetailsQuery, GetProviderPatientDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderPatientDetailsQuery, GetProviderPatientDetailsQueryVariables>(GetProviderPatientDetailsDocument, options);
      }
export function useGetProviderPatientDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderPatientDetailsQuery, GetProviderPatientDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderPatientDetailsQuery, GetProviderPatientDetailsQueryVariables>(GetProviderPatientDetailsDocument, options);
        }
export type GetProviderPatientDetailsQueryHookResult = ReturnType<typeof useGetProviderPatientDetailsQuery>;
export type GetProviderPatientDetailsLazyQueryHookResult = ReturnType<typeof useGetProviderPatientDetailsLazyQuery>;
export type GetProviderPatientDetailsQueryResult = Apollo.QueryResult<GetProviderPatientDetailsQuery, GetProviderPatientDetailsQueryVariables>;
export const GetAppointmentMessageListByAppointmentCodexIdDocument = gql`
    query getAppointmentMessageListByAppointmentCodexId($appointmentCodexId: String!) {
  getAppointmentMessageListByAppointmentCodexId(
    appointmentCodexId: $appointmentCodexId
  ) {
    chat {
      id
      patientId
      providerId
      messages {
        from
        mediaUrl
        fileId
        message
        contentType
        date
        fileName
      }
    }
  }
}
    `;

/**
 * __useGetAppointmentMessageListByAppointmentCodexIdQuery__
 *
 * To run a query within a React component, call `useGetAppointmentMessageListByAppointmentCodexIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentMessageListByAppointmentCodexIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentMessageListByAppointmentCodexIdQuery({
 *   variables: {
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *   },
 * });
 */
export function useGetAppointmentMessageListByAppointmentCodexIdQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentMessageListByAppointmentCodexIdQuery, GetAppointmentMessageListByAppointmentCodexIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentMessageListByAppointmentCodexIdQuery, GetAppointmentMessageListByAppointmentCodexIdQueryVariables>(GetAppointmentMessageListByAppointmentCodexIdDocument, options);
      }
export function useGetAppointmentMessageListByAppointmentCodexIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentMessageListByAppointmentCodexIdQuery, GetAppointmentMessageListByAppointmentCodexIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentMessageListByAppointmentCodexIdQuery, GetAppointmentMessageListByAppointmentCodexIdQueryVariables>(GetAppointmentMessageListByAppointmentCodexIdDocument, options);
        }
export type GetAppointmentMessageListByAppointmentCodexIdQueryHookResult = ReturnType<typeof useGetAppointmentMessageListByAppointmentCodexIdQuery>;
export type GetAppointmentMessageListByAppointmentCodexIdLazyQueryHookResult = ReturnType<typeof useGetAppointmentMessageListByAppointmentCodexIdLazyQuery>;
export type GetAppointmentMessageListByAppointmentCodexIdQueryResult = Apollo.QueryResult<GetAppointmentMessageListByAppointmentCodexIdQuery, GetAppointmentMessageListByAppointmentCodexIdQueryVariables>;
export const GetFhirPatientRelatedToProviderByPatientIdDocument = gql`
    query GetFhirPatientRelatedToProviderByPatientId($patientCodexId: String!) {
  getFHIRPatientsById(patientCodexId: $patientCodexId) {
    patients {
      memberDetails {
        period {
          start
        }
        inactive
      }
      patient {
        id
        created_at
        parentCodexId
        SENSITIVE_email
        SENSITIVE_firstname
        SENSITIVE_lastname
        SENSITIVE_birth_date
        SENSITIVE_gender
        SENSITIVE_profile_picture_id
        SENSITIVE_user_measurements {
          heightFt
          heightIn
          hips
          waist
          weight
        }
        SENSITIVE_address_information {
          city
          country
          state
        }
        SENSITIVE_pharmacies {
          address1
          city
          country
          address2
          name
          state
          zipCode
        }
        fhirId
        kyc_approved
        canReceivePrescriptions
        SENSITIVE_etnicity
        SENSITIVE_self_identity_gender
      }
    }
    total
  }
}
    `;

/**
 * __useGetFhirPatientRelatedToProviderByPatientIdQuery__
 *
 * To run a query within a React component, call `useGetFhirPatientRelatedToProviderByPatientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirPatientRelatedToProviderByPatientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirPatientRelatedToProviderByPatientIdQuery({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *   },
 * });
 */
export function useGetFhirPatientRelatedToProviderByPatientIdQuery(baseOptions: Apollo.QueryHookOptions<GetFhirPatientRelatedToProviderByPatientIdQuery, GetFhirPatientRelatedToProviderByPatientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirPatientRelatedToProviderByPatientIdQuery, GetFhirPatientRelatedToProviderByPatientIdQueryVariables>(GetFhirPatientRelatedToProviderByPatientIdDocument, options);
      }
export function useGetFhirPatientRelatedToProviderByPatientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirPatientRelatedToProviderByPatientIdQuery, GetFhirPatientRelatedToProviderByPatientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirPatientRelatedToProviderByPatientIdQuery, GetFhirPatientRelatedToProviderByPatientIdQueryVariables>(GetFhirPatientRelatedToProviderByPatientIdDocument, options);
        }
export type GetFhirPatientRelatedToProviderByPatientIdQueryHookResult = ReturnType<typeof useGetFhirPatientRelatedToProviderByPatientIdQuery>;
export type GetFhirPatientRelatedToProviderByPatientIdLazyQueryHookResult = ReturnType<typeof useGetFhirPatientRelatedToProviderByPatientIdLazyQuery>;
export type GetFhirPatientRelatedToProviderByPatientIdQueryResult = Apollo.QueryResult<GetFhirPatientRelatedToProviderByPatientIdQuery, GetFhirPatientRelatedToProviderByPatientIdQueryVariables>;
export const GetProviderPatientsByIdDocument = gql`
    query getProviderPatientsById {
  getFHIRPatientsById {
    patients {
      patient {
        id
        SENSITIVE_firstname
        SENSITIVE_lastname
      }
    }
  }
}
    `;

/**
 * __useGetProviderPatientsByIdQuery__
 *
 * To run a query within a React component, call `useGetProviderPatientsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderPatientsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderPatientsByIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProviderPatientsByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetProviderPatientsByIdQuery, GetProviderPatientsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderPatientsByIdQuery, GetProviderPatientsByIdQueryVariables>(GetProviderPatientsByIdDocument, options);
      }
export function useGetProviderPatientsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderPatientsByIdQuery, GetProviderPatientsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderPatientsByIdQuery, GetProviderPatientsByIdQueryVariables>(GetProviderPatientsByIdDocument, options);
        }
export type GetProviderPatientsByIdQueryHookResult = ReturnType<typeof useGetProviderPatientsByIdQuery>;
export type GetProviderPatientsByIdLazyQueryHookResult = ReturnType<typeof useGetProviderPatientsByIdLazyQuery>;
export type GetProviderPatientsByIdQueryResult = Apollo.QueryResult<GetProviderPatientsByIdQuery, GetProviderPatientsByIdQueryVariables>;
export const GetFhirProviderByRequestIdDocument = gql`
    query getFHIRProviderByRequestId {
  getFHIRProviderByRequestId {
    providers {
      id
      enabled
      fullscriptId
      ePrescribeUserId
      id_verified
      codex_approved
      SENSITIVE_firstname
      SENSITIVE_email
      SENSITIVE_gender
      SENSITIVE_lastname
      SENSITIVE_phone
      SENSITIVE_profile_picture_id
      SENSITIVE_national_provider_identifier
      SENSITIVE_languages_of_communication
      SENSITIVE_about
      acuityOwnerId
      acuityCalendarId
      SENSITIVE_credentials {
        yearsOfPractice
        certifications
        medicalRole
        titles
      }
      SENSITIVE_education {
        medicalSchool
        residency
        undergraduate
      }
      SENSITIVE_office_information {
        officeName
        email
        phone
        address1
        address2
        city
        country
        state
        province
        zipCode
      }
      SENSITIVE_address_information {
        address1
        address2
        city
        country
        state
        province
        zipCode
      }
    }
  }
}
    `;

/**
 * __useGetFhirProviderByRequestIdQuery__
 *
 * To run a query within a React component, call `useGetFhirProviderByRequestIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirProviderByRequestIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirProviderByRequestIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFhirProviderByRequestIdQuery(baseOptions?: Apollo.QueryHookOptions<GetFhirProviderByRequestIdQuery, GetFhirProviderByRequestIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirProviderByRequestIdQuery, GetFhirProviderByRequestIdQueryVariables>(GetFhirProviderByRequestIdDocument, options);
      }
export function useGetFhirProviderByRequestIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirProviderByRequestIdQuery, GetFhirProviderByRequestIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirProviderByRequestIdQuery, GetFhirProviderByRequestIdQueryVariables>(GetFhirProviderByRequestIdDocument, options);
        }
export type GetFhirProviderByRequestIdQueryHookResult = ReturnType<typeof useGetFhirProviderByRequestIdQuery>;
export type GetFhirProviderByRequestIdLazyQueryHookResult = ReturnType<typeof useGetFhirProviderByRequestIdLazyQuery>;
export type GetFhirProviderByRequestIdQueryResult = Apollo.QueryResult<GetFhirProviderByRequestIdQuery, GetFhirProviderByRequestIdQueryVariables>;
export const GetLastViewedPatientByProviderDocument = gql`
    query GetLastViewedPatientByProvider {
  getLastViewedPatientByProvider {
    patients {
      id
      SENSITIVE_firstname
      SENSITIVE_lastname
      SENSITIVE_dob
      SENSITIVE_gender
      SENSITIVE_profile_picture_id
      SENSITIVE_address_information {
        city
        state
      }
    }
  }
}
    `;

/**
 * __useGetLastViewedPatientByProviderQuery__
 *
 * To run a query within a React component, call `useGetLastViewedPatientByProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastViewedPatientByProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastViewedPatientByProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLastViewedPatientByProviderQuery(baseOptions?: Apollo.QueryHookOptions<GetLastViewedPatientByProviderQuery, GetLastViewedPatientByProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastViewedPatientByProviderQuery, GetLastViewedPatientByProviderQueryVariables>(GetLastViewedPatientByProviderDocument, options);
      }
export function useGetLastViewedPatientByProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastViewedPatientByProviderQuery, GetLastViewedPatientByProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastViewedPatientByProviderQuery, GetLastViewedPatientByProviderQueryVariables>(GetLastViewedPatientByProviderDocument, options);
        }
export type GetLastViewedPatientByProviderQueryHookResult = ReturnType<typeof useGetLastViewedPatientByProviderQuery>;
export type GetLastViewedPatientByProviderLazyQueryHookResult = ReturnType<typeof useGetLastViewedPatientByProviderLazyQuery>;
export type GetLastViewedPatientByProviderQueryResult = Apollo.QueryResult<GetLastViewedPatientByProviderQuery, GetLastViewedPatientByProviderQueryVariables>;
export const GetFhirdPrivderInfoByZrtSwabcodeQueryDocument = gql`
    query getFHIRDPrivderInfoByZrtSwabcodeQuery($getFHIRDPrivderInfoByZrtSwabcode: String!) {
  getFHIRDPrivderInfoByZrtSwabcode(
    getFHIRDPrivderInfoByZrtSwabcode: $getFHIRDPrivderInfoByZrtSwabcode
  ) {
    id
    SENSITIVE_lastname
    SENSITIVE_firstname
  }
}
    `;

/**
 * __useGetFhirdPrivderInfoByZrtSwabcodeQueryQuery__
 *
 * To run a query within a React component, call `useGetFhirdPrivderInfoByZrtSwabcodeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirdPrivderInfoByZrtSwabcodeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirdPrivderInfoByZrtSwabcodeQueryQuery({
 *   variables: {
 *      getFHIRDPrivderInfoByZrtSwabcode: // value for 'getFHIRDPrivderInfoByZrtSwabcode'
 *   },
 * });
 */
export function useGetFhirdPrivderInfoByZrtSwabcodeQueryQuery(baseOptions: Apollo.QueryHookOptions<GetFhirdPrivderInfoByZrtSwabcodeQueryQuery, GetFhirdPrivderInfoByZrtSwabcodeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirdPrivderInfoByZrtSwabcodeQueryQuery, GetFhirdPrivderInfoByZrtSwabcodeQueryQueryVariables>(GetFhirdPrivderInfoByZrtSwabcodeQueryDocument, options);
      }
export function useGetFhirdPrivderInfoByZrtSwabcodeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirdPrivderInfoByZrtSwabcodeQueryQuery, GetFhirdPrivderInfoByZrtSwabcodeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirdPrivderInfoByZrtSwabcodeQueryQuery, GetFhirdPrivderInfoByZrtSwabcodeQueryQueryVariables>(GetFhirdPrivderInfoByZrtSwabcodeQueryDocument, options);
        }
export type GetFhirdPrivderInfoByZrtSwabcodeQueryQueryHookResult = ReturnType<typeof useGetFhirdPrivderInfoByZrtSwabcodeQueryQuery>;
export type GetFhirdPrivderInfoByZrtSwabcodeQueryLazyQueryHookResult = ReturnType<typeof useGetFhirdPrivderInfoByZrtSwabcodeQueryLazyQuery>;
export type GetFhirdPrivderInfoByZrtSwabcodeQueryQueryResult = Apollo.QueryResult<GetFhirdPrivderInfoByZrtSwabcodeQueryQuery, GetFhirdPrivderInfoByZrtSwabcodeQueryQueryVariables>;
export const GetFhirPatientsRelatedToProviderCountDocument = gql`
    query GetFhirPatientsRelatedToProviderCount($limit: Int = 1, $offset: Int = 0) {
  getFHIRPatientsById(limit: $limit, offset: $offset) {
    total
  }
}
    `;

/**
 * __useGetFhirPatientsRelatedToProviderCountQuery__
 *
 * To run a query within a React component, call `useGetFhirPatientsRelatedToProviderCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirPatientsRelatedToProviderCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirPatientsRelatedToProviderCountQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetFhirPatientsRelatedToProviderCountQuery(baseOptions?: Apollo.QueryHookOptions<GetFhirPatientsRelatedToProviderCountQuery, GetFhirPatientsRelatedToProviderCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirPatientsRelatedToProviderCountQuery, GetFhirPatientsRelatedToProviderCountQueryVariables>(GetFhirPatientsRelatedToProviderCountDocument, options);
      }
export function useGetFhirPatientsRelatedToProviderCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirPatientsRelatedToProviderCountQuery, GetFhirPatientsRelatedToProviderCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirPatientsRelatedToProviderCountQuery, GetFhirPatientsRelatedToProviderCountQueryVariables>(GetFhirPatientsRelatedToProviderCountDocument, options);
        }
export type GetFhirPatientsRelatedToProviderCountQueryHookResult = ReturnType<typeof useGetFhirPatientsRelatedToProviderCountQuery>;
export type GetFhirPatientsRelatedToProviderCountLazyQueryHookResult = ReturnType<typeof useGetFhirPatientsRelatedToProviderCountLazyQuery>;
export type GetFhirPatientsRelatedToProviderCountQueryResult = Apollo.QueryResult<GetFhirPatientsRelatedToProviderCountQuery, GetFhirPatientsRelatedToProviderCountQueryVariables>;
export const GetTotalsProviderByPatientsIdDocument = gql`
    query GetTotalsProviderByPatientsId($patientCodexId: String) {
  getProvidersByPatientId(patientCodexId: $patientCodexId) {
    total
  }
}
    `;

/**
 * __useGetTotalsProviderByPatientsIdQuery__
 *
 * To run a query within a React component, call `useGetTotalsProviderByPatientsIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalsProviderByPatientsIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalsProviderByPatientsIdQuery({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *   },
 * });
 */
export function useGetTotalsProviderByPatientsIdQuery(baseOptions?: Apollo.QueryHookOptions<GetTotalsProviderByPatientsIdQuery, GetTotalsProviderByPatientsIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotalsProviderByPatientsIdQuery, GetTotalsProviderByPatientsIdQueryVariables>(GetTotalsProviderByPatientsIdDocument, options);
      }
export function useGetTotalsProviderByPatientsIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotalsProviderByPatientsIdQuery, GetTotalsProviderByPatientsIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotalsProviderByPatientsIdQuery, GetTotalsProviderByPatientsIdQueryVariables>(GetTotalsProviderByPatientsIdDocument, options);
        }
export type GetTotalsProviderByPatientsIdQueryHookResult = ReturnType<typeof useGetTotalsProviderByPatientsIdQuery>;
export type GetTotalsProviderByPatientsIdLazyQueryHookResult = ReturnType<typeof useGetTotalsProviderByPatientsIdLazyQuery>;
export type GetTotalsProviderByPatientsIdQueryResult = Apollo.QueryResult<GetTotalsProviderByPatientsIdQuery, GetTotalsProviderByPatientsIdQueryVariables>;
export const InsertFhirQuestionnaireResponseDocument = gql`
    mutation InsertFHIRQuestionnaireResponse($createQuestionnaireResponsesInput: QuestionnaireResponseInput!) {
  insertFHIRQuestionnaireResponse(
    createQuestionnaireResponsesInput: $createQuestionnaireResponsesInput
  ) {
    questionnaire_response {
      created_at
      id
    }
  }
}
    `;
export type InsertFhirQuestionnaireResponseMutationFn = Apollo.MutationFunction<InsertFhirQuestionnaireResponseMutation, InsertFhirQuestionnaireResponseMutationVariables>;

/**
 * __useInsertFhirQuestionnaireResponseMutation__
 *
 * To run a mutation, you first call `useInsertFhirQuestionnaireResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertFhirQuestionnaireResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertFhirQuestionnaireResponseMutation, { data, loading, error }] = useInsertFhirQuestionnaireResponseMutation({
 *   variables: {
 *      createQuestionnaireResponsesInput: // value for 'createQuestionnaireResponsesInput'
 *   },
 * });
 */
export function useInsertFhirQuestionnaireResponseMutation(baseOptions?: Apollo.MutationHookOptions<InsertFhirQuestionnaireResponseMutation, InsertFhirQuestionnaireResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertFhirQuestionnaireResponseMutation, InsertFhirQuestionnaireResponseMutationVariables>(InsertFhirQuestionnaireResponseDocument, options);
      }
export type InsertFhirQuestionnaireResponseMutationHookResult = ReturnType<typeof useInsertFhirQuestionnaireResponseMutation>;
export type InsertFhirQuestionnaireResponseMutationResult = Apollo.MutationResult<InsertFhirQuestionnaireResponseMutation>;
export type InsertFhirQuestionnaireResponseMutationOptions = Apollo.BaseMutationOptions<InsertFhirQuestionnaireResponseMutation, InsertFhirQuestionnaireResponseMutationVariables>;
export const UpdateFhirQuestionnaireResponseDocument = gql`
    mutation UpdateFHIRQuestionnaireResponse($identifier: String, $isComplete: Boolean = false, $questionnaireId: String!, $responses: JSON!, $swabCode: String!, $currentStepIndex: Int) {
  updateFHIRQuestionnaireResponse(
    responses: $responses
    swabCode: $swabCode
    identifier: $identifier
    questionnaireId: $questionnaireId
    isComplete: $isComplete
    currentStepIndex: $currentStepIndex
  ) {
    questionnaire_response {
      id
    }
  }
}
    `;
export type UpdateFhirQuestionnaireResponseMutationFn = Apollo.MutationFunction<UpdateFhirQuestionnaireResponseMutation, UpdateFhirQuestionnaireResponseMutationVariables>;

/**
 * __useUpdateFhirQuestionnaireResponseMutation__
 *
 * To run a mutation, you first call `useUpdateFhirQuestionnaireResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFhirQuestionnaireResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFhirQuestionnaireResponseMutation, { data, loading, error }] = useUpdateFhirQuestionnaireResponseMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      isComplete: // value for 'isComplete'
 *      questionnaireId: // value for 'questionnaireId'
 *      responses: // value for 'responses'
 *      swabCode: // value for 'swabCode'
 *      currentStepIndex: // value for 'currentStepIndex'
 *   },
 * });
 */
export function useUpdateFhirQuestionnaireResponseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFhirQuestionnaireResponseMutation, UpdateFhirQuestionnaireResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFhirQuestionnaireResponseMutation, UpdateFhirQuestionnaireResponseMutationVariables>(UpdateFhirQuestionnaireResponseDocument, options);
      }
export type UpdateFhirQuestionnaireResponseMutationHookResult = ReturnType<typeof useUpdateFhirQuestionnaireResponseMutation>;
export type UpdateFhirQuestionnaireResponseMutationResult = Apollo.MutationResult<UpdateFhirQuestionnaireResponseMutation>;
export type UpdateFhirQuestionnaireResponseMutationOptions = Apollo.BaseMutationOptions<UpdateFhirQuestionnaireResponseMutation, UpdateFhirQuestionnaireResponseMutationVariables>;
export const SaveFhirQuestionnaireManuallyDocument = gql`
    mutation SaveFHIRQuestionnaireManually($questionnaireId: Int!, $userID: String!, $responses: JSON!, $isComplete: Boolean!) {
  saveFHIRQuestionnaireManually(
    responses: $responses
    userID: $userID
    isComplete: $isComplete
    questionnaireId: $questionnaireId
  ) {
    id
    responses
  }
}
    `;
export type SaveFhirQuestionnaireManuallyMutationFn = Apollo.MutationFunction<SaveFhirQuestionnaireManuallyMutation, SaveFhirQuestionnaireManuallyMutationVariables>;

/**
 * __useSaveFhirQuestionnaireManuallyMutation__
 *
 * To run a mutation, you first call `useSaveFhirQuestionnaireManuallyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFhirQuestionnaireManuallyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFhirQuestionnaireManuallyMutation, { data, loading, error }] = useSaveFhirQuestionnaireManuallyMutation({
 *   variables: {
 *      questionnaireId: // value for 'questionnaireId'
 *      userID: // value for 'userID'
 *      responses: // value for 'responses'
 *      isComplete: // value for 'isComplete'
 *   },
 * });
 */
export function useSaveFhirQuestionnaireManuallyMutation(baseOptions?: Apollo.MutationHookOptions<SaveFhirQuestionnaireManuallyMutation, SaveFhirQuestionnaireManuallyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFhirQuestionnaireManuallyMutation, SaveFhirQuestionnaireManuallyMutationVariables>(SaveFhirQuestionnaireManuallyDocument, options);
      }
export type SaveFhirQuestionnaireManuallyMutationHookResult = ReturnType<typeof useSaveFhirQuestionnaireManuallyMutation>;
export type SaveFhirQuestionnaireManuallyMutationResult = Apollo.MutationResult<SaveFhirQuestionnaireManuallyMutation>;
export type SaveFhirQuestionnaireManuallyMutationOptions = Apollo.BaseMutationOptions<SaveFhirQuestionnaireManuallyMutation, SaveFhirQuestionnaireManuallyMutationVariables>;
export const UpdateFhirUserLatestQuestionnaireDocument = gql`
    mutation UpdateFHIRUserLatestQuestionnaire($id: String!, $responses: JSON!, $isComplete: Boolean!) {
  updateFHIRUserLatestQuestionnaire(
    responses: $responses
    isComplete: $isComplete
    id: $id
  ) {
    affected_rows
  }
}
    `;
export type UpdateFhirUserLatestQuestionnaireMutationFn = Apollo.MutationFunction<UpdateFhirUserLatestQuestionnaireMutation, UpdateFhirUserLatestQuestionnaireMutationVariables>;

/**
 * __useUpdateFhirUserLatestQuestionnaireMutation__
 *
 * To run a mutation, you first call `useUpdateFhirUserLatestQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFhirUserLatestQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFhirUserLatestQuestionnaireMutation, { data, loading, error }] = useUpdateFhirUserLatestQuestionnaireMutation({
 *   variables: {
 *      id: // value for 'id'
 *      responses: // value for 'responses'
 *      isComplete: // value for 'isComplete'
 *   },
 * });
 */
export function useUpdateFhirUserLatestQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFhirUserLatestQuestionnaireMutation, UpdateFhirUserLatestQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFhirUserLatestQuestionnaireMutation, UpdateFhirUserLatestQuestionnaireMutationVariables>(UpdateFhirUserLatestQuestionnaireDocument, options);
      }
export type UpdateFhirUserLatestQuestionnaireMutationHookResult = ReturnType<typeof useUpdateFhirUserLatestQuestionnaireMutation>;
export type UpdateFhirUserLatestQuestionnaireMutationResult = Apollo.MutationResult<UpdateFhirUserLatestQuestionnaireMutation>;
export type UpdateFhirUserLatestQuestionnaireMutationOptions = Apollo.BaseMutationOptions<UpdateFhirUserLatestQuestionnaireMutation, UpdateFhirUserLatestQuestionnaireMutationVariables>;
export const GetFhirQuestionnaireResponseDocument = gql`
    query GetFHIRQuestionnaireResponse($codexPatientId: String!, $identifier: String!, $system: String!, $swabCode: String) {
  getFHIRQuestionnaireResponse(
    codexPatientId: $codexPatientId
    identifier: $identifier
    system: $system
    swabCode: $swabCode
  ) {
    questionnaire_response {
      id
      current_step_index
      is_complete
      responses {
        __typename
        ... on HasuraAnswerItem {
          child_questions
          currentIndexOfSection
          currentSection
          questionID
          responseType
          stringArrayResponse
          stringResponse
          hasuraItemArrayResponse {
            currentIndexOfSection
            currentSection
            questionID
            responseType
            stringArrayResponse
            stringResponse
            hasuraItemArrayResponse {
              currentIndexOfSection
              currentSection
              questionID
              responseType
              stringArrayResponse
              stringResponse
              hasuraMedicationItemResponse {
                completed
                id
                stringArrayResponse
                stringResponse
                responseType
                title
                value
              }
            }
          }
        }
        ... on HasuraMedicationItem {
          completed
          id
          child_questions
          responseType
          stringArrayResponse
          stringResponse
          title
          value
          hasuraItemArrayResponse {
            currentIndexOfSection
            currentSection
            questionID
            responseType
            stringArrayResponse
            stringResponse
          }
          hasuraMedicationItemResponse {
            completed
            id
            responseType
            stringArrayResponse
            stringResponse
            title
          }
        }
      }
      updated_at
    }
  }
}
    `;

/**
 * __useGetFhirQuestionnaireResponseQuery__
 *
 * To run a query within a React component, call `useGetFhirQuestionnaireResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirQuestionnaireResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirQuestionnaireResponseQuery({
 *   variables: {
 *      codexPatientId: // value for 'codexPatientId'
 *      identifier: // value for 'identifier'
 *      system: // value for 'system'
 *      swabCode: // value for 'swabCode'
 *   },
 * });
 */
export function useGetFhirQuestionnaireResponseQuery(baseOptions: Apollo.QueryHookOptions<GetFhirQuestionnaireResponseQuery, GetFhirQuestionnaireResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirQuestionnaireResponseQuery, GetFhirQuestionnaireResponseQueryVariables>(GetFhirQuestionnaireResponseDocument, options);
      }
export function useGetFhirQuestionnaireResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirQuestionnaireResponseQuery, GetFhirQuestionnaireResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirQuestionnaireResponseQuery, GetFhirQuestionnaireResponseQueryVariables>(GetFhirQuestionnaireResponseDocument, options);
        }
export type GetFhirQuestionnaireResponseQueryHookResult = ReturnType<typeof useGetFhirQuestionnaireResponseQuery>;
export type GetFhirQuestionnaireResponseLazyQueryHookResult = ReturnType<typeof useGetFhirQuestionnaireResponseLazyQuery>;
export type GetFhirQuestionnaireResponseQueryResult = Apollo.QueryResult<GetFhirQuestionnaireResponseQuery, GetFhirQuestionnaireResponseQueryVariables>;
export const GetLatestFhirQuestionnaireByIdDocument = gql`
    query GetLatestFHIRQuestionnaireById($questionnaire_id: Int!) {
  getLatestFHIRQuestionnaireById(questionnaire_id: $questionnaire_id) {
    questionnaire_responses {
      responses
      id
    }
  }
}
    `;

/**
 * __useGetLatestFhirQuestionnaireByIdQuery__
 *
 * To run a query within a React component, call `useGetLatestFhirQuestionnaireByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestFhirQuestionnaireByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestFhirQuestionnaireByIdQuery({
 *   variables: {
 *      questionnaire_id: // value for 'questionnaire_id'
 *   },
 * });
 */
export function useGetLatestFhirQuestionnaireByIdQuery(baseOptions: Apollo.QueryHookOptions<GetLatestFhirQuestionnaireByIdQuery, GetLatestFhirQuestionnaireByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestFhirQuestionnaireByIdQuery, GetLatestFhirQuestionnaireByIdQueryVariables>(GetLatestFhirQuestionnaireByIdDocument, options);
      }
export function useGetLatestFhirQuestionnaireByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestFhirQuestionnaireByIdQuery, GetLatestFhirQuestionnaireByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestFhirQuestionnaireByIdQuery, GetLatestFhirQuestionnaireByIdQueryVariables>(GetLatestFhirQuestionnaireByIdDocument, options);
        }
export type GetLatestFhirQuestionnaireByIdQueryHookResult = ReturnType<typeof useGetLatestFhirQuestionnaireByIdQuery>;
export type GetLatestFhirQuestionnaireByIdLazyQueryHookResult = ReturnType<typeof useGetLatestFhirQuestionnaireByIdLazyQuery>;
export type GetLatestFhirQuestionnaireByIdQueryResult = Apollo.QueryResult<GetLatestFhirQuestionnaireByIdQuery, GetLatestFhirQuestionnaireByIdQueryVariables>;
export const GetFhirQuestionnaireByIdDocument = gql`
    query GetFHIRQuestionnaireById($questionnaire_id: Int!) {
  getFHIRQuestionnaireByCodexID(questionnaireId: $questionnaire_id) {
    title
    subtitle
    data {
      name
      properties
      complete
      dependencies {
        if
        then {
          enabled
          required
        }
      }
    }
    questionnaires_questionnaire_questions {
      questionnaire_questions_question {
        id
        text
        subtitle
        answers
        ui_control
        dont_know_answer
        double_text_combo_helper_texts {
          helper_text_1
          helper_text_2
        }
        dropdown_combo_answers
        dropdown_label_1
        dropdown_label_2
        measurement_unit
        response_property
        array_field_config {
          add_button_label
          max_items
          min_items
        }
        children {
          all_option
          answers
          array_field_config {
            add_button_label
            max_items
            min_items
          }
          dont_know_answer
          dropdown_combo_answers
          dropdown_label_1
          dropdown_label_2
          helper_text
          id
          measurement_unit
          none_option
          response_property
          subtitle
          text
          ui_control
        }
        helper_text
        none_option
        all_option
      }
    }
  }
}
    `;

/**
 * __useGetFhirQuestionnaireByIdQuery__
 *
 * To run a query within a React component, call `useGetFhirQuestionnaireByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFhirQuestionnaireByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFhirQuestionnaireByIdQuery({
 *   variables: {
 *      questionnaire_id: // value for 'questionnaire_id'
 *   },
 * });
 */
export function useGetFhirQuestionnaireByIdQuery(baseOptions: Apollo.QueryHookOptions<GetFhirQuestionnaireByIdQuery, GetFhirQuestionnaireByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFhirQuestionnaireByIdQuery, GetFhirQuestionnaireByIdQueryVariables>(GetFhirQuestionnaireByIdDocument, options);
      }
export function useGetFhirQuestionnaireByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFhirQuestionnaireByIdQuery, GetFhirQuestionnaireByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFhirQuestionnaireByIdQuery, GetFhirQuestionnaireByIdQueryVariables>(GetFhirQuestionnaireByIdDocument, options);
        }
export type GetFhirQuestionnaireByIdQueryHookResult = ReturnType<typeof useGetFhirQuestionnaireByIdQuery>;
export type GetFhirQuestionnaireByIdLazyQueryHookResult = ReturnType<typeof useGetFhirQuestionnaireByIdLazyQuery>;
export type GetFhirQuestionnaireByIdQueryResult = Apollo.QueryResult<GetFhirQuestionnaireByIdQuery, GetFhirQuestionnaireByIdQueryVariables>;
export const AddProductToCartDocument = gql`
    mutation AddProductToCart($productId: Int = 10, $quantity: Int = 10, $recommendationId: String) {
  createCartProduct(
    input: {productId: $productId, quantity: $quantity, recommendationId: $recommendationId}
  ) {
    created_at
    id
    product {
      created_at
      description
      id
      price
      short_description
      specs {
        contents
        expiration_period
        made_in
      }
      title
      updated_at
    }
    product_id
    quantity
    updated_at
    user_id
  }
}
    `;
export type AddProductToCartMutationFn = Apollo.MutationFunction<AddProductToCartMutation, AddProductToCartMutationVariables>;

/**
 * __useAddProductToCartMutation__
 *
 * To run a mutation, you first call `useAddProductToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductToCartMutation, { data, loading, error }] = useAddProductToCartMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      quantity: // value for 'quantity'
 *      recommendationId: // value for 'recommendationId'
 *   },
 * });
 */
export function useAddProductToCartMutation(baseOptions?: Apollo.MutationHookOptions<AddProductToCartMutation, AddProductToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductToCartMutation, AddProductToCartMutationVariables>(AddProductToCartDocument, options);
      }
export type AddProductToCartMutationHookResult = ReturnType<typeof useAddProductToCartMutation>;
export type AddProductToCartMutationResult = Apollo.MutationResult<AddProductToCartMutation>;
export type AddProductToCartMutationOptions = Apollo.BaseMutationOptions<AddProductToCartMutation, AddProductToCartMutationVariables>;
export const UpdateProductInCartDocument = gql`
    mutation UpdateProductInCart($id: Int = 10, $quantity: Int = 10) {
  updateCartProduct(input: {id: $id, quantity: $quantity}) {
    product {
      created_at
      description
      id
      price
      short_description
      specs {
        contents
        expiration_period
        made_in
      }
      title
      updated_at
    }
    created_at
    id
    product_id
    quantity
    updated_at
    user_id
  }
}
    `;
export type UpdateProductInCartMutationFn = Apollo.MutationFunction<UpdateProductInCartMutation, UpdateProductInCartMutationVariables>;

/**
 * __useUpdateProductInCartMutation__
 *
 * To run a mutation, you first call `useUpdateProductInCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductInCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductInCartMutation, { data, loading, error }] = useUpdateProductInCartMutation({
 *   variables: {
 *      id: // value for 'id'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useUpdateProductInCartMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductInCartMutation, UpdateProductInCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductInCartMutation, UpdateProductInCartMutationVariables>(UpdateProductInCartDocument, options);
      }
export type UpdateProductInCartMutationHookResult = ReturnType<typeof useUpdateProductInCartMutation>;
export type UpdateProductInCartMutationResult = Apollo.MutationResult<UpdateProductInCartMutation>;
export type UpdateProductInCartMutationOptions = Apollo.BaseMutationOptions<UpdateProductInCartMutation, UpdateProductInCartMutationVariables>;
export const DeleteCartProductDocument = gql`
    mutation DeleteCartProduct($id: Int = 10) {
  deleteCartProduct(id: $id) {
    message
    status
  }
}
    `;
export type DeleteCartProductMutationFn = Apollo.MutationFunction<DeleteCartProductMutation, DeleteCartProductMutationVariables>;

/**
 * __useDeleteCartProductMutation__
 *
 * To run a mutation, you first call `useDeleteCartProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCartProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCartProductMutation, { data, loading, error }] = useDeleteCartProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCartProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCartProductMutation, DeleteCartProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCartProductMutation, DeleteCartProductMutationVariables>(DeleteCartProductDocument, options);
      }
export type DeleteCartProductMutationHookResult = ReturnType<typeof useDeleteCartProductMutation>;
export type DeleteCartProductMutationResult = Apollo.MutationResult<DeleteCartProductMutation>;
export type DeleteCartProductMutationOptions = Apollo.BaseMutationOptions<DeleteCartProductMutation, DeleteCartProductMutationVariables>;
export const DeleteLastAddressDocument = gql`
    mutation DeleteLastAddress($id: Int = 10) {
  deleteDeliveryAddress(id: $id) {
    message
    status
  }
}
    `;
export type DeleteLastAddressMutationFn = Apollo.MutationFunction<DeleteLastAddressMutation, DeleteLastAddressMutationVariables>;

/**
 * __useDeleteLastAddressMutation__
 *
 * To run a mutation, you first call `useDeleteLastAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLastAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLastAddressMutation, { data, loading, error }] = useDeleteLastAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLastAddressMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLastAddressMutation, DeleteLastAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLastAddressMutation, DeleteLastAddressMutationVariables>(DeleteLastAddressDocument, options);
      }
export type DeleteLastAddressMutationHookResult = ReturnType<typeof useDeleteLastAddressMutation>;
export type DeleteLastAddressMutationResult = Apollo.MutationResult<DeleteLastAddressMutation>;
export type DeleteLastAddressMutationOptions = Apollo.BaseMutationOptions<DeleteLastAddressMutation, DeleteLastAddressMutationVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($deliveryAddressId: Int, $providerId: String, $promoCode: String, $useSavedAddress: Boolean, $deliveryAddress1: CreateDeliveryAddressInput, $paymentProvider: PaymentProviderEnum = Stripe) {
  createOrder(
    input: {providerId: $providerId, deliveryAddressId: $deliveryAddressId, deliveryAddress: $deliveryAddress1, promoCode: $promoCode, useSavedAddress: $useSavedAddress, paymentProvider: $paymentProvider}
  ) {
    link
  }
}
    `;
export type CreateOrderMutationFn = Apollo.MutationFunction<CreateOrderMutation, CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      deliveryAddressId: // value for 'deliveryAddressId'
 *      providerId: // value for 'providerId'
 *      promoCode: // value for 'promoCode'
 *      useSavedAddress: // value for 'useSavedAddress'
 *      deliveryAddress1: // value for 'deliveryAddress1'
 *      paymentProvider: // value for 'paymentProvider'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<CreateOrderMutation, CreateOrderMutationVariables>;
export const RecommendProductsDocument = gql`
    mutation RecommendProducts($codexPatientId: String!, $appointmentCodexId: String, $recommendations: [ProductRecommendationInput!]!) {
  recommendProducts(
    codexPatientId: $codexPatientId
    input: {recommendations: $recommendations, appointmentCodexId: $appointmentCodexId}
  ) {
    serviceRequestIds
  }
}
    `;
export type RecommendProductsMutationFn = Apollo.MutationFunction<RecommendProductsMutation, RecommendProductsMutationVariables>;

/**
 * __useRecommendProductsMutation__
 *
 * To run a mutation, you first call `useRecommendProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecommendProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recommendProductsMutation, { data, loading, error }] = useRecommendProductsMutation({
 *   variables: {
 *      codexPatientId: // value for 'codexPatientId'
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *      recommendations: // value for 'recommendations'
 *   },
 * });
 */
export function useRecommendProductsMutation(baseOptions?: Apollo.MutationHookOptions<RecommendProductsMutation, RecommendProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecommendProductsMutation, RecommendProductsMutationVariables>(RecommendProductsDocument, options);
      }
export type RecommendProductsMutationHookResult = ReturnType<typeof useRecommendProductsMutation>;
export type RecommendProductsMutationResult = Apollo.MutationResult<RecommendProductsMutation>;
export type RecommendProductsMutationOptions = Apollo.BaseMutationOptions<RecommendProductsMutation, RecommendProductsMutationVariables>;
export const UpdateRecommendationStatusDocument = gql`
    mutation UpdateRecommendationStatus($recommendationId: String!, $status: UpdatableRecommendationStatus!) {
  updateRecommendationStatus(recommendationId: $recommendationId, status: $status) {
    message
    status
  }
}
    `;
export type UpdateRecommendationStatusMutationFn = Apollo.MutationFunction<UpdateRecommendationStatusMutation, UpdateRecommendationStatusMutationVariables>;

/**
 * __useUpdateRecommendationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateRecommendationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecommendationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecommendationStatusMutation, { data, loading, error }] = useUpdateRecommendationStatusMutation({
 *   variables: {
 *      recommendationId: // value for 'recommendationId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateRecommendationStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecommendationStatusMutation, UpdateRecommendationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecommendationStatusMutation, UpdateRecommendationStatusMutationVariables>(UpdateRecommendationStatusDocument, options);
      }
export type UpdateRecommendationStatusMutationHookResult = ReturnType<typeof useUpdateRecommendationStatusMutation>;
export type UpdateRecommendationStatusMutationResult = Apollo.MutationResult<UpdateRecommendationStatusMutation>;
export type UpdateRecommendationStatusMutationOptions = Apollo.BaseMutationOptions<UpdateRecommendationStatusMutation, UpdateRecommendationStatusMutationVariables>;
export const DeleteDraftRecommendationDocument = gql`
    mutation DeleteDraftRecommendation($recommendationId: String!) {
  deleteRecommendationByRequestUserCodexId(recommendationId: $recommendationId) {
    message
    status
  }
}
    `;
export type DeleteDraftRecommendationMutationFn = Apollo.MutationFunction<DeleteDraftRecommendationMutation, DeleteDraftRecommendationMutationVariables>;

/**
 * __useDeleteDraftRecommendationMutation__
 *
 * To run a mutation, you first call `useDeleteDraftRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDraftRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDraftRecommendationMutation, { data, loading, error }] = useDeleteDraftRecommendationMutation({
 *   variables: {
 *      recommendationId: // value for 'recommendationId'
 *   },
 * });
 */
export function useDeleteDraftRecommendationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDraftRecommendationMutation, DeleteDraftRecommendationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDraftRecommendationMutation, DeleteDraftRecommendationMutationVariables>(DeleteDraftRecommendationDocument, options);
      }
export type DeleteDraftRecommendationMutationHookResult = ReturnType<typeof useDeleteDraftRecommendationMutation>;
export type DeleteDraftRecommendationMutationResult = Apollo.MutationResult<DeleteDraftRecommendationMutation>;
export type DeleteDraftRecommendationMutationOptions = Apollo.BaseMutationOptions<DeleteDraftRecommendationMutation, DeleteDraftRecommendationMutationVariables>;
export const GetShopProductsDocument = gql`
    query GetShopProducts($limit: Int = 10, $offset: Int = 0, $categories: [Int!]) {
  getProducts(offset: $offset, limit: $limit, categories: $categories) {
    products {
      title
      short_description
      price
      quantity
      reserved_quantity
      in_stock
      image_url
      default_image_id
      id
      is_shipmonk_active
      description
      specs {
        contents
        expiration_period
        made_in
      }
    }
    total
  }
}
    `;

/**
 * __useGetShopProductsQuery__
 *
 * To run a query within a React component, call `useGetShopProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopProductsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      categories: // value for 'categories'
 *   },
 * });
 */
export function useGetShopProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetShopProductsQuery, GetShopProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShopProductsQuery, GetShopProductsQueryVariables>(GetShopProductsDocument, options);
      }
export function useGetShopProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShopProductsQuery, GetShopProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShopProductsQuery, GetShopProductsQueryVariables>(GetShopProductsDocument, options);
        }
export type GetShopProductsQueryHookResult = ReturnType<typeof useGetShopProductsQuery>;
export type GetShopProductsLazyQueryHookResult = ReturnType<typeof useGetShopProductsLazyQuery>;
export type GetShopProductsQueryResult = Apollo.QueryResult<GetShopProductsQuery, GetShopProductsQueryVariables>;
export const GetCartProductsDocument = gql`
    query GetCartProducts {
  getCartProducts {
    cart_products {
      provider {
        id
        SENSITIVE_lastname
        SENSITIVE_firstname
      }
      patientOwner {
        id
        parentCodexId
        SENSITIVE_firstname
        SENSITIVE_lastname
      }
      product {
        title
        short_description
        is_shipmonk_deleted
        price
        image_url
        id
        description
        category
        specs {
          contents
          expiration_period
          made_in
        }
        updated_at
      }
      id
      product_id
      quantity
      updated_at
      user_id
      created_at
    }
    shipping_for_products
    shipping_for_test_kits
    subtotal
    tax
    total
  }
}
    `;

/**
 * __useGetCartProductsQuery__
 *
 * To run a query within a React component, call `useGetCartProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetCartProductsQuery, GetCartProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartProductsQuery, GetCartProductsQueryVariables>(GetCartProductsDocument, options);
      }
export function useGetCartProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartProductsQuery, GetCartProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartProductsQuery, GetCartProductsQueryVariables>(GetCartProductsDocument, options);
        }
export type GetCartProductsQueryHookResult = ReturnType<typeof useGetCartProductsQuery>;
export type GetCartProductsLazyQueryHookResult = ReturnType<typeof useGetCartProductsLazyQuery>;
export type GetCartProductsQueryResult = Apollo.QueryResult<GetCartProductsQuery, GetCartProductsQueryVariables>;
export const GetLastAddressesDocument = gql`
    query GetLastAddresses($limit: Int = 10, $offset: Int = 0) {
  getDeliveryAddresses(limit: $limit, offset: $offset) {
    delivery_addresses {
      address1
      address2
      city
      country
      created_at
      id
      phone
      state
      updated_at
      user_id
      zip_code
    }
    total
  }
}
    `;

/**
 * __useGetLastAddressesQuery__
 *
 * To run a query within a React component, call `useGetLastAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastAddressesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetLastAddressesQuery(baseOptions?: Apollo.QueryHookOptions<GetLastAddressesQuery, GetLastAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastAddressesQuery, GetLastAddressesQueryVariables>(GetLastAddressesDocument, options);
      }
export function useGetLastAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastAddressesQuery, GetLastAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastAddressesQuery, GetLastAddressesQueryVariables>(GetLastAddressesDocument, options);
        }
export type GetLastAddressesQueryHookResult = ReturnType<typeof useGetLastAddressesQuery>;
export type GetLastAddressesLazyQueryHookResult = ReturnType<typeof useGetLastAddressesLazyQuery>;
export type GetLastAddressesQueryResult = Apollo.QueryResult<GetLastAddressesQuery, GetLastAddressesQueryVariables>;
export const GetRecommendationsByRequestPatientCodexIdDocument = gql`
    query GetRecommendationsByRequestPatientCodexId($limit: Int = 10, $offset: Int = 0, $direction: OrderByDirections = DESC, $field: FHIRRecommendationsOrderByCriterias = CreatedAt, $statuses: [ServiceRequestStatus!]) {
  getRecommendationsByRequestPatientCodexId(
    limit: $limit
    offset: $offset
    orderBy: {direction: $direction, field: $field}
    statuses: $statuses
  ) {
    recommendations {
      createdAt
      id
      imageUrl
      productTitle
      providerCodexId
      patientCodexId
      providerName
      quantity
      status
      productId
      totalPrice
    }
    total
  }
}
    `;

/**
 * __useGetRecommendationsByRequestPatientCodexIdQuery__
 *
 * To run a query within a React component, call `useGetRecommendationsByRequestPatientCodexIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendationsByRequestPatientCodexIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendationsByRequestPatientCodexIdQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      direction: // value for 'direction'
 *      field: // value for 'field'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetRecommendationsByRequestPatientCodexIdQuery(baseOptions?: Apollo.QueryHookOptions<GetRecommendationsByRequestPatientCodexIdQuery, GetRecommendationsByRequestPatientCodexIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendationsByRequestPatientCodexIdQuery, GetRecommendationsByRequestPatientCodexIdQueryVariables>(GetRecommendationsByRequestPatientCodexIdDocument, options);
      }
export function useGetRecommendationsByRequestPatientCodexIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendationsByRequestPatientCodexIdQuery, GetRecommendationsByRequestPatientCodexIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendationsByRequestPatientCodexIdQuery, GetRecommendationsByRequestPatientCodexIdQueryVariables>(GetRecommendationsByRequestPatientCodexIdDocument, options);
        }
export type GetRecommendationsByRequestPatientCodexIdQueryHookResult = ReturnType<typeof useGetRecommendationsByRequestPatientCodexIdQuery>;
export type GetRecommendationsByRequestPatientCodexIdLazyQueryHookResult = ReturnType<typeof useGetRecommendationsByRequestPatientCodexIdLazyQuery>;
export type GetRecommendationsByRequestPatientCodexIdQueryResult = Apollo.QueryResult<GetRecommendationsByRequestPatientCodexIdQuery, GetRecommendationsByRequestPatientCodexIdQueryVariables>;
export const GetInvoiceOrReceiptUrlDocument = gql`
    query GetInvoiceOrReceiptUrl($appointmentId: String, $orderId: Int, $paymentTransactionId: Int) {
  getInvoiceOrReceiptUrl(
    appointmentId: $appointmentId
    orderId: $orderId
    paymentTransactionId: $paymentTransactionId
  ) {
    invoiceUrl
    receiptUrl
  }
}
    `;

/**
 * __useGetInvoiceOrReceiptUrlQuery__
 *
 * To run a query within a React component, call `useGetInvoiceOrReceiptUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceOrReceiptUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceOrReceiptUrlQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      orderId: // value for 'orderId'
 *      paymentTransactionId: // value for 'paymentTransactionId'
 *   },
 * });
 */
export function useGetInvoiceOrReceiptUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetInvoiceOrReceiptUrlQuery, GetInvoiceOrReceiptUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceOrReceiptUrlQuery, GetInvoiceOrReceiptUrlQueryVariables>(GetInvoiceOrReceiptUrlDocument, options);
      }
export function useGetInvoiceOrReceiptUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceOrReceiptUrlQuery, GetInvoiceOrReceiptUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceOrReceiptUrlQuery, GetInvoiceOrReceiptUrlQueryVariables>(GetInvoiceOrReceiptUrlDocument, options);
        }
export type GetInvoiceOrReceiptUrlQueryHookResult = ReturnType<typeof useGetInvoiceOrReceiptUrlQuery>;
export type GetInvoiceOrReceiptUrlLazyQueryHookResult = ReturnType<typeof useGetInvoiceOrReceiptUrlLazyQuery>;
export type GetInvoiceOrReceiptUrlQueryResult = Apollo.QueryResult<GetInvoiceOrReceiptUrlQuery, GetInvoiceOrReceiptUrlQueryVariables>;